// src/data/oncologistsData.js
// Auto-generated & refreshed via CMS NPPES NPI Registry API.
// Generated on: 2026-09-24T22:47:38.805Z

export const ONCOLOGY_TAXONOMIES = [
  {
    slug: 'medical-oncology',
    name: 'Medical Oncology',
    code: '207RX0202X',
    short: 'Medical Oncologist',
    description: 'Specializes in the diagnosis, staging, and systemic treatment of solid tumors and hematologic malignancies using chemotherapy, immunotherapy, and targeted molecular therapies.',
  },
  {
    slug: 'radiation-oncology',
    name: 'Radiation Oncology',
    code: '2085R0001X',
    short: 'Radiation Oncologist',
    description: 'Expertise in treating localized and metastatic tumors with high-energy ionizing radiation, stereotactic body radiation therapy (SBRT/SRS), IMRT, and proton beam therapy.',
  },
  {
    slug: 'gynecologic-oncology',
    name: 'Gynecologic Oncology',
    code: '207VX0201X',
    short: 'Gynecologic Oncologist',
    description: 'Surgical and medical subspecialists managing cancers of the female reproductive system including ovarian, cervical, uterine, endometrial, and vulvar malignancies.',
  },
  {
    slug: 'hematology-oncology',
    name: 'Hematology-Oncology',
    code: '207RH0003X',
    short: 'Hematologist-Oncologist',
    description: 'Dual-certified physicians diagnosing and treating blood cancers (leukemia, lymphoma, multiple myeloma, myelodysplastic syndromes) and complex non-malignant hematology.',
  },
  {
    slug: 'surgical-oncology',
    name: 'Surgical Oncology',
    code: '2086X0206X',
    short: 'Surgical Oncologist',
    description: 'Fellowship-trained surgeons specializing in complex tumor resections, organ-preserving oncologic surgeries, sentinel lymph node biopsies, and cytoreductive HIPEC procedures.',
  },
  {
    slug: 'pediatric-hem-onc',
    name: 'Pediatric Hematology-Oncology',
    code: '2080P0207X',
    short: 'Pediatric Oncologist',
    description: 'Dedicated pediatric cancer physicians treating childhood leukemias, neuroblastomas, Wilms tumors, sarcomas, and pediatric central nervous system malignancies.',
  },
];

export const QUALIFIED_CITIES = [
  {
    "stateSlug": "new-york",
    "citySlug": "new-york-city",
    "cityName": "New York City",
    "stateName": "New York",
    "stateAbbr": "NY",
    "path": "/find-oncologists/new-york/new-york-city",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in New York City, NY. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "texas",
    "citySlug": "houston",
    "cityName": "Houston",
    "stateName": "Texas",
    "stateAbbr": "TX",
    "path": "/find-oncologists/texas/houston",
    "providerCount": 24,
    "description": "Verified directory of 24+ board-certified oncologists in Houston, TX. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "massachusetts",
    "citySlug": "boston",
    "cityName": "Boston",
    "stateName": "Massachusetts",
    "stateAbbr": "MA",
    "path": "/find-oncologists/massachusetts/boston",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Boston, MA. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "california",
    "citySlug": "los-angeles",
    "cityName": "Los Angeles",
    "stateName": "California",
    "stateAbbr": "CA",
    "path": "/find-oncologists/california/los-angeles",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Los Angeles, CA. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "illinois",
    "citySlug": "chicago",
    "cityName": "Chicago",
    "stateName": "Illinois",
    "stateAbbr": "IL",
    "path": "/find-oncologists/illinois/chicago",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Chicago, IL. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "pennsylvania",
    "citySlug": "philadelphia",
    "cityName": "Philadelphia",
    "stateName": "Pennsylvania",
    "stateAbbr": "PA",
    "path": "/find-oncologists/pennsylvania/philadelphia",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Philadelphia, PA. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "georgia",
    "citySlug": "atlanta",
    "cityName": "Atlanta",
    "stateName": "Georgia",
    "stateAbbr": "GA",
    "path": "/find-oncologists/georgia/atlanta",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Atlanta, GA. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "washington",
    "citySlug": "seattle",
    "cityName": "Seattle",
    "stateName": "Washington",
    "stateAbbr": "WA",
    "path": "/find-oncologists/washington/seattle",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Seattle, WA. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "ohio",
    "citySlug": "cleveland",
    "cityName": "Cleveland",
    "stateName": "Ohio",
    "stateAbbr": "OH",
    "path": "/find-oncologists/ohio/cleveland",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Cleveland, OH. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "maryland",
    "citySlug": "baltimore",
    "cityName": "Baltimore",
    "stateName": "Maryland",
    "stateAbbr": "MD",
    "path": "/find-oncologists/maryland/baltimore",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Baltimore, MD. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "texas",
    "citySlug": "dallas",
    "cityName": "Dallas",
    "stateName": "Texas",
    "stateAbbr": "TX",
    "path": "/find-oncologists/texas/dallas",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Dallas, TX. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "florida",
    "citySlug": "miami",
    "cityName": "Miami",
    "stateName": "Florida",
    "stateAbbr": "FL",
    "path": "/find-oncologists/florida/miami",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Miami, FL. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "california",
    "citySlug": "san-francisco",
    "cityName": "San Francisco",
    "stateName": "California",
    "stateAbbr": "CA",
    "path": "/find-oncologists/california/san-francisco",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in San Francisco, CA. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "arizona",
    "citySlug": "phoenix",
    "cityName": "Phoenix",
    "stateName": "Arizona",
    "stateAbbr": "AZ",
    "path": "/find-oncologists/arizona/phoenix",
    "providerCount": 24,
    "description": "Verified directory of 24+ board-certified oncologists in Phoenix, AZ. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "colorado",
    "citySlug": "denver",
    "cityName": "Denver",
    "stateName": "Colorado",
    "stateAbbr": "CO",
    "path": "/find-oncologists/colorado/denver",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Denver, CO. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "north-carolina",
    "citySlug": "durham",
    "cityName": "Durham",
    "stateName": "North Carolina",
    "stateAbbr": "NC",
    "path": "/find-oncologists/north-carolina/durham",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Durham, NC. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "tennessee",
    "citySlug": "nashville",
    "cityName": "Nashville",
    "stateName": "Tennessee",
    "stateAbbr": "TN",
    "path": "/find-oncologists/tennessee/nashville",
    "providerCount": 25,
    "description": "Verified directory of 25+ board-certified oncologists in Nashville, TN. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  },
  {
    "stateSlug": "michigan",
    "citySlug": "detroit",
    "cityName": "Detroit",
    "stateName": "Michigan",
    "stateAbbr": "MI",
    "path": "/find-oncologists/michigan/detroit",
    "providerCount": 24,
    "description": "Verified directory of 24+ board-certified oncologists in Detroit, MI. Filter by medical oncology, radiation oncology, and surgical oncology with direct practice phone and NPI registry details."
  }
];

export const ONCOLOGISTS_BY_CITY = {
  "new-york/new-york-city": [
    {
      "npi": "1134190168",
      "name": "Dr. Ghassan Abou-alfa, MD",
      "rawName": "Ghassan Abou-alfa",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10021",
      "phone": "212-639-2000",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1598146227",
      "name": "Dr. Nour Abuhadra, MD",
      "rawName": "Nour Abuhadra",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-2000",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1740422039",
      "name": "Dr. Melissa Accordino, MD",
      "rawName": "Melissa Accordino",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "161 FORT WASHINGTON AVENUE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10032",
      "phone": "212-305-9382",
      "affiliation": "Columbia University Herbert Irving Comprehensive Cancer Center"
    },
    {
      "npi": "1538574926",
      "name": "Dr. Ana Acuna-villaorduna, MD",
      "rawName": "Ana Acuna-villaorduna",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "263 FARMINGTON AVE",
      "city": "Farmington",
      "state": "CT",
      "postalCode": "06030",
      "phone": "860-679-2100",
      "affiliation": "Regional Academic Oncology Network (Farmington, CT)"
    },
    {
      "npi": "1194168955",
      "name": "Dr. David Aggen, MD",
      "rawName": "David Aggen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "353 E 68TH ST",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "646-422-4679",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1275570533",
      "name": "Dr. Carol Aghajanian, MD",
      "rawName": "Carol Aghajanian",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10021",
      "phone": "212-639-2000",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1720540495",
      "name": "Dr. Prashasti Agrawal, MD",
      "rawName": "Prashasti Agrawal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "480 RED HILL RD",
      "city": "Middletown",
      "state": "NJ",
      "postalCode": "07748",
      "phone": "833-921-2959",
      "affiliation": "Regional Academic Oncology Network (Middletown, NJ)"
    },
    {
      "npi": "1811348931",
      "name": "Dr. Mohamed Ahmed, MD",
      "rawName": "Mohamed Ahmed",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1600 E HIGH ST",
      "city": "Pottstown",
      "state": "PA",
      "postalCode": "19464",
      "phone": "610-327-7000",
      "affiliation": "Regional Academic Oncology Network (Pottstown, PA)"
    },
    {
      "npi": "1366735722",
      "name": "Dr. Omobolaji Akala, MD",
      "rawName": "Omobolaji Akala",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "630 W 168TH ST",
      "city": "New york",
      "state": "NY",
      "postalCode": "10032",
      "phone": "212-305-2913",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1356838353",
      "name": "Dr. Duaa Al rawi, MD",
      "rawName": "Duaa Al rawi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "646-888-2115",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1861424061",
      "name": "Dr. Louis Aledort, MD",
      "rawName": "Louis Aledort",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1190 5TH AVENUE GUGGENHEIM PAVILL",
      "city": "New york",
      "state": "NY",
      "postalCode": "10029",
      "phone": "212-241-6756",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1225354442",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "39 GRAMERCY PARK N",
      "city": "New york",
      "state": "NY",
      "postalCode": "10010",
      "phone": "212-505-7660",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1891882981",
      "name": "Dr. Sandra Allen-bard, MD",
      "rawName": "Sandra Allen-bard",
      "credential": "MD",
      "specialty": "Nurse Practitioner, Adult Health",
      "taxonomyCode": "363LA2200X",
      "practiceAddress": "530 E 74TH ST FL 14",
      "city": "New york",
      "state": "NY",
      "postalCode": "10021",
      "phone": "646-608-4308",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1356796833",
      "name": "Dr. Salvador Alonso martinez, MD",
      "rawName": "Salvador Alonso martinez",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1689412801",
      "name": "Dr. Reem Alsuwailem, MD",
      "rawName": "Reem Alsuwailem",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-5422",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1821672957",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Clinic/Center, Ambulatory Surgical",
      "taxonomyCode": "261QA1903X",
      "practiceAddress": "5 E 98TH ST FL 14",
      "city": "New york",
      "state": "NY",
      "postalCode": "10029",
      "phone": "212-241-3364",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1770105728",
      "name": "Dr. Lamiaa Abdallah, MD",
      "rawName": "Lamiaa Abdallah",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1275 YORK AVE # 22",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-6800",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1811341944",
      "name": "Dr. Jalal Ahmed, MD",
      "rawName": "Jalal Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1184 5TH AVE FL 1",
      "city": "New york",
      "state": "NY",
      "postalCode": "10029",
      "phone": "212-241-7500",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1144200791",
      "name": "Dr. Kaled Alektiar, MD",
      "rawName": "Kaled Alektiar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10021",
      "phone": "212-639-2000",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1265893184",
      "name": "Dr. Alexander Augustyn, MD",
      "rawName": "Alexander Augustyn",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1215377056",
      "name": "Dr. Samuel Bakhoum, MD",
      "rawName": "Samuel Bakhoum",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-7900",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1528226339",
      "name": "Dr. Richard Bakst, MD",
      "rawName": "Richard Bakst",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1184 5TH AVENUE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10029",
      "phone": "212-241-7500",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1962728949",
      "name": "Dr. Onyinye Balogun, MD",
      "rawName": "Onyinye Balogun",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "525 E 68TH ST",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-746-3600",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1598959058",
      "name": "Dr. Christopher Barker, MD",
      "rawName": "Christopher Barker",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-8168",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1932189586",
      "name": "Dr. Kathryn Beal, MD",
      "rawName": "Kathryn Beal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10021",
      "phone": "212-639-2000",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    }
  ],
  "texas/houston": [
    {
      "npi": "1396065934",
      "name": "Dr. Kanza Abbas, MD",
      "rawName": "Kanza Abbas",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2727 W HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77025",
      "phone": "713-442-0000",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1134233224",
      "name": "Dr. James Abbruzzese, MD",
      "rawName": "James Abbruzzese",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1518227735",
      "name": "Dr. Maen Abdelrahim, MD",
      "rawName": "Maen Abdelrahim",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6445 MAIN STREET, OPC24",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-441-9948",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    },
    {
      "npi": "1205097599",
      "name": "Dr. Sausan Abouharb, MD",
      "rawName": "Sausan Abouharb",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD.",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1215123971",
      "name": "Dr. Fadi Abu-shahin, MD",
      "rawName": "Fadi Abu-shahin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "18220 STATE HIGHWAY 249 STE 100",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77070",
      "phone": "276-546-2928",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    },
    {
      "npi": "1285846790",
      "name": "Dr. Kerin Adelson, MD",
      "rawName": "Kerin Adelson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1225567233",
      "name": "Dr. Talha Aijaz, MD",
      "rawName": "Talha Aijaz",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1124107156",
      "name": "Dr. Jaffer Ajani, MD",
      "rawName": "Jaffer Ajani",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1679988323",
      "name": "Dr. Neal Akhave, MD",
      "rawName": "Neal Akhave",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1518059898",
      "name": "Dr. Gheath Al-atrash, DO",
      "rawName": "Gheath Al-atrash",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1356796833",
      "name": "Dr. Salvador Alonso martinez, MD",
      "rawName": "Salvador Alonso martinez",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1982011375",
      "name": "Dr. Humaid Alshamsi, MD",
      "rawName": "Humaid Alshamsi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1649441601",
      "name": "Dr. Ricardo Alvarez, MD",
      "rawName": "Ricardo Alvarez",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "925 GESSNER RD STE 600",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77024",
      "phone": "713-827-9525",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    },
    {
      "npi": "1912053596",
      "name": "Dr. Rodabe Amaria, MD",
      "rawName": "Rodabe Amaria",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1124447255",
      "name": "Dr. Mediha Ahmad, MD",
      "rawName": "Mediha Ahmad",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "601 E SAN ANTONIO ST STE 101W",
      "city": "Victoria",
      "state": "TX",
      "postalCode": "77901",
      "phone": "361-485-9600",
      "affiliation": "Regional Academic Oncology Network (Victoria, TX)"
    },
    {
      "npi": "1154320976",
      "name": "Dr. Neelofur Ahmad, MD",
      "rawName": "Neelofur Ahmad",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1861999161",
      "name": "Dr. Karine Al feghali, MD",
      "rawName": "Karine Al feghali",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-563-0188",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1003166109",
      "name": "Dr. Jeffrey Albert, MD",
      "rawName": "Jeffrey Albert",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "11750 W 2ND PL STE 150",
      "city": "Lakewood",
      "state": "CO",
      "postalCode": "80228",
      "phone": "720-321-8800",
      "affiliation": "Regional Academic Oncology Network (Lakewood, CO)"
    },
    {
      "npi": "1306322979",
      "name": "Dr. Mohammed Aldehaim, MD",
      "rawName": "Mohammed Aldehaim",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "877-632-6789",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1245598168",
      "name": "Dr. Mark Amsbaugh, MD",
      "rawName": "Mark Amsbaugh",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "6400 FANNIN ST STE 2800",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-486-8000",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    },
    {
      "npi": "1174055545",
      "name": "Dr. Chidinma Anakwenze, MD",
      "rawName": "Chidinma Anakwenze",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1366472102",
      "name": "Dr. Mitchell Anscher, MD",
      "rawName": "Mitchell Anscher",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "101 MANNING DR",
      "city": "Chapel hill",
      "state": "NC",
      "postalCode": "27514",
      "phone": "984-974-1000",
      "affiliation": "Regional Academic Oncology Network (Chapel hill, NC)"
    },
    {
      "npi": "1932557030",
      "name": "Dr. Joseph Arko, MD",
      "rawName": "Joseph Arko",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "11532 CHAMPIONS GREEN DR",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77066",
      "phone": "214-918-5517",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    }
  ],
  "massachusetts/boston": [
    {
      "npi": "1861854937",
      "name": "Dr. Maya Abdallah, MD",
      "rawName": "Maya Abdallah",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "830 HARRISON AVENUE, 3RD FL",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02118",
      "phone": "617-638-6428",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1255821617",
      "name": "Dr. Rachel Abelman, MD",
      "rawName": "Rachel Abelman",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "55 FRUIT ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02114",
      "phone": "617-231-9943",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1427024264",
      "name": "Dr. Janet Abrahm, MD",
      "rawName": "Janet Abrahm",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "44 BINNEY ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-632-6464",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1184693947",
      "name": "Dr. Thomas Abrams, MD",
      "rawName": "Thomas Abrams",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "44 BINNEY ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-632-6932",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1740262484",
      "name": "Dr. Jeremy Abramson, MD",
      "rawName": "Jeremy Abramson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "55 FRUIT ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02114",
      "phone": "617-724-4000",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1801277173",
      "name": "Dr. Jose Acevedo mejia, MD",
      "rawName": "Jose Acevedo mejia",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "830 HARRISON AVENUE, 3RD FL",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02118",
      "phone": "617-638-6428",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1942557079",
      "name": "Dr. Nana Addo-tabiri, MD",
      "rawName": "Nana Addo-tabiri",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "830 HARRISON AVENUE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02118",
      "phone": "617-638-6428",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1316920838",
      "name": "Dr. Adeboye Adewoye, MD",
      "rawName": "Adeboye Adewoye",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "732 HARRISON AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02118",
      "phone": "617-638-6428",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1417078221",
      "name": "Dr. Neeraj Agarwal, MD",
      "rawName": "Neeraj Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "450 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-632-3466",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1609071208",
      "name": "Dr. Andrew Aguirre, MD",
      "rawName": "Andrew Aguirre",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "450 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-632-3476",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1053632984",
      "name": "Dr. Inhye Ahn, MD",
      "rawName": "Inhye Ahn",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "450 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-582-9164",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1154760734",
      "name": "Dr. Oladimeji Akinboro, MD",
      "rawName": "Oladimeji Akinboro",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "10903 NEW HAMPSHIRE AVE BLDG 22",
      "city": "Silver spring",
      "state": "MD",
      "postalCode": "20993",
      "phone": "817-317-1540",
      "affiliation": "Regional Academic Oncology Network (Silver spring, MD)"
    },
    {
      "npi": "1578281796",
      "name": "Dr. Jean joseph thierry Alcindor, MD",
      "rawName": "Jean joseph thierry Alcindor",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "450 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "514-865-1732",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1285671453",
      "name": "Dr. Jill Allen, MD",
      "rawName": "Jill Allen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "55 FRUIT STREET YAWKEY 7E",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02114",
      "phone": "617-724-4000",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1073589578",
      "name": "Dr. Philip Amrein, MD",
      "rawName": "Philip Amrein",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "55 FRUIT ST YAW 7",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02114",
      "phone": "617-726-8748",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1104189117",
      "name": "Dr. Matthew Abrams, MD",
      "rawName": "Matthew Abrams",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "330 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-667-2345",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1528613833",
      "name": "Dr. Jenna Adleman, MD",
      "rawName": "Jenna Adleman",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-430-2431",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1942696752",
      "name": "Dr. Nima Aghdam, MD",
      "rawName": "Nima Aghdam",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "330 BROOKLINE AVE BSMT",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-667-2345",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1619105095",
      "name": "Dr. Ayal Aizer, MD",
      "rawName": "Ayal Aizer",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-525-7136",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1285691972",
      "name": "Dr. Michele Albert, MD",
      "rawName": "Michele Albert",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS STREET ASB1 L2",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-732-7936",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1275511149",
      "name": "Dr. Brian Alexander, MD",
      "rawName": "Brian Alexander",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-732-5500",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1396849527",
      "name": "Dr. Aaron Allen, MD",
      "rawName": "Aaron Allen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-632-7325",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1528488269",
      "name": "Dr. Erik Anderson, MD",
      "rawName": "Erik Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "330 BROOKLINE AVE # FNB-25",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-667-2345",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1225560345",
      "name": "Dr. Mona Arbab, MD",
      "rawName": "Mona Arbab",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-732-6861",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1316995418",
      "name": "Dr. Joseph Aronovitz, MD",
      "rawName": "Joseph Aronovitz",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "330 BROOKLINE AVENUE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-667-2345",
      "affiliation": "Dana-Farber Cancer Institute"
    }
  ],
  "california/los-angeles": [
    {
      "npi": "1013595743",
      "name": "Dr. Alexander Agelidis, MD",
      "rawName": "Alexander Agelidis",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "200 W ARBOR DR",
      "city": "San diego",
      "state": "CA",
      "postalCode": "92103",
      "phone": "800-926-8273",
      "affiliation": "Regional Academic Oncology Network (San diego, CA)"
    },
    {
      "npi": "1164448734",
      "name": "Dr. Mark Agulnik, MD",
      "rawName": "Mark Agulnik",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1441 EASTLAKE AVE",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90089",
      "phone": "323-865-3000",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1356328249",
      "name": "Dr. David Agus, MD",
      "rawName": "David Agus",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "12414 EXPOSITION BLVD",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90064",
      "phone": "310-272-7640",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1568581759",
      "name": "Dr. Sang hoon Ahn, MD",
      "rawName": "Sang hoon Ahn",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "1950 SUNNY CREST DR STE 2800",
      "city": "Fullerton",
      "state": "CA",
      "postalCode": "92835",
      "phone": "657-888-9919",
      "affiliation": "Regional Academic Oncology Network (Fullerton, CA)"
    },
    {
      "npi": "1861886707",
      "name": "Dr. Sandra Algaze, MD",
      "rawName": "Sandra Algaze",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1441 EASTLAKE AVE",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90089",
      "phone": "323-865-3000",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1568921716",
      "name": "Dr. Lauren Antrim, MD",
      "rawName": "Lauren Antrim",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1500 DUARTE RD",
      "city": "Duarte",
      "state": "CA",
      "postalCode": "91010",
      "phone": "800-826-4673",
      "affiliation": "City of Hope Comprehensive Cancer Center"
    },
    {
      "npi": "1649632696",
      "name": "Dr. Nikita Baclig, MD",
      "rawName": "Nikita Baclig",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2020 SANTA MONICA BLVD STE 580",
      "city": "Santa monica",
      "state": "CA",
      "postalCode": "90404",
      "phone": "310-829-5471",
      "affiliation": "Regional Academic Oncology Network (Santa monica, CA)"
    },
    {
      "npi": "1295734614",
      "name": "Dr. Bahareh Bahadini, MD",
      "rawName": "Bahareh Bahadini",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "425 HAALAND DR STE 101",
      "city": "Thousand oaks",
      "state": "CA",
      "postalCode": "91361",
      "phone": "805-496-2949",
      "affiliation": "Regional Academic Oncology Network (Thousand oaks, CA)"
    },
    {
      "npi": "1427493998",
      "name": "Dr. John Baird, MD",
      "rawName": "John Baird",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "1500 DUARTE RD",
      "city": "Duarte",
      "state": "CA",
      "postalCode": "91010",
      "phone": "626-256-4673",
      "affiliation": "City of Hope Comprehensive Cancer Center"
    },
    {
      "npi": "1639210107",
      "name": "Dr. Aditya Bardia, MD",
      "rawName": "Aditya Bardia",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2336 SANTA MONICA BLVD STE 304",
      "city": "Santa monica",
      "state": "CA",
      "postalCode": "90404",
      "phone": "310-998-4747",
      "affiliation": "Regional Academic Oncology Network (Santa monica, CA)"
    },
    {
      "npi": "1265480412",
      "name": "Dr. Afsaneh Barzi, MD",
      "rawName": "Afsaneh Barzi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1441 EASTLAKE AVE",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90033",
      "phone": "323-865-3105",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1508146721",
      "name": "Dr. Reva Basho, MD",
      "rawName": "Reva Basho",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8700 BEVERLY BLVD",
      "city": "West hollywood",
      "state": "CA",
      "postalCode": "90048",
      "phone": "310-967-2700",
      "affiliation": "Regional Academic Oncology Network (West hollywood, CA)"
    },
    {
      "npi": "1770961575",
      "name": "Dr. Abinav Baweja, MD",
      "rawName": "Abinav Baweja",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5555 W LAS POSITAS BLVD",
      "city": "Pleasanton",
      "state": "CA",
      "postalCode": "94588",
      "phone": "925-416-5470",
      "affiliation": "Regional Academic Oncology Network (Pleasanton, CA)"
    },
    {
      "npi": "1164726378",
      "name": "Dr. Osagie Bello, MD",
      "rawName": "Osagie Bello",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "205 W LEGION RD",
      "city": "Brawley",
      "state": "CA",
      "postalCode": "92227",
      "phone": "760-351-3737",
      "affiliation": "Regional Academic Oncology Network (Brawley, CA)"
    },
    {
      "npi": "1235499518",
      "name": "Dr. Munveer Bhangoo, MD",
      "rawName": "Munveer Bhangoo",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10666 N TORREY PINES RD",
      "city": "La jolla",
      "state": "CA",
      "postalCode": "92037",
      "phone": "858-554-3200",
      "affiliation": "Regional Academic Oncology Network (La jolla, CA)"
    },
    {
      "npi": "1861955460",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2407 W VINE ST",
      "city": "Lodi",
      "state": "CA",
      "postalCode": "95242",
      "phone": "209-334-8585",
      "affiliation": "Regional Academic Oncology Network (Lodi, CA)"
    },
    {
      "npi": "1720831720",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2985 SYCAMORE DR",
      "city": "Simi valley",
      "state": "CA",
      "postalCode": "93065",
      "phone": "805-584-6611",
      "affiliation": "Regional Academic Oncology Network (Simi valley, CA)"
    },
    {
      "npi": "1124250642",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4032 WILSHIRE BLVD",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90010",
      "phone": "323-532-9308",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1750325973",
      "name": "Dr. Martin Allen-auerbach, MD",
      "rawName": "Martin Allen-auerbach",
      "credential": "MD",
      "specialty": "Nuclear Medicine",
      "taxonomyCode": "207U00000X",
      "practiceAddress": "200 UCLA MEDICAL PLZ STE B114",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90095",
      "phone": "310-794-1005",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1831697374",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1876 E SABIN DR STE 10",
      "city": "Casa grande",
      "state": "AZ",
      "postalCode": "85122",
      "phone": "520-836-1510",
      "affiliation": "Regional Academic Oncology Network (Casa grande, AZ)"
    },
    {
      "npi": "1487910774",
      "name": "Dr. Arya Amini, MD",
      "rawName": "Arya Amini",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1500 E. DUARTE ROAD",
      "city": "Duarte",
      "state": "CA",
      "postalCode": "91010",
      "phone": "626-256-4673",
      "affiliation": "City of Hope Comprehensive Cancer Center"
    },
    {
      "npi": "1043461437",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9055 E. DEL CAMINO",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85258",
      "phone": "480-922-4600",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1457521510",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "201 S ALVARADO ST",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90057",
      "phone": "213-484-7577",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1326238650",
      "name": "Dr. Robert Ash, MD",
      "rawName": "Robert Ash",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1000 W. LAVETA AVE.",
      "city": "Orange",
      "state": "CA",
      "postalCode": "92868",
      "phone": "714-734-6250",
      "affiliation": "Regional Academic Oncology Network (Orange, CA)"
    },
    {
      "npi": "1528470739",
      "name": "Dr. Katelyn Atkins, MD",
      "rawName": "Katelyn Atkins",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8700 BEVERLY BLVD",
      "city": "West hollywood",
      "state": "CA",
      "postalCode": "90048",
      "phone": "310-423-2178",
      "affiliation": "Regional Academic Oncology Network (West hollywood, CA)"
    }
  ],
  "illinois/chicago": [
    {
      "npi": "1316965320",
      "name": "Dr. Camille Abboud, MD",
      "rawName": "Camille Abboud",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4500 FOREST PARK AVE",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63108",
      "phone": "314-454-8304",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1649684200",
      "name": "Dr. Ramzi Abboud, MD",
      "rawName": "Ramzi Abboud",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 BARNES JEWISH HOSPITAL PLZ",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "314-454-8304",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1114183290",
      "name": "Dr. Syed Abutalib, MD",
      "rawName": "Syed Abutalib",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2900 W OKLAHOMA AVE",
      "city": "Milwaukee",
      "state": "WI",
      "postalCode": "53215",
      "phone": "414-649-6380",
      "affiliation": "Regional Academic Oncology Network (Milwaukee, WI)"
    },
    {
      "npi": "1346473345",
      "name": "Dr. Kalid Adab, MD",
      "rawName": "Kalid Adab",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2900 W OKLAHOMA AVE",
      "city": "Milwaukee",
      "state": "WI",
      "postalCode": "53215",
      "phone": "414-649-6380",
      "affiliation": "Regional Academic Oncology Network (Milwaukee, WI)"
    },
    {
      "npi": "1144780107",
      "name": "Dr. Jacob Adashek, DO",
      "rawName": "Jacob Adashek",
      "credential": "DO",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "W180N11070 RIVER LN",
      "city": "Germantown",
      "state": "WI",
      "postalCode": "53022",
      "phone": "262-532-9755",
      "affiliation": "Regional Academic Oncology Network (Germantown, WI)"
    },
    {
      "npi": "1083875538",
      "name": "Dr. Foluso Ademuyiwa, MD",
      "rawName": "Foluso Ademuyiwa",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4921 PARKVIEW PL",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "800-647-2098",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1164440616",
      "name": "Dr. Douglas Adkins, MD",
      "rawName": "Douglas Adkins",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4500 FOREST PARK AVE",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63108",
      "phone": "314-747-1171",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1831539808",
      "name": "Dr. Amber Afzal, MD",
      "rawName": "Amber Afzal",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4500 FOREST PARK AVE",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63108",
      "phone": "314-362-7216",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1093911307",
      "name": "Dr. Eugene Ahn, MD",
      "rawName": "Eugene Ahn",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2361 PAYSPHERE CIR",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60674",
      "phone": "847-746-4358",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1225567233",
      "name": "Dr. Talha Aijaz, MD",
      "rawName": "Talha Aijaz",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1497282115",
      "name": "Dr. Helen Ajufo, MD",
      "rawName": "Helen Ajufo",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4921 PARKVIEW PL",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "314-362-7216",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1376527739",
      "name": "Dr. Mebea Aklilu, MD",
      "rawName": "Mebea Aklilu",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "901 W WELLINGTON AVE",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60657",
      "phone": "773-296-7248",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1417182858",
      "name": "Dr. Andrea Amico, MD",
      "rawName": "Andrea Amico",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2160 S 1ST AVE",
      "city": "Maywood",
      "state": "IL",
      "postalCode": "60153",
      "phone": "708-216-9000",
      "affiliation": "Regional Academic Oncology Network (Maywood, IL)"
    },
    {
      "npi": "1265689889",
      "name": "Dr. Manik Amin, MD",
      "rawName": "Manik Amin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5841 S MARYLAND AVE",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60637",
      "phone": "773-702-1000",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1982196499",
      "name": "Dr. Nikolaos Andreatos, MD",
      "rawName": "Nikolaos Andreatos",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 BARNES JEWISH HOSPITAL PLZ",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "800-647-2098",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1205096609",
      "name": "Dr. Mohamed Abazeed, MD",
      "rawName": "Mohamed Abazeed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "251 E HURON ST",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60611",
      "phone": "312-926-5392",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1356317564",
      "name": "Dr. Ross Abrams, MD",
      "rawName": "Ross Abrams",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "520 S PAULINA ST",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60612",
      "phone": "312-942-0712",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1710205067",
      "name": "Dr. Maria Aguirre, MD",
      "rawName": "Maria Aguirre",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9201 CALUMET AVE",
      "city": "Munster",
      "state": "IN",
      "postalCode": "46321",
      "phone": "219-836-9024",
      "affiliation": "Regional Academic Oncology Network (Munster, IN)"
    },
    {
      "npi": "1285754895",
      "name": "Dr. Elke Aippersbach, MD",
      "rawName": "Elke Aippersbach",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4440 W 95TH ST",
      "city": "Oak lawn",
      "state": "IL",
      "postalCode": "60453",
      "phone": "708-684-5475",
      "affiliation": "Regional Academic Oncology Network (Oak lawn, IL)"
    },
    {
      "npi": "1063607125",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "15055 COLLECTION CENTER DR",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60693",
      "phone": "256-383-3325",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1144416389",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3411 MC INTOSH CIR",
      "city": "Joplin",
      "state": "MO",
      "postalCode": "64804",
      "phone": "417-782-3154",
      "affiliation": "Regional Academic Oncology Network (Joplin, MO)"
    },
    {
      "npi": "1669851424",
      "name": "Dr. Basel Altoos, MD",
      "rawName": "Basel Altoos",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4955 NORTON HEALTHCARE BLVD",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40241",
      "phone": "502-394-6350",
      "affiliation": "Regional Academic Oncology Network (Louisville, KY)"
    },
    {
      "npi": "1336554666",
      "name": "Dr. Sobiya Ansari, MD",
      "rawName": "Sobiya Ansari",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1653 W CONGRESS PKWY",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60612",
      "phone": "312-942-7774",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1457589681",
      "name": "Dr. Anthony Apicelli, MD",
      "rawName": "Anthony Apicelli",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4921 PARKVIEW PL",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "314-747-7236",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1235588344",
      "name": "Dr. Jessica Arden, MD",
      "rawName": "Jessica Arden",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "217 S MADISON ST",
      "city": "Traverse city",
      "state": "MI",
      "postalCode": "49684",
      "phone": "231-392-8400",
      "affiliation": "Regional Academic Oncology Network (Traverse city, MI)"
    }
  ],
  "pennsylvania/philadelphia": [
    {
      "npi": "1073803896",
      "name": "Dr. Peter Abdelmessieh, DO",
      "rawName": "Peter Abdelmessieh",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "16 EMERALD ROAD",
      "city": "Robbinsville",
      "state": "NJ",
      "postalCode": "08691",
      "phone": "212-434-2000",
      "affiliation": "Regional Academic Oncology Network (Robbinsville, NJ)"
    },
    {
      "npi": "1194713495",
      "name": "Dr. Maysa Abu-khalaf, MD",
      "rawName": "Maysa Abu-khalaf",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "925 CHESTNUT ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-8874",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1558538991",
      "name": "Dr. Seyfettin Alpdogan, MD",
      "rawName": "Seyfettin Alpdogan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "925 CHESTNUT ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-8874",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1043252455",
      "name": "Dr. Ravi Amaravadi, MD",
      "rawName": "Ravi Amaravadi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 CIVIC CENTER BLVD",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-615-5858",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1922340090",
      "name": "Dr. Fern Anari, MD",
      "rawName": "Fern Anari",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-2500",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1205877669",
      "name": "Dr. Charalambos Andreadis, MD",
      "rawName": "Charalambos Andreadis",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 SPRUCE ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-662-3914",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1992703516",
      "name": "Dr. Mariette Austin, MD",
      "rawName": "Mariette Austin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2003 FAIRVIEW AVE",
      "city": "Easton",
      "state": "PA",
      "postalCode": "18042",
      "phone": "484-821-1373",
      "affiliation": "Regional Academic Oncology Network (Easton, PA)"
    },
    {
      "npi": "1710193982",
      "name": "Dr. Tiffany Avery, MD",
      "rawName": "Tiffany Avery",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "925 CHESTNUT STREET",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-8874",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1881616126",
      "name": "Dr. Rita Axelrod, MD",
      "rawName": "Rita Axelrod",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "925 CHESTNUT ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-8874",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1558521054",
      "name": "Dr. Daria Babushok, MD",
      "rawName": "Daria Babushok",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3400 CIVIC CENTER BLVD FL 3",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-615-5858",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1477516888",
      "name": "Dr. Naomi Balzer, MD",
      "rawName": "Naomi Balzer",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 CIVIC CENTER BOULEVARD",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-615-5858",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1073892626",
      "name": "Dr. Babar Bashir, MD",
      "rawName": "Babar Bashir",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "909 WALNUT ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-7000",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1619139235",
      "name": "Dr. Jessica Bauman, MD",
      "rawName": "Jessica Bauman",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-6900",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1740449487",
      "name": "Dr. Joshua Bauml, MD",
      "rawName": "Joshua Bauml",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 SPRUCE STREET",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-615-5858",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1730242363",
      "name": "Dr. Gregory Beatty, MD",
      "rawName": "Gregory Beatty",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 CIVIC CENTER BOULEVARD",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-615-5858",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1487980157",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1200 OLD YORK RD",
      "city": "Abington",
      "state": "PA",
      "postalCode": "19001",
      "phone": "215-481-6253",
      "affiliation": "Regional Academic Oncology Network (Abington, PA)"
    },
    {
      "npi": "1265470850",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1200 OLD YORK RD",
      "city": "Abington",
      "state": "PA",
      "postalCode": "19001",
      "phone": "215-481-2800",
      "affiliation": "Regional Academic Oncology Network (Abington, PA)"
    },
    {
      "npi": "1316262363",
      "name": "Dr. Manuj Agarwal, MD",
      "rawName": "Manuj Agarwal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "333 COTTMAN AVENUE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-2581",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1710117106",
      "name": "Dr. Peter Ahn, MD",
      "rawName": "Peter Ahn",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3400 CIVIC CENTER BLVD",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-614-0392",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1831393800",
      "name": "Dr. Michelle Alonso-basanta, MD",
      "rawName": "Michelle Alonso-basanta",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3400 CIVIC CENTER BLVD",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-662-2428",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1811969868",
      "name": "Dr. Penny Anderson, MD",
      "rawName": "Penny Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-6900",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1982626321",
      "name": "Dr. Pramila Anne, MD",
      "rawName": "Pramila Anne",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "111 S 11TH ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-6702",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1477355725",
      "name": "Dr. Alyssa Asaro, MD",
      "rawName": "Alyssa Asaro",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "888-369-2427",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1972921062",
      "name": "Dr. Vladimir Avkshtol, MD",
      "rawName": "Vladimir Avkshtol",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-3016",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1346229705",
      "name": "Dr. Usha Babaria, MD",
      "rawName": "Usha Babaria",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "230 N BROAD ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19102",
      "phone": "215-762-8409",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    }
  ],
  "georgia/atlanta": [
    {
      "npi": "1134313273",
      "name": "Dr. Guillermo Abesada-terk, MD",
      "rawName": "Guillermo Abesada-terk",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "301 SE OCEAN BLVD",
      "city": "Stuart",
      "state": "FL",
      "postalCode": "34994",
      "phone": "772-287-4061",
      "affiliation": "Regional Academic Oncology Network (Stuart, FL)"
    },
    {
      "npi": "1639132269",
      "name": "Dr. Patrick Acevedo, MD",
      "rawName": "Patrick Acevedo",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1630 SE 18TH ST STE 602",
      "city": "Ocala",
      "state": "FL",
      "postalCode": "34471",
      "phone": "352-369-0181",
      "affiliation": "Regional Academic Oncology Network (Ocala, FL)"
    },
    {
      "npi": "1598766925",
      "name": "Dr. Farrukh Adhami, MD",
      "rawName": "Farrukh Adhami",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2514 E DUPONT RD STE 100",
      "city": "Fort wayne",
      "state": "IN",
      "postalCode": "46825",
      "phone": "260-484-8830",
      "affiliation": "Regional Academic Oncology Network (Fort wayne, IN)"
    },
    {
      "npi": "1700880697",
      "name": "Dr. Syed Ahmed, MD",
      "rawName": "Syed Ahmed",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1396 WHISPER CIR",
      "city": "Sebring",
      "state": "FL",
      "postalCode": "33870",
      "phone": "863-385-1244",
      "affiliation": "Regional Academic Oncology Network (Sebring, FL)"
    },
    {
      "npi": "1366435927",
      "name": "Dr. Geethanjali Akula, MD",
      "rawName": "Geethanjali Akula",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "70 W GORE ST STE 100",
      "city": "Orlando",
      "state": "FL",
      "postalCode": "32806",
      "phone": "407-426-8484",
      "affiliation": "Regional Academic Oncology Network (Orlando, FL)"
    },
    {
      "npi": "1841482270",
      "name": "Dr. Ahmed Al-hazzouri, MD",
      "rawName": "Ahmed Al-hazzouri",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1340 N HANCOCK RD",
      "city": "Clermont",
      "state": "FL",
      "postalCode": "34711",
      "phone": "352-394-1150",
      "affiliation": "Regional Academic Oncology Network (Clermont, FL)"
    },
    {
      "npi": "1922635432",
      "name": "Dr. Mina Aleksan, MD",
      "rawName": "Mina Aleksan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9320 STATE ROAD 54",
      "city": "Trinity",
      "state": "FL",
      "postalCode": "34655",
      "phone": "727-842-8411",
      "affiliation": "Regional Academic Oncology Network (Trinity, FL)"
    },
    {
      "npi": "1154302156",
      "name": "Dr. Jose Alemar, MD",
      "rawName": "Jose Alemar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3220 N MCMULLEN BOOTH RD STE C",
      "city": "Clearwater",
      "state": "FL",
      "postalCode": "33761",
      "phone": "727-223-7485",
      "affiliation": "Regional Academic Oncology Network (Clearwater, FL)"
    },
    {
      "npi": "1053631010",
      "name": "Dr. Olatunji Alese, MD",
      "rawName": "Olatunji Alese",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1365 CLIFTON RD NE",
      "city": "Atlanta",
      "state": "GA",
      "postalCode": "30322",
      "phone": "404-778-1900",
      "affiliation": "Regional Academic Oncology Network (Atlanta, GA)"
    },
    {
      "npi": "1306850508",
      "name": "Dr. Christopher Alexander, DO",
      "rawName": "Christopher Alexander",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "325 CLYDE MORRIS BLVD STE 450",
      "city": "Ormond beach",
      "state": "FL",
      "postalCode": "32174",
      "phone": "386-673-2442",
      "affiliation": "Regional Academic Oncology Network (Ormond beach, FL)"
    },
    {
      "npi": "1376868836",
      "name": "Dr. Pamela Allen, MD",
      "rawName": "Pamela Allen",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1365 CLIFTON RD NE STE 4000",
      "city": "Atlanta",
      "state": "GA",
      "postalCode": "30322",
      "phone": "404-778-1900",
      "affiliation": "Regional Academic Oncology Network (Atlanta, GA)"
    },
    {
      "npi": "1508353699",
      "name": "Dr. Yasir Alsaraf, MD",
      "rawName": "Yasir Alsaraf",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3402 W DR MARTIN LUTHER KING JR BLVD",
      "city": "Tampa",
      "state": "FL",
      "postalCode": "33607",
      "phone": "813-875-3950",
      "affiliation": "Regional Academic Oncology Network (Tampa, FL)"
    },
    {
      "npi": "1770549115",
      "name": "Dr. Roy Ambinder, MD",
      "rawName": "Roy Ambinder",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "106 BOSTON AVE STE 105",
      "city": "Altamonte springs",
      "state": "FL",
      "postalCode": "32701",
      "phone": "407-553-7710",
      "affiliation": "Regional Academic Oncology Network (Altamonte springs, FL)"
    },
    {
      "npi": "1245551134",
      "name": "Dr. Tadeu Ambros, MD",
      "rawName": "Tadeu Ambros",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1030 COMMERCE CREEK BLVD",
      "city": "Cape coral",
      "state": "FL",
      "postalCode": "33909",
      "phone": "239-772-3544",
      "affiliation": "Regional Academic Oncology Network (Cape coral, FL)"
    },
    {
      "npi": "1831624428",
      "name": "Dr. Bahaa Amer, MD",
      "rawName": "Bahaa Amer",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "600 N CATTLEMEN RD STE 200",
      "city": "Sarasota",
      "state": "FL",
      "postalCode": "34232",
      "phone": "941-377-9993",
      "affiliation": "Regional Academic Oncology Network (Sarasota, FL)"
    },
    {
      "npi": "1417944745",
      "name": "Dr. Andre Abitbol, MD",
      "rawName": "Andre Abitbol",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1730576455",
      "name": "Dr. Mustafa Abugideiri, MD",
      "rawName": "Mustafa Abugideiri",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1988 S 16TH ST",
      "city": "Wilmington",
      "state": "NC",
      "postalCode": "28401",
      "phone": "910-662-8440",
      "affiliation": "Regional Academic Oncology Network (Wilmington, NC)"
    },
    {
      "npi": "1720489362",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "525 N LEWIS ST",
      "city": "New iberia",
      "state": "LA",
      "postalCode": "70563",
      "phone": "337-364-1131",
      "affiliation": "Regional Academic Oncology Network (New iberia, LA)"
    },
    {
      "npi": "1316923014",
      "name": "Dr. Sanjeev Aggarwal, MD",
      "rawName": "Sanjeev Aggarwal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "7901 LAKE MANASSAS DR STE 100",
      "city": "Gainesville",
      "state": "VA",
      "postalCode": "20155",
      "phone": "540-829-8888",
      "affiliation": "Regional Academic Oncology Network (Gainesville, VA)"
    },
    {
      "npi": "1043743339",
      "name": "Dr. Hiba Ahmed, MD",
      "rawName": "Hiba Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "225 E WASHINGTON AVE",
      "city": "Jonesboro",
      "state": "AR",
      "postalCode": "72401",
      "phone": "870-207-8210",
      "affiliation": "Regional Academic Oncology Network (Jonesboro, AR)"
    },
    {
      "npi": "1659633915",
      "name": "Dr. Kamran Ahmed, MD",
      "rawName": "Kamran Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "12902 USF MAGNOLIA DR",
      "city": "Tampa",
      "state": "FL",
      "postalCode": "33612",
      "phone": "813-745-8535",
      "affiliation": "Regional Academic Oncology Network (Tampa, FL)"
    },
    {
      "npi": "1174691133",
      "name": "Dr. Robin Akins, MD",
      "rawName": "Robin Akins",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8019 S NEW BRAUNFELS STE 101",
      "city": "San antonio",
      "state": "TX",
      "postalCode": "78235",
      "phone": "210-981-3051",
      "affiliation": "Regional Academic Oncology Network (San antonio, TX)"
    },
    {
      "npi": "1013407675",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3670 GRANDVIEW PKWY #100",
      "city": "Birmingham",
      "state": "AL",
      "postalCode": "35243",
      "phone": "205-971-1800",
      "affiliation": "Regional Academic Oncology Network (Birmingham, AL)"
    },
    {
      "npi": "1396808010",
      "name": "Dr. Ahmed Ali, MD",
      "rawName": "Ahmed Ali",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2400 MT. ZION PARKWAY",
      "city": "Jonesboro",
      "state": "GA",
      "postalCode": "30236",
      "phone": "215-662-3957",
      "affiliation": "Regional Academic Oncology Network (Jonesboro, GA)"
    },
    {
      "npi": "1962686238",
      "name": "Dr. Arif Ali, MD",
      "rawName": "Arif Ali",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1200 MEMORIAL DR",
      "city": "Dalton",
      "state": "GA",
      "postalCode": "30720",
      "phone": "706-271-0100",
      "affiliation": "Regional Academic Oncology Network (Dalton, GA)"
    }
  ],
  "washington/seattle": [
    {
      "npi": "1003171976",
      "name": "Dr. Vyshak Alva venur, MD",
      "rawName": "Vyshak Alva venur",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "825 EASTLAKE AVE E",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-520-5700",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1184924870",
      "name": "Dr. Richard Ancheta, MD",
      "rawName": "Richard Ancheta",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1717 13TH ST",
      "city": "Everett",
      "state": "WA",
      "postalCode": "98201",
      "phone": "425-297-5500",
      "affiliation": "Regional Academic Oncology Network (Everett, WA)"
    },
    {
      "npi": "1144267766",
      "name": "Dr. Larry Anderson, MD",
      "rawName": "Larry Anderson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2201 INWOOD RD",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75235",
      "phone": "214-645-4673",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1356426183",
      "name": "Dr. Frederick Appelbaum, MD",
      "rawName": "Frederick Appelbaum",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "UNIVERSITY OF WASHINGTON MEDICAL CTR",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98195",
      "phone": "206-288-1000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1174849855",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "510A RAINIER AVE S",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98144",
      "phone": "206-686-1266",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1932285731",
      "name": "Dr. Anthony Back, MD",
      "rawName": "Anthony Back",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "AMBULATORY CLINIC",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-288-1000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1962777862",
      "name": "Dr. Charles Bagley, MD",
      "rawName": "Charles Bagley",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1235 8TH AVE W",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98119",
      "phone": "206-282-1578",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1255523775",
      "name": "Dr. Christina Baik, MD",
      "rawName": "Christina Baik",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "825 EASTLAKE AVE E",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-543-6420",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1992912224",
      "name": "Dr. Merav Bar, MD",
      "rawName": "Merav Bar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1959 NE PACIFIC ST",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98195",
      "phone": "206-520-5000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1922198886",
      "name": "Dr. William Bensinger, MD",
      "rawName": "William Bensinger",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "11311 BRIDGEPORT WAY SW STE 302",
      "city": "Lakewood",
      "state": "WA",
      "postalCode": "98499",
      "phone": "253-533-6700",
      "affiliation": "Regional Academic Oncology Network (Lakewood, WA)"
    },
    {
      "npi": "1225041791",
      "name": "Dr. Shailender Bhatia, MD",
      "rawName": "Shailender Bhatia",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "825 EASTLAKE AVE E",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-288-2015",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1073695227",
      "name": "Dr. Marie Bleakley, MD",
      "rawName": "Marie Bleakley",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4800 SAND POINT WAY NE",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98105",
      "phone": "206-288-1000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1902366677",
      "name": "Dr. Steven Blinka, MD",
      "rawName": "Steven Blinka",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "825 EASTLAKE AVE E",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-520-5000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1346683547",
      "name": "Dr. Mary Bolton, MD",
      "rawName": "Mary Bolton",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "9730 3RD AVE NE STE 208",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98115",
      "phone": "206-522-5646",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1992880991",
      "name": "Dr. Thomas Brown, MD",
      "rawName": "Thomas Brown",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1221 MADISON ST FL 2",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98104",
      "phone": "206-386-2323",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1417510900",
      "name": "Dr. Ahsen Ahmed, MD",
      "rawName": "Ahsen Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1959 NE PACIFIC ST.",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98195",
      "phone": "206-520-5000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1720512296",
      "name": "Dr. Saif Aljabab, MD",
      "rawName": "Saif Aljabab",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1959 NE PACIFIC ST",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98195",
      "phone": "206-598-5825",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1942478854",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3851 PIPER STREET",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99508",
      "phone": "907-212-3186",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1184839722",
      "name": "Dr. Smith Apisarnthanarax, MD",
      "rawName": "Smith Apisarnthanarax",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1570 N 115TH ST",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98133",
      "phone": "206-306-2804",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1194833780",
      "name": "Dr. Kasra Badiozamani, MD",
      "rawName": "Kasra Badiozamani",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "60 MEMORIAL MEDICAL PKWY",
      "city": "Palm coast",
      "state": "FL",
      "postalCode": "32164",
      "phone": "386-586-2060",
      "affiliation": "Regional Academic Oncology Network (Palm coast, FL)"
    },
    {
      "npi": "1629091483",
      "name": "Dr. Todd Barnett, MD",
      "rawName": "Todd Barnett",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1221 MADISON, 1ST FLOOR",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98104",
      "phone": "206-386-2323",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1720356090",
      "name": "Dr. Herbert Berry, MD",
      "rawName": "Herbert Berry",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "65 E. ROANOKE ST.",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98102",
      "phone": "206-323-0982",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1780656785",
      "name": "Dr. Sudershan Bhatia, MD",
      "rawName": "Sudershan Bhatia",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1595 NE PACIFIC ST",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98195",
      "phone": "206-520-5000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1710306592",
      "name": "Dr. Onita Bhattasali, MD",
      "rawName": "Onita Bhattasali",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4950 W SUNSET BLVD",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90027",
      "phone": "323-783-2841",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1194748715",
      "name": "Dr. John Blasko, MD",
      "rawName": "John Blasko",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1101 MADISON, SUITE 1101",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98104",
      "phone": "206-215-2480",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    }
  ],
  "ohio/cleveland": [
    {
      "npi": "1104244540",
      "name": "Dr. Asrar Alahmadi, MD",
      "rawName": "Asrar Alahmadi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "300 W 10TH AVE FL 2",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43210",
      "phone": "614-293-5066",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1023927803",
      "name": "Dr. Reham Ali, MD",
      "rawName": "Reham Ali",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-645-2238",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1174000707",
      "name": "Dr. Yasmin Arafah, MD",
      "rawName": "Yasmin Arafah",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "8326 NAAB RD",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46260",
      "phone": "317-871-0000",
      "affiliation": "Regional Academic Oncology Network (Indianapolis, IN)"
    },
    {
      "npi": "1740700194",
      "name": "Dr. Shimoli Barot, MD",
      "rawName": "Shimoli Barot",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-444-2200",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1528022282",
      "name": "Dr. Brian Bolwell, MD",
      "rawName": "Brian Bolwell",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "800-223-2273",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1457315673",
      "name": "Dr. G thomas Budd, MD",
      "rawName": "G thomas Budd",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "800-223-2273",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1508154345",
      "name": "Dr. Shruti Chaturvedi, MD",
      "rawName": "Shruti Chaturvedi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1800 ORLEANS STREET",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21205",
      "phone": "410-502-6686",
      "affiliation": "Johns Hopkins Sidney Kimmel Cancer Center"
    },
    {
      "npi": "1932594728",
      "name": "Dr. Lauren Chiec, MD",
      "rawName": "Lauren Chiec",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "11100 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-844-3951",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1407218704",
      "name": "Dr. Jacob Choi, MD",
      "rawName": "Jacob Choi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "251 E HURON ST",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60611",
      "phone": "312-695-6939",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1144586348",
      "name": "Dr. Christine Cordova, MD",
      "rawName": "Christine Cordova",
      "credential": "MD",
      "specialty": "Psychiatry & Neurology, Neurology",
      "taxonomyCode": "2084N0400X",
      "practiceAddress": "4500 SAN PABLO RD S",
      "city": "Jacksonville",
      "state": "FL",
      "postalCode": "32224",
      "phone": "904-953-2000",
      "affiliation": "Regional Academic Oncology Network (Jacksonville, FL)"
    },
    {
      "npi": "1316391253",
      "name": "Dr. Scott Dawsey, MD",
      "rawName": "Scott Dawsey",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4646 JOHN R ST",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48201",
      "phone": "313-576-1000",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1851491195",
      "name": "Dr. Marcos De lima, MD",
      "rawName": "Marcos De lima",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "11100 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-844-3951",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1306800735",
      "name": "Dr. Robert Dean, MD",
      "rawName": "Robert Dean",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "800-223-2273",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1326797218",
      "name": "Dr. Chaim Domb, MD",
      "rawName": "Chaim Domb",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2500 METROHEALTH DR",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44109",
      "phone": "216-778-4486",
      "affiliation": "Regional Academic Oncology Network (Cleveland, OH)"
    },
    {
      "npi": "1841188042",
      "name": "Dr. Sonia margarida Duarte de oliveira, MD",
      "rawName": "Sonia margarida Duarte de oliveira",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "11100 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-844-3293",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1205096609",
      "name": "Dr. Mohamed Abazeed, MD",
      "rawName": "Mohamed Abazeed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "251 E HURON ST",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60611",
      "phone": "312-926-5392",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1982620340",
      "name": "Dr. May Abdel-wahab, MD",
      "rawName": "May Abdel-wahab",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-445-7930",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1013438571",
      "name": "Dr. Ibrahim Abugheida, MD",
      "rawName": "Ibrahim Abugheida",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-444-2200",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1437675741",
      "name": "Dr. Salem Alfaifi, MD",
      "rawName": "Salem Alfaifi",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "10201 CARNEGIE AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-312-6671",
      "affiliation": "Regional Academic Oncology Network (Cleveland, OH)"
    },
    {
      "npi": "1932366267",
      "name": "Dr. Sudha Amarnath, MD",
      "rawName": "Sudha Amarnath",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "617-251-5421",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1003858234",
      "name": "Dr. Thomas Anderson, DO",
      "rawName": "Thomas Anderson",
      "credential": "DO",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5200 W BROAD ST",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43228",
      "phone": "614-544-1930",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1104867357",
      "name": "Dr. Nami Azar, MD",
      "rawName": "Nami Azar",
      "credential": "MD",
      "specialty": "Radiology, Diagnostic Radiology",
      "taxonomyCode": "2085R0202X",
      "practiceAddress": "11100 EUCLID AVENUE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-844-7200",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1710229117",
      "name": "Dr. Ehsan Balagamwala, MD",
      "rawName": "Ehsan Balagamwala",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-444-2200",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1932146800",
      "name": "Dr. Barbara Bangert, MD",
      "rawName": "Barbara Bangert",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085N0700X",
      "practiceAddress": "11100 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-844-1700",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1194717934",
      "name": "Dr. Fredrick Barton, MD",
      "rawName": "Fredrick Barton",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "11100 EUCLID AVENUE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "440-324-0440",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    }
  ],
  "maryland/baltimore": [
    {
      "npi": "1881805166",
      "name": "Dr. Nagla Abdel karim, MD",
      "rawName": "Nagla Abdel karim",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8081 INNOVATION PARK DR",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22031",
      "phone": "571-472-4724",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1528446242",
      "name": "Dr. Jafar Al-mondhiry, MD",
      "rawName": "Jafar Al-mondhiry",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8081 INNOVATION PARK DR",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22031",
      "phone": "571-472-1190",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1356565501",
      "name": "Dr. Syed abbas Ali, MD",
      "rawName": "Syed abbas Ali",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 HIGHWAY 78 E",
      "city": "Jasper",
      "state": "AL",
      "postalCode": "35501",
      "phone": "205-387-4401",
      "affiliation": "Regional Academic Oncology Network (Jasper, AL)"
    },
    {
      "npi": "1942628458",
      "name": "Dr. Joshua Allen, MD",
      "rawName": "Joshua Allen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3580 JOSEPH SIEWICK DR STE 403",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22033",
      "phone": "703-391-4395",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1629411558",
      "name": "Dr. Alexander Ambinder, MD",
      "rawName": "Alexander Ambinder",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1650 ORLEANS ST # 1186",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-614-4459",
      "affiliation": "Johns Hopkins Sidney Kimmel Cancer Center"
    },
    {
      "npi": "1528022407",
      "name": "Dr. Richard Ambinder, MD",
      "rawName": "Richard Ambinder",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "600 N WOLFE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-8964",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1164089843",
      "name": "Dr. Amir Ameri, MD",
      "rawName": "Amir Ameri",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1800 ORLEANS ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-5000",
      "affiliation": "Johns Hopkins Sidney Kimmel Cancer Center"
    },
    {
      "npi": "1043841059",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "9160 FORUM CORPORATE PKWY STE 350",
      "city": "Fort myers",
      "state": "FL",
      "postalCode": "33905",
      "phone": "239-785-3200",
      "affiliation": "Regional Academic Oncology Network (Fort myers, FL)"
    },
    {
      "npi": "1629865126",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "5233 KING AVE STE 308",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21237",
      "phone": "410-780-4050",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1821314030",
      "name": "Dr. Valsamo Anagnostou, MD",
      "rawName": "Valsamo Anagnostou",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1650 ORLEANS STREET",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21231",
      "phone": "410-955-8893",
      "affiliation": "Johns Hopkins Sidney Kimmel Cancer Center"
    },
    {
      "npi": "1568528768",
      "name": "Dr. Emmanuel Antonarakis, MD",
      "rawName": "Emmanuel Antonarakis",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "909 FULTON ST SE",
      "city": "Minneapolis",
      "state": "MN",
      "postalCode": "55455",
      "phone": "612-672-6000",
      "affiliation": "Regional Academic Oncology Network (Minneapolis, MN)"
    },
    {
      "npi": "1619211745",
      "name": "Dr. Khurram Anwar, MD",
      "rawName": "Khurram Anwar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3580 JOSEPH SIEWICK DR STE 403",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22033",
      "phone": "703-391-4395",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1376701946",
      "name": "Dr. Jeanny Aragon-ching, MD",
      "rawName": "Jeanny Aragon-ching",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3300 GALLOWS RD",
      "city": "Falls church",
      "state": "VA",
      "postalCode": "22042",
      "phone": "703-776-4001",
      "affiliation": "Regional Academic Oncology Network (Falls church, VA)"
    },
    {
      "npi": "1588628390",
      "name": "Dr. Mary Armanios, MD",
      "rawName": "Mary Armanios",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "600 N WOLFE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-8964",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1437113255",
      "name": "Dr. Deborah Armstrong, MD",
      "rawName": "Deborah Armstrong",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10755 FALLS RD",
      "city": "Lutherville",
      "state": "MD",
      "postalCode": "21093",
      "phone": "410-583-2970",
      "affiliation": "Regional Academic Oncology Network (Lutherville, MD)"
    },
    {
      "npi": "1639436603",
      "name": "Dr. Sahaja Acharya, MD",
      "rawName": "Sahaja Acharya",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "600 N WOLFE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-5000",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1871813204",
      "name": "Dr. Sara Alcorn, MD",
      "rawName": "Sara Alcorn",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4940 EASTERN AVE",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21224",
      "phone": "410-955-7390",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1215961727",
      "name": "Dr. Pradip Amin, MD",
      "rawName": "Pradip Amin",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "22 S GREENE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21201",
      "phone": "410-328-3037",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1841439908",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1701 N GEORGE MASON DR",
      "city": "Arlington",
      "state": "VA",
      "postalCode": "22205",
      "phone": "703-558-6284",
      "affiliation": "Regional Academic Oncology Network (Arlington, VA)"
    },
    {
      "npi": "1073578837",
      "name": "Dr. Fariba Asrari, MD",
      "rawName": "Fariba Asrari",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "600 N WOLFE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-8964",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1174528798",
      "name": "Dr. Cengiz Aygun, MD",
      "rawName": "Cengiz Aygun",
      "credential": "MD",
      "specialty": "Specialist",
      "taxonomyCode": "174400000X",
      "practiceAddress": "9105 FRANKLIN SQUARE DR",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21237",
      "phone": "410-682-6800",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1881213007",
      "name": "Dr. Khaled Aziz, MD",
      "rawName": "Khaled Aziz",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    },
    {
      "npi": "1376163154",
      "name": "Dr. Soha Bazyar, MD",
      "rawName": "Soha Bazyar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2401 W BELVEDERE AVE",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21215",
      "phone": "410-601-5689",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1407485519",
      "name": "Dr. Akrita Bhatnagar, MD",
      "rawName": "Akrita Bhatnagar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9000 FRANKLIN SQUARE DR DEPT OF",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21237",
      "phone": "443-777-7771",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1205837390",
      "name": "Dr. Albert Blumberg, MD",
      "rawName": "Albert Blumberg",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "6701 N CHARLES ST",
      "city": "Towson",
      "state": "MD",
      "postalCode": "21204",
      "phone": "443-849-2540",
      "affiliation": "Regional Academic Oncology Network (Towson, MD)"
    }
  ],
  "texas/dallas": [
    {
      "npi": "1033567409",
      "name": "Dr. Seyed Abedi, MD",
      "rawName": "Seyed Abedi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1401 MEDICAL PKWY STE 200",
      "city": "Cedar park",
      "state": "TX",
      "postalCode": "78613",
      "phone": "512-260-6050",
      "affiliation": "Regional Academic Oncology Network (Cedar park, TX)"
    },
    {
      "npi": "1326288564",
      "name": "Dr. Laith Abushahin, MD",
      "rawName": "Laith Abushahin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3410 WORTH ST STE 400",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75246",
      "phone": "214-370-1000",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1548262900",
      "name": "Dr. John Adams, DO",
      "rawName": "John Adams",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "906 W RANDOL MILL RD",
      "city": "Arlington",
      "state": "TX",
      "postalCode": "76012",
      "phone": "817-261-0929",
      "affiliation": "Regional Academic Oncology Network (Arlington, TX)"
    },
    {
      "npi": "1740484336",
      "name": "Dr. Prashanth Adapala, MD",
      "rawName": "Prashanth Adapala",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "800 W HIGHWAY 71",
      "city": "Marble falls",
      "state": "TX",
      "postalCode": "78654",
      "phone": "512-901-4008",
      "affiliation": "Regional Academic Oncology Network (Marble falls, TX)"
    },
    {
      "npi": "1801837497",
      "name": "Dr. Ashwani Agarwal, MD",
      "rawName": "Ashwani Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3555 W WHEATLAND RD",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75237",
      "phone": "972-709-2580",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1386867448",
      "name": "Dr. Sachin Agarwal, MD",
      "rawName": "Sachin Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 SCOTT AND WHITE DR",
      "city": "College station",
      "state": "TX",
      "postalCode": "77845",
      "phone": "979-207-4000",
      "affiliation": "Regional Academic Oncology Network (College station, TX)"
    },
    {
      "npi": "1871531350",
      "name": "Dr. Edward Agura, MD",
      "rawName": "Edward Agura",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3410 WORTH ST",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75246",
      "phone": "214-370-1513",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1861802332",
      "name": "Dr. Shane Ahlers, MD",
      "rawName": "Shane Ahlers",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "100 E IDAHO ST",
      "city": "Boise",
      "state": "ID",
      "postalCode": "83712",
      "phone": "208-381-2711",
      "affiliation": "Regional Academic Oncology Network (Boise, ID)"
    },
    {
      "npi": "1578773511",
      "name": "Dr. Cristi Aitelli, DO",
      "rawName": "Cristi Aitelli",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6500 HARRIS PKWY",
      "city": "Fort worth",
      "state": "TX",
      "postalCode": "76132",
      "phone": "817-346-6748",
      "affiliation": "Regional Academic Oncology Network (Fort worth, TX)"
    },
    {
      "npi": "1124060124",
      "name": "Dr. Syed Akhtar, MD",
      "rawName": "Syed Akhtar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3010 HARRISON AVE",
      "city": "Beaumont",
      "state": "TX",
      "postalCode": "77702",
      "phone": "409-899-7180",
      "affiliation": "Regional Academic Oncology Network (Beaumont, TX)"
    },
    {
      "npi": "1508285313",
      "name": "Dr. Salwan Al mutar, MD",
      "rawName": "Salwan Al mutar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2201 INWOOD RD 2ND FLOOR",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75390",
      "phone": "214-645-4673",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1114341716",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "1222 BELLEAU DR",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75208",
      "phone": "214-724-0338",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1205060746",
      "name": "Dr. Miguel Albino, MD",
      "rawName": "Miguel Albino",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "12221 RENFERT WAY STE 300",
      "city": "Austin",
      "state": "TX",
      "postalCode": "78758",
      "phone": "512-873-8900",
      "affiliation": "Regional Academic Oncology Network (Austin, TX)"
    },
    {
      "npi": "1073712709",
      "name": "Dr. Nitya Alluri, MD",
      "rawName": "Nitya Alluri",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "901 W 38TH ST STE 300",
      "city": "Austin",
      "state": "TX",
      "postalCode": "78705",
      "phone": "512-421-4100",
      "affiliation": "Regional Academic Oncology Network (Austin, TX)"
    },
    {
      "npi": "1306923180",
      "name": "Dr. Maria Aloba, MD",
      "rawName": "Maria Aloba",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3270 JOE BATTLE BLVD STE 312",
      "city": "El paso",
      "state": "TX",
      "postalCode": "79938",
      "phone": "915-747-4877",
      "affiliation": "Regional Academic Oncology Network (El paso, TX)"
    },
    {
      "npi": "1265574263",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1304 WONDER WORLD DR",
      "city": "San marcos",
      "state": "TX",
      "postalCode": "78666",
      "phone": "512-396-2500",
      "affiliation": "Regional Academic Oncology Network (San marcos, TX)"
    },
    {
      "npi": "1386938371",
      "name": "Dr. Mirna Abboud, MD",
      "rawName": "Mirna Abboud",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "501 W MEDICAL CENTER BLVD",
      "city": "Webster",
      "state": "TX",
      "postalCode": "77598",
      "phone": "281-332-7505",
      "affiliation": "Regional Academic Oncology Network (Webster, TX)"
    },
    {
      "npi": "1851702831",
      "name": "Dr. Awad Ahmed, MD",
      "rawName": "Awad Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2121 PEASE ST STE 101",
      "city": "Harlingen",
      "state": "TX",
      "postalCode": "78550",
      "phone": "956-425-8845",
      "affiliation": "Regional Academic Oncology Network (Harlingen, TX)"
    },
    {
      "npi": "1871856914",
      "name": "Dr. Mani Akhtari, MD",
      "rawName": "Mani Akhtari",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "500 S HENDERSON ST STE 200",
      "city": "Fort worth",
      "state": "TX",
      "postalCode": "76104",
      "phone": "817-413-1500",
      "affiliation": "Regional Academic Oncology Network (Fort worth, TX)"
    },
    {
      "npi": "1457338329",
      "name": "Dr. Kevin Albuquerque, MD",
      "rawName": "Kevin Albuquerque",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5323 HARRY HINES BLVD",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75390",
      "phone": "214-645-8525",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1821592791",
      "name": "Dr. Hayden Ansinelli, MD",
      "rawName": "Hayden Ansinelli",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1845 W ORANGE GROVE RD BLDG 1",
      "city": "Tucson",
      "state": "AZ",
      "postalCode": "85704",
      "phone": "352-401-8311",
      "affiliation": "Regional Academic Oncology Network (Tucson, AZ)"
    },
    {
      "npi": "1265675854",
      "name": "Dr. Daniel Arsenault, MD",
      "rawName": "Daniel Arsenault",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1751 WALLACE BLVD",
      "city": "Amarillo",
      "state": "TX",
      "postalCode": "79106",
      "phone": "806-212-4673",
      "affiliation": "Regional Academic Oncology Network (Amarillo, TX)"
    },
    {
      "npi": "1669859377",
      "name": "Dr. Ritu Arya, MD",
      "rawName": "Ritu Arya",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "906 W RANDOL MILL RD STE 200",
      "city": "Arlington",
      "state": "TX",
      "postalCode": "76012",
      "phone": "817-664-9600",
      "affiliation": "Regional Academic Oncology Network (Arlington, TX)"
    },
    {
      "npi": "1497793814",
      "name": "Dr. Kin Au, MD",
      "rawName": "Kin Au",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1415 SANTA FE ST",
      "city": "Corpus christi",
      "state": "TX",
      "postalCode": "78404",
      "phone": "361-861-9760",
      "affiliation": "Regional Academic Oncology Network (Corpus christi, TX)"
    },
    {
      "npi": "1184604902",
      "name": "Dr. Yadvindera Bains, MD",
      "rawName": "Yadvindera Bains",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "800 SCOTT AND WHITE DR",
      "city": "College station",
      "state": "TX",
      "postalCode": "77845",
      "phone": "979-207-4000",
      "affiliation": "Regional Academic Oncology Network (College station, TX)"
    }
  ],
  "florida/miami": [
    {
      "npi": "1356385140",
      "name": "Dr. Bach Ardalan, MD",
      "rawName": "Bach Ardalan",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1475 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-1000",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1780229047",
      "name": "Dr. Kyaw Aung, MD",
      "rawName": "Kyaw Aung",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1417451667",
      "name": "Dr. Priscila Barreto coelho, MD",
      "rawName": "Priscila Barreto coelho",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1611 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-915-1103",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1528095775",
      "name": "Dr. Pasquale Benedetto, MD",
      "rawName": "Pasquale Benedetto",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1611 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-4664",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1447347851",
      "name": "Dr. Aron Berkman, MD",
      "rawName": "Aron Berkman",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 SW 108TH AVE STE 100",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33174",
      "phone": "786-595-0000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1184884090",
      "name": "Dr. Marijo Bilusic, MD",
      "rawName": "Marijo Bilusic",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1120 NW 14TH ST STE 610B",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-9779",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1770729543",
      "name": "Dr. Lauren Carcas, MD",
      "rawName": "Lauren Carcas",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6738 W SUNRISE BLVD STE 103",
      "city": "Plantation",
      "state": "FL",
      "postalCode": "33313",
      "phone": "954-837-1490",
      "affiliation": "Regional Academic Oncology Network (Plantation, FL)"
    },
    {
      "npi": "1306010590",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8740 SW 88TH ST",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "305-271-1515",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1902193147",
      "name": "Dr. Aman Chauhan, MD",
      "rawName": "Aman Chauhan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1825 4TH ST FL 4",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-9888",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1871720235",
      "name": "Dr. Zhijian Chen, MD",
      "rawName": "Zhijian Chen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1619292406",
      "name": "Dr. Anthony Daniyan, MD",
      "rawName": "Anthony Daniyan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-3007",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1144454257",
      "name": "Dr. Nicole Eiseler, MD",
      "rawName": "Nicole Eiseler",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8900 N. KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1659624856",
      "name": "Dr. Firas El chaer, MD",
      "rawName": "Firas El chaer",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1649233370",
      "name": "Dr. Donald Ernst, MD",
      "rawName": "Donald Ernst",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1611 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-6484",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1467820837",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "78 SW 13TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33135",
      "phone": "305-642-6966",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1417944745",
      "name": "Dr. Andre Abitbol, MD",
      "rawName": "Andre Abitbol",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1295993699",
      "name": "Dr. Matthew Abramowitz, MD",
      "rawName": "Matthew Abramowitz",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1475 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-4200",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1891056495",
      "name": "Dr. Bret Adams, MD",
      "rawName": "Bret Adams",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2013 JEFFERSON ST SW FL 2",
      "city": "Roanoke",
      "state": "VA",
      "postalCode": "24014",
      "phone": "540-982-0237",
      "affiliation": "Regional Academic Oncology Network (Roanoke, VA)"
    },
    {
      "npi": "1245296904",
      "name": "Dr. Ahmed Akl, MD",
      "rawName": "Ahmed Akl",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "803 W MARKET ST STE 100",
      "city": "Lima",
      "state": "OH",
      "postalCode": "45805",
      "phone": "419-996-5063",
      "affiliation": "Regional Academic Oncology Network (Lima, OH)"
    },
    {
      "npi": "1073511333",
      "name": "Dr. Beatriz Amendola, MD",
      "rawName": "Beatriz Amendola",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5995 SW 71ST ST STE 1-A",
      "city": "South miami",
      "state": "FL",
      "postalCode": "33143",
      "phone": "305-669-6833",
      "affiliation": "Regional Academic Oncology Network (South miami, FL)"
    },
    {
      "npi": "1629903018",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiology, Diagnostic Radiology",
      "taxonomyCode": "2085R0202X",
      "practiceAddress": "13155 SW 134TH ST STE 204",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33186",
      "phone": "786-839-0862",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1417516600",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1100 N.W. 95TH STREET",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33150",
      "phone": "305-835-6173",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1861870636",
      "name": "Dr. Gregory Azzam, MD",
      "rawName": "Gregory Azzam",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1611 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-4200",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1679978118",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1548707458",
      "name": "Dr. Jonathan Bell, MD",
      "rawName": "Jonathan Bell",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1611 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-4200",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    }
  ],
  "california/san-francisco": [
    {
      "npi": "1679530018",
      "name": "Dr. Donald Abrams, MD",
      "rawName": "Donald Abrams",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1701 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-7720",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1649346842",
      "name": "Dr. Weiyun Ai, MD",
      "rawName": "Weiyun Ai",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "400 PARNASSUS AVE",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-2737",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1659637452",
      "name": "Dr. Luai Al rabadi, MD",
      "rawName": "Luai Al rabadi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1825 4TH STREET",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94158",
      "phone": "415-353-9888",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1326058777",
      "name": "Dr. Chloe Atreya, MD",
      "rawName": "Chloe Atreya",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1600 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-9888",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1225529928",
      "name": "Dr. Hemali Batra-sharma, MD",
      "rawName": "Hemali Batra-sharma",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1825 4TH ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-7070",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1538418298",
      "name": "Dr. Mark Benyunes, MD",
      "rawName": "Mark Benyunes",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 DNA WAY",
      "city": "South san francisco",
      "state": "CA",
      "postalCode": "94080",
      "phone": "650-225-1628",
      "affiliation": "Regional Academic Oncology Network (South san francisco, CA)"
    },
    {
      "npi": "1457381014",
      "name": "Dr. Christopher Benz, MD",
      "rawName": "Christopher Benz",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1600 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-7070",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1295792729",
      "name": "Dr. Emily Bergsland, MD",
      "rawName": "Emily Bergsland",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1600 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-9888",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1942236997",
      "name": "Dr. John Berry, MD",
      "rawName": "John Berry",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1600 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-7100",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1093861346",
      "name": "Dr. Trever Bivona, MD",
      "rawName": "Trever Bivona",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1600 DIVISADERO STREET, 4TH FLOOR",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-7160",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1235312323",
      "name": "Dr. Robert Bok, MD",
      "rawName": "Robert Bok",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1700 4TH ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94158",
      "phone": "415-514-9716",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1932914926",
      "name": "Dr. Guus Bol, MD",
      "rawName": "Guus Bol",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1975 4TH ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-3000",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1477571347",
      "name": "Dr. Pamela Bolyanatz, MD",
      "rawName": "Pamela Bolyanatz",
      "credential": "MD",
      "specialty": "Nurse Practitioner, Family",
      "taxonomyCode": "363LF0000X",
      "practiceAddress": "3035 BOOK RD",
      "city": "Naperville",
      "state": "IL",
      "postalCode": "60564",
      "phone": "630-319-1962",
      "affiliation": "Regional Academic Oncology Network (Naperville, IL)"
    },
    {
      "npi": "1710140850",
      "name": "Dr. Rohit Bose, MD",
      "rawName": "Rohit Bose",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1825 4TH ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-476-4616",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1134330988",
      "name": "Dr. Edward Cha, MD",
      "rawName": "Edward Cha",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "505 PARNASSUS AVE",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-885-7276",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1811988421",
      "name": "Dr. Roy Abendroth, MD",
      "rawName": "Roy Abendroth",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2333 BUCHANAN ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "209-342-2300",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1992394811",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "900 HYDE ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94109",
      "phone": "415-353-6420",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1215161211",
      "name": "Dr. Moshiur Anwar, MD",
      "rawName": "Moshiur Anwar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1825 4TH ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94158",
      "phone": "415-353-7175",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1811105943",
      "name": "Dr. Igor Barani, MD",
      "rawName": "Igor Barani",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "350 W THOMAS RD",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-406-6761",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1679990071",
      "name": "Dr. Lauren Boreta, MD",
      "rawName": "Lauren Boreta",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1600 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-443-0283",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1760610141",
      "name": "Dr. Steve Braunstein, MD",
      "rawName": "Steve Braunstein",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1600 DIVISADERO ST, SUITE H1031",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-7175",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1033536917",
      "name": "Dr. Jason Chan, MD",
      "rawName": "Jason Chan",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1600 DIVISADERO STREET",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-7175",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1861079592",
      "name": "Dr. Enoch Chang, MD",
      "rawName": "Enoch Chang",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1902897515",
      "name": "Dr. Barry Chauser, MD",
      "rawName": "Barry Chauser",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2333 BUCHANAN ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "209-342-2300",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1912433632",
      "name": "Dr. Victor Chen, MD",
      "rawName": "Victor Chen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1600 DIVISADERO ST # H1031",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-7175",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    }
  ],
  "arizona/phoenix": [
    {
      "npi": "1548431042",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3411 N 5TH AVE",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-248-0448",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1750511051",
      "name": "Dr. Rishi Agarwal, MD",
      "rawName": "Rishi Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10460 N 92ND ST STE 400",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85258",
      "phone": "623-238-7630",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1609187921",
      "name": "Dr. Nazish Ahmad, DO",
      "rawName": "Nazish Ahmad",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5601 W EUGIE AVE",
      "city": "Glendale",
      "state": "AZ",
      "postalCode": "85304",
      "phone": "602-978-6255",
      "affiliation": "Regional Academic Oncology Network (Glendale, AZ)"
    },
    {
      "npi": "1063036135",
      "name": "Dr. Isaak Ailts, MD",
      "rawName": "Isaak Ailts",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "701-234-6161",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1154369577",
      "name": "Dr. Waqas Arslan, MD",
      "rawName": "Waqas Arslan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2525 E ROOSEVELT ST",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85008",
      "phone": "602-344-1015",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1881733889",
      "name": "Dr. John Bibb, MD",
      "rawName": "John Bibb",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10460 N 92ND ST # 200-400",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85258",
      "phone": "623-238-7630",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1275910911",
      "name": "Dr. Gehan Botrus, MD",
      "rawName": "Gehan Botrus",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "4800 ALBERTA AVE",
      "city": "El paso",
      "state": "TX",
      "postalCode": "79905",
      "phone": "915-215-8000",
      "affiliation": "Regional Academic Oncology Network (El paso, TX)"
    },
    {
      "npi": "1801397658",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2915 W ROSE GARDEN LN",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85027",
      "phone": "623-932-8960",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1720293608",
      "name": "Dr. Tania Cortas, MD",
      "rawName": "Tania Cortas",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "11209 N TATUM BLVD STE 200",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85028",
      "phone": "480-530-4200",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1265765374",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2525 E ROOSEVELT ST",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85008",
      "phone": "602-344-1095",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1396735585",
      "name": "Dr. Panagiotis Fidias, MD",
      "rawName": "Panagiotis Fidias",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5 ALUMNI DR",
      "city": "Exeter",
      "state": "NH",
      "postalCode": "03833",
      "phone": "603-580-7054",
      "affiliation": "Regional Academic Oncology Network (Exeter, NH)"
    },
    {
      "npi": "1093008336",
      "name": "Dr. Amber Flaherty, MD",
      "rawName": "Amber Flaherty",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "11209 N TATUM BLVD STE B200",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85028",
      "phone": "480-530-4200",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1831167402",
      "name": "Dr. David Garfield, MD",
      "rawName": "David Garfield",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2601 N SPRUCE ST",
      "city": "Ogallala",
      "state": "NE",
      "postalCode": "69153",
      "phone": "308-284-3645",
      "affiliation": "Regional Academic Oncology Network (Ogallala, NE)"
    },
    {
      "npi": "1558724013",
      "name": "Dr. Charles Gaulin, MD",
      "rawName": "Charles Gaulin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Lebanon",
      "state": "NH",
      "postalCode": "03756",
      "phone": "603-650-5000",
      "affiliation": "Regional Academic Oncology Network (Lebanon, NH)"
    },
    {
      "npi": "1548609910",
      "name": "Dr. Safia Ahmed, MD",
      "rawName": "Safia Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "13400 E SHEA BLVD",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85259",
      "phone": "072-842-5115",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1902645823",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5925 KISSENA BLVD STE 800",
      "city": "Flushing",
      "state": "NY",
      "postalCode": "11355",
      "phone": "347-428-1020",
      "affiliation": "Regional Academic Oncology Network (Flushing, NY)"
    },
    {
      "npi": "1699426445",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1445 W CHANDLER BLVD STE A5",
      "city": "Chandler",
      "state": "AZ",
      "postalCode": "85224",
      "phone": "480-360-4009",
      "affiliation": "Regional Academic Oncology Network (Chandler, AZ)"
    },
    {
      "npi": "1750683710",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "350 W THOMAS RD",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-406-3170",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1972628675",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "300 W CLARENDON",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-274-4484",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1922203728",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "300 W CLARENDON AVE",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-240-3395",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1083066450",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "16620 N 40TH ST",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85032",
      "phone": "602-396-0851",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1174434823",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "18250 N HAYDEN RD",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85255",
      "phone": "480-771-2744",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1811105943",
      "name": "Dr. Igor Barani, MD",
      "rawName": "Igor Barani",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "350 W THOMAS RD",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-406-6761",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    }
  ],
  "colorado/denver": [
    {
      "npi": "1588176051",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "499 E HAMPDEN AVE STE 450",
      "city": "Englewood",
      "state": "CO",
      "postalCode": "80113",
      "phone": "720-389-7749",
      "affiliation": "Regional Academic Oncology Network (Englewood, CO)"
    },
    {
      "npi": "1942356530",
      "name": "Dr. Eamon Berge, MD",
      "rawName": "Eamon Berge",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2045 N FRANKLIN ST",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80205",
      "phone": "303-338-4545",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1346287968",
      "name": "Dr. Laurie Carr, MD",
      "rawName": "Laurie Carr",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1400 JACKSON ST",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80206",
      "phone": "303-388-4461",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1316957368",
      "name": "Dr. Ping Chu, MD",
      "rawName": "Ping Chu",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2555 S DOWNING ST STE 240",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80210",
      "phone": "303-715-7030",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1124603816",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1601 E 19TH AVE STE 3550",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "720-316-8091",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1477643153",
      "name": "Dr. Harry Drabkin, MD",
      "rawName": "Harry Drabkin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "171 ASHLEY AVE",
      "city": "Charleston",
      "state": "SC",
      "postalCode": "29425",
      "phone": "843-792-4271",
      "affiliation": "Regional Academic Oncology Network (Charleston, SC)"
    },
    {
      "npi": "1366541294",
      "name": "Dr. Gerald Falchook, MD",
      "rawName": "Gerald Falchook",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1800 WILLIAMS ST",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "720-754-2610",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1588290332",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1800 N WILLIAMS ST STE 300",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "720-754-2610",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1508491606",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1719 E 19TH AVE",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "303-839-6000",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1851301881",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2005 FRANKLIN ST STE 170",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80205",
      "phone": "303-860-9100",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1790642338",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1818 N OGDEN ST STE 200",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "303-318-3434",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1841454048",
      "name": "Dr. Sudy Jahangiri, MD",
      "rawName": "Sudy Jahangiri",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1818 N OGDEN ST STE 200",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "303-318-3434",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1518109420",
      "name": "Dr. Ghayathri Jeyakumar, MD",
      "rawName": "Ghayathri Jeyakumar",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4623 160TH ST",
      "city": "Flushing",
      "state": "NY",
      "postalCode": "11358",
      "phone": "310-357-9793",
      "affiliation": "Regional Academic Oncology Network (Flushing, NY)"
    },
    {
      "npi": "1700876992",
      "name": "Dr. Christopher Jones, MD",
      "rawName": "Christopher Jones",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "9451 HURON ST",
      "city": "Thornton",
      "state": "CO",
      "postalCode": "80260",
      "phone": "303-650-4042",
      "affiliation": "Regional Academic Oncology Network (Thornton, CO)"
    },
    {
      "npi": "1942592563",
      "name": "Dr. Juraj Kavecansky, MD",
      "rawName": "Juraj Kavecansky",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1425 S MAIN ST FL 2",
      "city": "Walnut creek",
      "state": "CA",
      "postalCode": "94596",
      "phone": "925-295-4030",
      "affiliation": "Regional Academic Oncology Network (Walnut creek, CA)"
    },
    {
      "npi": "1689720260",
      "name": "Dr. Ari Ballonoff, MD",
      "rawName": "Ari Ballonoff",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1375 E 19TH AVE",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "303-338-4545",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1417161704",
      "name": "Dr. Ajay Bhatnagar, MD",
      "rawName": "Ajay Bhatnagar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "500 UNIVERSITY DR",
      "city": "Hershey",
      "state": "PA",
      "postalCode": "17033",
      "phone": "717-531-8024",
      "affiliation": "Regional Academic Oncology Network (Hershey, PA)"
    },
    {
      "npi": "1780687889",
      "name": "Dr. Steven Bush, MD",
      "rawName": "Steven Bush",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1 MERCADO ST",
      "city": "Durango",
      "state": "CO",
      "postalCode": "81301",
      "phone": "970-385-4746",
      "affiliation": "Regional Academic Oncology Network (Durango, CO)"
    },
    {
      "npi": "1336256171",
      "name": "Dr. Changhu Chen, MD",
      "rawName": "Changhu Chen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "200 EXEMPLA CIR",
      "city": "Lafayette",
      "state": "CO",
      "postalCode": "80026",
      "phone": "303-338-4545",
      "affiliation": "Regional Academic Oncology Network (Lafayette, CO)"
    },
    {
      "npi": "1780711366",
      "name": "Dr. Mark Chidel, MD",
      "rawName": "Mark Chidel",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1375 E 19TH AVE",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "303-338-4545",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1285834945",
      "name": "Dr. Eugene Chung, MD",
      "rawName": "Eugene Chung",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4567 E 9TH AVE",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80220",
      "phone": "303-338-4545",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1336696152",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Emergency Medicine",
      "taxonomyCode": "207P00000X",
      "practiceAddress": "3010 15TH AVE S",
      "city": "Great falls",
      "state": "MT",
      "postalCode": "59405",
      "phone": "406-216-8000",
      "affiliation": "Regional Academic Oncology Network (Great falls, MT)"
    },
    {
      "npi": "1043743883",
      "name": "Dr. Christopher Deig, MD",
      "rawName": "Christopher Deig",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1721 E 19TH AVE",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "812-449-1243",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1275740508",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2555 S. DOWNING ST",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80210",
      "phone": "303-778-5714",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1407261290",
      "name": "Dr. Kaleigh Doke, MD",
      "rawName": "Kaleigh Doke",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "525 BOB PETERS GRV",
      "city": "Colorado springs",
      "state": "CO",
      "postalCode": "80909",
      "phone": "719-365-6800",
      "affiliation": "Regional Academic Oncology Network (Colorado springs, CO)"
    }
  ],
  "north-carolina/durham": [
    {
      "npi": "1962598094",
      "name": "Dr. Amy Abernethy, MD",
      "rawName": "Amy Abernethy",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4101 N ROXBORO ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27704",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1932633617",
      "name": "Dr. Laura Alder, MD",
      "rawName": "Laura Alder",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "20 DUKE MEDICINE CIR",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-681-9509",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1528160199",
      "name": "Dr. Andrew Armstrong, MD",
      "rawName": "Andrew Armstrong",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4101 N ROXBORO ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27704",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1144858549",
      "name": "Dr. Kirstin Binz, MD",
      "rawName": "Kirstin Binz",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "12200 W 110TH ST",
      "city": "Overland park",
      "state": "KS",
      "postalCode": "66210",
      "phone": "913-588-1227",
      "affiliation": "Regional Academic Oncology Network (Overland park, KS)"
    },
    {
      "npi": "1184694754",
      "name": "Dr. Gerard Blobe, MD",
      "rawName": "Gerard Blobe",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "BOX 2631 DUMC",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-668-1352",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1023119534",
      "name": "Dr. Carin Caves, MD",
      "rawName": "Carin Caves",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "DUKE UNIVERSITY HOSPITAL, 9300 INPATIENT UNIT",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-681-9341",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1215951587",
      "name": "Dr. Nelson Chao, MD",
      "rawName": "Nelson Chao",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4101 N ROXBORO ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27704",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1912290719",
      "name": "Dr. Jennifer Choe, MD",
      "rawName": "Jennifer Choe",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-936-9177",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1164505319",
      "name": "Dr. John Chute, MD",
      "rawName": "John Chute",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "8700 BEVERLY BLVD",
      "city": "West hollywood",
      "state": "CA",
      "postalCode": "90048",
      "phone": "310-248-7622",
      "affiliation": "Regional Academic Oncology Network (West hollywood, CA)"
    },
    {
      "npi": "1437787074",
      "name": "Dr. John Claiborne, MD",
      "rawName": "John Claiborne",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2400 PRATT ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27705",
      "phone": "919-684-3495",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1922543131",
      "name": "Dr. Jason Crockett, MD",
      "rawName": "Jason Crockett",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "20 DUKE MEDICINE CIRCLE DUKE CANCER CENTER CLINIC 5-1",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-668-8108",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1629151873",
      "name": "Dr. Frank Dunphy, MD",
      "rawName": "Frank Dunphy",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "DUKE UNIVERSITY MEDICAL CTR",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-620-4467",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1952796385",
      "name": "Dr. Megan Dupuis, MD",
      "rawName": "Megan Dupuis",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1548720956",
      "name": "Dr. Catherine Fahey, MD",
      "rawName": "Catherine Fahey",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "101 MANNING DR",
      "city": "Chapel hill",
      "state": "NC",
      "postalCode": "27514",
      "phone": "984-974-1000",
      "affiliation": "Regional Academic Oncology Network (Chapel hill, NC)"
    },
    {
      "npi": "1649513250",
      "name": "Dr. Eric Fountain, MD",
      "rawName": "Eric Fountain",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "520 S EAGLE RD",
      "city": "Meridian",
      "state": "ID",
      "postalCode": "83642",
      "phone": "208-381-2484",
      "affiliation": "Regional Academic Oncology Network (Meridian, ID)"
    },
    {
      "npi": "1861724627",
      "name": "Dr. Karen Allen, MD",
      "rawName": "Karen Allen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2100 ERWIN RD",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27705",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1659554897",
      "name": "Dr. Rachel Blitzblau, MD",
      "rawName": "Rachel Blitzblau",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2100 ERWIN RD",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27705",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1043586142",
      "name": "Dr. Matthew Boyer, MD",
      "rawName": "Matthew Boyer",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "DURHAM VAMC DEPARTMENT OF RADIATION ONCOLOGY",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27705",
      "phone": "919-286-6996",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1720173560",
      "name": "Dr. David Brizel, MD",
      "rawName": "David Brizel",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4101 N ROXBORO ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27704",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1114951423",
      "name": "Dr. Andrew Brown, MD",
      "rawName": "Andrew Brown",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "500 LAUCHWOOD DRIVE",
      "city": "Laurinburg",
      "state": "NC",
      "postalCode": "28352",
      "phone": "910-291-7120",
      "affiliation": "Regional Academic Oncology Network (Laurinburg, NC)"
    },
    {
      "npi": "1487731949",
      "name": "Dr. Catherine Chang, MD",
      "rawName": "Catherine Chang",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2100 ERWIN RD",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27705",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1023695251",
      "name": "Dr. Mark Chen, MD",
      "rawName": "Mark Chen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "20 DUKE MEDICINE CIR",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-660-2100",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1316138548",
      "name": "Dr. Junzo Chino, MD",
      "rawName": "Junzo Chino",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2100 ERWIN RD",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1205104783",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4700 WATERS AVE",
      "city": "Savannah",
      "state": "GA",
      "postalCode": "31404",
      "phone": "912-350-8490",
      "affiliation": "Regional Academic Oncology Network (Savannah, GA)"
    },
    {
      "npi": "1336234012",
      "name": "Dr. Brian Czito, MD",
      "rawName": "Brian Czito",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4101 N ROXBORO ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27704",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    }
  ],
  "tennessee/nashville": [
    {
      "npi": "1154359602",
      "name": "Dr. Vandana Abramson, MD",
      "rawName": "Vandana Abramson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-936-2000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1790027936",
      "name": "Dr. Rajiv Agarwal, MD",
      "rawName": "Rajiv Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1548142102",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1316 ADAMS ST STE 400",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37208",
      "phone": "203-461-1446",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1588621031",
      "name": "Dr. Carlos Bachier, MD",
      "rawName": "Carlos Bachier",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "HOSPITAL AUXILIO MUTUO",
      "city": "San juan",
      "state": "PR",
      "postalCode": "00917",
      "phone": "787-758-2000",
      "affiliation": "Regional Academic Oncology Network (San juan, PR)"
    },
    {
      "npi": "1740507706",
      "name": "Dr. Muhamed Baljevic, MD",
      "rawName": "Muhamed Baljevic",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4301 W MARKHAM ST # 506",
      "city": "Little rock",
      "state": "AR",
      "postalCode": "72205",
      "phone": "501-686-8000",
      "affiliation": "Regional Academic Oncology Network (Little rock, AR)"
    },
    {
      "npi": "1467407429",
      "name": "Dr. John Barton, MD",
      "rawName": "John Barton",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1840 MEDICAL CENTER PKWY",
      "city": "Murfreesboro",
      "state": "TN",
      "postalCode": "37129",
      "phone": "615-848-0488",
      "affiliation": "Regional Academic Oncology Network (Murfreesboro, TN)"
    },
    {
      "npi": "1083703540",
      "name": "Dr. Johanna Bendell, MD",
      "rawName": "Johanna Bendell",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "250 25TH AVE N",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37203",
      "phone": "615-320-5090",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1275620312",
      "name": "Dr. Jordan Berlin, MD",
      "rawName": "Jordan Berlin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 TVC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1477182749",
      "name": "Dr. Sean Bliven, MD",
      "rawName": "Sean Bliven",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1032 MCCALLIE AVE STE 200",
      "city": "Chattanooga",
      "state": "TN",
      "postalCode": "37403",
      "phone": "423-752-5004",
      "affiliation": "Regional Academic Oncology Network (Chattanooga, TN)"
    },
    {
      "npi": "1528105616",
      "name": "Dr. Johann Brandes, MD",
      "rawName": "Johann Brandes",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1840 MEDICAL CENTER PKWY",
      "city": "Murfreesboro",
      "state": "TN",
      "postalCode": "37129",
      "phone": "615-848-0488",
      "affiliation": "Regional Academic Oncology Network (Murfreesboro, TN)"
    },
    {
      "npi": "1417992397",
      "name": "Dr. Howard Burris, MD",
      "rawName": "Howard Burris",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "250 25TH AVE N",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37203",
      "phone": "615-320-5090",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1487701280",
      "name": "Dr. Dana Cardin, MD",
      "rawName": "Dana Cardin",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1528202579",
      "name": "Dr. Emily Castellanos, MD",
      "rawName": "Emily Castellanos",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-2570",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1053495168",
      "name": "Dr. Emily Chan, MD",
      "rawName": "Emily Chan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 TVC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1912290719",
      "name": "Dr. Jennifer Choe, MD",
      "rawName": "Jennifer Choe",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-936-9177",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1962906974",
      "name": "Dr. Sean All, MD",
      "rawName": "Sean All",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1134582240",
      "name": "Dr. Khush Aujla, MD",
      "rawName": "Khush Aujla",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1558682336",
      "name": "Dr. Diandra Ayala-peacock, MD",
      "rawName": "Diandra Ayala-peacock",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3601 TVC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1629690573",
      "name": "Dr. Milad Baradaran ghahfarokhi, MD",
      "rawName": "Milad Baradaran ghahfarokhi",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2220 PIERCE AVE",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-343-9241",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1811923386",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8787 BRYAN DAIRY RD",
      "city": "Largo",
      "state": "FL",
      "postalCode": "33777",
      "phone": "727-320-0200",
      "affiliation": "Regional Academic Oncology Network (Largo, FL)"
    },
    {
      "npi": "1467251454",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3155 N MCMULLEN BOOTH RD",
      "city": "Clearwater",
      "state": "FL",
      "postalCode": "33761",
      "phone": "727-320-0200",
      "affiliation": "Regional Academic Oncology Network (Clearwater, FL)"
    },
    {
      "npi": "1952330672",
      "name": "Dr. Marion Bolin, MD",
      "rawName": "Marion Bolin",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4220 HARDING PIKE",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37205",
      "phone": "615-222-6755",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1417367863",
      "name": "Dr. Christopher Brett, MD",
      "rawName": "Christopher Brett",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1926 ALCOA HWY STE 130",
      "city": "Knoxville",
      "state": "TN",
      "postalCode": "37920",
      "phone": "865-305-9040",
      "affiliation": "Regional Academic Oncology Network (Knoxville, TN)"
    },
    {
      "npi": "1093274227",
      "name": "Dr. Aaron Bush, MD",
      "rawName": "Aaron Bush",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1231 N LAWNWOOD CIR STE B",
      "city": "Fort pierce",
      "state": "FL",
      "postalCode": "34950",
      "phone": "772-271-4830",
      "affiliation": "Regional Academic Oncology Network (Fort pierce, FL)"
    },
    {
      "npi": "1992383335",
      "name": "Dr. Hayden Byrd, MD",
      "rawName": "Hayden Byrd",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "605 GLENWOOD DR STE 200",
      "city": "Chattanooga",
      "state": "TN",
      "postalCode": "37404",
      "phone": "423-495-7730",
      "affiliation": "Regional Academic Oncology Network (Chattanooga, TN)"
    }
  ],
  "michigan/detroit": [
    {
      "npi": "1992226575",
      "name": "Dr. Fawzi Abu rous, MD",
      "rawName": "Fawzi Abu rous",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1215 E MICHIGAN AVE",
      "city": "Lansing",
      "state": "MI",
      "postalCode": "48912",
      "phone": "517-364-1000",
      "affiliation": "Regional Academic Oncology Network (Lansing, MI)"
    },
    {
      "npi": "1790952562",
      "name": "Dr. Asif Alavi, MD",
      "rawName": "Asif Alavi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4100 JOHN R",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48201",
      "phone": "800-527-6266",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1427381607",
      "name": "Dr. Costantine Albany, MD",
      "rawName": "Costantine Albany",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1701 S CREASY LN",
      "city": "Lafayette",
      "state": "IN",
      "postalCode": "47905",
      "phone": "765-775-2800",
      "affiliation": "Regional Academic Oncology Network (Lafayette, IN)"
    },
    {
      "npi": "1174691695",
      "name": "Dr. Haythem Ali, MD",
      "rawName": "Haythem Ali",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "HENRY FORD HEALTH SYSTEM",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "313-916-7648",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1811935273",
      "name": "Dr. Joel Appel, DO",
      "rawName": "Joel Appel",
      "credential": "DO",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "27207 LAHSER RD",
      "city": "Southfield",
      "state": "MI",
      "postalCode": "48034",
      "phone": "248-358-4892",
      "affiliation": "Regional Academic Oncology Network (Southfield, MI)"
    },
    {
      "npi": "1427781186",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1200 MEDICAL CENTER PKWY",
      "city": "Maumee",
      "state": "OH",
      "postalCode": "43537",
      "phone": "313-576-9182",
      "affiliation": "Regional Academic Oncology Network (Maumee, OH)"
    },
    {
      "npi": "1851040356",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Medical Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1200 MEDICAL CENTER PARKWAY",
      "city": "Maumee",
      "state": "OH",
      "postalCode": "43537",
      "phone": "313-576-9182",
      "affiliation": "Regional Academic Oncology Network (Maumee, OH)"
    },
    {
      "npi": "1265500797",
      "name": "Dr. Bernd Barthel, MD",
      "rawName": "Bernd Barthel",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "HENRY FORD HEALTH SYSTEM",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "313-916-1431",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1447280631",
      "name": "Dr. Gerold Bepler, MD",
      "rawName": "Gerold Bepler",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4100 JOHN R",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48201",
      "phone": "800-527-6266",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1922322601",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "13355 E 10 MILE RD",
      "city": "Warren",
      "state": "MI",
      "postalCode": "48089",
      "phone": "586-756-7090",
      "affiliation": "Regional Academic Oncology Network (Warren, MI)"
    },
    {
      "npi": "1316391253",
      "name": "Dr. Scott Dawsey, MD",
      "rawName": "Scott Dawsey",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4646 JOHN R ST",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48201",
      "phone": "313-576-1000",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1003259045",
      "name": "Dr. Maria Diab, MD",
      "rawName": "Maria Diab",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "2799 W GRAND BLVD",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "800-653-6568",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1437196433",
      "name": "Dr. Bassel El-rayes, MD",
      "rawName": "Bassel El-rayes",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "200 W ARBOR DR",
      "city": "San diego",
      "state": "CA",
      "postalCode": "92103",
      "phone": "800-926-8273",
      "affiliation": "Regional Academic Oncology Network (San diego, CA)"
    },
    {
      "npi": "1629241443",
      "name": "Dr. Josephine Emole, MD",
      "rawName": "Josephine Emole",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2799 W GRAND BLVD # K-13",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "800-653-6568",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1033156534",
      "name": "Dr. Shirish Gadgeel, MD",
      "rawName": "Shirish Gadgeel",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2799 W GRAND BLVD",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "800-653-6568",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1669944237",
      "name": "Dr. Khaled Adil, MD",
      "rawName": "Khaled Adil",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "43 NEW SCOTLAND AVE",
      "city": "Albany",
      "state": "NY",
      "postalCode": "12208",
      "phone": "518-262-3368",
      "affiliation": "Regional Academic Oncology Network (Albany, NY)"
    },
    {
      "npi": "1578846440",
      "name": "Dr. Zishan Alibhai, MD",
      "rawName": "Zishan Alibhai",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "540 E CANFIELD ST",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48201",
      "phone": "248-795-4276",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1376603787",
      "name": "Dr. Ibrahim Aref, MD",
      "rawName": "Ibrahim Aref",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "HENRY FORD HEALTH SYSTEM",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "313-916-9106",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1013302397",
      "name": "Dr. David Bergman, MD",
      "rawName": "David Bergman",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3180 E MIDLAND RD",
      "city": "Bay city",
      "state": "MI",
      "postalCode": "48706",
      "phone": "989-667-6670",
      "affiliation": "Regional Academic Oncology Network (Bay city, MI)"
    },
    {
      "npi": "1487323432",
      "name": "Dr. Aseem Bhatnagar, MD",
      "rawName": "Aseem Bhatnagar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2799 W GRAND BLVD",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "313-916-2899",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1104053099",
      "name": "Dr. Eva Bieniek, MD",
      "rawName": "Eva Bieniek",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5301 E HURON RIVER DR",
      "city": "Ypsilanti",
      "state": "MI",
      "postalCode": "48197",
      "phone": "734-712-3456",
      "affiliation": "Regional Academic Oncology Network (Ypsilanti, MI)"
    },
    {
      "npi": "1699970525",
      "name": "Dr. Thomas Boike, MD",
      "rawName": "Thomas Boike",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2800 W GRAND BLVD",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "800-436-7936",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1528687886",
      "name": "Dr. Ryan Brisson, MD",
      "rawName": "Ryan Brisson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    },
    {
      "npi": "1659491132",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "6100 W 96TH ST STE 125",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46278",
      "phone": "317-715-1800",
      "affiliation": "Regional Academic Oncology Network (Indianapolis, IN)"
    }
  ]
};

export const ONCOLOGISTS_BY_STATE = {
  "new-york": [
    {
      "npi": "1134190168",
      "name": "Dr. Ghassan Abou-alfa, MD",
      "rawName": "Ghassan Abou-alfa",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10021",
      "phone": "212-639-2000",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1598146227",
      "name": "Dr. Nour Abuhadra, MD",
      "rawName": "Nour Abuhadra",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-2000",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1740422039",
      "name": "Dr. Melissa Accordino, MD",
      "rawName": "Melissa Accordino",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "161 FORT WASHINGTON AVENUE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10032",
      "phone": "212-305-9382",
      "affiliation": "Columbia University Herbert Irving Comprehensive Cancer Center"
    },
    {
      "npi": "1538574926",
      "name": "Dr. Ana Acuna-villaorduna, MD",
      "rawName": "Ana Acuna-villaorduna",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "263 FARMINGTON AVE",
      "city": "Farmington",
      "state": "CT",
      "postalCode": "06030",
      "phone": "860-679-2100",
      "affiliation": "Regional Academic Oncology Network (Farmington, CT)"
    },
    {
      "npi": "1194168955",
      "name": "Dr. David Aggen, MD",
      "rawName": "David Aggen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "353 E 68TH ST",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "646-422-4679",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1275570533",
      "name": "Dr. Carol Aghajanian, MD",
      "rawName": "Carol Aghajanian",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10021",
      "phone": "212-639-2000",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1720540495",
      "name": "Dr. Prashasti Agrawal, MD",
      "rawName": "Prashasti Agrawal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "480 RED HILL RD",
      "city": "Middletown",
      "state": "NJ",
      "postalCode": "07748",
      "phone": "833-921-2959",
      "affiliation": "Regional Academic Oncology Network (Middletown, NJ)"
    },
    {
      "npi": "1811348931",
      "name": "Dr. Mohamed Ahmed, MD",
      "rawName": "Mohamed Ahmed",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1600 E HIGH ST",
      "city": "Pottstown",
      "state": "PA",
      "postalCode": "19464",
      "phone": "610-327-7000",
      "affiliation": "Regional Academic Oncology Network (Pottstown, PA)"
    },
    {
      "npi": "1366735722",
      "name": "Dr. Omobolaji Akala, MD",
      "rawName": "Omobolaji Akala",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "630 W 168TH ST",
      "city": "New york",
      "state": "NY",
      "postalCode": "10032",
      "phone": "212-305-2913",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1356838353",
      "name": "Dr. Duaa Al rawi, MD",
      "rawName": "Duaa Al rawi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "646-888-2115",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1861424061",
      "name": "Dr. Louis Aledort, MD",
      "rawName": "Louis Aledort",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1190 5TH AVENUE GUGGENHEIM PAVILL",
      "city": "New york",
      "state": "NY",
      "postalCode": "10029",
      "phone": "212-241-6756",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1225354442",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "39 GRAMERCY PARK N",
      "city": "New york",
      "state": "NY",
      "postalCode": "10010",
      "phone": "212-505-7660",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1891882981",
      "name": "Dr. Sandra Allen-bard, MD",
      "rawName": "Sandra Allen-bard",
      "credential": "MD",
      "specialty": "Nurse Practitioner, Adult Health",
      "taxonomyCode": "363LA2200X",
      "practiceAddress": "530 E 74TH ST FL 14",
      "city": "New york",
      "state": "NY",
      "postalCode": "10021",
      "phone": "646-608-4308",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1356796833",
      "name": "Dr. Salvador Alonso martinez, MD",
      "rawName": "Salvador Alonso martinez",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1689412801",
      "name": "Dr. Reem Alsuwailem, MD",
      "rawName": "Reem Alsuwailem",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-5422",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1821672957",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Clinic/Center, Ambulatory Surgical",
      "taxonomyCode": "261QA1903X",
      "practiceAddress": "5 E 98TH ST FL 14",
      "city": "New york",
      "state": "NY",
      "postalCode": "10029",
      "phone": "212-241-3364",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1770105728",
      "name": "Dr. Lamiaa Abdallah, MD",
      "rawName": "Lamiaa Abdallah",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1275 YORK AVE # 22",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-6800",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1811341944",
      "name": "Dr. Jalal Ahmed, MD",
      "rawName": "Jalal Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1184 5TH AVE FL 1",
      "city": "New york",
      "state": "NY",
      "postalCode": "10029",
      "phone": "212-241-7500",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1144200791",
      "name": "Dr. Kaled Alektiar, MD",
      "rawName": "Kaled Alektiar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10021",
      "phone": "212-639-2000",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1265893184",
      "name": "Dr. Alexander Augustyn, MD",
      "rawName": "Alexander Augustyn",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1215377056",
      "name": "Dr. Samuel Bakhoum, MD",
      "rawName": "Samuel Bakhoum",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-7900",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1528226339",
      "name": "Dr. Richard Bakst, MD",
      "rawName": "Richard Bakst",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1184 5TH AVENUE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10029",
      "phone": "212-241-7500",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1962728949",
      "name": "Dr. Onyinye Balogun, MD",
      "rawName": "Onyinye Balogun",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "525 E 68TH ST",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-746-3600",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1598959058",
      "name": "Dr. Christopher Barker, MD",
      "rawName": "Christopher Barker",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-8168",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1932189586",
      "name": "Dr. Kathryn Beal, MD",
      "rawName": "Kathryn Beal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10021",
      "phone": "212-639-2000",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    }
  ],
  "texas": [
    {
      "npi": "1396065934",
      "name": "Dr. Kanza Abbas, MD",
      "rawName": "Kanza Abbas",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2727 W HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77025",
      "phone": "713-442-0000",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1134233224",
      "name": "Dr. James Abbruzzese, MD",
      "rawName": "James Abbruzzese",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1518227735",
      "name": "Dr. Maen Abdelrahim, MD",
      "rawName": "Maen Abdelrahim",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6445 MAIN STREET, OPC24",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-441-9948",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    },
    {
      "npi": "1205097599",
      "name": "Dr. Sausan Abouharb, MD",
      "rawName": "Sausan Abouharb",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD.",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1215123971",
      "name": "Dr. Fadi Abu-shahin, MD",
      "rawName": "Fadi Abu-shahin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "18220 STATE HIGHWAY 249 STE 100",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77070",
      "phone": "276-546-2928",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    },
    {
      "npi": "1285846790",
      "name": "Dr. Kerin Adelson, MD",
      "rawName": "Kerin Adelson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1225567233",
      "name": "Dr. Talha Aijaz, MD",
      "rawName": "Talha Aijaz",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1124107156",
      "name": "Dr. Jaffer Ajani, MD",
      "rawName": "Jaffer Ajani",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1679988323",
      "name": "Dr. Neal Akhave, MD",
      "rawName": "Neal Akhave",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1518059898",
      "name": "Dr. Gheath Al-atrash, DO",
      "rawName": "Gheath Al-atrash",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1356796833",
      "name": "Dr. Salvador Alonso martinez, MD",
      "rawName": "Salvador Alonso martinez",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1982011375",
      "name": "Dr. Humaid Alshamsi, MD",
      "rawName": "Humaid Alshamsi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1649441601",
      "name": "Dr. Ricardo Alvarez, MD",
      "rawName": "Ricardo Alvarez",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "925 GESSNER RD STE 600",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77024",
      "phone": "713-827-9525",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    },
    {
      "npi": "1912053596",
      "name": "Dr. Rodabe Amaria, MD",
      "rawName": "Rodabe Amaria",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1124447255",
      "name": "Dr. Mediha Ahmad, MD",
      "rawName": "Mediha Ahmad",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "601 E SAN ANTONIO ST STE 101W",
      "city": "Victoria",
      "state": "TX",
      "postalCode": "77901",
      "phone": "361-485-9600",
      "affiliation": "Regional Academic Oncology Network (Victoria, TX)"
    },
    {
      "npi": "1154320976",
      "name": "Dr. Neelofur Ahmad, MD",
      "rawName": "Neelofur Ahmad",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1861999161",
      "name": "Dr. Karine Al feghali, MD",
      "rawName": "Karine Al feghali",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-563-0188",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1003166109",
      "name": "Dr. Jeffrey Albert, MD",
      "rawName": "Jeffrey Albert",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "11750 W 2ND PL STE 150",
      "city": "Lakewood",
      "state": "CO",
      "postalCode": "80228",
      "phone": "720-321-8800",
      "affiliation": "Regional Academic Oncology Network (Lakewood, CO)"
    },
    {
      "npi": "1306322979",
      "name": "Dr. Mohammed Aldehaim, MD",
      "rawName": "Mohammed Aldehaim",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "877-632-6789",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1245598168",
      "name": "Dr. Mark Amsbaugh, MD",
      "rawName": "Mark Amsbaugh",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "6400 FANNIN ST STE 2800",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-486-8000",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    },
    {
      "npi": "1174055545",
      "name": "Dr. Chidinma Anakwenze, MD",
      "rawName": "Chidinma Anakwenze",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1366472102",
      "name": "Dr. Mitchell Anscher, MD",
      "rawName": "Mitchell Anscher",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "101 MANNING DR",
      "city": "Chapel hill",
      "state": "NC",
      "postalCode": "27514",
      "phone": "984-974-1000",
      "affiliation": "Regional Academic Oncology Network (Chapel hill, NC)"
    },
    {
      "npi": "1932557030",
      "name": "Dr. Joseph Arko, MD",
      "rawName": "Joseph Arko",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "11532 CHAMPIONS GREEN DR",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77066",
      "phone": "214-918-5517",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    },
    {
      "npi": "1033567409",
      "name": "Dr. Seyed Abedi, MD",
      "rawName": "Seyed Abedi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1401 MEDICAL PKWY STE 200",
      "city": "Cedar park",
      "state": "TX",
      "postalCode": "78613",
      "phone": "512-260-6050",
      "affiliation": "Regional Academic Oncology Network (Cedar park, TX)"
    },
    {
      "npi": "1326288564",
      "name": "Dr. Laith Abushahin, MD",
      "rawName": "Laith Abushahin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3410 WORTH ST STE 400",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75246",
      "phone": "214-370-1000",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1548262900",
      "name": "Dr. John Adams, DO",
      "rawName": "John Adams",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "906 W RANDOL MILL RD",
      "city": "Arlington",
      "state": "TX",
      "postalCode": "76012",
      "phone": "817-261-0929",
      "affiliation": "Regional Academic Oncology Network (Arlington, TX)"
    },
    {
      "npi": "1740484336",
      "name": "Dr. Prashanth Adapala, MD",
      "rawName": "Prashanth Adapala",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "800 W HIGHWAY 71",
      "city": "Marble falls",
      "state": "TX",
      "postalCode": "78654",
      "phone": "512-901-4008",
      "affiliation": "Regional Academic Oncology Network (Marble falls, TX)"
    },
    {
      "npi": "1801837497",
      "name": "Dr. Ashwani Agarwal, MD",
      "rawName": "Ashwani Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3555 W WHEATLAND RD",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75237",
      "phone": "972-709-2580",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1386867448",
      "name": "Dr. Sachin Agarwal, MD",
      "rawName": "Sachin Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 SCOTT AND WHITE DR",
      "city": "College station",
      "state": "TX",
      "postalCode": "77845",
      "phone": "979-207-4000",
      "affiliation": "Regional Academic Oncology Network (College station, TX)"
    },
    {
      "npi": "1871531350",
      "name": "Dr. Edward Agura, MD",
      "rawName": "Edward Agura",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3410 WORTH ST",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75246",
      "phone": "214-370-1513",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1861802332",
      "name": "Dr. Shane Ahlers, MD",
      "rawName": "Shane Ahlers",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "100 E IDAHO ST",
      "city": "Boise",
      "state": "ID",
      "postalCode": "83712",
      "phone": "208-381-2711",
      "affiliation": "Regional Academic Oncology Network (Boise, ID)"
    },
    {
      "npi": "1578773511",
      "name": "Dr. Cristi Aitelli, DO",
      "rawName": "Cristi Aitelli",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6500 HARRIS PKWY",
      "city": "Fort worth",
      "state": "TX",
      "postalCode": "76132",
      "phone": "817-346-6748",
      "affiliation": "Regional Academic Oncology Network (Fort worth, TX)"
    },
    {
      "npi": "1124060124",
      "name": "Dr. Syed Akhtar, MD",
      "rawName": "Syed Akhtar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3010 HARRISON AVE",
      "city": "Beaumont",
      "state": "TX",
      "postalCode": "77702",
      "phone": "409-899-7180",
      "affiliation": "Regional Academic Oncology Network (Beaumont, TX)"
    },
    {
      "npi": "1508285313",
      "name": "Dr. Salwan Al mutar, MD",
      "rawName": "Salwan Al mutar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2201 INWOOD RD 2ND FLOOR",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75390",
      "phone": "214-645-4673",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1114341716",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "1222 BELLEAU DR",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75208",
      "phone": "214-724-0338",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1205060746",
      "name": "Dr. Miguel Albino, MD",
      "rawName": "Miguel Albino",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "12221 RENFERT WAY STE 300",
      "city": "Austin",
      "state": "TX",
      "postalCode": "78758",
      "phone": "512-873-8900",
      "affiliation": "Regional Academic Oncology Network (Austin, TX)"
    },
    {
      "npi": "1073712709",
      "name": "Dr. Nitya Alluri, MD",
      "rawName": "Nitya Alluri",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "901 W 38TH ST STE 300",
      "city": "Austin",
      "state": "TX",
      "postalCode": "78705",
      "phone": "512-421-4100",
      "affiliation": "Regional Academic Oncology Network (Austin, TX)"
    },
    {
      "npi": "1306923180",
      "name": "Dr. Maria Aloba, MD",
      "rawName": "Maria Aloba",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3270 JOE BATTLE BLVD STE 312",
      "city": "El paso",
      "state": "TX",
      "postalCode": "79938",
      "phone": "915-747-4877",
      "affiliation": "Regional Academic Oncology Network (El paso, TX)"
    },
    {
      "npi": "1265574263",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1304 WONDER WORLD DR",
      "city": "San marcos",
      "state": "TX",
      "postalCode": "78666",
      "phone": "512-396-2500",
      "affiliation": "Regional Academic Oncology Network (San marcos, TX)"
    },
    {
      "npi": "1386938371",
      "name": "Dr. Mirna Abboud, MD",
      "rawName": "Mirna Abboud",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "501 W MEDICAL CENTER BLVD",
      "city": "Webster",
      "state": "TX",
      "postalCode": "77598",
      "phone": "281-332-7505",
      "affiliation": "Regional Academic Oncology Network (Webster, TX)"
    },
    {
      "npi": "1851702831",
      "name": "Dr. Awad Ahmed, MD",
      "rawName": "Awad Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2121 PEASE ST STE 101",
      "city": "Harlingen",
      "state": "TX",
      "postalCode": "78550",
      "phone": "956-425-8845",
      "affiliation": "Regional Academic Oncology Network (Harlingen, TX)"
    },
    {
      "npi": "1871856914",
      "name": "Dr. Mani Akhtari, MD",
      "rawName": "Mani Akhtari",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "500 S HENDERSON ST STE 200",
      "city": "Fort worth",
      "state": "TX",
      "postalCode": "76104",
      "phone": "817-413-1500",
      "affiliation": "Regional Academic Oncology Network (Fort worth, TX)"
    },
    {
      "npi": "1457338329",
      "name": "Dr. Kevin Albuquerque, MD",
      "rawName": "Kevin Albuquerque",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5323 HARRY HINES BLVD",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75390",
      "phone": "214-645-8525",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1821592791",
      "name": "Dr. Hayden Ansinelli, MD",
      "rawName": "Hayden Ansinelli",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1845 W ORANGE GROVE RD BLDG 1",
      "city": "Tucson",
      "state": "AZ",
      "postalCode": "85704",
      "phone": "352-401-8311",
      "affiliation": "Regional Academic Oncology Network (Tucson, AZ)"
    },
    {
      "npi": "1265675854",
      "name": "Dr. Daniel Arsenault, MD",
      "rawName": "Daniel Arsenault",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1751 WALLACE BLVD",
      "city": "Amarillo",
      "state": "TX",
      "postalCode": "79106",
      "phone": "806-212-4673",
      "affiliation": "Regional Academic Oncology Network (Amarillo, TX)"
    },
    {
      "npi": "1669859377",
      "name": "Dr. Ritu Arya, MD",
      "rawName": "Ritu Arya",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "906 W RANDOL MILL RD STE 200",
      "city": "Arlington",
      "state": "TX",
      "postalCode": "76012",
      "phone": "817-664-9600",
      "affiliation": "Regional Academic Oncology Network (Arlington, TX)"
    },
    {
      "npi": "1497793814",
      "name": "Dr. Kin Au, MD",
      "rawName": "Kin Au",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1415 SANTA FE ST",
      "city": "Corpus christi",
      "state": "TX",
      "postalCode": "78404",
      "phone": "361-861-9760",
      "affiliation": "Regional Academic Oncology Network (Corpus christi, TX)"
    },
    {
      "npi": "1184604902",
      "name": "Dr. Yadvindera Bains, MD",
      "rawName": "Yadvindera Bains",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "800 SCOTT AND WHITE DR",
      "city": "College station",
      "state": "TX",
      "postalCode": "77845",
      "phone": "979-207-4000",
      "affiliation": "Regional Academic Oncology Network (College station, TX)"
    }
  ],
  "massachusetts": [
    {
      "npi": "1861854937",
      "name": "Dr. Maya Abdallah, MD",
      "rawName": "Maya Abdallah",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "830 HARRISON AVENUE, 3RD FL",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02118",
      "phone": "617-638-6428",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1255821617",
      "name": "Dr. Rachel Abelman, MD",
      "rawName": "Rachel Abelman",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "55 FRUIT ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02114",
      "phone": "617-231-9943",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1427024264",
      "name": "Dr. Janet Abrahm, MD",
      "rawName": "Janet Abrahm",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "44 BINNEY ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-632-6464",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1184693947",
      "name": "Dr. Thomas Abrams, MD",
      "rawName": "Thomas Abrams",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "44 BINNEY ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-632-6932",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1740262484",
      "name": "Dr. Jeremy Abramson, MD",
      "rawName": "Jeremy Abramson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "55 FRUIT ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02114",
      "phone": "617-724-4000",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1801277173",
      "name": "Dr. Jose Acevedo mejia, MD",
      "rawName": "Jose Acevedo mejia",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "830 HARRISON AVENUE, 3RD FL",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02118",
      "phone": "617-638-6428",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1942557079",
      "name": "Dr. Nana Addo-tabiri, MD",
      "rawName": "Nana Addo-tabiri",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "830 HARRISON AVENUE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02118",
      "phone": "617-638-6428",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1316920838",
      "name": "Dr. Adeboye Adewoye, MD",
      "rawName": "Adeboye Adewoye",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "732 HARRISON AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02118",
      "phone": "617-638-6428",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1417078221",
      "name": "Dr. Neeraj Agarwal, MD",
      "rawName": "Neeraj Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "450 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-632-3466",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1609071208",
      "name": "Dr. Andrew Aguirre, MD",
      "rawName": "Andrew Aguirre",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "450 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-632-3476",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1053632984",
      "name": "Dr. Inhye Ahn, MD",
      "rawName": "Inhye Ahn",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "450 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-582-9164",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1154760734",
      "name": "Dr. Oladimeji Akinboro, MD",
      "rawName": "Oladimeji Akinboro",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "10903 NEW HAMPSHIRE AVE BLDG 22",
      "city": "Silver spring",
      "state": "MD",
      "postalCode": "20993",
      "phone": "817-317-1540",
      "affiliation": "Regional Academic Oncology Network (Silver spring, MD)"
    },
    {
      "npi": "1578281796",
      "name": "Dr. Jean joseph thierry Alcindor, MD",
      "rawName": "Jean joseph thierry Alcindor",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "450 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "514-865-1732",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1285671453",
      "name": "Dr. Jill Allen, MD",
      "rawName": "Jill Allen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "55 FRUIT STREET YAWKEY 7E",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02114",
      "phone": "617-724-4000",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1073589578",
      "name": "Dr. Philip Amrein, MD",
      "rawName": "Philip Amrein",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "55 FRUIT ST YAW 7",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02114",
      "phone": "617-726-8748",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1104189117",
      "name": "Dr. Matthew Abrams, MD",
      "rawName": "Matthew Abrams",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "330 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-667-2345",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1528613833",
      "name": "Dr. Jenna Adleman, MD",
      "rawName": "Jenna Adleman",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-430-2431",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1942696752",
      "name": "Dr. Nima Aghdam, MD",
      "rawName": "Nima Aghdam",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "330 BROOKLINE AVE BSMT",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-667-2345",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1619105095",
      "name": "Dr. Ayal Aizer, MD",
      "rawName": "Ayal Aizer",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-525-7136",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1285691972",
      "name": "Dr. Michele Albert, MD",
      "rawName": "Michele Albert",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS STREET ASB1 L2",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-732-7936",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1275511149",
      "name": "Dr. Brian Alexander, MD",
      "rawName": "Brian Alexander",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-732-5500",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1396849527",
      "name": "Dr. Aaron Allen, MD",
      "rawName": "Aaron Allen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-632-7325",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1528488269",
      "name": "Dr. Erik Anderson, MD",
      "rawName": "Erik Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "330 BROOKLINE AVE # FNB-25",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-667-2345",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1225560345",
      "name": "Dr. Mona Arbab, MD",
      "rawName": "Mona Arbab",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-732-6861",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1316995418",
      "name": "Dr. Joseph Aronovitz, MD",
      "rawName": "Joseph Aronovitz",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "330 BROOKLINE AVENUE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-667-2345",
      "affiliation": "Dana-Farber Cancer Institute"
    }
  ],
  "california": [
    {
      "npi": "1013595743",
      "name": "Dr. Alexander Agelidis, MD",
      "rawName": "Alexander Agelidis",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "200 W ARBOR DR",
      "city": "San diego",
      "state": "CA",
      "postalCode": "92103",
      "phone": "800-926-8273",
      "affiliation": "Regional Academic Oncology Network (San diego, CA)"
    },
    {
      "npi": "1164448734",
      "name": "Dr. Mark Agulnik, MD",
      "rawName": "Mark Agulnik",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1441 EASTLAKE AVE",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90089",
      "phone": "323-865-3000",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1356328249",
      "name": "Dr. David Agus, MD",
      "rawName": "David Agus",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "12414 EXPOSITION BLVD",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90064",
      "phone": "310-272-7640",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1568581759",
      "name": "Dr. Sang hoon Ahn, MD",
      "rawName": "Sang hoon Ahn",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "1950 SUNNY CREST DR STE 2800",
      "city": "Fullerton",
      "state": "CA",
      "postalCode": "92835",
      "phone": "657-888-9919",
      "affiliation": "Regional Academic Oncology Network (Fullerton, CA)"
    },
    {
      "npi": "1861886707",
      "name": "Dr. Sandra Algaze, MD",
      "rawName": "Sandra Algaze",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1441 EASTLAKE AVE",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90089",
      "phone": "323-865-3000",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1568921716",
      "name": "Dr. Lauren Antrim, MD",
      "rawName": "Lauren Antrim",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1500 DUARTE RD",
      "city": "Duarte",
      "state": "CA",
      "postalCode": "91010",
      "phone": "800-826-4673",
      "affiliation": "City of Hope Comprehensive Cancer Center"
    },
    {
      "npi": "1649632696",
      "name": "Dr. Nikita Baclig, MD",
      "rawName": "Nikita Baclig",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2020 SANTA MONICA BLVD STE 580",
      "city": "Santa monica",
      "state": "CA",
      "postalCode": "90404",
      "phone": "310-829-5471",
      "affiliation": "Regional Academic Oncology Network (Santa monica, CA)"
    },
    {
      "npi": "1295734614",
      "name": "Dr. Bahareh Bahadini, MD",
      "rawName": "Bahareh Bahadini",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "425 HAALAND DR STE 101",
      "city": "Thousand oaks",
      "state": "CA",
      "postalCode": "91361",
      "phone": "805-496-2949",
      "affiliation": "Regional Academic Oncology Network (Thousand oaks, CA)"
    },
    {
      "npi": "1427493998",
      "name": "Dr. John Baird, MD",
      "rawName": "John Baird",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "1500 DUARTE RD",
      "city": "Duarte",
      "state": "CA",
      "postalCode": "91010",
      "phone": "626-256-4673",
      "affiliation": "City of Hope Comprehensive Cancer Center"
    },
    {
      "npi": "1639210107",
      "name": "Dr. Aditya Bardia, MD",
      "rawName": "Aditya Bardia",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2336 SANTA MONICA BLVD STE 304",
      "city": "Santa monica",
      "state": "CA",
      "postalCode": "90404",
      "phone": "310-998-4747",
      "affiliation": "Regional Academic Oncology Network (Santa monica, CA)"
    },
    {
      "npi": "1265480412",
      "name": "Dr. Afsaneh Barzi, MD",
      "rawName": "Afsaneh Barzi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1441 EASTLAKE AVE",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90033",
      "phone": "323-865-3105",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1508146721",
      "name": "Dr. Reva Basho, MD",
      "rawName": "Reva Basho",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8700 BEVERLY BLVD",
      "city": "West hollywood",
      "state": "CA",
      "postalCode": "90048",
      "phone": "310-967-2700",
      "affiliation": "Regional Academic Oncology Network (West hollywood, CA)"
    },
    {
      "npi": "1770961575",
      "name": "Dr. Abinav Baweja, MD",
      "rawName": "Abinav Baweja",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5555 W LAS POSITAS BLVD",
      "city": "Pleasanton",
      "state": "CA",
      "postalCode": "94588",
      "phone": "925-416-5470",
      "affiliation": "Regional Academic Oncology Network (Pleasanton, CA)"
    },
    {
      "npi": "1164726378",
      "name": "Dr. Osagie Bello, MD",
      "rawName": "Osagie Bello",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "205 W LEGION RD",
      "city": "Brawley",
      "state": "CA",
      "postalCode": "92227",
      "phone": "760-351-3737",
      "affiliation": "Regional Academic Oncology Network (Brawley, CA)"
    },
    {
      "npi": "1235499518",
      "name": "Dr. Munveer Bhangoo, MD",
      "rawName": "Munveer Bhangoo",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10666 N TORREY PINES RD",
      "city": "La jolla",
      "state": "CA",
      "postalCode": "92037",
      "phone": "858-554-3200",
      "affiliation": "Regional Academic Oncology Network (La jolla, CA)"
    },
    {
      "npi": "1861955460",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2407 W VINE ST",
      "city": "Lodi",
      "state": "CA",
      "postalCode": "95242",
      "phone": "209-334-8585",
      "affiliation": "Regional Academic Oncology Network (Lodi, CA)"
    },
    {
      "npi": "1720831720",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2985 SYCAMORE DR",
      "city": "Simi valley",
      "state": "CA",
      "postalCode": "93065",
      "phone": "805-584-6611",
      "affiliation": "Regional Academic Oncology Network (Simi valley, CA)"
    },
    {
      "npi": "1124250642",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4032 WILSHIRE BLVD",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90010",
      "phone": "323-532-9308",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1750325973",
      "name": "Dr. Martin Allen-auerbach, MD",
      "rawName": "Martin Allen-auerbach",
      "credential": "MD",
      "specialty": "Nuclear Medicine",
      "taxonomyCode": "207U00000X",
      "practiceAddress": "200 UCLA MEDICAL PLZ STE B114",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90095",
      "phone": "310-794-1005",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1831697374",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1876 E SABIN DR STE 10",
      "city": "Casa grande",
      "state": "AZ",
      "postalCode": "85122",
      "phone": "520-836-1510",
      "affiliation": "Regional Academic Oncology Network (Casa grande, AZ)"
    },
    {
      "npi": "1487910774",
      "name": "Dr. Arya Amini, MD",
      "rawName": "Arya Amini",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1500 E. DUARTE ROAD",
      "city": "Duarte",
      "state": "CA",
      "postalCode": "91010",
      "phone": "626-256-4673",
      "affiliation": "City of Hope Comprehensive Cancer Center"
    },
    {
      "npi": "1043461437",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9055 E. DEL CAMINO",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85258",
      "phone": "480-922-4600",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1457521510",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "201 S ALVARADO ST",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90057",
      "phone": "213-484-7577",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1326238650",
      "name": "Dr. Robert Ash, MD",
      "rawName": "Robert Ash",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1000 W. LAVETA AVE.",
      "city": "Orange",
      "state": "CA",
      "postalCode": "92868",
      "phone": "714-734-6250",
      "affiliation": "Regional Academic Oncology Network (Orange, CA)"
    },
    {
      "npi": "1528470739",
      "name": "Dr. Katelyn Atkins, MD",
      "rawName": "Katelyn Atkins",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8700 BEVERLY BLVD",
      "city": "West hollywood",
      "state": "CA",
      "postalCode": "90048",
      "phone": "310-423-2178",
      "affiliation": "Regional Academic Oncology Network (West hollywood, CA)"
    },
    {
      "npi": "1679530018",
      "name": "Dr. Donald Abrams, MD",
      "rawName": "Donald Abrams",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1701 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-7720",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1649346842",
      "name": "Dr. Weiyun Ai, MD",
      "rawName": "Weiyun Ai",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "400 PARNASSUS AVE",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-2737",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1659637452",
      "name": "Dr. Luai Al rabadi, MD",
      "rawName": "Luai Al rabadi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1825 4TH STREET",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94158",
      "phone": "415-353-9888",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1326058777",
      "name": "Dr. Chloe Atreya, MD",
      "rawName": "Chloe Atreya",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1600 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-9888",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1225529928",
      "name": "Dr. Hemali Batra-sharma, MD",
      "rawName": "Hemali Batra-sharma",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1825 4TH ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-7070",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1538418298",
      "name": "Dr. Mark Benyunes, MD",
      "rawName": "Mark Benyunes",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 DNA WAY",
      "city": "South san francisco",
      "state": "CA",
      "postalCode": "94080",
      "phone": "650-225-1628",
      "affiliation": "Regional Academic Oncology Network (South san francisco, CA)"
    },
    {
      "npi": "1457381014",
      "name": "Dr. Christopher Benz, MD",
      "rawName": "Christopher Benz",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1600 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-7070",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1295792729",
      "name": "Dr. Emily Bergsland, MD",
      "rawName": "Emily Bergsland",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1600 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-9888",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1942236997",
      "name": "Dr. John Berry, MD",
      "rawName": "John Berry",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1600 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-7100",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1093861346",
      "name": "Dr. Trever Bivona, MD",
      "rawName": "Trever Bivona",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1600 DIVISADERO STREET, 4TH FLOOR",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-7160",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1235312323",
      "name": "Dr. Robert Bok, MD",
      "rawName": "Robert Bok",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1700 4TH ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94158",
      "phone": "415-514-9716",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1932914926",
      "name": "Dr. Guus Bol, MD",
      "rawName": "Guus Bol",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1975 4TH ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-3000",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1477571347",
      "name": "Dr. Pamela Bolyanatz, MD",
      "rawName": "Pamela Bolyanatz",
      "credential": "MD",
      "specialty": "Nurse Practitioner, Family",
      "taxonomyCode": "363LF0000X",
      "practiceAddress": "3035 BOOK RD",
      "city": "Naperville",
      "state": "IL",
      "postalCode": "60564",
      "phone": "630-319-1962",
      "affiliation": "Regional Academic Oncology Network (Naperville, IL)"
    },
    {
      "npi": "1710140850",
      "name": "Dr. Rohit Bose, MD",
      "rawName": "Rohit Bose",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1825 4TH ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-476-4616",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1134330988",
      "name": "Dr. Edward Cha, MD",
      "rawName": "Edward Cha",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "505 PARNASSUS AVE",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-885-7276",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1811988421",
      "name": "Dr. Roy Abendroth, MD",
      "rawName": "Roy Abendroth",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2333 BUCHANAN ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "209-342-2300",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1992394811",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "900 HYDE ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94109",
      "phone": "415-353-6420",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1215161211",
      "name": "Dr. Moshiur Anwar, MD",
      "rawName": "Moshiur Anwar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1825 4TH ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94158",
      "phone": "415-353-7175",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1811105943",
      "name": "Dr. Igor Barani, MD",
      "rawName": "Igor Barani",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "350 W THOMAS RD",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-406-6761",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1679990071",
      "name": "Dr. Lauren Boreta, MD",
      "rawName": "Lauren Boreta",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1600 DIVISADERO ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-443-0283",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1760610141",
      "name": "Dr. Steve Braunstein, MD",
      "rawName": "Steve Braunstein",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1600 DIVISADERO ST, SUITE H1031",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-7175",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1033536917",
      "name": "Dr. Jason Chan, MD",
      "rawName": "Jason Chan",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1600 DIVISADERO STREET",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "415-353-7175",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1861079592",
      "name": "Dr. Enoch Chang, MD",
      "rawName": "Enoch Chang",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1902897515",
      "name": "Dr. Barry Chauser, MD",
      "rawName": "Barry Chauser",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2333 BUCHANAN ST",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94115",
      "phone": "209-342-2300",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1912433632",
      "name": "Dr. Victor Chen, MD",
      "rawName": "Victor Chen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1600 DIVISADERO ST # H1031",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-7175",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    }
  ],
  "illinois": [
    {
      "npi": "1316965320",
      "name": "Dr. Camille Abboud, MD",
      "rawName": "Camille Abboud",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4500 FOREST PARK AVE",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63108",
      "phone": "314-454-8304",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1649684200",
      "name": "Dr. Ramzi Abboud, MD",
      "rawName": "Ramzi Abboud",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 BARNES JEWISH HOSPITAL PLZ",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "314-454-8304",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1114183290",
      "name": "Dr. Syed Abutalib, MD",
      "rawName": "Syed Abutalib",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2900 W OKLAHOMA AVE",
      "city": "Milwaukee",
      "state": "WI",
      "postalCode": "53215",
      "phone": "414-649-6380",
      "affiliation": "Regional Academic Oncology Network (Milwaukee, WI)"
    },
    {
      "npi": "1346473345",
      "name": "Dr. Kalid Adab, MD",
      "rawName": "Kalid Adab",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2900 W OKLAHOMA AVE",
      "city": "Milwaukee",
      "state": "WI",
      "postalCode": "53215",
      "phone": "414-649-6380",
      "affiliation": "Regional Academic Oncology Network (Milwaukee, WI)"
    },
    {
      "npi": "1144780107",
      "name": "Dr. Jacob Adashek, DO",
      "rawName": "Jacob Adashek",
      "credential": "DO",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "W180N11070 RIVER LN",
      "city": "Germantown",
      "state": "WI",
      "postalCode": "53022",
      "phone": "262-532-9755",
      "affiliation": "Regional Academic Oncology Network (Germantown, WI)"
    },
    {
      "npi": "1083875538",
      "name": "Dr. Foluso Ademuyiwa, MD",
      "rawName": "Foluso Ademuyiwa",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4921 PARKVIEW PL",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "800-647-2098",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1164440616",
      "name": "Dr. Douglas Adkins, MD",
      "rawName": "Douglas Adkins",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4500 FOREST PARK AVE",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63108",
      "phone": "314-747-1171",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1831539808",
      "name": "Dr. Amber Afzal, MD",
      "rawName": "Amber Afzal",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4500 FOREST PARK AVE",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63108",
      "phone": "314-362-7216",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1093911307",
      "name": "Dr. Eugene Ahn, MD",
      "rawName": "Eugene Ahn",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2361 PAYSPHERE CIR",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60674",
      "phone": "847-746-4358",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1225567233",
      "name": "Dr. Talha Aijaz, MD",
      "rawName": "Talha Aijaz",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1497282115",
      "name": "Dr. Helen Ajufo, MD",
      "rawName": "Helen Ajufo",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4921 PARKVIEW PL",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "314-362-7216",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1376527739",
      "name": "Dr. Mebea Aklilu, MD",
      "rawName": "Mebea Aklilu",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "901 W WELLINGTON AVE",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60657",
      "phone": "773-296-7248",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1417182858",
      "name": "Dr. Andrea Amico, MD",
      "rawName": "Andrea Amico",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2160 S 1ST AVE",
      "city": "Maywood",
      "state": "IL",
      "postalCode": "60153",
      "phone": "708-216-9000",
      "affiliation": "Regional Academic Oncology Network (Maywood, IL)"
    },
    {
      "npi": "1265689889",
      "name": "Dr. Manik Amin, MD",
      "rawName": "Manik Amin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5841 S MARYLAND AVE",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60637",
      "phone": "773-702-1000",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1982196499",
      "name": "Dr. Nikolaos Andreatos, MD",
      "rawName": "Nikolaos Andreatos",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 BARNES JEWISH HOSPITAL PLZ",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "800-647-2098",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1205096609",
      "name": "Dr. Mohamed Abazeed, MD",
      "rawName": "Mohamed Abazeed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "251 E HURON ST",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60611",
      "phone": "312-926-5392",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1356317564",
      "name": "Dr. Ross Abrams, MD",
      "rawName": "Ross Abrams",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "520 S PAULINA ST",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60612",
      "phone": "312-942-0712",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1710205067",
      "name": "Dr. Maria Aguirre, MD",
      "rawName": "Maria Aguirre",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9201 CALUMET AVE",
      "city": "Munster",
      "state": "IN",
      "postalCode": "46321",
      "phone": "219-836-9024",
      "affiliation": "Regional Academic Oncology Network (Munster, IN)"
    },
    {
      "npi": "1285754895",
      "name": "Dr. Elke Aippersbach, MD",
      "rawName": "Elke Aippersbach",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4440 W 95TH ST",
      "city": "Oak lawn",
      "state": "IL",
      "postalCode": "60453",
      "phone": "708-684-5475",
      "affiliation": "Regional Academic Oncology Network (Oak lawn, IL)"
    },
    {
      "npi": "1063607125",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "15055 COLLECTION CENTER DR",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60693",
      "phone": "256-383-3325",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1144416389",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3411 MC INTOSH CIR",
      "city": "Joplin",
      "state": "MO",
      "postalCode": "64804",
      "phone": "417-782-3154",
      "affiliation": "Regional Academic Oncology Network (Joplin, MO)"
    },
    {
      "npi": "1669851424",
      "name": "Dr. Basel Altoos, MD",
      "rawName": "Basel Altoos",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4955 NORTON HEALTHCARE BLVD",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40241",
      "phone": "502-394-6350",
      "affiliation": "Regional Academic Oncology Network (Louisville, KY)"
    },
    {
      "npi": "1336554666",
      "name": "Dr. Sobiya Ansari, MD",
      "rawName": "Sobiya Ansari",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1653 W CONGRESS PKWY",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60612",
      "phone": "312-942-7774",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1457589681",
      "name": "Dr. Anthony Apicelli, MD",
      "rawName": "Anthony Apicelli",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4921 PARKVIEW PL",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "314-747-7236",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1235588344",
      "name": "Dr. Jessica Arden, MD",
      "rawName": "Jessica Arden",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "217 S MADISON ST",
      "city": "Traverse city",
      "state": "MI",
      "postalCode": "49684",
      "phone": "231-392-8400",
      "affiliation": "Regional Academic Oncology Network (Traverse city, MI)"
    }
  ],
  "pennsylvania": [
    {
      "npi": "1073803896",
      "name": "Dr. Peter Abdelmessieh, DO",
      "rawName": "Peter Abdelmessieh",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "16 EMERALD ROAD",
      "city": "Robbinsville",
      "state": "NJ",
      "postalCode": "08691",
      "phone": "212-434-2000",
      "affiliation": "Regional Academic Oncology Network (Robbinsville, NJ)"
    },
    {
      "npi": "1194713495",
      "name": "Dr. Maysa Abu-khalaf, MD",
      "rawName": "Maysa Abu-khalaf",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "925 CHESTNUT ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-8874",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1558538991",
      "name": "Dr. Seyfettin Alpdogan, MD",
      "rawName": "Seyfettin Alpdogan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "925 CHESTNUT ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-8874",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1043252455",
      "name": "Dr. Ravi Amaravadi, MD",
      "rawName": "Ravi Amaravadi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 CIVIC CENTER BLVD",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-615-5858",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1922340090",
      "name": "Dr. Fern Anari, MD",
      "rawName": "Fern Anari",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-2500",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1205877669",
      "name": "Dr. Charalambos Andreadis, MD",
      "rawName": "Charalambos Andreadis",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 SPRUCE ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-662-3914",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1992703516",
      "name": "Dr. Mariette Austin, MD",
      "rawName": "Mariette Austin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2003 FAIRVIEW AVE",
      "city": "Easton",
      "state": "PA",
      "postalCode": "18042",
      "phone": "484-821-1373",
      "affiliation": "Regional Academic Oncology Network (Easton, PA)"
    },
    {
      "npi": "1710193982",
      "name": "Dr. Tiffany Avery, MD",
      "rawName": "Tiffany Avery",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "925 CHESTNUT STREET",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-8874",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1881616126",
      "name": "Dr. Rita Axelrod, MD",
      "rawName": "Rita Axelrod",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "925 CHESTNUT ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-8874",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1558521054",
      "name": "Dr. Daria Babushok, MD",
      "rawName": "Daria Babushok",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3400 CIVIC CENTER BLVD FL 3",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-615-5858",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1477516888",
      "name": "Dr. Naomi Balzer, MD",
      "rawName": "Naomi Balzer",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 CIVIC CENTER BOULEVARD",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-615-5858",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1073892626",
      "name": "Dr. Babar Bashir, MD",
      "rawName": "Babar Bashir",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "909 WALNUT ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-7000",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1619139235",
      "name": "Dr. Jessica Bauman, MD",
      "rawName": "Jessica Bauman",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-6900",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1740449487",
      "name": "Dr. Joshua Bauml, MD",
      "rawName": "Joshua Bauml",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 SPRUCE STREET",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-615-5858",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1730242363",
      "name": "Dr. Gregory Beatty, MD",
      "rawName": "Gregory Beatty",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 CIVIC CENTER BOULEVARD",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-615-5858",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1487980157",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1200 OLD YORK RD",
      "city": "Abington",
      "state": "PA",
      "postalCode": "19001",
      "phone": "215-481-6253",
      "affiliation": "Regional Academic Oncology Network (Abington, PA)"
    },
    {
      "npi": "1265470850",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1200 OLD YORK RD",
      "city": "Abington",
      "state": "PA",
      "postalCode": "19001",
      "phone": "215-481-2800",
      "affiliation": "Regional Academic Oncology Network (Abington, PA)"
    },
    {
      "npi": "1316262363",
      "name": "Dr. Manuj Agarwal, MD",
      "rawName": "Manuj Agarwal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "333 COTTMAN AVENUE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-2581",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1710117106",
      "name": "Dr. Peter Ahn, MD",
      "rawName": "Peter Ahn",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3400 CIVIC CENTER BLVD",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-614-0392",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1831393800",
      "name": "Dr. Michelle Alonso-basanta, MD",
      "rawName": "Michelle Alonso-basanta",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3400 CIVIC CENTER BLVD",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19104",
      "phone": "215-662-2428",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1811969868",
      "name": "Dr. Penny Anderson, MD",
      "rawName": "Penny Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-6900",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1982626321",
      "name": "Dr. Pramila Anne, MD",
      "rawName": "Pramila Anne",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "111 S 11TH ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19107",
      "phone": "215-955-6702",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1477355725",
      "name": "Dr. Alyssa Asaro, MD",
      "rawName": "Alyssa Asaro",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "888-369-2427",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1972921062",
      "name": "Dr. Vladimir Avkshtol, MD",
      "rawName": "Vladimir Avkshtol",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-3016",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1346229705",
      "name": "Dr. Usha Babaria, MD",
      "rawName": "Usha Babaria",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "230 N BROAD ST",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19102",
      "phone": "215-762-8409",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    }
  ],
  "georgia": [
    {
      "npi": "1134313273",
      "name": "Dr. Guillermo Abesada-terk, MD",
      "rawName": "Guillermo Abesada-terk",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "301 SE OCEAN BLVD",
      "city": "Stuart",
      "state": "FL",
      "postalCode": "34994",
      "phone": "772-287-4061",
      "affiliation": "Regional Academic Oncology Network (Stuart, FL)"
    },
    {
      "npi": "1639132269",
      "name": "Dr. Patrick Acevedo, MD",
      "rawName": "Patrick Acevedo",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1630 SE 18TH ST STE 602",
      "city": "Ocala",
      "state": "FL",
      "postalCode": "34471",
      "phone": "352-369-0181",
      "affiliation": "Regional Academic Oncology Network (Ocala, FL)"
    },
    {
      "npi": "1598766925",
      "name": "Dr. Farrukh Adhami, MD",
      "rawName": "Farrukh Adhami",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2514 E DUPONT RD STE 100",
      "city": "Fort wayne",
      "state": "IN",
      "postalCode": "46825",
      "phone": "260-484-8830",
      "affiliation": "Regional Academic Oncology Network (Fort wayne, IN)"
    },
    {
      "npi": "1700880697",
      "name": "Dr. Syed Ahmed, MD",
      "rawName": "Syed Ahmed",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1396 WHISPER CIR",
      "city": "Sebring",
      "state": "FL",
      "postalCode": "33870",
      "phone": "863-385-1244",
      "affiliation": "Regional Academic Oncology Network (Sebring, FL)"
    },
    {
      "npi": "1366435927",
      "name": "Dr. Geethanjali Akula, MD",
      "rawName": "Geethanjali Akula",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "70 W GORE ST STE 100",
      "city": "Orlando",
      "state": "FL",
      "postalCode": "32806",
      "phone": "407-426-8484",
      "affiliation": "Regional Academic Oncology Network (Orlando, FL)"
    },
    {
      "npi": "1841482270",
      "name": "Dr. Ahmed Al-hazzouri, MD",
      "rawName": "Ahmed Al-hazzouri",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1340 N HANCOCK RD",
      "city": "Clermont",
      "state": "FL",
      "postalCode": "34711",
      "phone": "352-394-1150",
      "affiliation": "Regional Academic Oncology Network (Clermont, FL)"
    },
    {
      "npi": "1922635432",
      "name": "Dr. Mina Aleksan, MD",
      "rawName": "Mina Aleksan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9320 STATE ROAD 54",
      "city": "Trinity",
      "state": "FL",
      "postalCode": "34655",
      "phone": "727-842-8411",
      "affiliation": "Regional Academic Oncology Network (Trinity, FL)"
    },
    {
      "npi": "1154302156",
      "name": "Dr. Jose Alemar, MD",
      "rawName": "Jose Alemar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3220 N MCMULLEN BOOTH RD STE C",
      "city": "Clearwater",
      "state": "FL",
      "postalCode": "33761",
      "phone": "727-223-7485",
      "affiliation": "Regional Academic Oncology Network (Clearwater, FL)"
    },
    {
      "npi": "1053631010",
      "name": "Dr. Olatunji Alese, MD",
      "rawName": "Olatunji Alese",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1365 CLIFTON RD NE",
      "city": "Atlanta",
      "state": "GA",
      "postalCode": "30322",
      "phone": "404-778-1900",
      "affiliation": "Regional Academic Oncology Network (Atlanta, GA)"
    },
    {
      "npi": "1306850508",
      "name": "Dr. Christopher Alexander, DO",
      "rawName": "Christopher Alexander",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "325 CLYDE MORRIS BLVD STE 450",
      "city": "Ormond beach",
      "state": "FL",
      "postalCode": "32174",
      "phone": "386-673-2442",
      "affiliation": "Regional Academic Oncology Network (Ormond beach, FL)"
    },
    {
      "npi": "1376868836",
      "name": "Dr. Pamela Allen, MD",
      "rawName": "Pamela Allen",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1365 CLIFTON RD NE STE 4000",
      "city": "Atlanta",
      "state": "GA",
      "postalCode": "30322",
      "phone": "404-778-1900",
      "affiliation": "Regional Academic Oncology Network (Atlanta, GA)"
    },
    {
      "npi": "1508353699",
      "name": "Dr. Yasir Alsaraf, MD",
      "rawName": "Yasir Alsaraf",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3402 W DR MARTIN LUTHER KING JR BLVD",
      "city": "Tampa",
      "state": "FL",
      "postalCode": "33607",
      "phone": "813-875-3950",
      "affiliation": "Regional Academic Oncology Network (Tampa, FL)"
    },
    {
      "npi": "1770549115",
      "name": "Dr. Roy Ambinder, MD",
      "rawName": "Roy Ambinder",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "106 BOSTON AVE STE 105",
      "city": "Altamonte springs",
      "state": "FL",
      "postalCode": "32701",
      "phone": "407-553-7710",
      "affiliation": "Regional Academic Oncology Network (Altamonte springs, FL)"
    },
    {
      "npi": "1245551134",
      "name": "Dr. Tadeu Ambros, MD",
      "rawName": "Tadeu Ambros",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1030 COMMERCE CREEK BLVD",
      "city": "Cape coral",
      "state": "FL",
      "postalCode": "33909",
      "phone": "239-772-3544",
      "affiliation": "Regional Academic Oncology Network (Cape coral, FL)"
    },
    {
      "npi": "1831624428",
      "name": "Dr. Bahaa Amer, MD",
      "rawName": "Bahaa Amer",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "600 N CATTLEMEN RD STE 200",
      "city": "Sarasota",
      "state": "FL",
      "postalCode": "34232",
      "phone": "941-377-9993",
      "affiliation": "Regional Academic Oncology Network (Sarasota, FL)"
    },
    {
      "npi": "1417944745",
      "name": "Dr. Andre Abitbol, MD",
      "rawName": "Andre Abitbol",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1730576455",
      "name": "Dr. Mustafa Abugideiri, MD",
      "rawName": "Mustafa Abugideiri",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1988 S 16TH ST",
      "city": "Wilmington",
      "state": "NC",
      "postalCode": "28401",
      "phone": "910-662-8440",
      "affiliation": "Regional Academic Oncology Network (Wilmington, NC)"
    },
    {
      "npi": "1720489362",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "525 N LEWIS ST",
      "city": "New iberia",
      "state": "LA",
      "postalCode": "70563",
      "phone": "337-364-1131",
      "affiliation": "Regional Academic Oncology Network (New iberia, LA)"
    },
    {
      "npi": "1316923014",
      "name": "Dr. Sanjeev Aggarwal, MD",
      "rawName": "Sanjeev Aggarwal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "7901 LAKE MANASSAS DR STE 100",
      "city": "Gainesville",
      "state": "VA",
      "postalCode": "20155",
      "phone": "540-829-8888",
      "affiliation": "Regional Academic Oncology Network (Gainesville, VA)"
    },
    {
      "npi": "1043743339",
      "name": "Dr. Hiba Ahmed, MD",
      "rawName": "Hiba Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "225 E WASHINGTON AVE",
      "city": "Jonesboro",
      "state": "AR",
      "postalCode": "72401",
      "phone": "870-207-8210",
      "affiliation": "Regional Academic Oncology Network (Jonesboro, AR)"
    },
    {
      "npi": "1659633915",
      "name": "Dr. Kamran Ahmed, MD",
      "rawName": "Kamran Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "12902 USF MAGNOLIA DR",
      "city": "Tampa",
      "state": "FL",
      "postalCode": "33612",
      "phone": "813-745-8535",
      "affiliation": "Regional Academic Oncology Network (Tampa, FL)"
    },
    {
      "npi": "1174691133",
      "name": "Dr. Robin Akins, MD",
      "rawName": "Robin Akins",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8019 S NEW BRAUNFELS STE 101",
      "city": "San antonio",
      "state": "TX",
      "postalCode": "78235",
      "phone": "210-981-3051",
      "affiliation": "Regional Academic Oncology Network (San antonio, TX)"
    },
    {
      "npi": "1013407675",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3670 GRANDVIEW PKWY #100",
      "city": "Birmingham",
      "state": "AL",
      "postalCode": "35243",
      "phone": "205-971-1800",
      "affiliation": "Regional Academic Oncology Network (Birmingham, AL)"
    },
    {
      "npi": "1396808010",
      "name": "Dr. Ahmed Ali, MD",
      "rawName": "Ahmed Ali",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2400 MT. ZION PARKWAY",
      "city": "Jonesboro",
      "state": "GA",
      "postalCode": "30236",
      "phone": "215-662-3957",
      "affiliation": "Regional Academic Oncology Network (Jonesboro, GA)"
    },
    {
      "npi": "1962686238",
      "name": "Dr. Arif Ali, MD",
      "rawName": "Arif Ali",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1200 MEMORIAL DR",
      "city": "Dalton",
      "state": "GA",
      "postalCode": "30720",
      "phone": "706-271-0100",
      "affiliation": "Regional Academic Oncology Network (Dalton, GA)"
    }
  ],
  "washington": [
    {
      "npi": "1003171976",
      "name": "Dr. Vyshak Alva venur, MD",
      "rawName": "Vyshak Alva venur",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "825 EASTLAKE AVE E",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-520-5700",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1184924870",
      "name": "Dr. Richard Ancheta, MD",
      "rawName": "Richard Ancheta",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1717 13TH ST",
      "city": "Everett",
      "state": "WA",
      "postalCode": "98201",
      "phone": "425-297-5500",
      "affiliation": "Regional Academic Oncology Network (Everett, WA)"
    },
    {
      "npi": "1144267766",
      "name": "Dr. Larry Anderson, MD",
      "rawName": "Larry Anderson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2201 INWOOD RD",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75235",
      "phone": "214-645-4673",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1356426183",
      "name": "Dr. Frederick Appelbaum, MD",
      "rawName": "Frederick Appelbaum",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "UNIVERSITY OF WASHINGTON MEDICAL CTR",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98195",
      "phone": "206-288-1000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1174849855",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "510A RAINIER AVE S",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98144",
      "phone": "206-686-1266",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1932285731",
      "name": "Dr. Anthony Back, MD",
      "rawName": "Anthony Back",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "AMBULATORY CLINIC",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-288-1000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1962777862",
      "name": "Dr. Charles Bagley, MD",
      "rawName": "Charles Bagley",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1235 8TH AVE W",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98119",
      "phone": "206-282-1578",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1255523775",
      "name": "Dr. Christina Baik, MD",
      "rawName": "Christina Baik",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "825 EASTLAKE AVE E",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-543-6420",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1992912224",
      "name": "Dr. Merav Bar, MD",
      "rawName": "Merav Bar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1959 NE PACIFIC ST",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98195",
      "phone": "206-520-5000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1922198886",
      "name": "Dr. William Bensinger, MD",
      "rawName": "William Bensinger",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "11311 BRIDGEPORT WAY SW STE 302",
      "city": "Lakewood",
      "state": "WA",
      "postalCode": "98499",
      "phone": "253-533-6700",
      "affiliation": "Regional Academic Oncology Network (Lakewood, WA)"
    },
    {
      "npi": "1225041791",
      "name": "Dr. Shailender Bhatia, MD",
      "rawName": "Shailender Bhatia",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "825 EASTLAKE AVE E",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-288-2015",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1073695227",
      "name": "Dr. Marie Bleakley, MD",
      "rawName": "Marie Bleakley",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4800 SAND POINT WAY NE",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98105",
      "phone": "206-288-1000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1902366677",
      "name": "Dr. Steven Blinka, MD",
      "rawName": "Steven Blinka",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "825 EASTLAKE AVE E",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-520-5000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1346683547",
      "name": "Dr. Mary Bolton, MD",
      "rawName": "Mary Bolton",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "9730 3RD AVE NE STE 208",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98115",
      "phone": "206-522-5646",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1992880991",
      "name": "Dr. Thomas Brown, MD",
      "rawName": "Thomas Brown",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1221 MADISON ST FL 2",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98104",
      "phone": "206-386-2323",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1417510900",
      "name": "Dr. Ahsen Ahmed, MD",
      "rawName": "Ahsen Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1959 NE PACIFIC ST.",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98195",
      "phone": "206-520-5000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1720512296",
      "name": "Dr. Saif Aljabab, MD",
      "rawName": "Saif Aljabab",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1959 NE PACIFIC ST",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98195",
      "phone": "206-598-5825",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1942478854",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3851 PIPER STREET",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99508",
      "phone": "907-212-3186",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1184839722",
      "name": "Dr. Smith Apisarnthanarax, MD",
      "rawName": "Smith Apisarnthanarax",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1570 N 115TH ST",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98133",
      "phone": "206-306-2804",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1194833780",
      "name": "Dr. Kasra Badiozamani, MD",
      "rawName": "Kasra Badiozamani",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "60 MEMORIAL MEDICAL PKWY",
      "city": "Palm coast",
      "state": "FL",
      "postalCode": "32164",
      "phone": "386-586-2060",
      "affiliation": "Regional Academic Oncology Network (Palm coast, FL)"
    },
    {
      "npi": "1629091483",
      "name": "Dr. Todd Barnett, MD",
      "rawName": "Todd Barnett",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1221 MADISON, 1ST FLOOR",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98104",
      "phone": "206-386-2323",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1720356090",
      "name": "Dr. Herbert Berry, MD",
      "rawName": "Herbert Berry",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "65 E. ROANOKE ST.",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98102",
      "phone": "206-323-0982",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1780656785",
      "name": "Dr. Sudershan Bhatia, MD",
      "rawName": "Sudershan Bhatia",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1595 NE PACIFIC ST",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98195",
      "phone": "206-520-5000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1710306592",
      "name": "Dr. Onita Bhattasali, MD",
      "rawName": "Onita Bhattasali",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4950 W SUNSET BLVD",
      "city": "Los angeles",
      "state": "CA",
      "postalCode": "90027",
      "phone": "323-783-2841",
      "affiliation": "Regional Academic Oncology Network (Los angeles, CA)"
    },
    {
      "npi": "1194748715",
      "name": "Dr. John Blasko, MD",
      "rawName": "John Blasko",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1101 MADISON, SUITE 1101",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98104",
      "phone": "206-215-2480",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    }
  ],
  "ohio": [
    {
      "npi": "1104244540",
      "name": "Dr. Asrar Alahmadi, MD",
      "rawName": "Asrar Alahmadi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "300 W 10TH AVE FL 2",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43210",
      "phone": "614-293-5066",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1023927803",
      "name": "Dr. Reham Ali, MD",
      "rawName": "Reham Ali",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-645-2238",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1174000707",
      "name": "Dr. Yasmin Arafah, MD",
      "rawName": "Yasmin Arafah",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "8326 NAAB RD",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46260",
      "phone": "317-871-0000",
      "affiliation": "Regional Academic Oncology Network (Indianapolis, IN)"
    },
    {
      "npi": "1740700194",
      "name": "Dr. Shimoli Barot, MD",
      "rawName": "Shimoli Barot",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-444-2200",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1528022282",
      "name": "Dr. Brian Bolwell, MD",
      "rawName": "Brian Bolwell",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "800-223-2273",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1457315673",
      "name": "Dr. G thomas Budd, MD",
      "rawName": "G thomas Budd",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "800-223-2273",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1508154345",
      "name": "Dr. Shruti Chaturvedi, MD",
      "rawName": "Shruti Chaturvedi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1800 ORLEANS STREET",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21205",
      "phone": "410-502-6686",
      "affiliation": "Johns Hopkins Sidney Kimmel Cancer Center"
    },
    {
      "npi": "1932594728",
      "name": "Dr. Lauren Chiec, MD",
      "rawName": "Lauren Chiec",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "11100 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-844-3951",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1407218704",
      "name": "Dr. Jacob Choi, MD",
      "rawName": "Jacob Choi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "251 E HURON ST",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60611",
      "phone": "312-695-6939",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1144586348",
      "name": "Dr. Christine Cordova, MD",
      "rawName": "Christine Cordova",
      "credential": "MD",
      "specialty": "Psychiatry & Neurology, Neurology",
      "taxonomyCode": "2084N0400X",
      "practiceAddress": "4500 SAN PABLO RD S",
      "city": "Jacksonville",
      "state": "FL",
      "postalCode": "32224",
      "phone": "904-953-2000",
      "affiliation": "Regional Academic Oncology Network (Jacksonville, FL)"
    },
    {
      "npi": "1316391253",
      "name": "Dr. Scott Dawsey, MD",
      "rawName": "Scott Dawsey",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4646 JOHN R ST",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48201",
      "phone": "313-576-1000",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1851491195",
      "name": "Dr. Marcos De lima, MD",
      "rawName": "Marcos De lima",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "11100 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-844-3951",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1306800735",
      "name": "Dr. Robert Dean, MD",
      "rawName": "Robert Dean",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "800-223-2273",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1326797218",
      "name": "Dr. Chaim Domb, MD",
      "rawName": "Chaim Domb",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2500 METROHEALTH DR",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44109",
      "phone": "216-778-4486",
      "affiliation": "Regional Academic Oncology Network (Cleveland, OH)"
    },
    {
      "npi": "1841188042",
      "name": "Dr. Sonia margarida Duarte de oliveira, MD",
      "rawName": "Sonia margarida Duarte de oliveira",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "11100 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-844-3293",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1205096609",
      "name": "Dr. Mohamed Abazeed, MD",
      "rawName": "Mohamed Abazeed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "251 E HURON ST",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60611",
      "phone": "312-926-5392",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1982620340",
      "name": "Dr. May Abdel-wahab, MD",
      "rawName": "May Abdel-wahab",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-445-7930",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1013438571",
      "name": "Dr. Ibrahim Abugheida, MD",
      "rawName": "Ibrahim Abugheida",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-444-2200",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1437675741",
      "name": "Dr. Salem Alfaifi, MD",
      "rawName": "Salem Alfaifi",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "10201 CARNEGIE AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-312-6671",
      "affiliation": "Regional Academic Oncology Network (Cleveland, OH)"
    },
    {
      "npi": "1932366267",
      "name": "Dr. Sudha Amarnath, MD",
      "rawName": "Sudha Amarnath",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "617-251-5421",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1003858234",
      "name": "Dr. Thomas Anderson, DO",
      "rawName": "Thomas Anderson",
      "credential": "DO",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5200 W BROAD ST",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43228",
      "phone": "614-544-1930",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1104867357",
      "name": "Dr. Nami Azar, MD",
      "rawName": "Nami Azar",
      "credential": "MD",
      "specialty": "Radiology, Diagnostic Radiology",
      "taxonomyCode": "2085R0202X",
      "practiceAddress": "11100 EUCLID AVENUE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-844-7200",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1710229117",
      "name": "Dr. Ehsan Balagamwala, MD",
      "rawName": "Ehsan Balagamwala",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-444-2200",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1932146800",
      "name": "Dr. Barbara Bangert, MD",
      "rawName": "Barbara Bangert",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085N0700X",
      "practiceAddress": "11100 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "216-844-1700",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1194717934",
      "name": "Dr. Fredrick Barton, MD",
      "rawName": "Fredrick Barton",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "11100 EUCLID AVENUE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44106",
      "phone": "440-324-0440",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    }
  ],
  "maryland": [
    {
      "npi": "1881805166",
      "name": "Dr. Nagla Abdel karim, MD",
      "rawName": "Nagla Abdel karim",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8081 INNOVATION PARK DR",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22031",
      "phone": "571-472-4724",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1528446242",
      "name": "Dr. Jafar Al-mondhiry, MD",
      "rawName": "Jafar Al-mondhiry",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8081 INNOVATION PARK DR",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22031",
      "phone": "571-472-1190",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1356565501",
      "name": "Dr. Syed abbas Ali, MD",
      "rawName": "Syed abbas Ali",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 HIGHWAY 78 E",
      "city": "Jasper",
      "state": "AL",
      "postalCode": "35501",
      "phone": "205-387-4401",
      "affiliation": "Regional Academic Oncology Network (Jasper, AL)"
    },
    {
      "npi": "1942628458",
      "name": "Dr. Joshua Allen, MD",
      "rawName": "Joshua Allen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3580 JOSEPH SIEWICK DR STE 403",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22033",
      "phone": "703-391-4395",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1629411558",
      "name": "Dr. Alexander Ambinder, MD",
      "rawName": "Alexander Ambinder",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1650 ORLEANS ST # 1186",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-614-4459",
      "affiliation": "Johns Hopkins Sidney Kimmel Cancer Center"
    },
    {
      "npi": "1528022407",
      "name": "Dr. Richard Ambinder, MD",
      "rawName": "Richard Ambinder",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "600 N WOLFE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-8964",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1164089843",
      "name": "Dr. Amir Ameri, MD",
      "rawName": "Amir Ameri",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1800 ORLEANS ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-5000",
      "affiliation": "Johns Hopkins Sidney Kimmel Cancer Center"
    },
    {
      "npi": "1043841059",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "9160 FORUM CORPORATE PKWY STE 350",
      "city": "Fort myers",
      "state": "FL",
      "postalCode": "33905",
      "phone": "239-785-3200",
      "affiliation": "Regional Academic Oncology Network (Fort myers, FL)"
    },
    {
      "npi": "1629865126",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "5233 KING AVE STE 308",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21237",
      "phone": "410-780-4050",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1821314030",
      "name": "Dr. Valsamo Anagnostou, MD",
      "rawName": "Valsamo Anagnostou",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1650 ORLEANS STREET",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21231",
      "phone": "410-955-8893",
      "affiliation": "Johns Hopkins Sidney Kimmel Cancer Center"
    },
    {
      "npi": "1568528768",
      "name": "Dr. Emmanuel Antonarakis, MD",
      "rawName": "Emmanuel Antonarakis",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "909 FULTON ST SE",
      "city": "Minneapolis",
      "state": "MN",
      "postalCode": "55455",
      "phone": "612-672-6000",
      "affiliation": "Regional Academic Oncology Network (Minneapolis, MN)"
    },
    {
      "npi": "1619211745",
      "name": "Dr. Khurram Anwar, MD",
      "rawName": "Khurram Anwar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3580 JOSEPH SIEWICK DR STE 403",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22033",
      "phone": "703-391-4395",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1376701946",
      "name": "Dr. Jeanny Aragon-ching, MD",
      "rawName": "Jeanny Aragon-ching",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3300 GALLOWS RD",
      "city": "Falls church",
      "state": "VA",
      "postalCode": "22042",
      "phone": "703-776-4001",
      "affiliation": "Regional Academic Oncology Network (Falls church, VA)"
    },
    {
      "npi": "1588628390",
      "name": "Dr. Mary Armanios, MD",
      "rawName": "Mary Armanios",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "600 N WOLFE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-8964",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1437113255",
      "name": "Dr. Deborah Armstrong, MD",
      "rawName": "Deborah Armstrong",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10755 FALLS RD",
      "city": "Lutherville",
      "state": "MD",
      "postalCode": "21093",
      "phone": "410-583-2970",
      "affiliation": "Regional Academic Oncology Network (Lutherville, MD)"
    },
    {
      "npi": "1639436603",
      "name": "Dr. Sahaja Acharya, MD",
      "rawName": "Sahaja Acharya",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "600 N WOLFE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-5000",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1871813204",
      "name": "Dr. Sara Alcorn, MD",
      "rawName": "Sara Alcorn",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4940 EASTERN AVE",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21224",
      "phone": "410-955-7390",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1215961727",
      "name": "Dr. Pradip Amin, MD",
      "rawName": "Pradip Amin",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "22 S GREENE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21201",
      "phone": "410-328-3037",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1841439908",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1701 N GEORGE MASON DR",
      "city": "Arlington",
      "state": "VA",
      "postalCode": "22205",
      "phone": "703-558-6284",
      "affiliation": "Regional Academic Oncology Network (Arlington, VA)"
    },
    {
      "npi": "1073578837",
      "name": "Dr. Fariba Asrari, MD",
      "rawName": "Fariba Asrari",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "600 N WOLFE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-8964",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1174528798",
      "name": "Dr. Cengiz Aygun, MD",
      "rawName": "Cengiz Aygun",
      "credential": "MD",
      "specialty": "Specialist",
      "taxonomyCode": "174400000X",
      "practiceAddress": "9105 FRANKLIN SQUARE DR",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21237",
      "phone": "410-682-6800",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1881213007",
      "name": "Dr. Khaled Aziz, MD",
      "rawName": "Khaled Aziz",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    },
    {
      "npi": "1376163154",
      "name": "Dr. Soha Bazyar, MD",
      "rawName": "Soha Bazyar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2401 W BELVEDERE AVE",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21215",
      "phone": "410-601-5689",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1407485519",
      "name": "Dr. Akrita Bhatnagar, MD",
      "rawName": "Akrita Bhatnagar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9000 FRANKLIN SQUARE DR DEPT OF",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21237",
      "phone": "443-777-7771",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1205837390",
      "name": "Dr. Albert Blumberg, MD",
      "rawName": "Albert Blumberg",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "6701 N CHARLES ST",
      "city": "Towson",
      "state": "MD",
      "postalCode": "21204",
      "phone": "443-849-2540",
      "affiliation": "Regional Academic Oncology Network (Towson, MD)"
    }
  ],
  "florida": [
    {
      "npi": "1356385140",
      "name": "Dr. Bach Ardalan, MD",
      "rawName": "Bach Ardalan",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1475 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-1000",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1780229047",
      "name": "Dr. Kyaw Aung, MD",
      "rawName": "Kyaw Aung",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1417451667",
      "name": "Dr. Priscila Barreto coelho, MD",
      "rawName": "Priscila Barreto coelho",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1611 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-915-1103",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1528095775",
      "name": "Dr. Pasquale Benedetto, MD",
      "rawName": "Pasquale Benedetto",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1611 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-4664",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1447347851",
      "name": "Dr. Aron Berkman, MD",
      "rawName": "Aron Berkman",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 SW 108TH AVE STE 100",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33174",
      "phone": "786-595-0000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1184884090",
      "name": "Dr. Marijo Bilusic, MD",
      "rawName": "Marijo Bilusic",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1120 NW 14TH ST STE 610B",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-9779",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1770729543",
      "name": "Dr. Lauren Carcas, MD",
      "rawName": "Lauren Carcas",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6738 W SUNRISE BLVD STE 103",
      "city": "Plantation",
      "state": "FL",
      "postalCode": "33313",
      "phone": "954-837-1490",
      "affiliation": "Regional Academic Oncology Network (Plantation, FL)"
    },
    {
      "npi": "1306010590",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8740 SW 88TH ST",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "305-271-1515",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1902193147",
      "name": "Dr. Aman Chauhan, MD",
      "rawName": "Aman Chauhan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1825 4TH ST FL 4",
      "city": "San francisco",
      "state": "CA",
      "postalCode": "94143",
      "phone": "415-353-9888",
      "affiliation": "Regional Academic Oncology Network (San francisco, CA)"
    },
    {
      "npi": "1871720235",
      "name": "Dr. Zhijian Chen, MD",
      "rawName": "Zhijian Chen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1619292406",
      "name": "Dr. Anthony Daniyan, MD",
      "rawName": "Anthony Daniyan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1275 YORK AVE",
      "city": "New york",
      "state": "NY",
      "postalCode": "10065",
      "phone": "212-639-3007",
      "affiliation": "Memorial Sloan Kettering Cancer Center"
    },
    {
      "npi": "1144454257",
      "name": "Dr. Nicole Eiseler, MD",
      "rawName": "Nicole Eiseler",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8900 N. KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1659624856",
      "name": "Dr. Firas El chaer, MD",
      "rawName": "Firas El chaer",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1649233370",
      "name": "Dr. Donald Ernst, MD",
      "rawName": "Donald Ernst",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1611 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-6484",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1467820837",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "78 SW 13TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33135",
      "phone": "305-642-6966",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1417944745",
      "name": "Dr. Andre Abitbol, MD",
      "rawName": "Andre Abitbol",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1295993699",
      "name": "Dr. Matthew Abramowitz, MD",
      "rawName": "Matthew Abramowitz",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1475 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-4200",
      "affiliation": "Sylvester Comprehensive Cancer Center"
    },
    {
      "npi": "1891056495",
      "name": "Dr. Bret Adams, MD",
      "rawName": "Bret Adams",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2013 JEFFERSON ST SW FL 2",
      "city": "Roanoke",
      "state": "VA",
      "postalCode": "24014",
      "phone": "540-982-0237",
      "affiliation": "Regional Academic Oncology Network (Roanoke, VA)"
    },
    {
      "npi": "1245296904",
      "name": "Dr. Ahmed Akl, MD",
      "rawName": "Ahmed Akl",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "803 W MARKET ST STE 100",
      "city": "Lima",
      "state": "OH",
      "postalCode": "45805",
      "phone": "419-996-5063",
      "affiliation": "Regional Academic Oncology Network (Lima, OH)"
    },
    {
      "npi": "1073511333",
      "name": "Dr. Beatriz Amendola, MD",
      "rawName": "Beatriz Amendola",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5995 SW 71ST ST STE 1-A",
      "city": "South miami",
      "state": "FL",
      "postalCode": "33143",
      "phone": "305-669-6833",
      "affiliation": "Regional Academic Oncology Network (South miami, FL)"
    },
    {
      "npi": "1629903018",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiology, Diagnostic Radiology",
      "taxonomyCode": "2085R0202X",
      "practiceAddress": "13155 SW 134TH ST STE 204",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33186",
      "phone": "786-839-0862",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1417516600",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1100 N.W. 95TH STREET",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33150",
      "phone": "305-835-6173",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1861870636",
      "name": "Dr. Gregory Azzam, MD",
      "rawName": "Gregory Azzam",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1611 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-4200",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1679978118",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "8900 N KENDALL DR",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33176",
      "phone": "786-596-2000",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    },
    {
      "npi": "1548707458",
      "name": "Dr. Jonathan Bell, MD",
      "rawName": "Jonathan Bell",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1611 NW 12TH AVE",
      "city": "Miami",
      "state": "FL",
      "postalCode": "33136",
      "phone": "305-243-4200",
      "affiliation": "Regional Academic Oncology Network (Miami, FL)"
    }
  ],
  "arizona": [
    {
      "npi": "1548431042",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3411 N 5TH AVE",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-248-0448",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1750511051",
      "name": "Dr. Rishi Agarwal, MD",
      "rawName": "Rishi Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10460 N 92ND ST STE 400",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85258",
      "phone": "623-238-7630",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1609187921",
      "name": "Dr. Nazish Ahmad, DO",
      "rawName": "Nazish Ahmad",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5601 W EUGIE AVE",
      "city": "Glendale",
      "state": "AZ",
      "postalCode": "85304",
      "phone": "602-978-6255",
      "affiliation": "Regional Academic Oncology Network (Glendale, AZ)"
    },
    {
      "npi": "1063036135",
      "name": "Dr. Isaak Ailts, MD",
      "rawName": "Isaak Ailts",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "701-234-6161",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1154369577",
      "name": "Dr. Waqas Arslan, MD",
      "rawName": "Waqas Arslan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2525 E ROOSEVELT ST",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85008",
      "phone": "602-344-1015",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1881733889",
      "name": "Dr. John Bibb, MD",
      "rawName": "John Bibb",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10460 N 92ND ST # 200-400",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85258",
      "phone": "623-238-7630",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1275910911",
      "name": "Dr. Gehan Botrus, MD",
      "rawName": "Gehan Botrus",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "4800 ALBERTA AVE",
      "city": "El paso",
      "state": "TX",
      "postalCode": "79905",
      "phone": "915-215-8000",
      "affiliation": "Regional Academic Oncology Network (El paso, TX)"
    },
    {
      "npi": "1801397658",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2915 W ROSE GARDEN LN",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85027",
      "phone": "623-932-8960",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1720293608",
      "name": "Dr. Tania Cortas, MD",
      "rawName": "Tania Cortas",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "11209 N TATUM BLVD STE 200",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85028",
      "phone": "480-530-4200",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1265765374",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2525 E ROOSEVELT ST",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85008",
      "phone": "602-344-1095",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1396735585",
      "name": "Dr. Panagiotis Fidias, MD",
      "rawName": "Panagiotis Fidias",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5 ALUMNI DR",
      "city": "Exeter",
      "state": "NH",
      "postalCode": "03833",
      "phone": "603-580-7054",
      "affiliation": "Regional Academic Oncology Network (Exeter, NH)"
    },
    {
      "npi": "1093008336",
      "name": "Dr. Amber Flaherty, MD",
      "rawName": "Amber Flaherty",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "11209 N TATUM BLVD STE B200",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85028",
      "phone": "480-530-4200",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1831167402",
      "name": "Dr. David Garfield, MD",
      "rawName": "David Garfield",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2601 N SPRUCE ST",
      "city": "Ogallala",
      "state": "NE",
      "postalCode": "69153",
      "phone": "308-284-3645",
      "affiliation": "Regional Academic Oncology Network (Ogallala, NE)"
    },
    {
      "npi": "1558724013",
      "name": "Dr. Charles Gaulin, MD",
      "rawName": "Charles Gaulin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Lebanon",
      "state": "NH",
      "postalCode": "03756",
      "phone": "603-650-5000",
      "affiliation": "Regional Academic Oncology Network (Lebanon, NH)"
    },
    {
      "npi": "1548609910",
      "name": "Dr. Safia Ahmed, MD",
      "rawName": "Safia Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "13400 E SHEA BLVD",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85259",
      "phone": "072-842-5115",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1902645823",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5925 KISSENA BLVD STE 800",
      "city": "Flushing",
      "state": "NY",
      "postalCode": "11355",
      "phone": "347-428-1020",
      "affiliation": "Regional Academic Oncology Network (Flushing, NY)"
    },
    {
      "npi": "1699426445",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1445 W CHANDLER BLVD STE A5",
      "city": "Chandler",
      "state": "AZ",
      "postalCode": "85224",
      "phone": "480-360-4009",
      "affiliation": "Regional Academic Oncology Network (Chandler, AZ)"
    },
    {
      "npi": "1750683710",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "350 W THOMAS RD",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-406-3170",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1972628675",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "300 W CLARENDON",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-274-4484",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1922203728",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "300 W CLARENDON AVE",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-240-3395",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1083066450",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "16620 N 40TH ST",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85032",
      "phone": "602-396-0851",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    },
    {
      "npi": "1174434823",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "18250 N HAYDEN RD",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85255",
      "phone": "480-771-2744",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1811105943",
      "name": "Dr. Igor Barani, MD",
      "rawName": "Igor Barani",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "350 W THOMAS RD",
      "city": "Phoenix",
      "state": "AZ",
      "postalCode": "85013",
      "phone": "602-406-6761",
      "affiliation": "Regional Academic Oncology Network (Phoenix, AZ)"
    }
  ],
  "colorado": [
    {
      "npi": "1588176051",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "499 E HAMPDEN AVE STE 450",
      "city": "Englewood",
      "state": "CO",
      "postalCode": "80113",
      "phone": "720-389-7749",
      "affiliation": "Regional Academic Oncology Network (Englewood, CO)"
    },
    {
      "npi": "1942356530",
      "name": "Dr. Eamon Berge, MD",
      "rawName": "Eamon Berge",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2045 N FRANKLIN ST",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80205",
      "phone": "303-338-4545",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1346287968",
      "name": "Dr. Laurie Carr, MD",
      "rawName": "Laurie Carr",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1400 JACKSON ST",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80206",
      "phone": "303-388-4461",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1316957368",
      "name": "Dr. Ping Chu, MD",
      "rawName": "Ping Chu",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2555 S DOWNING ST STE 240",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80210",
      "phone": "303-715-7030",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1124603816",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1601 E 19TH AVE STE 3550",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "720-316-8091",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1477643153",
      "name": "Dr. Harry Drabkin, MD",
      "rawName": "Harry Drabkin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "171 ASHLEY AVE",
      "city": "Charleston",
      "state": "SC",
      "postalCode": "29425",
      "phone": "843-792-4271",
      "affiliation": "Regional Academic Oncology Network (Charleston, SC)"
    },
    {
      "npi": "1366541294",
      "name": "Dr. Gerald Falchook, MD",
      "rawName": "Gerald Falchook",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1800 WILLIAMS ST",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "720-754-2610",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1588290332",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1800 N WILLIAMS ST STE 300",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "720-754-2610",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1508491606",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1719 E 19TH AVE",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "303-839-6000",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1851301881",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2005 FRANKLIN ST STE 170",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80205",
      "phone": "303-860-9100",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1790642338",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1818 N OGDEN ST STE 200",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "303-318-3434",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1841454048",
      "name": "Dr. Sudy Jahangiri, MD",
      "rawName": "Sudy Jahangiri",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1818 N OGDEN ST STE 200",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "303-318-3434",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1518109420",
      "name": "Dr. Ghayathri Jeyakumar, MD",
      "rawName": "Ghayathri Jeyakumar",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4623 160TH ST",
      "city": "Flushing",
      "state": "NY",
      "postalCode": "11358",
      "phone": "310-357-9793",
      "affiliation": "Regional Academic Oncology Network (Flushing, NY)"
    },
    {
      "npi": "1700876992",
      "name": "Dr. Christopher Jones, MD",
      "rawName": "Christopher Jones",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "9451 HURON ST",
      "city": "Thornton",
      "state": "CO",
      "postalCode": "80260",
      "phone": "303-650-4042",
      "affiliation": "Regional Academic Oncology Network (Thornton, CO)"
    },
    {
      "npi": "1942592563",
      "name": "Dr. Juraj Kavecansky, MD",
      "rawName": "Juraj Kavecansky",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1425 S MAIN ST FL 2",
      "city": "Walnut creek",
      "state": "CA",
      "postalCode": "94596",
      "phone": "925-295-4030",
      "affiliation": "Regional Academic Oncology Network (Walnut creek, CA)"
    },
    {
      "npi": "1689720260",
      "name": "Dr. Ari Ballonoff, MD",
      "rawName": "Ari Ballonoff",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1375 E 19TH AVE",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "303-338-4545",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1417161704",
      "name": "Dr. Ajay Bhatnagar, MD",
      "rawName": "Ajay Bhatnagar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "500 UNIVERSITY DR",
      "city": "Hershey",
      "state": "PA",
      "postalCode": "17033",
      "phone": "717-531-8024",
      "affiliation": "Regional Academic Oncology Network (Hershey, PA)"
    },
    {
      "npi": "1780687889",
      "name": "Dr. Steven Bush, MD",
      "rawName": "Steven Bush",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1 MERCADO ST",
      "city": "Durango",
      "state": "CO",
      "postalCode": "81301",
      "phone": "970-385-4746",
      "affiliation": "Regional Academic Oncology Network (Durango, CO)"
    },
    {
      "npi": "1336256171",
      "name": "Dr. Changhu Chen, MD",
      "rawName": "Changhu Chen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "200 EXEMPLA CIR",
      "city": "Lafayette",
      "state": "CO",
      "postalCode": "80026",
      "phone": "303-338-4545",
      "affiliation": "Regional Academic Oncology Network (Lafayette, CO)"
    },
    {
      "npi": "1780711366",
      "name": "Dr. Mark Chidel, MD",
      "rawName": "Mark Chidel",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1375 E 19TH AVE",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "303-338-4545",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1285834945",
      "name": "Dr. Eugene Chung, MD",
      "rawName": "Eugene Chung",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4567 E 9TH AVE",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80220",
      "phone": "303-338-4545",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1336696152",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Emergency Medicine",
      "taxonomyCode": "207P00000X",
      "practiceAddress": "3010 15TH AVE S",
      "city": "Great falls",
      "state": "MT",
      "postalCode": "59405",
      "phone": "406-216-8000",
      "affiliation": "Regional Academic Oncology Network (Great falls, MT)"
    },
    {
      "npi": "1043743883",
      "name": "Dr. Christopher Deig, MD",
      "rawName": "Christopher Deig",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1721 E 19TH AVE",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80218",
      "phone": "812-449-1243",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1275740508",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2555 S. DOWNING ST",
      "city": "Denver",
      "state": "CO",
      "postalCode": "80210",
      "phone": "303-778-5714",
      "affiliation": "Regional Academic Oncology Network (Denver, CO)"
    },
    {
      "npi": "1407261290",
      "name": "Dr. Kaleigh Doke, MD",
      "rawName": "Kaleigh Doke",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "525 BOB PETERS GRV",
      "city": "Colorado springs",
      "state": "CO",
      "postalCode": "80909",
      "phone": "719-365-6800",
      "affiliation": "Regional Academic Oncology Network (Colorado springs, CO)"
    }
  ],
  "north-carolina": [
    {
      "npi": "1962598094",
      "name": "Dr. Amy Abernethy, MD",
      "rawName": "Amy Abernethy",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4101 N ROXBORO ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27704",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1932633617",
      "name": "Dr. Laura Alder, MD",
      "rawName": "Laura Alder",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "20 DUKE MEDICINE CIR",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-681-9509",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1528160199",
      "name": "Dr. Andrew Armstrong, MD",
      "rawName": "Andrew Armstrong",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4101 N ROXBORO ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27704",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1144858549",
      "name": "Dr. Kirstin Binz, MD",
      "rawName": "Kirstin Binz",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "12200 W 110TH ST",
      "city": "Overland park",
      "state": "KS",
      "postalCode": "66210",
      "phone": "913-588-1227",
      "affiliation": "Regional Academic Oncology Network (Overland park, KS)"
    },
    {
      "npi": "1184694754",
      "name": "Dr. Gerard Blobe, MD",
      "rawName": "Gerard Blobe",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "BOX 2631 DUMC",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-668-1352",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1023119534",
      "name": "Dr. Carin Caves, MD",
      "rawName": "Carin Caves",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "DUKE UNIVERSITY HOSPITAL, 9300 INPATIENT UNIT",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-681-9341",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1215951587",
      "name": "Dr. Nelson Chao, MD",
      "rawName": "Nelson Chao",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4101 N ROXBORO ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27704",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1912290719",
      "name": "Dr. Jennifer Choe, MD",
      "rawName": "Jennifer Choe",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-936-9177",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1164505319",
      "name": "Dr. John Chute, MD",
      "rawName": "John Chute",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "8700 BEVERLY BLVD",
      "city": "West hollywood",
      "state": "CA",
      "postalCode": "90048",
      "phone": "310-248-7622",
      "affiliation": "Regional Academic Oncology Network (West hollywood, CA)"
    },
    {
      "npi": "1437787074",
      "name": "Dr. John Claiborne, MD",
      "rawName": "John Claiborne",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2400 PRATT ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27705",
      "phone": "919-684-3495",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1922543131",
      "name": "Dr. Jason Crockett, MD",
      "rawName": "Jason Crockett",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "20 DUKE MEDICINE CIRCLE DUKE CANCER CENTER CLINIC 5-1",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-668-8108",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1629151873",
      "name": "Dr. Frank Dunphy, MD",
      "rawName": "Frank Dunphy",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "DUKE UNIVERSITY MEDICAL CTR",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-620-4467",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1952796385",
      "name": "Dr. Megan Dupuis, MD",
      "rawName": "Megan Dupuis",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1548720956",
      "name": "Dr. Catherine Fahey, MD",
      "rawName": "Catherine Fahey",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "101 MANNING DR",
      "city": "Chapel hill",
      "state": "NC",
      "postalCode": "27514",
      "phone": "984-974-1000",
      "affiliation": "Regional Academic Oncology Network (Chapel hill, NC)"
    },
    {
      "npi": "1649513250",
      "name": "Dr. Eric Fountain, MD",
      "rawName": "Eric Fountain",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "520 S EAGLE RD",
      "city": "Meridian",
      "state": "ID",
      "postalCode": "83642",
      "phone": "208-381-2484",
      "affiliation": "Regional Academic Oncology Network (Meridian, ID)"
    },
    {
      "npi": "1861724627",
      "name": "Dr. Karen Allen, MD",
      "rawName": "Karen Allen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2100 ERWIN RD",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27705",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1659554897",
      "name": "Dr. Rachel Blitzblau, MD",
      "rawName": "Rachel Blitzblau",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2100 ERWIN RD",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27705",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1043586142",
      "name": "Dr. Matthew Boyer, MD",
      "rawName": "Matthew Boyer",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "DURHAM VAMC DEPARTMENT OF RADIATION ONCOLOGY",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27705",
      "phone": "919-286-6996",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1720173560",
      "name": "Dr. David Brizel, MD",
      "rawName": "David Brizel",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4101 N ROXBORO ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27704",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1114951423",
      "name": "Dr. Andrew Brown, MD",
      "rawName": "Andrew Brown",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "500 LAUCHWOOD DRIVE",
      "city": "Laurinburg",
      "state": "NC",
      "postalCode": "28352",
      "phone": "910-291-7120",
      "affiliation": "Regional Academic Oncology Network (Laurinburg, NC)"
    },
    {
      "npi": "1487731949",
      "name": "Dr. Catherine Chang, MD",
      "rawName": "Catherine Chang",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2100 ERWIN RD",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27705",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1023695251",
      "name": "Dr. Mark Chen, MD",
      "rawName": "Mark Chen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "20 DUKE MEDICINE CIR",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-660-2100",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1316138548",
      "name": "Dr. Junzo Chino, MD",
      "rawName": "Junzo Chino",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2100 ERWIN RD",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27710",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    },
    {
      "npi": "1205104783",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4700 WATERS AVE",
      "city": "Savannah",
      "state": "GA",
      "postalCode": "31404",
      "phone": "912-350-8490",
      "affiliation": "Regional Academic Oncology Network (Savannah, GA)"
    },
    {
      "npi": "1336234012",
      "name": "Dr. Brian Czito, MD",
      "rawName": "Brian Czito",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4101 N ROXBORO ST",
      "city": "Durham",
      "state": "NC",
      "postalCode": "27704",
      "phone": "919-684-8111",
      "affiliation": "Regional Academic Oncology Network (Durham, NC)"
    }
  ],
  "tennessee": [
    {
      "npi": "1154359602",
      "name": "Dr. Vandana Abramson, MD",
      "rawName": "Vandana Abramson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-936-2000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1790027936",
      "name": "Dr. Rajiv Agarwal, MD",
      "rawName": "Rajiv Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1548142102",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1316 ADAMS ST STE 400",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37208",
      "phone": "203-461-1446",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1588621031",
      "name": "Dr. Carlos Bachier, MD",
      "rawName": "Carlos Bachier",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "HOSPITAL AUXILIO MUTUO",
      "city": "San juan",
      "state": "PR",
      "postalCode": "00917",
      "phone": "787-758-2000",
      "affiliation": "Regional Academic Oncology Network (San juan, PR)"
    },
    {
      "npi": "1740507706",
      "name": "Dr. Muhamed Baljevic, MD",
      "rawName": "Muhamed Baljevic",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4301 W MARKHAM ST # 506",
      "city": "Little rock",
      "state": "AR",
      "postalCode": "72205",
      "phone": "501-686-8000",
      "affiliation": "Regional Academic Oncology Network (Little rock, AR)"
    },
    {
      "npi": "1467407429",
      "name": "Dr. John Barton, MD",
      "rawName": "John Barton",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1840 MEDICAL CENTER PKWY",
      "city": "Murfreesboro",
      "state": "TN",
      "postalCode": "37129",
      "phone": "615-848-0488",
      "affiliation": "Regional Academic Oncology Network (Murfreesboro, TN)"
    },
    {
      "npi": "1083703540",
      "name": "Dr. Johanna Bendell, MD",
      "rawName": "Johanna Bendell",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "250 25TH AVE N",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37203",
      "phone": "615-320-5090",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1275620312",
      "name": "Dr. Jordan Berlin, MD",
      "rawName": "Jordan Berlin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 TVC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1477182749",
      "name": "Dr. Sean Bliven, MD",
      "rawName": "Sean Bliven",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1032 MCCALLIE AVE STE 200",
      "city": "Chattanooga",
      "state": "TN",
      "postalCode": "37403",
      "phone": "423-752-5004",
      "affiliation": "Regional Academic Oncology Network (Chattanooga, TN)"
    },
    {
      "npi": "1528105616",
      "name": "Dr. Johann Brandes, MD",
      "rawName": "Johann Brandes",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1840 MEDICAL CENTER PKWY",
      "city": "Murfreesboro",
      "state": "TN",
      "postalCode": "37129",
      "phone": "615-848-0488",
      "affiliation": "Regional Academic Oncology Network (Murfreesboro, TN)"
    },
    {
      "npi": "1417992397",
      "name": "Dr. Howard Burris, MD",
      "rawName": "Howard Burris",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "250 25TH AVE N",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37203",
      "phone": "615-320-5090",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1487701280",
      "name": "Dr. Dana Cardin, MD",
      "rawName": "Dana Cardin",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1528202579",
      "name": "Dr. Emily Castellanos, MD",
      "rawName": "Emily Castellanos",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "333 COTTMAN AVE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-2570",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1053495168",
      "name": "Dr. Emily Chan, MD",
      "rawName": "Emily Chan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 TVC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1912290719",
      "name": "Dr. Jennifer Choe, MD",
      "rawName": "Jennifer Choe",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-936-9177",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1962906974",
      "name": "Dr. Sean All, MD",
      "rawName": "Sean All",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1134582240",
      "name": "Dr. Khush Aujla, MD",
      "rawName": "Khush Aujla",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1558682336",
      "name": "Dr. Diandra Ayala-peacock, MD",
      "rawName": "Diandra Ayala-peacock",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3601 TVC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1629690573",
      "name": "Dr. Milad Baradaran ghahfarokhi, MD",
      "rawName": "Milad Baradaran ghahfarokhi",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2220 PIERCE AVE",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-343-9241",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1811923386",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8787 BRYAN DAIRY RD",
      "city": "Largo",
      "state": "FL",
      "postalCode": "33777",
      "phone": "727-320-0200",
      "affiliation": "Regional Academic Oncology Network (Largo, FL)"
    },
    {
      "npi": "1467251454",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3155 N MCMULLEN BOOTH RD",
      "city": "Clearwater",
      "state": "FL",
      "postalCode": "33761",
      "phone": "727-320-0200",
      "affiliation": "Regional Academic Oncology Network (Clearwater, FL)"
    },
    {
      "npi": "1952330672",
      "name": "Dr. Marion Bolin, MD",
      "rawName": "Marion Bolin",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4220 HARDING PIKE",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37205",
      "phone": "615-222-6755",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    },
    {
      "npi": "1417367863",
      "name": "Dr. Christopher Brett, MD",
      "rawName": "Christopher Brett",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1926 ALCOA HWY STE 130",
      "city": "Knoxville",
      "state": "TN",
      "postalCode": "37920",
      "phone": "865-305-9040",
      "affiliation": "Regional Academic Oncology Network (Knoxville, TN)"
    },
    {
      "npi": "1093274227",
      "name": "Dr. Aaron Bush, MD",
      "rawName": "Aaron Bush",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1231 N LAWNWOOD CIR STE B",
      "city": "Fort pierce",
      "state": "FL",
      "postalCode": "34950",
      "phone": "772-271-4830",
      "affiliation": "Regional Academic Oncology Network (Fort pierce, FL)"
    },
    {
      "npi": "1992383335",
      "name": "Dr. Hayden Byrd, MD",
      "rawName": "Hayden Byrd",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "605 GLENWOOD DR STE 200",
      "city": "Chattanooga",
      "state": "TN",
      "postalCode": "37404",
      "phone": "423-495-7730",
      "affiliation": "Regional Academic Oncology Network (Chattanooga, TN)"
    }
  ],
  "michigan": [
    {
      "npi": "1992226575",
      "name": "Dr. Fawzi Abu rous, MD",
      "rawName": "Fawzi Abu rous",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1215 E MICHIGAN AVE",
      "city": "Lansing",
      "state": "MI",
      "postalCode": "48912",
      "phone": "517-364-1000",
      "affiliation": "Regional Academic Oncology Network (Lansing, MI)"
    },
    {
      "npi": "1790952562",
      "name": "Dr. Asif Alavi, MD",
      "rawName": "Asif Alavi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4100 JOHN R",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48201",
      "phone": "800-527-6266",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1427381607",
      "name": "Dr. Costantine Albany, MD",
      "rawName": "Costantine Albany",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1701 S CREASY LN",
      "city": "Lafayette",
      "state": "IN",
      "postalCode": "47905",
      "phone": "765-775-2800",
      "affiliation": "Regional Academic Oncology Network (Lafayette, IN)"
    },
    {
      "npi": "1174691695",
      "name": "Dr. Haythem Ali, MD",
      "rawName": "Haythem Ali",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "HENRY FORD HEALTH SYSTEM",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "313-916-7648",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1811935273",
      "name": "Dr. Joel Appel, DO",
      "rawName": "Joel Appel",
      "credential": "DO",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "27207 LAHSER RD",
      "city": "Southfield",
      "state": "MI",
      "postalCode": "48034",
      "phone": "248-358-4892",
      "affiliation": "Regional Academic Oncology Network (Southfield, MI)"
    },
    {
      "npi": "1427781186",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1200 MEDICAL CENTER PKWY",
      "city": "Maumee",
      "state": "OH",
      "postalCode": "43537",
      "phone": "313-576-9182",
      "affiliation": "Regional Academic Oncology Network (Maumee, OH)"
    },
    {
      "npi": "1851040356",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Medical Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1200 MEDICAL CENTER PARKWAY",
      "city": "Maumee",
      "state": "OH",
      "postalCode": "43537",
      "phone": "313-576-9182",
      "affiliation": "Regional Academic Oncology Network (Maumee, OH)"
    },
    {
      "npi": "1265500797",
      "name": "Dr. Bernd Barthel, MD",
      "rawName": "Bernd Barthel",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "HENRY FORD HEALTH SYSTEM",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "313-916-1431",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1447280631",
      "name": "Dr. Gerold Bepler, MD",
      "rawName": "Gerold Bepler",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4100 JOHN R",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48201",
      "phone": "800-527-6266",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1922322601",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "13355 E 10 MILE RD",
      "city": "Warren",
      "state": "MI",
      "postalCode": "48089",
      "phone": "586-756-7090",
      "affiliation": "Regional Academic Oncology Network (Warren, MI)"
    },
    {
      "npi": "1316391253",
      "name": "Dr. Scott Dawsey, MD",
      "rawName": "Scott Dawsey",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4646 JOHN R ST",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48201",
      "phone": "313-576-1000",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1003259045",
      "name": "Dr. Maria Diab, MD",
      "rawName": "Maria Diab",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "2799 W GRAND BLVD",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "800-653-6568",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1437196433",
      "name": "Dr. Bassel El-rayes, MD",
      "rawName": "Bassel El-rayes",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "200 W ARBOR DR",
      "city": "San diego",
      "state": "CA",
      "postalCode": "92103",
      "phone": "800-926-8273",
      "affiliation": "Regional Academic Oncology Network (San diego, CA)"
    },
    {
      "npi": "1629241443",
      "name": "Dr. Josephine Emole, MD",
      "rawName": "Josephine Emole",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2799 W GRAND BLVD # K-13",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "800-653-6568",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1033156534",
      "name": "Dr. Shirish Gadgeel, MD",
      "rawName": "Shirish Gadgeel",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2799 W GRAND BLVD",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "800-653-6568",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1669944237",
      "name": "Dr. Khaled Adil, MD",
      "rawName": "Khaled Adil",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "43 NEW SCOTLAND AVE",
      "city": "Albany",
      "state": "NY",
      "postalCode": "12208",
      "phone": "518-262-3368",
      "affiliation": "Regional Academic Oncology Network (Albany, NY)"
    },
    {
      "npi": "1578846440",
      "name": "Dr. Zishan Alibhai, MD",
      "rawName": "Zishan Alibhai",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "540 E CANFIELD ST",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48201",
      "phone": "248-795-4276",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1376603787",
      "name": "Dr. Ibrahim Aref, MD",
      "rawName": "Ibrahim Aref",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "HENRY FORD HEALTH SYSTEM",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "313-916-9106",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1013302397",
      "name": "Dr. David Bergman, MD",
      "rawName": "David Bergman",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3180 E MIDLAND RD",
      "city": "Bay city",
      "state": "MI",
      "postalCode": "48706",
      "phone": "989-667-6670",
      "affiliation": "Regional Academic Oncology Network (Bay city, MI)"
    },
    {
      "npi": "1487323432",
      "name": "Dr. Aseem Bhatnagar, MD",
      "rawName": "Aseem Bhatnagar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2799 W GRAND BLVD",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "313-916-2899",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1104053099",
      "name": "Dr. Eva Bieniek, MD",
      "rawName": "Eva Bieniek",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5301 E HURON RIVER DR",
      "city": "Ypsilanti",
      "state": "MI",
      "postalCode": "48197",
      "phone": "734-712-3456",
      "affiliation": "Regional Academic Oncology Network (Ypsilanti, MI)"
    },
    {
      "npi": "1699970525",
      "name": "Dr. Thomas Boike, MD",
      "rawName": "Thomas Boike",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2800 W GRAND BLVD",
      "city": "Detroit",
      "state": "MI",
      "postalCode": "48202",
      "phone": "800-436-7936",
      "affiliation": "Regional Academic Oncology Network (Detroit, MI)"
    },
    {
      "npi": "1528687886",
      "name": "Dr. Ryan Brisson, MD",
      "rawName": "Ryan Brisson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    },
    {
      "npi": "1659491132",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "6100 W 96TH ST STE 125",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46278",
      "phone": "317-715-1800",
      "affiliation": "Regional Academic Oncology Network (Indianapolis, IN)"
    }
  ],
  "alabama": [
    {
      "npi": "1639480106",
      "name": "Dr. Mehmet Akce, MD",
      "rawName": "Mehmet Akce",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "619 19TH ST S",
      "city": "Birmingham",
      "state": "AL",
      "postalCode": "35233",
      "phone": "205-934-4011",
      "affiliation": "Regional Academic Oncology Network (Birmingham, AL)"
    },
    {
      "npi": "1336150713",
      "name": "Dr. Zaid Al-kadhimi, MD",
      "rawName": "Zaid Al-kadhimi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "EMILE @ 42ND ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-559-5600",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1356565501",
      "name": "Dr. Syed abbas Ali, MD",
      "rawName": "Syed abbas Ali",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3400 HIGHWAY 78 E",
      "city": "Jasper",
      "state": "AL",
      "postalCode": "35501",
      "phone": "205-387-4401",
      "affiliation": "Regional Academic Oncology Network (Jasper, AL)"
    },
    {
      "npi": "1457305229",
      "name": "Dr. Nicole Angel, MD",
      "rawName": "Nicole Angel",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6701 AIRPORT BLVD",
      "city": "Mobile",
      "state": "AL",
      "postalCode": "36608",
      "phone": "251-625-6896",
      "affiliation": "Regional Academic Oncology Network (Mobile, AL)"
    },
    {
      "npi": "1992771448",
      "name": "Dr. Ariel Anguiano, MD",
      "rawName": "Ariel Anguiano",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "801 UNIVERSITY BLVD E",
      "city": "Tuscaloosa",
      "state": "AL",
      "postalCode": "35401",
      "phone": "205-759-7800",
      "affiliation": "Regional Academic Oncology Network (Tuscaloosa, AL)"
    },
    {
      "npi": "1881805406",
      "name": "Dr. Sherri Arledge, MD",
      "rawName": "Sherri Arledge",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3719 DAUPHIN ST FL 5",
      "city": "Mobile",
      "state": "AL",
      "postalCode": "36608",
      "phone": "251-625-6896",
      "affiliation": "Regional Academic Oncology Network (Mobile, AL)"
    },
    {
      "npi": "1245181429",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "120 19TH ST N STE 290",
      "city": "Birmingham",
      "state": "AL",
      "postalCode": "35203",
      "phone": "203-461-1446",
      "affiliation": "Regional Academic Oncology Network (Birmingham, AL)"
    },
    {
      "npi": "1356395214",
      "name": "Dr. Harry Barnes, MD",
      "rawName": "Harry Barnes",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4145 CARMICHAEL ROAD",
      "city": "Montgomery",
      "state": "AL",
      "postalCode": "36106",
      "phone": "334-273-7000",
      "affiliation": "Regional Academic Oncology Network (Montgomery, AL)"
    },
    {
      "npi": "1730583089",
      "name": "Dr. Martin Barnes, MD",
      "rawName": "Martin Barnes",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "639 HOSPITAL DR",
      "city": "Mountain home",
      "state": "AR",
      "postalCode": "72653",
      "phone": "479-587-1700",
      "affiliation": "Regional Academic Oncology Network (Mountain home, AR)"
    },
    {
      "npi": "1659582369",
      "name": "Dr. Susan Bostick, MD",
      "rawName": "Susan Bostick",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "809 UNIVERSITY BLVD E",
      "city": "Tuscaloosa",
      "state": "AL",
      "postalCode": "35401",
      "phone": "205-759-7800",
      "affiliation": "Regional Academic Oncology Network (Tuscaloosa, AL)"
    },
    {
      "npi": "1780870428",
      "name": "Dr. Yanis Boumber, MD",
      "rawName": "Yanis Boumber",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1000 MCKINLEY PARK DR",
      "city": "Marion",
      "state": "OH",
      "postalCode": "43302",
      "phone": "740-383-7830",
      "affiliation": "Regional Academic Oncology Network (Marion, OH)"
    },
    {
      "npi": "1295773125",
      "name": "Dr. Laura Bunch, MD",
      "rawName": "Laura Bunch",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4500 MONTEVALLO RD",
      "city": "Irondale",
      "state": "AL",
      "postalCode": "35210",
      "phone": "205-490-4690",
      "affiliation": "Regional Academic Oncology Network (Irondale, AL)"
    },
    {
      "npi": "1790719318",
      "name": "Dr. Jarrod Adkison, MD",
      "rawName": "Jarrod Adkison",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1108 ROSS CLARK CIRCLE",
      "city": "Dothan",
      "state": "AL",
      "postalCode": "36301",
      "phone": "334-793-8081",
      "affiliation": "Regional Academic Oncology Network (Dothan, AL)"
    },
    {
      "npi": "1013407675",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3670 GRANDVIEW PKWY #100",
      "city": "Birmingham",
      "state": "AL",
      "postalCode": "35243",
      "phone": "205-971-1800",
      "affiliation": "Regional Academic Oncology Network (Birmingham, AL)"
    },
    {
      "npi": "1750577466",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "208 MARENGO ST",
      "city": "Florence",
      "state": "AL",
      "postalCode": "35630",
      "phone": "256-760-1150",
      "affiliation": "Regional Academic Oncology Network (Florence, AL)"
    },
    {
      "npi": "1841486552",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1110 S JACKSON HWY",
      "city": "Sheffield",
      "state": "AL",
      "postalCode": "35660",
      "phone": "256-383-5211",
      "affiliation": "Regional Academic Oncology Network (Sheffield, AL)"
    },
    {
      "npi": "1699961300",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1175 E KARSCH BLVD",
      "city": "Farmington",
      "state": "MO",
      "postalCode": "63640",
      "phone": "573-756-6797",
      "affiliation": "Regional Academic Oncology Network (Farmington, MO)"
    },
    {
      "npi": "1689869497",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1514 E UNION ST",
      "city": "Greenville",
      "state": "MS",
      "postalCode": "38703",
      "phone": "662-332-6150",
      "affiliation": "Regional Academic Oncology Network (Greenville, MS)"
    },
    {
      "npi": "1114112927",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "581 MEDICAL DR",
      "city": "Clarksdale",
      "state": "MS",
      "postalCode": "38614",
      "phone": "662-624-8731",
      "affiliation": "Regional Academic Oncology Network (Clarksdale, MS)"
    },
    {
      "npi": "1013384056",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1110 S JACKSON HWY",
      "city": "Sheffield",
      "state": "AL",
      "postalCode": "35660",
      "phone": "256-383-5211",
      "affiliation": "Regional Academic Oncology Network (Sheffield, AL)"
    }
  ],
  "alaska": [
    {
      "npi": "1265460661",
      "name": "Dr. Dennis Beckworth, MD",
      "rawName": "Dennis Beckworth",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "133 ROUTE 3",
      "city": "Dededo",
      "state": "GU",
      "postalCode": "96929",
      "phone": "671-645-5546",
      "affiliation": "Regional Academic Oncology Network (Dededo, GU)"
    },
    {
      "npi": "1821030206",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3851 PIPER STREET",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99508",
      "phone": "907-562-0321",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1740243914",
      "name": "Dr. Lawrence Lawson, MD",
      "rawName": "Lawrence Lawson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2490 S WOODWORTH LOOP STE 499",
      "city": "Palmer",
      "state": "AK",
      "postalCode": "99645",
      "phone": "907-746-7771",
      "affiliation": "Regional Academic Oncology Network (Palmer, AK)"
    },
    {
      "npi": "1952758435",
      "name": "Dr. Yifan Pang, MD",
      "rawName": "Yifan Pang",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3900 AMBASSADOR DR",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99508",
      "phone": "907-729-1180",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1780741306",
      "name": "Dr. John Siebel, MD",
      "rawName": "John Siebel",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "218 DE ANZA BLVD",
      "city": "San mateo",
      "state": "CA",
      "postalCode": "94402",
      "phone": "650-341-9131",
      "affiliation": "Regional Academic Oncology Network (San mateo, CA)"
    },
    {
      "npi": "1124054655",
      "name": "Dr. Verneeda Spencer, MD",
      "rawName": "Verneeda Spencer",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "825 EASTLAKE AVE E",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98109",
      "phone": "206-520-5000",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1841262201",
      "name": "Dr. Latha Subramanian, MD",
      "rawName": "Latha Subramanian",
      "credential": "MD",
      "specialty": "Specialist",
      "taxonomyCode": "174400000X",
      "practiceAddress": "4048 LAUREL ST",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99508",
      "phone": "907-569-2627",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1518177864",
      "name": "Dr. Jason Taylor, MD",
      "rawName": "Jason Taylor",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "701 PIKE ST STE 1900",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98101",
      "phone": "206-614-1200",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1740221225",
      "name": "Dr. John Zimmermann, MD",
      "rawName": "John Zimmermann",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2490 S WOODWORTH LOOP",
      "city": "Palmer",
      "state": "AK",
      "postalCode": "99645",
      "phone": "907-746-7771",
      "affiliation": "Regional Academic Oncology Network (Palmer, AK)"
    },
    {
      "npi": "1689716185",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Urology",
      "taxonomyCode": "208800000X",
      "practiceAddress": "188 W NORTHERN LIGHTS BLVD",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99503",
      "phone": "907-276-2806",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1942478854",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3851 PIPER STREET",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99508",
      "phone": "907-212-3186",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1871565556",
      "name": "Dr. James Blom, MD",
      "rawName": "James Blom",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3851 PIPER ST",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99508",
      "phone": "907-212-3186",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1942331558",
      "name": "Dr. Malcolm Bull, MD",
      "rawName": "Malcolm Bull",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "7220 RUSSELL CIR",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99507",
      "phone": "907-868-7864",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1407011208",
      "name": "Dr. Larry Daugherty, MD",
      "rawName": "Larry Daugherty",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "188 W NORTHERN LIGHTS BLVD STE 100",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99503",
      "phone": "907-276-2803",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1356437792",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1650 COWLES STREET",
      "city": "Fairbanks",
      "state": "AK",
      "postalCode": "99701",
      "phone": "907-458-5380",
      "affiliation": "Regional Academic Oncology Network (Fairbanks, AK)"
    },
    {
      "npi": "1053722918",
      "name": "Dr. Michael Green, MD",
      "rawName": "Michael Green",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "188 W NORTHERN LIGHTS BLVD STE 100",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99503",
      "phone": "907-562-2002",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    },
    {
      "npi": "1982676284",
      "name": "Dr. John Halligan, MD",
      "rawName": "John Halligan",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3851 PIPER ST",
      "city": "Anchorage",
      "state": "AK",
      "postalCode": "99508",
      "phone": "907-212-7961",
      "affiliation": "Regional Academic Oncology Network (Anchorage, AK)"
    }
  ],
  "arkansas": [
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1033008321",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "5620 W MARKHAM ST",
      "city": "Little rock",
      "state": "AR",
      "postalCode": "72205",
      "phone": "501-508-7163",
      "affiliation": "Regional Academic Oncology Network (Little rock, AR)"
    },
    {
      "npi": "1225920770",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4419 N HIGHWAY 7 STE 100",
      "city": "Hot springs village",
      "state": "AR",
      "postalCode": "71909",
      "phone": "501-623-2731",
      "affiliation": "Regional Academic Oncology Network (Hot springs village, AR)"
    },
    {
      "npi": "1710861919",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4419 N HIGHWAY 7 STE 201",
      "city": "Hot springs village",
      "state": "AR",
      "postalCode": "71909",
      "phone": "501-525-4555",
      "affiliation": "Regional Academic Oncology Network (Hot springs village, AR)"
    },
    {
      "npi": "1104312628",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "133 HARMONY PARK CIR",
      "city": "Hot springs",
      "state": "AR",
      "postalCode": "71913",
      "phone": "501-624-7700",
      "affiliation": "Regional Academic Oncology Network (Hot springs, AR)"
    },
    {
      "npi": "1245726843",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "101 PLAZA CARMONA PL STE C",
      "city": "Hot springs village",
      "state": "AR",
      "postalCode": "71909",
      "phone": "501-623-2731",
      "affiliation": "Regional Academic Oncology Network (Hot springs village, AR)"
    },
    {
      "npi": "1689160293",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1455 HIGDON FERRY RD STE B",
      "city": "Hot springs",
      "state": "AR",
      "postalCode": "71913",
      "phone": "501-623-2731",
      "affiliation": "Regional Academic Oncology Network (Hot springs, AR)"
    },
    {
      "npi": "1265321541",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "350 SALEM RD STE 4",
      "city": "Conway",
      "state": "AR",
      "postalCode": "72034",
      "phone": "501-327-2995",
      "affiliation": "Regional Academic Oncology Network (Conway, AR)"
    },
    {
      "npi": "1255220844",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3 MEDICAL PARK DR STE 202",
      "city": "Benton",
      "state": "AR",
      "postalCode": "72015",
      "phone": "501-507-6035",
      "affiliation": "Regional Academic Oncology Network (Benton, AR)"
    },
    {
      "npi": "1104312701",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "130 MEDICAL CIR",
      "city": "Nashville",
      "state": "AR",
      "postalCode": "71852",
      "phone": "501-624-7700",
      "affiliation": "Regional Academic Oncology Network (Nashville, AR)"
    },
    {
      "npi": "1487546495",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4419 N HIGHWAY 7 STE 100",
      "city": "Hot springs village",
      "state": "AR",
      "postalCode": "71909",
      "phone": "501-623-2731",
      "affiliation": "Regional Academic Oncology Network (Hot springs village, AR)"
    },
    {
      "npi": "1649766247",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "400 CRESTWOOD CIR STE G",
      "city": "Mena",
      "state": "AR",
      "postalCode": "71953",
      "phone": "479-385-8011",
      "affiliation": "Regional Academic Oncology Network (Mena, AR)"
    },
    {
      "npi": "1710093166",
      "name": "Dr. Edward Abraham, MD",
      "rawName": "Edward Abraham",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1455 HIGDON FERRY RD STE C",
      "city": "Hot springs",
      "state": "AR",
      "postalCode": "71913",
      "phone": "501-622-2100",
      "affiliation": "Regional Academic Oncology Network (Hot springs, AR)"
    },
    {
      "npi": "1295362184",
      "name": "Dr. Scarlett Acklin-wehnert, MD",
      "rawName": "Scarlett Acklin-wehnert",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "60 E MONTE PAINTER DR",
      "city": "Fayetteville",
      "state": "AR",
      "postalCode": "72703",
      "phone": "794-587-1700",
      "affiliation": "Regional Academic Oncology Network (Fayetteville, AR)"
    },
    {
      "npi": "1043743339",
      "name": "Dr. Hiba Ahmed, MD",
      "rawName": "Hiba Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "225 E WASHINGTON AVE",
      "city": "Jonesboro",
      "state": "AR",
      "postalCode": "72401",
      "phone": "870-207-8210",
      "affiliation": "Regional Academic Oncology Network (Jonesboro, AR)"
    },
    {
      "npi": "1205446739",
      "name": "Dr. Sondos Alkhatib, MD",
      "rawName": "Sondos Alkhatib",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3900 W CAPITOL AVE",
      "city": "Little rock",
      "state": "AR",
      "postalCode": "72205",
      "phone": "501-686-8000",
      "affiliation": "Regional Academic Oncology Network (Little rock, AR)"
    },
    {
      "npi": "1184674608",
      "name": "Dr. John Allgood, MD",
      "rawName": "John Allgood",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "225 E JACKSON AVE",
      "city": "Jonesboro",
      "state": "AR",
      "postalCode": "72401",
      "phone": "870-972-4510",
      "affiliation": "Regional Academic Oncology Network (Jonesboro, AR)"
    },
    {
      "npi": "1982231833",
      "name": "Dr. Joshua Anderson, MD",
      "rawName": "Joshua Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "60 E MONTE PAINTER DR",
      "city": "Fayetteville",
      "state": "AR",
      "postalCode": "72703",
      "phone": "479-587-1700",
      "affiliation": "Regional Academic Oncology Network (Fayetteville, AR)"
    },
    {
      "npi": "1407278120",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "7200 SOUTH HAZEL STREET",
      "city": "Pine bluff",
      "state": "AR",
      "postalCode": "71603",
      "phone": "870-535-2800",
      "affiliation": "Regional Academic Oncology Network (Pine bluff, AR)"
    }
  ],
  "connecticut": [
    {
      "npi": "1538574926",
      "name": "Dr. Ana Acuna-villaorduna, MD",
      "rawName": "Ana Acuna-villaorduna",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "263 FARMINGTON AVE",
      "city": "Farmington",
      "state": "CT",
      "postalCode": "06030",
      "phone": "860-679-2100",
      "affiliation": "Regional Academic Oncology Network (Farmington, CT)"
    },
    {
      "npi": "1447505110",
      "name": "Dr. Omar Al asad, MD",
      "rawName": "Omar Al asad",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "20 YORK ST",
      "city": "New haven",
      "state": "CT",
      "postalCode": "06510",
      "phone": "203-688-4748",
      "affiliation": "Regional Academic Oncology Network (New haven, CT)"
    },
    {
      "npi": "1689134041",
      "name": "Dr. Haripriya Andanamala, MD",
      "rawName": "Haripriya Andanamala",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 NE 10TH ST",
      "city": "Oklahoma city",
      "state": "OK",
      "postalCode": "73104",
      "phone": "405-271-4022",
      "affiliation": "Regional Academic Oncology Network (Oklahoma city, OK)"
    },
    {
      "npi": "1376668004",
      "name": "Dr. Anne Angevine, MD",
      "rawName": "Anne Angevine",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 HOSPITAL PLAZA",
      "city": "Stamford",
      "state": "CT",
      "postalCode": "06904",
      "phone": "203-276-2695",
      "affiliation": "Regional Academic Oncology Network (Stamford, CT)"
    },
    {
      "npi": "1447816202",
      "name": "Dr. Philippos Apolinario costa, MD",
      "rawName": "Philippos Apolinario costa",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "20 YORK ST",
      "city": "New haven",
      "state": "CT",
      "postalCode": "06510",
      "phone": "203-688-4242",
      "affiliation": "Regional Academic Oncology Network (New haven, CT)"
    },
    {
      "npi": "1538576111",
      "name": "Dr. Amandeep Aujla, MD",
      "rawName": "Amandeep Aujla",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "196 PARKWAY SOUTH",
      "city": "Waterford",
      "state": "CT",
      "postalCode": "06385",
      "phone": "860-443-4455",
      "affiliation": "Regional Academic Oncology Network (Waterford, CT)"
    },
    {
      "npi": "1043200272",
      "name": "Dr. Erkut Bahceci, MD",
      "rawName": "Erkut Bahceci",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "800 HOWARD AVE",
      "city": "New haven",
      "state": "CT",
      "postalCode": "06519",
      "phone": "203-785-2140",
      "affiliation": "Regional Academic Oncology Network (New haven, CT)"
    },
    {
      "npi": "1952527269",
      "name": "Dr. Marc Ballas, MD",
      "rawName": "Marc Ballas",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "160 E 34TH ST",
      "city": "New york",
      "state": "NY",
      "postalCode": "10016",
      "phone": "212-731-6645",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1093800369",
      "name": "Dr. Michael Bar, MD",
      "rawName": "Michael Bar",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "34 SHELBURNE ROAD",
      "city": "Stamford",
      "state": "CT",
      "postalCode": "06902",
      "phone": "203-325-2695",
      "affiliation": "Regional Academic Oncology Network (Stamford, CT)"
    },
    {
      "npi": "1215179106",
      "name": "Dr. Noffar Bar, MD",
      "rawName": "Noffar Bar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "20 YORK ST # T-209",
      "city": "New haven",
      "state": "CT",
      "postalCode": "06510",
      "phone": "203-688-2259",
      "affiliation": "Regional Academic Oncology Network (New haven, CT)"
    },
    {
      "npi": "1467607283",
      "name": "Dr. Myra Barginear, MD",
      "rawName": "Myra Barginear",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "15 MANITOU RD",
      "city": "Westport",
      "state": "CT",
      "postalCode": "06880",
      "phone": "203-293-4208",
      "affiliation": "Regional Academic Oncology Network (Westport, CT)"
    },
    {
      "npi": "1861629180",
      "name": "Dr. Aarti Bhatia, MD",
      "rawName": "Aarti Bhatia",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "333 CEDAR ST",
      "city": "New haven",
      "state": "CT",
      "postalCode": "06510",
      "phone": "203-785-2360",
      "affiliation": "Regional Academic Oncology Network (New haven, CT)"
    },
    {
      "npi": "1407173115",
      "name": "Dr. William Aberizk, MD",
      "rawName": "William Aberizk",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "166 LEDGEWOOD RD",
      "city": "Groton",
      "state": "CT",
      "postalCode": "06340",
      "phone": "860-614-3066",
      "affiliation": "Regional Academic Oncology Network (Groton, CT)"
    },
    {
      "npi": "1184702524",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "435 LEWIS AVE",
      "city": "Meriden",
      "state": "CT",
      "postalCode": "06451",
      "phone": "203-694-8433",
      "affiliation": "Regional Academic Oncology Network (Meriden, CT)"
    },
    {
      "npi": "1669714739",
      "name": "Dr. Yi An, MD",
      "rawName": "Yi An",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "20 YORK ST",
      "city": "New haven",
      "state": "CT",
      "postalCode": "06510",
      "phone": "203-688-4242",
      "affiliation": "Regional Academic Oncology Network (New haven, CT)"
    },
    {
      "npi": "1699119628",
      "name": "Dr. Sanjay Aneja, MD",
      "rawName": "Sanjay Aneja",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "20 YORK ST",
      "city": "New haven",
      "state": "CT",
      "postalCode": "06510",
      "phone": "203-785-2959",
      "affiliation": "Regional Academic Oncology Network (New haven, CT)"
    },
    {
      "npi": "1295222784",
      "name": "Dr. Emily Anstadt lutz, MD",
      "rawName": "Emily Anstadt lutz",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "85 RETREAT AVE",
      "city": "Hartford",
      "state": "CT",
      "postalCode": "06106",
      "phone": "608-972-2803",
      "affiliation": "Regional Academic Oncology Network (Hartford, CT)"
    },
    {
      "npi": "1619062494",
      "name": "Dr. Joseph Bargellini, MD",
      "rawName": "Joseph Bargellini",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "21 ELM ST",
      "city": "New milford",
      "state": "CT",
      "postalCode": "06776",
      "phone": "860-210-7490",
      "affiliation": "Regional Academic Oncology Network (New milford, CT)"
    },
    {
      "npi": "1629753116",
      "name": "Dr. Pamela Bartolotta, MD",
      "rawName": "Pamela Bartolotta",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4 CARPENTER AVE",
      "city": "Niantic",
      "state": "CT",
      "postalCode": "06357",
      "phone": "860-235-2367",
      "affiliation": "Regional Academic Oncology Network (Niantic, CT)"
    },
    {
      "npi": "1265536635",
      "name": "Dr. Jonathan Beitler, MD",
      "rawName": "Jonathan Beitler",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "915 N GRAND BLVD",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63106",
      "phone": "314-289-6324",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    }
  ],
  "delaware": [
    {
      "npi": "1386720340",
      "name": "Dr. Ammar Alzoubi, MD",
      "rawName": "Ammar Alzoubi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4701 OGLETOWN STANTON RD STE 2300",
      "city": "Newark",
      "state": "DE",
      "postalCode": "19713",
      "phone": "023-731-7782",
      "affiliation": "Regional Academic Oncology Network (Newark, DE)"
    },
    {
      "npi": "1811935273",
      "name": "Dr. Joel Appel, DO",
      "rawName": "Joel Appel",
      "credential": "DO",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "27207 LAHSER RD",
      "city": "Southfield",
      "state": "MI",
      "postalCode": "48034",
      "phone": "248-358-4892",
      "affiliation": "Regional Academic Oncology Network (Southfield, MI)"
    },
    {
      "npi": "1154393510",
      "name": "Dr. Muhammad Arif, MD",
      "rawName": "Muhammad Arif",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1000 E MOUNTAIN DR",
      "city": "Wilkes barre",
      "state": "PA",
      "postalCode": "18711",
      "phone": "570-808-4772",
      "affiliation": "Regional Academic Oncology Network (Wilkes barre, PA)"
    },
    {
      "npi": "1447744552",
      "name": "Dr. Sheeba habeeb Ba aqeel, MD",
      "rawName": "Sheeba habeeb Ba aqeel",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "640 S STATE ST FL 2",
      "city": "Dover",
      "state": "DE",
      "postalCode": "19901",
      "phone": "302-744-7994",
      "affiliation": "Regional Academic Oncology Network (Dover, DE)"
    },
    {
      "npi": "1295292183",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "640 S STATE ST",
      "city": "Dover",
      "state": "DE",
      "postalCode": "19901",
      "phone": "302-744-7000",
      "affiliation": "Regional Academic Oncology Network (Dover, DE)"
    },
    {
      "npi": "1104383041",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "100 WELLNESS WAY",
      "city": "Milford",
      "state": "DE",
      "postalCode": "19963",
      "phone": "302-430-5738",
      "affiliation": "Regional Academic Oncology Network (Milford, DE)"
    },
    {
      "npi": "1275556516",
      "name": "Dr. Bruce Boman, MD",
      "rawName": "Bruce Boman",
      "credential": "MD",
      "specialty": "Medical Genetics, Clinical Genetics (M.D.)",
      "taxonomyCode": "207SG0201X",
      "practiceAddress": "4701 OGLETOWN STANTON RD STE 2200",
      "city": "Newark",
      "state": "DE",
      "postalCode": "19713",
      "phone": "302-623-4500",
      "affiliation": "Regional Academic Oncology Network (Newark, DE)"
    },
    {
      "npi": "1174508410",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Obstetrics & Gynecology, Gynecologic Oncology",
      "taxonomyCode": "207VX0201X",
      "practiceAddress": "4701 OGLETOWN STANTON RD",
      "city": "Newark",
      "state": "DE",
      "postalCode": "19713",
      "phone": "302-623-4285",
      "affiliation": "Regional Academic Oncology Network (Newark, DE)"
    },
    {
      "npi": "1306375373",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "111 W HIGH ST STE 104",
      "city": "Elkton",
      "state": "MD",
      "postalCode": "21921",
      "phone": "410-392-5566",
      "affiliation": "Regional Academic Oncology Network (Elkton, MD)"
    },
    {
      "npi": "1992133250",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Obstetrics & Gynecology, Gynecologic Oncology",
      "taxonomyCode": "207VX0201X",
      "practiceAddress": "161 WILMINGTON W CHESTER PIKE",
      "city": "Chadds ford",
      "state": "PA",
      "postalCode": "19317",
      "phone": "302-733-1000",
      "affiliation": "Regional Academic Oncology Network (Chadds ford, PA)"
    },
    {
      "npi": "1194255604",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1011 W BALTIMORE PIKE STE 307",
      "city": "West grove",
      "state": "PA",
      "postalCode": "19390",
      "phone": "610-869-1455",
      "affiliation": "Regional Academic Oncology Network (West grove, PA)"
    },
    {
      "npi": "1306273255",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Family Medicine",
      "taxonomyCode": "207Q00000X",
      "practiceAddress": "161 WILMINGTON W CHESTER PIKE",
      "city": "Chadds ford",
      "state": "PA",
      "postalCode": "19317",
      "phone": "302-733-1000",
      "affiliation": "Regional Academic Oncology Network (Chadds ford, PA)"
    },
    {
      "npi": "1225664030",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "701 MIDDLEFORD RD",
      "city": "Seaford",
      "state": "DE",
      "postalCode": "19973",
      "phone": "302-628-6344",
      "affiliation": "Regional Academic Oncology Network (Seaford, DE)"
    },
    {
      "npi": "1841757739",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "640 S STATE ST",
      "city": "Dover",
      "state": "DE",
      "postalCode": "19901",
      "phone": "302-744-7000",
      "affiliation": "Regional Academic Oncology Network (Dover, DE)"
    },
    {
      "npi": "1760949606",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "100 WELLNESS WAY",
      "city": "Milford",
      "state": "DE",
      "postalCode": "19963",
      "phone": "302-430-5738",
      "affiliation": "Regional Academic Oncology Network (Milford, DE)"
    },
    {
      "npi": "1780203463",
      "name": "Dr. Monica Chelius, MD",
      "rawName": "Monica Chelius",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4701 OGLETOWN STANTON RD",
      "city": "Newark",
      "state": "DE",
      "postalCode": "19713",
      "phone": "302-623-4532",
      "affiliation": "Regional Academic Oncology Network (Newark, DE)"
    },
    {
      "npi": "1295162055",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiology, Diagnostic Radiology",
      "taxonomyCode": "2085R0202X",
      "practiceAddress": "161 WILMINGTON W CHESTER PIKE",
      "city": "Chadds ford",
      "state": "PA",
      "postalCode": "19317",
      "phone": "302-733-1000",
      "affiliation": "Regional Academic Oncology Network (Chadds ford, PA)"
    },
    {
      "npi": "1679900435",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "161 WILMINGTON W CHESTER PIKE",
      "city": "Chadds ford",
      "state": "PA",
      "postalCode": "19317",
      "phone": "610-361-1170",
      "affiliation": "Regional Academic Oncology Network (Chadds ford, PA)"
    },
    {
      "npi": "1578429056",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Pulmonary Disease",
      "taxonomyCode": "207RP1001X",
      "practiceAddress": "30 LAWRENCE RD STE 300",
      "city": "Broomall",
      "state": "PA",
      "postalCode": "19008",
      "phone": "302-623-4530",
      "affiliation": "Regional Academic Oncology Network (Broomall, PA)"
    }
  ],
  "hawaii": [
    {
      "npi": "1346340239",
      "name": "Dr. Clayton Chan, MD",
      "rawName": "Clayton Chan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3288 MOANALUA RD",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96819",
      "phone": "808-432-0000",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1558562371",
      "name": "Dr. Cecilia Choi, MD",
      "rawName": "Cecilia Choi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "40 KUPAOA ST UNIT B-204",
      "city": "Makawao",
      "state": "HI",
      "postalCode": "96768",
      "phone": "808-500-3439",
      "affiliation": "Regional Academic Oncology Network (Makawao, HI)"
    },
    {
      "npi": "1558545681",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "75-5995 KUAKINI HWY STE 427",
      "city": "Kailua kona",
      "state": "HI",
      "postalCode": "96740",
      "phone": "808-557-0864",
      "affiliation": "Regional Academic Oncology Network (Kailua kona, HI)"
    },
    {
      "npi": "1104038249",
      "name": "Dr. Shaun Donegan, MD",
      "rawName": "Shaun Donegan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "321 N KUAKINI ST STE 412",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96817",
      "phone": "808-531-8521",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1518058163",
      "name": "Dr. Larry Ebbert, MD",
      "rawName": "Larry Ebbert",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "85 MAUI LANI PKWY",
      "city": "Wailuku",
      "state": "HI",
      "postalCode": "96793",
      "phone": "808-442-5700",
      "affiliation": "Regional Academic Oncology Network (Wailuku, HI)"
    },
    {
      "npi": "1811361678",
      "name": "Dr. Matthew Ebia, MD",
      "rawName": "Matthew Ebia",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "321 N KUAKINI ST STE 404",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96817",
      "phone": "808-772-4743",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1790084408",
      "name": "Dr. Jami Fukui, MD",
      "rawName": "Jami Fukui",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1907 S BERETANIA ST",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96826",
      "phone": "808-949-3444",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1699849034",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "30 N CHURCH ST",
      "city": "Wailuku",
      "state": "HI",
      "postalCode": "96793",
      "phone": "808-244-7627",
      "affiliation": "Regional Academic Oncology Network (Wailuku, HI)"
    },
    {
      "npi": "1417961038",
      "name": "Dr. Reuben Guerrero, MD",
      "rawName": "Reuben Guerrero",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "888 S KING ST",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96813",
      "phone": "808-522-4333",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1497783351",
      "name": "Dr. Kenneth Herbst, MD",
      "rawName": "Kenneth Herbst",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "86-260 FARRINGTON HWY",
      "city": "Waianae",
      "state": "HI",
      "postalCode": "96792",
      "phone": "808-697-3300",
      "affiliation": "Regional Academic Oncology Network (Waianae, HI)"
    },
    {
      "npi": "1518244631",
      "name": "Dr. Kevin Loh, MD",
      "rawName": "Kevin Loh",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1650 LILIHA ST",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96817",
      "phone": "808-524-3131",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1659062107",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "40 KUPAOA ST UNIT B-204",
      "city": "Makawao",
      "state": "HI",
      "postalCode": "96768",
      "phone": "808-500-3439",
      "affiliation": "Regional Academic Oncology Network (Makawao, HI)"
    },
    {
      "npi": "1679004014",
      "name": "Dr. Samuel Birer, MD",
      "rawName": "Samuel Birer",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2226 LILIHA ST STE B2",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96817",
      "phone": "808-547-6881",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1902885247",
      "name": "Dr. Vincent Brown, MD",
      "rawName": "Vincent Brown",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2226 LILIHA ST STE B2",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96817",
      "phone": "808-547-6881",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1144737925",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2226 LILIHA ST, #B2",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96817",
      "phone": "808-547-6881",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1144541756",
      "name": "Dr. Michael Chamberlin, MD",
      "rawName": "Michael Chamberlin",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1 JARRETT WHITE RD",
      "city": "Tripler army medical center",
      "state": "HI",
      "postalCode": "96859",
      "phone": "808-433-2390",
      "affiliation": "Regional Academic Oncology Network (Tripler army medical center, HI)"
    },
    {
      "npi": "1164609517",
      "name": "Dr. Susie Chen, MD",
      "rawName": "Susie Chen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2226 LILIHA ST STE B2",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96817",
      "phone": "808-744-6187",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1689709206",
      "name": "Dr. Ladonna Chung, MD",
      "rawName": "Ladonna Chung",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "347 N KUAKINI ST",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96817",
      "phone": "808-547-9548",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    },
    {
      "npi": "1437474046",
      "name": "Dr. Benjamin Falit, MD",
      "rawName": "Benjamin Falit",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "227 MAHALANI ST",
      "city": "Wailuku",
      "state": "HI",
      "postalCode": "96793",
      "phone": "808-242-2600",
      "affiliation": "Regional Academic Oncology Network (Wailuku, HI)"
    },
    {
      "npi": "1548751894",
      "name": "Dr. Jared Hara, MD",
      "rawName": "Jared Hara",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1301 PUNCHBOWL ST",
      "city": "Honolulu",
      "state": "HI",
      "postalCode": "96813",
      "phone": "808-691-8777",
      "affiliation": "Regional Academic Oncology Network (Honolulu, HI)"
    }
  ],
  "idaho": [
    {
      "npi": "1861802332",
      "name": "Dr. Shane Ahlers, MD",
      "rawName": "Shane Ahlers",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "100 E IDAHO ST",
      "city": "Boise",
      "state": "ID",
      "postalCode": "83712",
      "phone": "208-381-2711",
      "affiliation": "Regional Academic Oncology Network (Boise, ID)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1760365001",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "414 CHURCH ST STE 306",
      "city": "Sandpoint",
      "state": "ID",
      "postalCode": "83864",
      "phone": "208-618-5212",
      "affiliation": "Regional Academic Oncology Network (Sandpoint, ID)"
    },
    {
      "npi": "1962851519",
      "name": "Dr. Abeer Arain, MD",
      "rawName": "Abeer Arain",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1250 IDAHO ST",
      "city": "Lewiston",
      "state": "ID",
      "postalCode": "83501",
      "phone": "208-743-7427",
      "affiliation": "Regional Academic Oncology Network (Lewiston, ID)"
    },
    {
      "npi": "1235691478",
      "name": "Dr. Patricia Avancena, MD",
      "rawName": "Patricia Avancena",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1055 N CURTIS RD",
      "city": "Boise",
      "state": "ID",
      "postalCode": "83706",
      "phone": "208-367-3131",
      "affiliation": "Regional Academic Oncology Network (Boise, ID)"
    },
    {
      "npi": "1841458783",
      "name": "Dr. Goldy Bansal, MD",
      "rawName": "Goldy Bansal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3911 CASTLEVALE RD",
      "city": "Yakima",
      "state": "WA",
      "postalCode": "98902",
      "phone": "509-454-9499",
      "affiliation": "Regional Academic Oncology Network (Yakima, WA)"
    },
    {
      "npi": "1407335367",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Clinic/Center, Multi-Specialty",
      "taxonomyCode": "261QM1300X",
      "practiceAddress": "3815 N SCHREIBER WAY STE 101",
      "city": "Coeur d alene",
      "state": "ID",
      "postalCode": "83815",
      "phone": "208-755-2804",
      "affiliation": "Regional Academic Oncology Network (Coeur d alene, ID)"
    },
    {
      "npi": "1265460661",
      "name": "Dr. Dennis Beckworth, MD",
      "rawName": "Dennis Beckworth",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "133 ROUTE 3",
      "city": "Dededo",
      "state": "GU",
      "postalCode": "96929",
      "phone": "671-645-5546",
      "affiliation": "Regional Academic Oncology Network (Dededo, GU)"
    },
    {
      "npi": "1508077298",
      "name": "Dr. Shaalan Beg, MD",
      "rawName": "Shaalan Beg",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1055 N CURTIS RD",
      "city": "Boise",
      "state": "ID",
      "postalCode": "83706",
      "phone": "208-367-3131",
      "affiliation": "Regional Academic Oncology Network (Boise, ID)"
    },
    {
      "npi": "1508872458",
      "name": "Dr. Albert Brady, MD",
      "rawName": "Albert Brady",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3911 CASTLEVALE ROAD",
      "city": "Yakima",
      "state": "WA",
      "postalCode": "98902",
      "phone": "509-454-9499",
      "affiliation": "Regional Academic Oncology Network (Yakima, WA)"
    },
    {
      "npi": "1326140039",
      "name": "Dr. Silvana Bucur, MD",
      "rawName": "Silvana Bucur",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "520 S EAGLE RD",
      "city": "Meridian",
      "state": "ID",
      "postalCode": "83642",
      "phone": "208-706-5651",
      "affiliation": "Regional Academic Oncology Network (Meridian, ID)"
    },
    {
      "npi": "1871508564",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3911 CASTLEVALE RD",
      "city": "Yakima",
      "state": "WA",
      "postalCode": "98902",
      "phone": "509-454-9499",
      "affiliation": "Regional Academic Oncology Network (Yakima, WA)"
    },
    {
      "npi": "1821106071",
      "name": "Dr. Kent Anderson, MD",
      "rawName": "Kent Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "504 6TH ST",
      "city": "Lewiston",
      "state": "ID",
      "postalCode": "83501",
      "phone": "208-799-5600",
      "affiliation": "Regional Academic Oncology Network (Lewiston, ID)"
    },
    {
      "npi": "1992148332",
      "name": "Dr. Camille Berriochoa, MD",
      "rawName": "Camille Berriochoa",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9500 EUCLID AVE",
      "city": "Cleveland",
      "state": "OH",
      "postalCode": "44195",
      "phone": "216-444-2200",
      "affiliation": "Cleveland Clinic Taussig Cancer Institute"
    },
    {
      "npi": "1811003395",
      "name": "Dr. Sarah Bolender, MD",
      "rawName": "Sarah Bolender",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "100 E IDAHO ST",
      "city": "Boise",
      "state": "ID",
      "postalCode": "83712",
      "phone": "208-343-3223",
      "affiliation": "Regional Academic Oncology Network (Boise, ID)"
    },
    {
      "npi": "1265961908",
      "name": "Dr. David Boyce, MD",
      "rawName": "David Boyce",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1641 E POLSTON AVE STE 102",
      "city": "Post falls",
      "state": "ID",
      "postalCode": "83854",
      "phone": "208-755-2804",
      "affiliation": "Regional Academic Oncology Network (Post falls, ID)"
    },
    {
      "npi": "1316978539",
      "name": "Dr. Michael Callaghan, MD",
      "rawName": "Michael Callaghan",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "500 S 11TH AVE",
      "city": "Pocatello",
      "state": "ID",
      "postalCode": "83201",
      "phone": "208-239-1750",
      "affiliation": "Regional Academic Oncology Network (Pocatello, ID)"
    },
    {
      "npi": "1780790279",
      "name": "Dr. Ronald Dorn, MD",
      "rawName": "Ronald Dorn",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1055 N CURTIS ROAD",
      "city": "Boise",
      "state": "ID",
      "postalCode": "83706",
      "phone": "208-367-3131",
      "affiliation": "Regional Academic Oncology Network (Boise, ID)"
    }
  ],
  "indiana": [
    {
      "npi": "1205097599",
      "name": "Dr. Sausan Abouharb, MD",
      "rawName": "Sausan Abouharb",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1515 HOLCOMBE BLVD.",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1346473345",
      "name": "Dr. Kalid Adab, MD",
      "rawName": "Kalid Adab",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2900 W OKLAHOMA AVE",
      "city": "Milwaukee",
      "state": "WI",
      "postalCode": "53215",
      "phone": "414-649-6380",
      "affiliation": "Regional Academic Oncology Network (Milwaukee, WI)"
    },
    {
      "npi": "1811296668",
      "name": "Dr. Bolanle Adepoju, MD",
      "rawName": "Bolanle Adepoju",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "200 HIGH PARK AVE",
      "city": "Goshen",
      "state": "IN",
      "postalCode": "46526",
      "phone": "574-364-2888",
      "affiliation": "Regional Academic Oncology Network (Goshen, IN)"
    },
    {
      "npi": "1598766925",
      "name": "Dr. Farrukh Adhami, MD",
      "rawName": "Farrukh Adhami",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2514 E DUPONT RD STE 100",
      "city": "Fort wayne",
      "state": "IN",
      "postalCode": "46825",
      "phone": "260-484-8830",
      "affiliation": "Regional Academic Oncology Network (Fort wayne, IN)"
    },
    {
      "npi": "1811285893",
      "name": "Dr. Nabil Adra, MD",
      "rawName": "Nabil Adra",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "541 CLINICAL DR # CL630",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46202",
      "phone": "317-278-2694",
      "affiliation": "Regional Academic Oncology Network (Indianapolis, IN)"
    },
    {
      "npi": "1386867448",
      "name": "Dr. Sachin Agarwal, MD",
      "rawName": "Sachin Agarwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 SCOTT AND WHITE DR",
      "city": "College station",
      "state": "TX",
      "postalCode": "77845",
      "phone": "979-207-4000",
      "affiliation": "Regional Academic Oncology Network (College station, TX)"
    },
    {
      "npi": "1225236201",
      "name": "Dr. Anuj Agarwala, MD",
      "rawName": "Anuj Agarwala",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "7979 N SHADELAND AVE",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46250",
      "phone": "317-621-4300",
      "affiliation": "Regional Academic Oncology Network (Indianapolis, IN)"
    },
    {
      "npi": "1336591106",
      "name": "Dr. Kavita Agrawal, MD",
      "rawName": "Kavita Agrawal",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1236 HUFFMAN MILL RD STE 120",
      "city": "Burlington",
      "state": "NC",
      "postalCode": "27215",
      "phone": "336-538-7725",
      "affiliation": "Regional Academic Oncology Network (Burlington, NC)"
    },
    {
      "npi": "1750511218",
      "name": "Dr. Mufti Ahmad, MD",
      "rawName": "Mufti Ahmad",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3035 HAMILTON MASON RD",
      "city": "Fairfield township",
      "state": "OH",
      "postalCode": "45011",
      "phone": "513-853-1300",
      "affiliation": "Regional Academic Oncology Network (Fairfield township, OH)"
    },
    {
      "npi": "1417997065",
      "name": "Dr. Muhammad Ahmed, MD",
      "rawName": "Muhammad Ahmed",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "701 S HEALTH PKWY",
      "city": "Three rivers",
      "state": "MI",
      "postalCode": "49093",
      "phone": "269-278-1145",
      "affiliation": "Regional Academic Oncology Network (Three rivers, MI)"
    },
    {
      "npi": "1396772117",
      "name": "Dr. Farooq Akbar, MD",
      "rawName": "Farooq Akbar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "308 COLISEUM DR STE 120",
      "city": "Macon",
      "state": "GA",
      "postalCode": "31217",
      "phone": "478-745-6130",
      "affiliation": "Regional Academic Oncology Network (Macon, GA)"
    },
    {
      "npi": "1265746119",
      "name": "Dr. Ahmad Al-hader, MD",
      "rawName": "Ahmad Al-hader",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "535 BARNHILL DRIVE",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46202",
      "phone": "317-948-6953",
      "affiliation": "Regional Academic Oncology Network (Indianapolis, IN)"
    },
    {
      "npi": "1396748992",
      "name": "Dr. Scott Ackley, MD",
      "rawName": "Scott Ackley",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1606 N 7TH ST",
      "city": "Terre haute",
      "state": "IN",
      "postalCode": "47804",
      "phone": "812-238-7504",
      "affiliation": "Regional Academic Oncology Network (Terre haute, IN)"
    },
    {
      "npi": "1780817502",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Otolaryngology",
      "taxonomyCode": "207Y00000X",
      "practiceAddress": "2944 BRECKENRIDGE LN",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40220",
      "phone": "502-893-0159",
      "affiliation": "Regional Academic Oncology Network (Louisville, KY)"
    },
    {
      "npi": "1295906600",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3901 S 7TH ST",
      "city": "Terre haute",
      "state": "IN",
      "postalCode": "47802",
      "phone": "812-237-1630",
      "affiliation": "Regional Academic Oncology Network (Terre haute, IN)"
    },
    {
      "npi": "1811376759",
      "name": "Dr. Namita Agrawal, MD",
      "rawName": "Namita Agrawal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1701 N SENATE BLVD",
      "city": "Indianapolis",
      "state": "IN",
      "postalCode": "46202",
      "phone": "317-688-4800",
      "affiliation": "Regional Academic Oncology Network (Indianapolis, IN)"
    },
    {
      "npi": "1710205067",
      "name": "Dr. Maria Aguirre, MD",
      "rawName": "Maria Aguirre",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9201 CALUMET AVE",
      "city": "Munster",
      "state": "IN",
      "postalCode": "46321",
      "phone": "219-836-9024",
      "affiliation": "Regional Academic Oncology Network (Munster, IN)"
    },
    {
      "npi": "1770591893",
      "name": "Dr. Anwar Ahmad, MD",
      "rawName": "Anwar Ahmad",
      "credential": "MD",
      "specialty": "Radiology, Therapeutic Radiology",
      "taxonomyCode": "2085R0203X",
      "practiceAddress": "1500 S LAKE PARK AVE",
      "city": "Hobart",
      "state": "IN",
      "postalCode": "46342",
      "phone": "219-942-5745",
      "affiliation": "Regional Academic Oncology Network (Hobart, IN)"
    },
    {
      "npi": "1154320976",
      "name": "Dr. Neelofur Ahmad, MD",
      "rawName": "Neelofur Ahmad",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1386632248",
      "name": "Dr. Frederick Albrink, MD",
      "rawName": "Frederick Albrink",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1322 SPRING ST",
      "city": "Jeffersonville",
      "state": "IN",
      "postalCode": "47130",
      "phone": "812-285-6000",
      "affiliation": "Regional Academic Oncology Network (Jeffersonville, IN)"
    }
  ],
  "iowa": [
    {
      "npi": "1588827778",
      "name": "Dr. Kamal kant singh Abbi, MD",
      "rawName": "Kamal kant singh Abbi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1726 SHAWANO AVE",
      "city": "Green bay",
      "state": "WI",
      "postalCode": "54303",
      "phone": "920-884-3135",
      "affiliation": "Regional Academic Oncology Network (Green bay, WI)"
    },
    {
      "npi": "1447469655",
      "name": "Dr. Taher Abu hejleh, MD",
      "rawName": "Taher Abu hejleh",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "200 HAWKINS DR",
      "city": "Iowa city",
      "state": "IA",
      "postalCode": "52242",
      "phone": "319-356-2075",
      "affiliation": "Regional Academic Oncology Network (Iowa city, IA)"
    },
    {
      "npi": "1326288564",
      "name": "Dr. Laith Abushahin, MD",
      "rawName": "Laith Abushahin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3410 WORTH ST STE 400",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75246",
      "phone": "214-370-1000",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1427381607",
      "name": "Dr. Costantine Albany, MD",
      "rawName": "Costantine Albany",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1701 S CREASY LN",
      "city": "Lafayette",
      "state": "IN",
      "postalCode": "47905",
      "phone": "765-775-2800",
      "affiliation": "Regional Academic Oncology Network (Lafayette, IN)"
    },
    {
      "npi": "1881071223",
      "name": "Dr. Millicent Amankwah, MD",
      "rawName": "Millicent Amankwah",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1221 PLEASANT ST STE 250",
      "city": "Des moines",
      "state": "IA",
      "postalCode": "50309",
      "phone": "515-241-4674",
      "affiliation": "Regional Academic Oncology Network (Des moines, IA)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1336798750",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1 EDMUNDSON PL STE 100",
      "city": "Council bluffs",
      "state": "IA",
      "postalCode": "51503",
      "phone": "712-322-4136",
      "affiliation": "Regional Academic Oncology Network (Council bluffs, IA)"
    },
    {
      "npi": "1831204635",
      "name": "Dr. Walter Bate, MD",
      "rawName": "Walter Bate",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1000 4TH ST SW",
      "city": "Mason city",
      "state": "IA",
      "postalCode": "50401",
      "phone": "641-422-6300",
      "affiliation": "Regional Academic Oncology Network (Mason city, IA)"
    },
    {
      "npi": "1003020413",
      "name": "Dr. Nicole Batty, MD",
      "rawName": "Nicole Batty",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "27 INDUSTRIAL AVE STE 101",
      "city": "Sanford",
      "state": "ME",
      "postalCode": "04073",
      "phone": "207-459-1666",
      "affiliation": "Regional Academic Oncology Network (Sanford, ME)"
    },
    {
      "npi": "1215999800",
      "name": "Dr. Robert Behrens, MD",
      "rawName": "Robert Behrens",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1221 PLEASANT ST",
      "city": "Des moines",
      "state": "IA",
      "postalCode": "50309",
      "phone": "515-282-2921",
      "affiliation": "Regional Academic Oncology Network (Des moines, IA)"
    },
    {
      "npi": "1821529363",
      "name": "Dr. Sydney Brehany, MD",
      "rawName": "Sydney Brehany",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "411 LAUREL ST STE A300",
      "city": "Des moines",
      "state": "IA",
      "postalCode": "50314",
      "phone": "515-282-2921",
      "affiliation": "Regional Academic Oncology Network (Des moines, IA)"
    },
    {
      "npi": "1790136182",
      "name": "Dr. Emily Brugioni, DO",
      "rawName": "Emily Brugioni",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "411 LAUREL ST STE A300",
      "city": "Des moines",
      "state": "IA",
      "postalCode": "50314",
      "phone": "515-282-2921",
      "affiliation": "Regional Academic Oncology Network (Des moines, IA)"
    },
    {
      "npi": "1982162608",
      "name": "Dr. Mohamed Abdi, MD",
      "rawName": "Mohamed Abdi",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1000 4TH ST SW",
      "city": "Mason city",
      "state": "IA",
      "postalCode": "50401",
      "phone": "641-428-6330",
      "affiliation": "Regional Academic Oncology Network (Mason city, IA)"
    },
    {
      "npi": "1679923270",
      "name": "Dr. Quentin Adams, MD",
      "rawName": "Quentin Adams",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3333 SILAS CREEK PKWY",
      "city": "Winston salem",
      "state": "NC",
      "postalCode": "27103",
      "phone": "336-718-5095",
      "affiliation": "Regional Academic Oncology Network (Winston salem, NC)"
    },
    {
      "npi": "1760832513",
      "name": "Dr. Nandita Agarwal, MD",
      "rawName": "Nandita Agarwal",
      "credential": "MD",
      "specialty": "Radiology, Diagnostic Radiology",
      "taxonomyCode": "2085R0202X",
      "practiceAddress": "200 HAWKINS DR",
      "city": "Iowa city",
      "state": "IA",
      "postalCode": "52242",
      "phone": "319-356-3444",
      "affiliation": "Regional Academic Oncology Network (Iowa city, IA)"
    },
    {
      "npi": "1851702831",
      "name": "Dr. Awad Ahmed, MD",
      "rawName": "Awad Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2121 PEASE ST STE 101",
      "city": "Harlingen",
      "state": "TX",
      "postalCode": "78550",
      "phone": "956-425-8845",
      "affiliation": "Regional Academic Oncology Network (Harlingen, TX)"
    },
    {
      "npi": "1639866403",
      "name": "Dr. Olukemi Alegi, MD",
      "rawName": "Olukemi Alegi",
      "credential": "MD",
      "specialty": "Student in an Organized Health Care Education/Training Program",
      "taxonomyCode": "390200000X",
      "practiceAddress": "1270 PRINCE AVENUE, SUITE 102",
      "city": "Athens",
      "state": "GA",
      "postalCode": "30606",
      "phone": "706-475-7055",
      "affiliation": "Regional Academic Oncology Network (Athens, GA)"
    },
    {
      "npi": "1689832081",
      "name": "Dr. Bryan Allen, MD",
      "rawName": "Bryan Allen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "200 HAWKINS DR",
      "city": "Iowa city",
      "state": "IA",
      "postalCode": "52242",
      "phone": "319-353-8836",
      "affiliation": "Regional Academic Oncology Network (Iowa city, IA)"
    },
    {
      "npi": "1093342859",
      "name": "Dr. August Anderson, MD",
      "rawName": "August Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "230 NEBRASKA ST",
      "city": "Sioux city",
      "state": "IA",
      "postalCode": "51101",
      "phone": "209-727-2072",
      "affiliation": "Regional Academic Oncology Network (Sioux city, IA)"
    }
  ],
  "kansas": [
    {
      "npi": "1538547419",
      "name": "Dr. Saqib Abbasi, MD",
      "rawName": "Saqib Abbasi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2330 SHAWNEE MISSION PKWY",
      "city": "Westwood",
      "state": "KS",
      "postalCode": "66205",
      "phone": "913-588-7750",
      "affiliation": "Regional Academic Oncology Network (Westwood, KS)"
    },
    {
      "npi": "1689878688",
      "name": "Dr. Saaib Al shehadat, MD",
      "rawName": "Saaib Al shehadat",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2214 CANTERBURY DR",
      "city": "Hays",
      "state": "KS",
      "postalCode": "67601",
      "phone": "785-623-4699",
      "affiliation": "Regional Academic Oncology Network (Hays, KS)"
    },
    {
      "npi": "1497979678",
      "name": "Dr. Ajjai Alva, MD",
      "rawName": "Ajjai Alva",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10701 NALL AVE STE 100",
      "city": "Overland park",
      "state": "KS",
      "postalCode": "66211",
      "phone": "913-338-5585",
      "affiliation": "Regional Academic Oncology Network (Overland park, KS)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1750263729",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "8919 PARALLEL PKWY STE 326W",
      "city": "Kansas city",
      "state": "KS",
      "postalCode": "66112",
      "phone": "913-804-4031",
      "affiliation": "Regional Academic Oncology Network (Kansas city, KS)"
    },
    {
      "npi": "1801989041",
      "name": "Dr. Joaquina Baranda, MD",
      "rawName": "Joaquina Baranda",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2650 SHAWNEE MISSION PKWY",
      "city": "Westwood",
      "state": "KS",
      "postalCode": "66205",
      "phone": "913-588-1227",
      "affiliation": "Regional Academic Oncology Network (Westwood, KS)"
    },
    {
      "npi": "1144858549",
      "name": "Dr. Kirstin Binz, MD",
      "rawName": "Kirstin Binz",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "12200 W 110TH ST",
      "city": "Overland park",
      "state": "KS",
      "postalCode": "66210",
      "phone": "913-588-1227",
      "affiliation": "Regional Academic Oncology Network (Overland park, KS)"
    },
    {
      "npi": "1003871757",
      "name": "Dr. William Cathcart-rake, MD",
      "rawName": "William Cathcart-rake",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "511 S SANTA FE AVE",
      "city": "Salina",
      "state": "KS",
      "postalCode": "67401",
      "phone": "785-827-7261",
      "affiliation": "Regional Academic Oncology Network (Salina, KS)"
    },
    {
      "npi": "1316372154",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Non-Pharmacy Dispensing Site",
      "taxonomyCode": "332900000X",
      "practiceAddress": "1501 N OAKLAND AVE",
      "city": "Bolivar",
      "state": "MO",
      "postalCode": "65613",
      "phone": "417-326-7200",
      "affiliation": "Regional Academic Oncology Network (Bolivar, MO)"
    },
    {
      "npi": "1487253050",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3550 S 4TH ST STE 282",
      "city": "Leavenworth",
      "state": "KS",
      "postalCode": "66048",
      "phone": "913-318-7821",
      "affiliation": "Regional Academic Oncology Network (Leavenworth, KS)"
    },
    {
      "npi": "1558980474",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8919 PARALLEL PKWY STE 326",
      "city": "Kansas city",
      "state": "KS",
      "postalCode": "66112",
      "phone": "913-318-7821",
      "affiliation": "Regional Academic Oncology Network (Kansas city, KS)"
    },
    {
      "npi": "1922340223",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Non-Pharmacy Dispensing Site",
      "taxonomyCode": "332900000X",
      "practiceAddress": "204 CLEVELAND ST",
      "city": "Great bend",
      "state": "KS",
      "postalCode": "67530",
      "phone": "620-792-5511",
      "affiliation": "Regional Academic Oncology Network (Great bend, KS)"
    },
    {
      "npi": "1265873905",
      "name": "Dr. Yazan Abuodeh, MD",
      "rawName": "Yazan Abuodeh",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "511 S SANTA FE AVE STE A",
      "city": "Salina",
      "state": "KS",
      "postalCode": "67401",
      "phone": "785-452-4820",
      "affiliation": "Regional Academic Oncology Network (Salina, KS)"
    },
    {
      "npi": "1598105603",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "6427 W 119TH ST",
      "city": "Overland park",
      "state": "KS",
      "postalCode": "66209",
      "phone": "913-202-1700",
      "affiliation": "Regional Academic Oncology Network (Overland park, KS)"
    },
    {
      "npi": "1992185334",
      "name": "Dr. David Akhavan, MD",
      "rawName": "David Akhavan",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4001 RAINBOW BLVD",
      "city": "Kansas city",
      "state": "KS",
      "postalCode": "66160",
      "phone": "913-588-3600",
      "affiliation": "Regional Academic Oncology Network (Kansas city, KS)"
    },
    {
      "npi": "1942525423",
      "name": "Dr. Jes Alexander, MD",
      "rawName": "Jes Alexander",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4000 CAMBRIDGE ST",
      "city": "Kansas city",
      "state": "KS",
      "postalCode": "66160",
      "phone": "913-588-1227",
      "affiliation": "Regional Academic Oncology Network (Kansas city, KS)"
    },
    {
      "npi": "1386677151",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1102 E CENTENNIAL DR",
      "city": "Pittsburg",
      "state": "KS",
      "postalCode": "66762",
      "phone": "620-235-7900",
      "affiliation": "Regional Academic Oncology Network (Pittsburg, KS)"
    },
    {
      "npi": "1497750525",
      "name": "Dr. Jon Anders, MD",
      "rawName": "Jon Anders",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "817 N EMPORIA ST",
      "city": "Wichita",
      "state": "KS",
      "postalCode": "67214",
      "phone": "316-268-5927",
      "affiliation": "Regional Academic Oncology Network (Wichita, KS)"
    },
    {
      "npi": "1871589333",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Family Medicine",
      "taxonomyCode": "207Q00000X",
      "practiceAddress": "929 N. ST. FRANCIS",
      "city": "Wichita",
      "state": "KS",
      "postalCode": "67214",
      "phone": "316-268-5000",
      "affiliation": "Regional Academic Oncology Network (Wichita, KS)"
    }
  ],
  "kentucky": [
    {
      "npi": "1922520808",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1460 BLUEGRASS AVE",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40215",
      "phone": "502-361-8496",
      "affiliation": "Regional Academic Oncology Network (Louisville, KY)"
    },
    {
      "npi": "1225567233",
      "name": "Dr. Talha Aijaz, MD",
      "rawName": "Talha Aijaz",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1396059705",
      "name": "Dr. Mohamed Alsharedi, MD",
      "rawName": "Mohamed Alsharedi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2195 HARRODSBURG RD FL 2",
      "city": "Lexington",
      "state": "KY",
      "postalCode": "40504",
      "phone": "859-258-4673",
      "affiliation": "Regional Academic Oncology Network (Lexington, KY)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1669931259",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1460 BLUEGRASS AVE",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40215",
      "phone": "502-361-8496",
      "affiliation": "Regional Academic Oncology Network (Louisville, KY)"
    },
    {
      "npi": "1184622250",
      "name": "Dr. Lowell Anthony, MD",
      "rawName": "Lowell Anthony",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "MARKEY CANCER CTR",
      "city": "Lexington",
      "state": "KY",
      "postalCode": "40536",
      "phone": "859-323-6522",
      "affiliation": "Regional Academic Oncology Network (Lexington, KY)"
    },
    {
      "npi": "1316364441",
      "name": "Dr. Ruta Arays, MD",
      "rawName": "Ruta Arays",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 ROSE ST",
      "city": "Lexington",
      "state": "KY",
      "postalCode": "40536",
      "phone": "859-323-2650",
      "affiliation": "Regional Academic Oncology Network (Lexington, KY)"
    },
    {
      "npi": "1811992852",
      "name": "Dr. Aruna Arekapudi, MD",
      "rawName": "Aruna Arekapudi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "401 PALMETTO ST",
      "city": "New smyrna beach",
      "state": "FL",
      "postalCode": "32168",
      "phone": "386-424-5038",
      "affiliation": "Regional Academic Oncology Network (New smyrna beach, FL)"
    },
    {
      "npi": "1558335265",
      "name": "Dr. Paul Arena, MD",
      "rawName": "Paul Arena",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "100 E LIBERTY ST",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40202",
      "phone": "502-561-8200",
      "affiliation": "Regional Academic Oncology Network (Louisville, KY)"
    },
    {
      "npi": "1821931650",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Clinic/Center, Multi-Specialty",
      "taxonomyCode": "261QM1300X",
      "practiceAddress": "4948 KY ROUTE 321",
      "city": "Prestonsburg",
      "state": "KY",
      "postalCode": "41653",
      "phone": "606-889-6390",
      "affiliation": "Regional Academic Oncology Network (Prestonsburg, KY)"
    },
    {
      "npi": "1114934056",
      "name": "Dr. Susanne Arnold, MD",
      "rawName": "Susanne Arnold",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "740 S LIMESTONE",
      "city": "Lexington",
      "state": "KY",
      "postalCode": "40536",
      "phone": "859-323-5116",
      "affiliation": "Regional Academic Oncology Network (Lexington, KY)"
    },
    {
      "npi": "1629236930",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Obstetrics & Gynecology, Gynecologic Oncology",
      "taxonomyCode": "207VX0201X",
      "practiceAddress": "1780 NICHOLASVILLE RD",
      "city": "Lexington",
      "state": "KY",
      "postalCode": "40503",
      "phone": "859-278-2671",
      "affiliation": "Regional Academic Oncology Network (Lexington, KY)"
    },
    {
      "npi": "1437385770",
      "name": "Dr. Ryan Abel, MD",
      "rawName": "Ryan Abel",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1020 BRECKENRIDGE ST",
      "city": "Owensboro",
      "state": "KY",
      "postalCode": "42303",
      "phone": "270-688-3600",
      "affiliation": "Regional Academic Oncology Network (Owensboro, KY)"
    },
    {
      "npi": "1780817502",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Otolaryngology",
      "taxonomyCode": "207Y00000X",
      "practiceAddress": "2944 BRECKENRIDGE LN",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40220",
      "phone": "502-893-0159",
      "affiliation": "Regional Academic Oncology Network (Louisville, KY)"
    },
    {
      "npi": "1669851424",
      "name": "Dr. Basel Altoos, MD",
      "rawName": "Basel Altoos",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4955 NORTON HEALTHCARE BLVD",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40241",
      "phone": "502-394-6350",
      "affiliation": "Regional Academic Oncology Network (Louisville, KY)"
    },
    {
      "npi": "1285626283",
      "name": "Dr. Falguni Amin-zimmerman, MD",
      "rawName": "Falguni Amin-zimmerman",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1401 HARRODSBURG RD",
      "city": "Lexington",
      "state": "KY",
      "postalCode": "40504",
      "phone": "859-258-6505",
      "affiliation": "Regional Academic Oncology Network (Lexington, KY)"
    },
    {
      "npi": "1043772445",
      "name": "Dr. Evans Amoah, MD",
      "rawName": "Evans Amoah",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "250 PARK ST",
      "city": "Bowling green",
      "state": "KY",
      "postalCode": "42101",
      "phone": "270-781-7178",
      "affiliation": "Regional Academic Oncology Network (Bowling green, KY)"
    },
    {
      "npi": "1700381548",
      "name": "Dr. Justin Anderson, MD",
      "rawName": "Justin Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4003 KRESGE WAY STE 115",
      "city": "Louisville",
      "state": "KY",
      "postalCode": "40207",
      "phone": "502-897-8163",
      "affiliation": "Regional Academic Oncology Network (Louisville, KY)"
    },
    {
      "npi": "1972648285",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "706 23RD ST",
      "city": "Ashland",
      "state": "KY",
      "postalCode": "41101",
      "phone": "606-329-0060",
      "affiliation": "Regional Academic Oncology Network (Ashland, KY)"
    }
  ],
  "louisiana": [
    {
      "npi": "1720148208",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "500 JULIETTE PLACE",
      "city": "Lafayette",
      "state": "LA",
      "postalCode": "70506",
      "phone": "337-232-2520",
      "affiliation": "Regional Academic Oncology Network (Lafayette, LA)"
    },
    {
      "npi": "1679919963",
      "name": "Dr. Olufunke Akinbobuyi, MD",
      "rawName": "Olufunke Akinbobuyi",
      "credential": "MD",
      "specialty": "Hospitalist",
      "taxonomyCode": "208M00000X",
      "practiceAddress": "3501 JOHNSON ST",
      "city": "Hollywood",
      "state": "FL",
      "postalCode": "33021",
      "phone": "954-987-2000",
      "affiliation": "Regional Academic Oncology Network (Hollywood, FL)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1114819083",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4242 HIGHWAY 19",
      "city": "Zachary",
      "state": "LA",
      "postalCode": "70791",
      "phone": "225-306-7260",
      "affiliation": "Regional Academic Oncology Network (Zachary, LA)"
    },
    {
      "npi": "1659867265",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4242 HIGHWAY 19 STE B",
      "city": "Zachary",
      "state": "LA",
      "postalCode": "70791",
      "phone": "225-306-7260",
      "affiliation": "Regional Academic Oncology Network (Zachary, LA)"
    },
    {
      "npi": "1164305363",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "5326 OAK ST",
      "city": "Saint francisville",
      "state": "LA",
      "postalCode": "70775",
      "phone": "225-635-5848",
      "affiliation": "Regional Academic Oncology Network (Saint francisville, LA)"
    },
    {
      "npi": "1639215932",
      "name": "Dr. Willard Andes, MD",
      "rawName": "Willard Andes",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1615 DELAWARE ST",
      "city": "Longview",
      "state": "WA",
      "postalCode": "98632",
      "phone": "360-414-7878",
      "affiliation": "Regional Academic Oncology Network (Longview, WA)"
    },
    {
      "npi": "1285889675",
      "name": "Dr. Nelly Aoun, MD",
      "rawName": "Nelly Aoun",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "900 OCHSNER BLVD.",
      "city": "Covington",
      "state": "LA",
      "postalCode": "70433",
      "phone": "985-249-2383",
      "affiliation": "Regional Academic Oncology Network (Covington, LA)"
    },
    {
      "npi": "1083935878",
      "name": "Dr. Ali Baghian, MD",
      "rawName": "Ali Baghian",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "450 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-632-3446",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1013011303",
      "name": "Dr. Stephen Baker, MD",
      "rawName": "Stephen Baker",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "1051 GAUSE BLVD",
      "city": "Slidel",
      "state": "LA",
      "postalCode": "70458",
      "phone": "985-641-7577",
      "affiliation": "Regional Academic Oncology Network (Slidel, LA)"
    },
    {
      "npi": "1386614345",
      "name": "Dr. Elpidia Balbastro, MD",
      "rawName": "Elpidia Balbastro",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1200 HOSPITAL DR STE 2",
      "city": "Opelousas",
      "state": "LA",
      "postalCode": "70570",
      "phone": "337-942-7898",
      "affiliation": "Regional Academic Oncology Network (Opelousas, LA)"
    },
    {
      "npi": "1154366508",
      "name": "Dr. Ebenezer Berko, MD",
      "rawName": "Ebenezer Berko",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3330 MASONIC DR",
      "city": "Alexandria",
      "state": "LA",
      "postalCode": "71301",
      "phone": "318-448-6917",
      "affiliation": "Regional Academic Oncology Network (Alexandria, LA)"
    },
    {
      "npi": "1720489362",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "525 N LEWIS ST",
      "city": "New iberia",
      "state": "LA",
      "postalCode": "70563",
      "phone": "337-364-1131",
      "affiliation": "Regional Academic Oncology Network (New iberia, LA)"
    },
    {
      "npi": "1003255761",
      "name": "Dr. Natalie Alphonse sullivan, MD",
      "rawName": "Natalie Alphonse sullivan",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3330 MASONIC DR",
      "city": "Alexandria",
      "state": "LA",
      "postalCode": "71301",
      "phone": "318-448-6917",
      "affiliation": "Regional Academic Oncology Network (Alexandria, LA)"
    },
    {
      "npi": "1538185012",
      "name": "Dr. Federico Ampil, MD",
      "rawName": "Federico Ampil",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1541 KINGS HWY",
      "city": "Shreveport",
      "state": "LA",
      "postalCode": "71103",
      "phone": "318-626-0000",
      "affiliation": "Regional Academic Oncology Network (Shreveport, LA)"
    },
    {
      "npi": "1124288956",
      "name": "Dr. John Anderson, MD",
      "rawName": "John Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4809 AMBASSADOR CAFFERY PKWY",
      "city": "Lafayette",
      "state": "LA",
      "postalCode": "70508",
      "phone": "337-769-8660",
      "affiliation": "Regional Academic Oncology Network (Lafayette, LA)"
    },
    {
      "npi": "1013043009",
      "name": "Dr. Russell Anderson, MD",
      "rawName": "Russell Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1541 KINGS HWY",
      "city": "Shreveport",
      "state": "LA",
      "postalCode": "71103",
      "phone": "318-626-0000",
      "affiliation": "Regional Academic Oncology Network (Shreveport, LA)"
    },
    {
      "npi": "1023291465",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "302 ARABELLA BLVD",
      "city": "Lafayette",
      "state": "LA",
      "postalCode": "70508",
      "phone": "337-593-7285",
      "affiliation": "Regional Academic Oncology Network (Lafayette, LA)"
    },
    {
      "npi": "1700837002",
      "name": "Dr. Roxana Baluna, MD",
      "rawName": "Roxana Baluna",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "510 E STONER AVE",
      "city": "Shreveport",
      "state": "LA",
      "postalCode": "71101",
      "phone": "318-990-4773",
      "affiliation": "Regional Academic Oncology Network (Shreveport, LA)"
    }
  ],
  "maine": [
    {
      "npi": "1992771448",
      "name": "Dr. Ariel Anguiano, MD",
      "rawName": "Ariel Anguiano",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "801 UNIVERSITY BLVD E",
      "city": "Tuscaloosa",
      "state": "AL",
      "postalCode": "35401",
      "phone": "205-759-7800",
      "affiliation": "Regional Academic Oncology Network (Tuscaloosa, AL)"
    },
    {
      "npi": "1003020413",
      "name": "Dr. Nicole Batty, MD",
      "rawName": "Nicole Batty",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "27 INDUSTRIAL AVE STE 101",
      "city": "Sanford",
      "state": "ME",
      "postalCode": "04073",
      "phone": "207-459-1666",
      "affiliation": "Regional Academic Oncology Network (Sanford, ME)"
    },
    {
      "npi": "1821435140",
      "name": "Dr. Jessica Bian, MD",
      "rawName": "Jessica Bian",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "265 WESTERN AVE STE 2",
      "city": "South portland",
      "state": "ME",
      "postalCode": "04106",
      "phone": "207-661-0200",
      "affiliation": "Regional Academic Oncology Network (South portland, ME)"
    },
    {
      "npi": "1033246731",
      "name": "Dr. Alan Boone, MD",
      "rawName": "Alan Boone",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "36 HOWARD ST",
      "city": "Bangor",
      "state": "ME",
      "postalCode": "04401",
      "phone": "207-945-3616",
      "affiliation": "Regional Academic Oncology Network (Bangor, ME)"
    },
    {
      "npi": "1336465715",
      "name": "Dr. Dawn Brooks, MD",
      "rawName": "Dawn Brooks",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "80 FISHER DRIVE",
      "city": "Avon",
      "state": "CT",
      "postalCode": "06001",
      "phone": "860-674-0088",
      "affiliation": "Regional Academic Oncology Network (Avon, CT)"
    },
    {
      "npi": "1699980300",
      "name": "Dr. Leah Cream, MD",
      "rawName": "Leah Cream",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1703 INNOVATION DR STE 2001",
      "city": "York",
      "state": "PA",
      "postalCode": "17408",
      "phone": "717-801-0765",
      "affiliation": "Regional Academic Oncology Network (York, PA)"
    },
    {
      "npi": "1730477555",
      "name": "Dr. Allan louie Cruz, MD",
      "rawName": "Allan louie Cruz",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "414 GRAND ST STE 9-13",
      "city": "Jersey city",
      "state": "NJ",
      "postalCode": "07302",
      "phone": "201-915-2730",
      "affiliation": "Regional Academic Oncology Network (Jersey city, NJ)"
    },
    {
      "npi": "1386615201",
      "name": "Dr. Kurt Ebrahim, DO",
      "rawName": "Kurt Ebrahim",
      "credential": "DO",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2 INDEPENDENCE DR",
      "city": "Kennebunk",
      "state": "ME",
      "postalCode": "04043",
      "phone": "207-303-3300",
      "affiliation": "Regional Academic Oncology Network (Kennebunk, ME)"
    },
    {
      "npi": "1518080639",
      "name": "Dr. Rebecca Eisenberg, MD",
      "rawName": "Rebecca Eisenberg",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "27 INDUSTRIAL AVE STE 101",
      "city": "Sanford",
      "state": "ME",
      "postalCode": "04073",
      "phone": "207-294-5800",
      "affiliation": "Regional Academic Oncology Network (Sanford, ME)"
    },
    {
      "npi": "1902562556",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "660 GLADES RD STE 340",
      "city": "Boca raton",
      "state": "FL",
      "postalCode": "33431",
      "phone": "941-746-7507",
      "affiliation": "Regional Academic Oncology Network (Boca raton, FL)"
    },
    {
      "npi": "1407817406",
      "name": "Dr. Judit Gellen, MD",
      "rawName": "Judit Gellen",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "265 WESTERN AVE",
      "city": "South portland",
      "state": "ME",
      "postalCode": "04106",
      "phone": "207-459-1666",
      "affiliation": "Regional Academic Oncology Network (South portland, ME)"
    },
    {
      "npi": "1841385226",
      "name": "Dr. Peter Graham, MD",
      "rawName": "Peter Graham",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2 CAPITAL WAY STE 220",
      "city": "Pennington",
      "state": "NJ",
      "postalCode": "08534",
      "phone": "609-303-0747",
      "affiliation": "Regional Academic Oncology Network (Pennington, NJ)"
    },
    {
      "npi": "1073908505",
      "name": "Dr. Whitney Beeler, MD",
      "rawName": "Whitney Beeler",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "22 BRAMHALL ST",
      "city": "Portland",
      "state": "ME",
      "postalCode": "04102",
      "phone": "207-662-4735",
      "affiliation": "Regional Academic Oncology Network (Portland, ME)"
    },
    {
      "npi": "1548613128",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Urology",
      "taxonomyCode": "208800000X",
      "practiceAddress": "11301 FALLBROOK DR",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77065",
      "phone": "832-604-5414",
      "affiliation": "Regional Academic Oncology Network (Houston, TX)"
    },
    {
      "npi": "1235357294",
      "name": "Dr. Ian Bristol, MD",
      "rawName": "Ian Bristol",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "22 BRAMHALL ST",
      "city": "Portland",
      "state": "ME",
      "postalCode": "04102",
      "phone": "207-662-2276",
      "affiliation": "Regional Academic Oncology Network (Portland, ME)"
    },
    {
      "npi": "1235101825",
      "name": "Dr. Michael Brown, MD",
      "rawName": "Michael Brown",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "17 HIGH ST",
      "city": "Lewiston",
      "state": "ME",
      "postalCode": "04240",
      "phone": "207-795-2440",
      "affiliation": "Regional Academic Oncology Network (Lewiston, ME)"
    },
    {
      "npi": "1548882632",
      "name": "Dr. Haocheng Cai, DO",
      "rawName": "Haocheng Cai",
      "credential": "DO",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "880 E TUOLUMNE RD",
      "city": "Turlock",
      "state": "CA",
      "postalCode": "95382",
      "phone": "209-664-5030",
      "affiliation": "Regional Academic Oncology Network (Turlock, CA)"
    },
    {
      "npi": "1396927604",
      "name": "Dr. William Castrucci, MD",
      "rawName": "William Castrucci",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "33 WHITING HILL RD",
      "city": "Brewer",
      "state": "ME",
      "postalCode": "04412",
      "phone": "207-973-7499",
      "affiliation": "Regional Academic Oncology Network (Brewer, ME)"
    },
    {
      "npi": "1326363714",
      "name": "Dr. Matthew Cheney, MD",
      "rawName": "Matthew Cheney",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "22 BRAMHALL ST",
      "city": "Portland",
      "state": "ME",
      "postalCode": "04102",
      "phone": "207-662-2276",
      "affiliation": "Regional Academic Oncology Network (Portland, ME)"
    },
    {
      "npi": "1922090315",
      "name": "Dr. Bruce Cross, MD",
      "rawName": "Bruce Cross",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1502 DODSON AVE",
      "city": "Fort smith",
      "state": "AR",
      "postalCode": "72901",
      "phone": "479-709-7190",
      "affiliation": "Regional Academic Oncology Network (Fort smith, AR)"
    }
  ],
  "minnesota": [
    {
      "npi": "1982680583",
      "name": "Dr. Alex Adjei, MD",
      "rawName": "Alex Adjei",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    },
    {
      "npi": "1295804250",
      "name": "Dr. Naseer Ahmad, MD",
      "rawName": "Naseer Ahmad",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "11850 BLACKFOOT ST NW STE 200",
      "city": "Coon rapids",
      "state": "MN",
      "postalCode": "55433",
      "phone": "612-341-4800",
      "affiliation": "Regional Academic Oncology Network (Coon rapids, MN)"
    },
    {
      "npi": "1750395745",
      "name": "Dr. Eyad Al-hattab, MD",
      "rawName": "Eyad Al-hattab",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1400 BELLINGER ST",
      "city": "Eau claire",
      "state": "WI",
      "postalCode": "54703",
      "phone": "715-838-5222",
      "affiliation": "Regional Academic Oncology Network (Eau claire, WI)"
    },
    {
      "npi": "1780660209",
      "name": "Dr. Steven Alberts, MD",
      "rawName": "Steven Alberts",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    },
    {
      "npi": "1407721335",
      "name": "Dr. Melissa Allard, MD",
      "rawName": "Melissa Allard",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 VETERANS DR",
      "city": "Minneapolis",
      "state": "MN",
      "postalCode": "55417",
      "phone": "612-467-1100",
      "affiliation": "Regional Academic Oncology Network (Minneapolis, MN)"
    },
    {
      "npi": "1255243978",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "255 SMITH AVE N STE 100",
      "city": "Saint paul",
      "state": "MN",
      "postalCode": "55102",
      "phone": "612-262-1166",
      "affiliation": "Regional Academic Oncology Network (Saint paul, MN)"
    },
    {
      "npi": "1235041831",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "255 SMITH AVE N STE 110",
      "city": "Saint paul",
      "state": "MN",
      "postalCode": "55102",
      "phone": "612-262-1166",
      "affiliation": "Regional Academic Oncology Network (Saint paul, MN)"
    },
    {
      "npi": "1780026567",
      "name": "Dr. Theodora Anagnostou, MD",
      "rawName": "Theodora Anagnostou",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "10 E 102ND ST",
      "city": "New york",
      "state": "NY",
      "postalCode": "10029",
      "phone": "212-241-6756",
      "affiliation": "Regional Academic Oncology Network (New york, NY)"
    },
    {
      "npi": "1568528768",
      "name": "Dr. Emmanuel Antonarakis, MD",
      "rawName": "Emmanuel Antonarakis",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "909 FULTON ST SE",
      "city": "Minneapolis",
      "state": "MN",
      "postalCode": "55455",
      "phone": "612-672-6000",
      "affiliation": "Regional Academic Oncology Network (Minneapolis, MN)"
    },
    {
      "npi": "1710478094",
      "name": "Dr. Ryan Augustin, MD",
      "rawName": "Ryan Augustin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    },
    {
      "npi": "1255759163",
      "name": "Dr. Viswatej Avutu, MD",
      "rawName": "Viswatej Avutu",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    },
    {
      "npi": "1164558763",
      "name": "Dr. Ayodele Ayoola, MD",
      "rawName": "Ayodele Ayoola",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "500 UNIVERSITY DR",
      "city": "Hershey",
      "state": "PA",
      "postalCode": "17033",
      "phone": "800-243-1455",
      "affiliation": "Regional Academic Oncology Network (Hershey, PA)"
    },
    {
      "npi": "1720155336",
      "name": "Dr. Nelson Adamson, MD",
      "rawName": "Nelson Adamson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1475 SAINT FRANCIS AVE",
      "city": "Shakopee",
      "state": "MN",
      "postalCode": "55379",
      "phone": "952-428-2663",
      "affiliation": "Regional Academic Oncology Network (Shakopee, MN)"
    },
    {
      "npi": "1548609910",
      "name": "Dr. Safia Ahmed, MD",
      "rawName": "Safia Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "13400 E SHEA BLVD",
      "city": "Scottsdale",
      "state": "AZ",
      "postalCode": "85259",
      "phone": "072-842-5115",
      "affiliation": "Regional Academic Oncology Network (Scottsdale, AZ)"
    },
    {
      "npi": "1508363532",
      "name": "Dr. Now bahar Alam, MD",
      "rawName": "Now bahar Alam",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1400 BELLINGER STREET",
      "city": "Eau claire",
      "state": "WI",
      "postalCode": "54703",
      "phone": "715-838-5222",
      "affiliation": "Regional Academic Oncology Network (Eau claire, WI)"
    },
    {
      "npi": "1629646211",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "310 SMITH AVE N STE 180",
      "city": "Saint paul",
      "state": "MN",
      "postalCode": "55102",
      "phone": "651-241-7800",
      "affiliation": "Regional Academic Oncology Network (Saint paul, MN)"
    },
    {
      "npi": "1962607499",
      "name": "Dr. Nils Arvold, MD",
      "rawName": "Nils Arvold",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1001 E SUPERIOR ST",
      "city": "Duluth",
      "state": "MN",
      "postalCode": "55802",
      "phone": "218-249-7800",
      "affiliation": "Regional Academic Oncology Network (Duluth, MN)"
    },
    {
      "npi": "1881213007",
      "name": "Dr. Khaled Aziz, MD",
      "rawName": "Khaled Aziz",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    },
    {
      "npi": "1275531493",
      "name": "Dr. James Baer, MD",
      "rawName": "James Baer",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1400 BELLINGER STREET",
      "city": "Eau claire",
      "state": "WI",
      "postalCode": "54703",
      "phone": "715-838-5222",
      "affiliation": "Regional Academic Oncology Network (Eau claire, WI)"
    },
    {
      "npi": "1356968069",
      "name": "Dr. Justin Barnes, MD",
      "rawName": "Justin Barnes",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    }
  ],
  "mississippi": [
    {
      "npi": "1013011303",
      "name": "Dr. Stephen Baker, MD",
      "rawName": "Stephen Baker",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "1051 GAUSE BLVD",
      "city": "Slidel",
      "state": "LA",
      "postalCode": "70458",
      "phone": "985-641-7577",
      "affiliation": "Regional Academic Oncology Network (Slidel, LA)"
    },
    {
      "npi": "1891677555",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "147 REYNOIR ST STE 204",
      "city": "Biloxi",
      "state": "MS",
      "postalCode": "39530",
      "phone": "228-822-6320",
      "affiliation": "Regional Academic Oncology Network (Biloxi, MS)"
    },
    {
      "npi": "1770537920",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Family Medicine",
      "taxonomyCode": "207Q00000X",
      "practiceAddress": "147 REYNOIR ST",
      "city": "Biloxi",
      "state": "MS",
      "postalCode": "39530",
      "phone": "228-436-1583",
      "affiliation": "Regional Academic Oncology Network (Biloxi, MS)"
    },
    {
      "npi": "1902152606",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "147 REYNOIR ST",
      "city": "Biloxi",
      "state": "MS",
      "postalCode": "39530",
      "phone": "228-374-6296",
      "affiliation": "Regional Academic Oncology Network (Biloxi, MS)"
    },
    {
      "npi": "1356838783",
      "name": "Dr. Otis Brunson, MD",
      "rawName": "Otis Brunson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2500 N STATE ST",
      "city": "Jackson",
      "state": "MS",
      "postalCode": "39216",
      "phone": "601-984-5604",
      "affiliation": "Regional Academic Oncology Network (Jackson, MS)"
    },
    {
      "npi": "1285711978",
      "name": "Dr. James Clarkson, MD",
      "rawName": "James Clarkson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2809 DENNY AVE",
      "city": "Pascagoula",
      "state": "MS",
      "postalCode": "39581",
      "phone": "228-809-2057",
      "affiliation": "Regional Academic Oncology Network (Pascagoula, MS)"
    },
    {
      "npi": "1639380207",
      "name": "Dr. Nicole Cleveland, MD",
      "rawName": "Nicole Cleveland",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2969 CURRAN DR N",
      "city": "Jackson",
      "state": "MS",
      "postalCode": "39216",
      "phone": "601-974-5600",
      "affiliation": "Regional Academic Oncology Network (Jackson, MS)"
    },
    {
      "npi": "1831175280",
      "name": "Dr. Edwin Davidson, MD",
      "rawName": "Edwin Davidson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1340 BROAD AVE",
      "city": "Gulfport",
      "state": "MS",
      "postalCode": "39501",
      "phone": "228-575-1234",
      "affiliation": "Regional Academic Oncology Network (Gulfport, MS)"
    },
    {
      "npi": "1073569018",
      "name": "Dr. Stephanie Fussell, MD",
      "rawName": "Stephanie Fussell",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1340 BROAD AVE STE 330",
      "city": "Gulfport",
      "state": "MS",
      "postalCode": "39501",
      "phone": "228-575-1234",
      "affiliation": "Regional Academic Oncology Network (Gulfport, MS)"
    },
    {
      "npi": "1992298236",
      "name": "Dr. Paige Ganem, DO",
      "rawName": "Paige Ganem",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "65 INTERNATIONAL DR",
      "city": "Greenville",
      "state": "SC",
      "postalCode": "29615",
      "phone": "864-987-7000",
      "affiliation": "Regional Academic Oncology Network (Greenville, SC)"
    },
    {
      "npi": "1205831666",
      "name": "Dr. Bobby Graham, MD",
      "rawName": "Bobby Graham",
      "credential": "MD",
      "specialty": "Internal Medicine, Hospice and Palliative Medicine",
      "taxonomyCode": "207RH0002X",
      "practiceAddress": "969 LAKELAND DR",
      "city": "Jackson",
      "state": "MS",
      "postalCode": "39216",
      "phone": "601-200-5900",
      "affiliation": "Regional Academic Oncology Network (Jackson, MS)"
    },
    {
      "npi": "1154367837",
      "name": "Dr. Robert Hamilton, MD",
      "rawName": "Robert Hamilton",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2500 NORTH STATE STREET",
      "city": "Jackson",
      "state": "MS",
      "postalCode": "39216",
      "phone": "601-984-5615",
      "affiliation": "Regional Academic Oncology Network (Jackson, MS)"
    },
    {
      "npi": "1003602319",
      "name": "Dr. Nayan Agarwal, MD",
      "rawName": "Nayan Agarwal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2500 N STATE STREET",
      "city": "Jackson",
      "state": "MS",
      "postalCode": "39216",
      "phone": "601-984-1000",
      "affiliation": "Regional Academic Oncology Network (Jackson, MS)"
    },
    {
      "npi": "1043743339",
      "name": "Dr. Hiba Ahmed, MD",
      "rawName": "Hiba Ahmed",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "225 E WASHINGTON AVE",
      "city": "Jonesboro",
      "state": "AR",
      "postalCode": "72401",
      "phone": "870-207-8210",
      "affiliation": "Regional Academic Oncology Network (Jonesboro, AR)"
    },
    {
      "npi": "1477667327",
      "name": "Dr. Robert Allbright, MD",
      "rawName": "Robert Allbright",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "350 W WOODROW WILSON AVE",
      "city": "Jackson",
      "state": "MS",
      "postalCode": "39213",
      "phone": "601-815-6886",
      "affiliation": "Regional Academic Oncology Network (Jackson, MS)"
    },
    {
      "npi": "1689869497",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1514 E UNION ST",
      "city": "Greenville",
      "state": "MS",
      "postalCode": "38703",
      "phone": "662-332-6150",
      "affiliation": "Regional Academic Oncology Network (Greenville, MS)"
    },
    {
      "npi": "1114112927",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "581 MEDICAL DR",
      "city": "Clarksdale",
      "state": "MS",
      "postalCode": "38614",
      "phone": "662-624-8731",
      "affiliation": "Regional Academic Oncology Network (Clarksdale, MS)"
    },
    {
      "npi": "1043764699",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Specialist",
      "taxonomyCode": "174400000X",
      "practiceAddress": "2124 14TH ST",
      "city": "Meridian",
      "state": "MS",
      "postalCode": "39301",
      "phone": "601-553-6000",
      "affiliation": "Regional Academic Oncology Network (Meridian, MS)"
    },
    {
      "npi": "1376040121",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Clinic/Center, Multi-Specialty",
      "taxonomyCode": "261QM1300X",
      "practiceAddress": "2124 14TH ST",
      "city": "Meridian",
      "state": "MS",
      "postalCode": "39301",
      "phone": "601-703-3480",
      "affiliation": "Regional Academic Oncology Network (Meridian, MS)"
    },
    {
      "npi": "1134582240",
      "name": "Dr. Khush Aujla, MD",
      "rawName": "Khush Aujla",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3601 THE VANDERBILT CLINIC",
      "city": "Nashville",
      "state": "TN",
      "postalCode": "37232",
      "phone": "615-322-3000",
      "affiliation": "Regional Academic Oncology Network (Nashville, TN)"
    }
  ],
  "missouri": [
    {
      "npi": "1053379776",
      "name": "Dr. Elliot Abbey, MD",
      "rawName": "Elliot Abbey",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "232 S WOODS MILL RD",
      "city": "Chesterfield",
      "state": "MO",
      "postalCode": "63017",
      "phone": "314-205-6737",
      "affiliation": "Regional Academic Oncology Network (Chesterfield, MO)"
    },
    {
      "npi": "1316965320",
      "name": "Dr. Camille Abboud, MD",
      "rawName": "Camille Abboud",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4500 FOREST PARK AVE",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63108",
      "phone": "314-454-8304",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1649684200",
      "name": "Dr. Ramzi Abboud, MD",
      "rawName": "Ramzi Abboud",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 BARNES JEWISH HOSPITAL PLZ",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "314-454-8304",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1548226541",
      "name": "Dr. Rony Abou-jawde, MD",
      "rawName": "Rony Abou-jawde",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "902 NO RIVERSIDE RD",
      "city": "St joseph",
      "state": "MO",
      "postalCode": "64507",
      "phone": "816-271-1301",
      "affiliation": "Regional Academic Oncology Network (St joseph, MO)"
    },
    {
      "npi": "1083875538",
      "name": "Dr. Foluso Ademuyiwa, MD",
      "rawName": "Foluso Ademuyiwa",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4921 PARKVIEW PL",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "800-647-2098",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1164440616",
      "name": "Dr. Douglas Adkins, MD",
      "rawName": "Douglas Adkins",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4500 FOREST PARK AVE",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63108",
      "phone": "314-747-1171",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1831539808",
      "name": "Dr. Amber Afzal, MD",
      "rawName": "Amber Afzal",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4500 FOREST PARK AVE",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63108",
      "phone": "314-362-7216",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1497282115",
      "name": "Dr. Helen Ajufo, MD",
      "rawName": "Helen Ajufo",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4921 PARKVIEW PL",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "314-362-7216",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1679988323",
      "name": "Dr. Neal Akhave, MD",
      "rawName": "Neal Akhave",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1515 HOLCOMBE BLVD",
      "city": "Houston",
      "state": "TX",
      "postalCode": "77030",
      "phone": "713-792-6161",
      "affiliation": "MD Anderson Cancer Center"
    },
    {
      "npi": "1306826250",
      "name": "Dr. Muhammad Ali, MD",
      "rawName": "Muhammad Ali",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3301 BROADWAY",
      "city": "Quincy",
      "state": "IL",
      "postalCode": "62301",
      "phone": "217-277-3500",
      "affiliation": "Columbia University Herbert Irving Comprehensive Cancer Center"
    },
    {
      "npi": "1912999160",
      "name": "Dr. Stephen Allen, MD",
      "rawName": "Stephen Allen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10004 KENNERLY RD",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63128",
      "phone": "314-842-7301",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1932959954",
      "name": "Dr. Amy Abdalla, MD",
      "rawName": "Amy Abdalla",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1 BARNES JEWISH HOSPITAL PLZ",
      "city": "Saint louis",
      "state": "MO",
      "postalCode": "63110",
      "phone": "314-362-5000",
      "affiliation": "Regional Academic Oncology Network (Saint louis, MO)"
    },
    {
      "npi": "1437154630",
      "name": "Dr. Ibrahim Abdalla, MD",
      "rawName": "Ibrahim Abdalla",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3850 S NATIONAL AVE",
      "city": "Springfield",
      "state": "MO",
      "postalCode": "65807",
      "phone": "417-269-8926",
      "affiliation": "Regional Academic Oncology Network (Springfield, MO)"
    },
    {
      "npi": "1073017216",
      "name": "Dr. Mohamed Abdelhakiem, MD",
      "rawName": "Mohamed Abdelhakiem",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "ONE HOSPITAL DR",
      "city": "Columbia",
      "state": "MO",
      "postalCode": "65212",
      "phone": "573-884-7770",
      "affiliation": "Regional Academic Oncology Network (Columbia, MO)"
    },
    {
      "npi": "1548264971",
      "name": "Dr. Michael Albritton, MD",
      "rawName": "Michael Albritton",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3800 S NATIONAL AVE STE 100",
      "city": "Springfield",
      "state": "MO",
      "postalCode": "65807",
      "phone": "417-875-3000",
      "affiliation": "Regional Academic Oncology Network (Springfield, MO)"
    },
    {
      "npi": "1659369858",
      "name": "Dr. James Allen, MD",
      "rawName": "James Allen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1432 SOUTHWEST BLVD",
      "city": "Jefferson city",
      "state": "MO",
      "postalCode": "65109",
      "phone": "573-632-4800",
      "affiliation": "Regional Academic Oncology Network (Jefferson city, MO)"
    },
    {
      "npi": "1699961300",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1175 E KARSCH BLVD",
      "city": "Farmington",
      "state": "MO",
      "postalCode": "63640",
      "phone": "573-756-6797",
      "affiliation": "Regional Academic Oncology Network (Farmington, MO)"
    },
    {
      "npi": "1144416389",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3411 MC INTOSH CIR",
      "city": "Joplin",
      "state": "MO",
      "postalCode": "64804",
      "phone": "417-782-3154",
      "affiliation": "Regional Academic Oncology Network (Joplin, MO)"
    }
  ],
  "montana": [
    {
      "npi": "1578773511",
      "name": "Dr. Cristi Aitelli, DO",
      "rawName": "Cristi Aitelli",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6500 HARRIS PKWY",
      "city": "Fort worth",
      "state": "TX",
      "postalCode": "76132",
      "phone": "817-346-6748",
      "affiliation": "Regional Academic Oncology Network (Fort worth, TX)"
    },
    {
      "npi": "1003020413",
      "name": "Dr. Nicole Batty, MD",
      "rawName": "Nicole Batty",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "27 INDUSTRIAL AVE STE 101",
      "city": "Sanford",
      "state": "ME",
      "postalCode": "04073",
      "phone": "207-459-1666",
      "affiliation": "Regional Academic Oncology Network (Sanford, ME)"
    },
    {
      "npi": "1851404172",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1117 29TH ST S",
      "city": "Great falls",
      "state": "MT",
      "postalCode": "59405",
      "phone": "406-731-8210",
      "affiliation": "Regional Academic Oncology Network (Great falls, MT)"
    },
    {
      "npi": "1578586418",
      "name": "Dr. James Burke, MD",
      "rawName": "James Burke",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2825 8TH AVE N",
      "city": "Billings",
      "state": "MT",
      "postalCode": "59101",
      "phone": "406-238-2500",
      "affiliation": "Regional Academic Oncology Network (Billings, MT)"
    },
    {
      "npi": "1235134339",
      "name": "Dr. Erik Carson, MD",
      "rawName": "Erik Carson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "775 S MAIN ST",
      "city": "Chelsea",
      "state": "MI",
      "postalCode": "48118",
      "phone": "734-712-1000",
      "affiliation": "Regional Academic Oncology Network (Chelsea, MI)"
    },
    {
      "npi": "1770565871",
      "name": "Dr. David Christianson, MD",
      "rawName": "David Christianson",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1315 GOLDEN VALLEY CIR",
      "city": "Billings",
      "state": "MT",
      "postalCode": "59102",
      "phone": "406-238-6290",
      "affiliation": "Regional Academic Oncology Network (Billings, MT)"
    },
    {
      "npi": "1730568403",
      "name": "Dr. Aaron Franke, MD",
      "rawName": "Aaron Franke",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "216 14TH AVE SW",
      "city": "Sidney",
      "state": "MT",
      "postalCode": "59270",
      "phone": "406-488-2504",
      "affiliation": "Regional Academic Oncology Network (Sidney, MT)"
    },
    {
      "npi": "1427034834",
      "name": "Dr. Michael Goodman, MD",
      "rawName": "Michael Goodman",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "107 6TH AVE SW",
      "city": "Ronan",
      "state": "MT",
      "postalCode": "59864",
      "phone": "406-676-4441",
      "affiliation": "Regional Academic Oncology Network (Ronan, MT)"
    },
    {
      "npi": "1235369307",
      "name": "Dr. Hesham Hazin, MD",
      "rawName": "Hesham Hazin",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1 PROFESSIONAL PARK DR STE 21",
      "city": "Johnson city",
      "state": "TN",
      "postalCode": "37604",
      "phone": "423-232-6900",
      "affiliation": "Regional Academic Oncology Network (Johnson city, TN)"
    },
    {
      "npi": "1750324349",
      "name": "Dr. Robert Joseph, MD",
      "rawName": "Robert Joseph",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "216 14TH AVE SW",
      "city": "Sidney",
      "state": "MT",
      "postalCode": "59270",
      "phone": "406-488-2100",
      "affiliation": "Regional Academic Oncology Network (Sidney, MT)"
    },
    {
      "npi": "1659629822",
      "name": "Dr. Le min Lee, MD",
      "rawName": "Le min Lee",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "801 N 29TH ST",
      "city": "Billings",
      "state": "MT",
      "postalCode": "59101",
      "phone": "406-238-2500",
      "affiliation": "Regional Academic Oncology Network (Billings, MT)"
    },
    {
      "npi": "1154647758",
      "name": "Dr. Shin yin Lee, MD",
      "rawName": "Shin yin Lee",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "525 BOB PETERS GRV STE 202",
      "city": "Colorado springs",
      "state": "CO",
      "postalCode": "80909",
      "phone": "719-365-6568",
      "affiliation": "Regional Academic Oncology Network (Colorado springs, CO)"
    },
    {
      "npi": "1609223932",
      "name": "Dr. Christopher Baker, MD",
      "rawName": "Christopher Baker",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "931 HIGHLAND BLVD STE 3130",
      "city": "Bozeman",
      "state": "MT",
      "postalCode": "59715",
      "phone": "406-414-5070",
      "affiliation": "Regional Academic Oncology Network (Bozeman, MT)"
    },
    {
      "npi": "1023061488",
      "name": "Dr. Richard Belgrad, MD",
      "rawName": "Richard Belgrad",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9200 TROOPER TRL",
      "city": "Bozeman",
      "state": "MT",
      "postalCode": "59715",
      "phone": "406-522-1520",
      "affiliation": "Regional Academic Oncology Network (Bozeman, MT)"
    },
    {
      "npi": "1477584175",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1117 29TH ST S",
      "city": "Great falls",
      "state": "MT",
      "postalCode": "59405",
      "phone": "406-731-8240",
      "affiliation": "Regional Academic Oncology Network (Great falls, MT)"
    },
    {
      "npi": "1013164987",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "40 13TH ST W",
      "city": "Havre",
      "state": "MT",
      "postalCode": "59501",
      "phone": "406-265-7831",
      "affiliation": "Regional Academic Oncology Network (Havre, MT)"
    },
    {
      "npi": "1013152727",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1117 29TH ST S",
      "city": "Great falls",
      "state": "MT",
      "postalCode": "59405",
      "phone": "406-731-8150",
      "affiliation": "Regional Academic Oncology Network (Great falls, MT)"
    },
    {
      "npi": "1023125630",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1117 29TH ST S",
      "city": "Great falls",
      "state": "MT",
      "postalCode": "59405",
      "phone": "406-731-8240",
      "affiliation": "Regional Academic Oncology Network (Great falls, MT)"
    },
    {
      "npi": "1346489598",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Family Medicine",
      "taxonomyCode": "207Q00000X",
      "practiceAddress": "500 15TH AVENUE SOUTH",
      "city": "Great falls",
      "state": "MT",
      "postalCode": "59405",
      "phone": "406-455-2900",
      "affiliation": "Regional Academic Oncology Network (Great falls, MT)"
    },
    {
      "npi": "1427262880",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2800 10TH AVE N",
      "city": "Billings",
      "state": "MT",
      "postalCode": "59101",
      "phone": "406-657-4000",
      "affiliation": "Regional Academic Oncology Network (Billings, MT)"
    }
  ],
  "nebraska": [
    {
      "npi": "1336150713",
      "name": "Dr. Zaid Al-kadhimi, MD",
      "rawName": "Zaid Al-kadhimi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "EMILE @ 42ND ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-559-5600",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1093934598",
      "name": "Dr. Eric Avery, MD",
      "rawName": "Eric Avery",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4004 PIONEER WOODS DR",
      "city": "Lincoln",
      "state": "NE",
      "postalCode": "68506",
      "phone": "402-484-4900",
      "affiliation": "Regional Academic Oncology Network (Lincoln, NE)"
    },
    {
      "npi": "1740507706",
      "name": "Dr. Muhamed Baljevic, MD",
      "rawName": "Muhamed Baljevic",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "4301 W MARKHAM ST # 506",
      "city": "Little rock",
      "state": "AR",
      "postalCode": "72205",
      "phone": "501-686-8000",
      "affiliation": "Regional Academic Oncology Network (Little rock, AR)"
    },
    {
      "npi": "1205073186",
      "name": "Dr. Lyudmyla Berim, MD",
      "rawName": "Lyudmyla Berim",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "EMILE @ 42ND ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-559-5600",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1184604993",
      "name": "Dr. Laxmi narayana Buddharaju, MD",
      "rawName": "Laxmi narayana Buddharaju",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1111 6TH AVE",
      "city": "Des moines",
      "state": "IA",
      "postalCode": "50314",
      "phone": "515-643-8735",
      "affiliation": "Regional Academic Oncology Network (Des moines, IA)"
    },
    {
      "npi": "1649151531",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "909 22ND AVE",
      "city": "Kearney",
      "state": "NE",
      "postalCode": "68845",
      "phone": "402-420-7000",
      "affiliation": "Regional Academic Oncology Network (Kearney, NE)"
    },
    {
      "npi": "1831167402",
      "name": "Dr. David Garfield, MD",
      "rawName": "David Garfield",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2601 N SPRUCE ST",
      "city": "Ogallala",
      "state": "NE",
      "postalCode": "69153",
      "phone": "308-284-3645",
      "affiliation": "Regional Academic Oncology Network (Ogallala, NE)"
    },
    {
      "npi": "1811968225",
      "name": "Dr. Benjamin George, MD",
      "rawName": "Benjamin George",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "100 E COLLEGE DR",
      "city": "Colby",
      "state": "KS",
      "postalCode": "67701",
      "phone": "785-460-1713",
      "affiliation": "Regional Academic Oncology Network (Colby, KS)"
    },
    {
      "npi": "1780105064",
      "name": "Dr. Michael Haddadin, MD",
      "rawName": "Michael Haddadin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "505 S 45TH ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-559-8013",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1235349275",
      "name": "Dr. Sarah Holstein, MD",
      "rawName": "Sarah Holstein",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "EMILE 42ND ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-559-5600",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1396056149",
      "name": "Dr. Kelsey Klute, MD",
      "rawName": "Kelsey Klute",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "EMILE 42ND ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-559-5600",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1932335007",
      "name": "Dr. Jairam Krishnamurthy, MD",
      "rawName": "Jairam Krishnamurthy",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "EMILE 42ND ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-559-5600",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1508973082",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "555 S 70TH ST",
      "city": "Lincoln",
      "state": "NE",
      "postalCode": "68510",
      "phone": "402-483-5799",
      "affiliation": "Regional Academic Oncology Network (Lincoln, NE)"
    },
    {
      "npi": "1912192907",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Cardiovascular Disease",
      "taxonomyCode": "207RC0000X",
      "practiceAddress": "6901 N 72ND ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68122",
      "phone": "402-343-4328",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1093342859",
      "name": "Dr. August Anderson, MD",
      "rawName": "August Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "230 NEBRASKA ST",
      "city": "Sioux city",
      "state": "IA",
      "postalCode": "51101",
      "phone": "209-727-2072",
      "affiliation": "Regional Academic Oncology Network (Sioux city, IA)"
    },
    {
      "npi": "1043622764",
      "name": "Dr. Michael Baine, MD",
      "rawName": "Michael Baine",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "505 S. 45TH ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-559-5600",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1437171089",
      "name": "Dr. Bennett Barrios, MD",
      "rawName": "Bennett Barrios",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "201 S 68TH STREET PL",
      "city": "Lincoln",
      "state": "NE",
      "postalCode": "68510",
      "phone": "402-327-7300",
      "affiliation": "Regional Academic Oncology Network (Lincoln, NE)"
    },
    {
      "npi": "1336402874",
      "name": "Dr. Nathan Bennion, MD",
      "rawName": "Nathan Bennion",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "515 S 48TH ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-559-5600",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1750942272",
      "name": "Dr. Breann Bowar, MD",
      "rawName": "Breann Bowar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "505 S 45TH ST",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-559-5600",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    },
    {
      "npi": "1548831282",
      "name": "Dr. Abigail Bowser, MD",
      "rawName": "Abigail Bowser",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "986861 NEBRASKA MEDICAL CENTER",
      "city": "Omaha",
      "state": "NE",
      "postalCode": "68198",
      "phone": "402-552-3844",
      "affiliation": "Regional Academic Oncology Network (Omaha, NE)"
    }
  ],
  "nevada": [
    {
      "npi": "1598770471",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3730 S EASTERN AVE",
      "city": "Las vegas",
      "state": "NV",
      "postalCode": "89169",
      "phone": "702-952-3400",
      "affiliation": "Regional Academic Oncology Network (Las vegas, NV)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1780247106",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2340 E CALVADA BLVD STE 7",
      "city": "Pahrump",
      "state": "NV",
      "postalCode": "89048",
      "phone": "702-508-9128",
      "affiliation": "Regional Academic Oncology Network (Pahrump, NV)"
    },
    {
      "npi": "1356225452",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3035 W HORIZON RIDGE PKWY STE 100",
      "city": "Henderson",
      "state": "NV",
      "postalCode": "89052",
      "phone": "702-508-9128",
      "affiliation": "Regional Academic Oncology Network (Henderson, NV)"
    },
    {
      "npi": "1154984573",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "6827 W TROPICANA AVE",
      "city": "Las vegas",
      "state": "NV",
      "postalCode": "89103",
      "phone": "702-508-9128",
      "affiliation": "Regional Academic Oncology Network (Las vegas, NV)"
    },
    {
      "npi": "1619914959",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "6109 W RAMSEY ST",
      "city": "Banning",
      "state": "CA",
      "postalCode": "92220",
      "phone": "951-845-0313",
      "affiliation": "Regional Academic Oncology Network (Banning, CA)"
    },
    {
      "npi": "1366730491",
      "name": "Dr. Ragneel reddy Bijjula, MD",
      "rawName": "Ragneel reddy Bijjula",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1535 MEDICAL PKWY",
      "city": "Carson city",
      "state": "NV",
      "postalCode": "89703",
      "phone": "775-445-7960",
      "affiliation": "Regional Academic Oncology Network (Carson city, NV)"
    },
    {
      "npi": "1538268438",
      "name": "Dr. Fadi Braiteh, MD",
      "rawName": "Fadi Braiteh",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3730 S EASTERN AVE",
      "city": "Las vegas",
      "state": "NV",
      "postalCode": "89169",
      "phone": "702-952-3400",
      "affiliation": "Regional Academic Oncology Network (Las vegas, NV)"
    },
    {
      "npi": "1962368746",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3910 PECOS MCLEOD INTERCONNECT",
      "city": "Las vegas",
      "state": "NV",
      "postalCode": "89121",
      "phone": "725-735-5278",
      "affiliation": "Regional Academic Oncology Network (Las vegas, NV)"
    },
    {
      "npi": "1821084815",
      "name": "Dr. John Caton, MD",
      "rawName": "John Caton",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "75 PRINGLE WAY",
      "city": "Reno",
      "state": "NV",
      "postalCode": "89502",
      "phone": "775-982-2820",
      "affiliation": "Regional Academic Oncology Network (Reno, NV)"
    },
    {
      "npi": "1578557682",
      "name": "Dr. James Cohen, MD",
      "rawName": "James Cohen",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "75 PRINGLE WAY",
      "city": "Reno",
      "state": "NV",
      "postalCode": "89502",
      "phone": "775-982-2820",
      "affiliation": "Regional Academic Oncology Network (Reno, NV)"
    },
    {
      "npi": "1306317730",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "75 PRINGLE WAY STE 801",
      "city": "Reno",
      "state": "NV",
      "postalCode": "89502",
      "phone": "775-982-4000",
      "affiliation": "Regional Academic Oncology Network (Reno, NV)"
    },
    {
      "npi": "1124278650",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "52 N PECOS RD",
      "city": "Henderson",
      "state": "NV",
      "postalCode": "89074",
      "phone": "702-990-4767",
      "affiliation": "Regional Academic Oncology Network (Henderson, NV)"
    },
    {
      "npi": "1962405456",
      "name": "Dr. Phyllis Ager, MD",
      "rawName": "Phyllis Ager",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1155 MILL ST",
      "city": "Reno",
      "state": "NV",
      "postalCode": "89502",
      "phone": "775-982-4000",
      "affiliation": "Regional Academic Oncology Network (Reno, NV)"
    },
    {
      "npi": "1316916182",
      "name": "Dr. Michael Anderson, MD",
      "rawName": "Michael Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "10001 S EASTERN AVE STE 108",
      "city": "Henderson",
      "state": "NV",
      "postalCode": "89052",
      "phone": "702-952-3444",
      "affiliation": "Regional Academic Oncology Network (Henderson, NV)"
    },
    {
      "npi": "1336830769",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9139 W RUSSELL RD",
      "city": "Las vegas",
      "state": "NV",
      "postalCode": "89148",
      "phone": "702-604-5274",
      "affiliation": "Regional Academic Oncology Network (Las vegas, NV)"
    },
    {
      "npi": "1669671855",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "624 S TONOPAH DR",
      "city": "Las vegas",
      "state": "NV",
      "postalCode": "89106",
      "phone": "702-735-0006",
      "affiliation": "Regional Academic Oncology Network (Las vegas, NV)"
    },
    {
      "npi": "1720540347",
      "name": "Dr. Osman Atiq, MD",
      "rawName": "Osman Atiq",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8350 W BADURA AVE FL 1 STE A",
      "city": "Las vegas",
      "state": "NV",
      "postalCode": "89113",
      "phone": "702-968-7213",
      "affiliation": "Regional Academic Oncology Network (Las vegas, NV)"
    }
  ],
  "new-hampshire": [
    {
      "npi": "1922396753",
      "name": "Dr. Cherif Abdelmalek, MD",
      "rawName": "Cherif Abdelmalek",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10 PROSPECT ST",
      "city": "Nashua",
      "state": "NH",
      "postalCode": "03060",
      "phone": "603-886-7900",
      "affiliation": "Regional Academic Oncology Network (Nashua, NH)"
    },
    {
      "npi": "1336314533",
      "name": "Dr. Christine Alewine, MD",
      "rawName": "Christine Alewine",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Lebanon",
      "state": "NH",
      "postalCode": "03756",
      "phone": "603-650-5000",
      "affiliation": "Regional Academic Oncology Network (Lebanon, NH)"
    },
    {
      "npi": "1265453484",
      "name": "Dr. Bradley Arrick, MD",
      "rawName": "Bradley Arrick",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Lebanon",
      "state": "NH",
      "postalCode": "03756",
      "phone": "603-653-6181",
      "affiliation": "Regional Academic Oncology Network (Lebanon, NH)"
    },
    {
      "npi": "1114313962",
      "name": "Dr. Dinesh Atwal, MD",
      "rawName": "Dinesh Atwal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "55 FRUIT ST",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02114",
      "phone": "617-726-2000",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1730145087",
      "name": "Dr. Suzanne Berlin, DO",
      "rawName": "Suzanne Berlin",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "LAHEY HEMATOLOGY AND ONCOLOGY AT PARKLAND, DERRY",
      "city": "Derry",
      "state": "NH",
      "postalCode": "03038",
      "phone": "603-537-2060",
      "affiliation": "Regional Academic Oncology Network (Derry, NH)"
    },
    {
      "npi": "1366598955",
      "name": "Dr. Gabriel Brooks, MD",
      "rawName": "Gabriel Brooks",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Lebanon",
      "state": "NH",
      "postalCode": "03756",
      "phone": "603-650-7854",
      "affiliation": "Regional Academic Oncology Network (Lebanon, NH)"
    },
    {
      "npi": "1841302593",
      "name": "Dr. Mary Chamberlin, MD",
      "rawName": "Mary Chamberlin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Lebanon",
      "state": "NH",
      "postalCode": "03756",
      "phone": "603-653-6181",
      "affiliation": "Regional Academic Oncology Network (Lebanon, NH)"
    },
    {
      "npi": "1659635159",
      "name": "Dr. Rubens Chang, MD",
      "rawName": "Rubens Chang",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "525 BOB PETERS GRV STE 202",
      "city": "Colorado springs",
      "state": "CO",
      "postalCode": "80909",
      "phone": "719-365-6568",
      "affiliation": "Regional Academic Oncology Network (Colorado springs, CO)"
    },
    {
      "npi": "1275575219",
      "name": "Dr. Barbara Civiello, MD",
      "rawName": "Barbara Civiello",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "789 CENTRAL AVENUE",
      "city": "Dover",
      "state": "NH",
      "postalCode": "03820",
      "phone": "603-742-8787",
      "affiliation": "Regional Academic Oncology Network (Dover, NH)"
    },
    {
      "npi": "1184799256",
      "name": "Dr. Tyler Curiel, MD",
      "rawName": "Tyler Curiel",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Lebanon",
      "state": "NH",
      "postalCode": "03756",
      "phone": "603-650-5747",
      "affiliation": "Regional Academic Oncology Network (Lebanon, NH)"
    },
    {
      "npi": "1477555761",
      "name": "Dr. Alfonso Cutugno, MD",
      "rawName": "Alfonso Cutugno",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6511 SPRING BROOK AVE STE 101",
      "city": "Rhinebeck",
      "state": "NY",
      "postalCode": "12572",
      "phone": "845-871-3545",
      "affiliation": "Regional Academic Oncology Network (Rhinebeck, NY)"
    },
    {
      "npi": "1568023976",
      "name": "Dr. Devashish Desai, MD",
      "rawName": "Devashish Desai",
      "credential": "MD",
      "specialty": "Internal Medicine, Hospice and Palliative Medicine",
      "taxonomyCode": "207RH0002X",
      "practiceAddress": "250 PLEASANT ST",
      "city": "Concord",
      "state": "NH",
      "postalCode": "03301",
      "phone": "603-622-6484",
      "affiliation": "Regional Academic Oncology Network (Concord, NH)"
    },
    {
      "npi": "1710093166",
      "name": "Dr. Edward Abraham, MD",
      "rawName": "Edward Abraham",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1455 HIGDON FERRY RD STE C",
      "city": "Hot springs",
      "state": "AR",
      "postalCode": "71913",
      "phone": "501-622-2100",
      "affiliation": "Regional Academic Oncology Network (Hot springs, AR)"
    },
    {
      "npi": "1336163047",
      "name": "Dr. James Becht, MD",
      "rawName": "James Becht",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1 ELLIOT WAY",
      "city": "Manchester",
      "state": "NH",
      "postalCode": "03103",
      "phone": "603-663-1800",
      "affiliation": "Regional Academic Oncology Network (Manchester, NH)"
    },
    {
      "npi": "1235357294",
      "name": "Dr. Ian Bristol, MD",
      "rawName": "Ian Bristol",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "22 BRAMHALL ST",
      "city": "Portland",
      "state": "ME",
      "postalCode": "04102",
      "phone": "207-662-2276",
      "affiliation": "Regional Academic Oncology Network (Portland, ME)"
    },
    {
      "npi": "1588912307",
      "name": "Dr. Jeffrey Brower, MD",
      "rawName": "Jeffrey Brower",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "789 CENTRAL AVE",
      "city": "Dover",
      "state": "NH",
      "postalCode": "03820",
      "phone": "603-742-8787",
      "affiliation": "Regional Academic Oncology Network (Dover, NH)"
    },
    {
      "npi": "1518594845",
      "name": "Dr. David Buchberger, MD",
      "rawName": "David Buchberger",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1 ELLIOT WAY",
      "city": "Manchester",
      "state": "NH",
      "postalCode": "03103",
      "phone": "603-663-1800",
      "affiliation": "Regional Academic Oncology Network (Manchester, NH)"
    },
    {
      "npi": "1023513728",
      "name": "Dr. James Cordova, MD",
      "rawName": "James Cordova",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Lebanon",
      "state": "NH",
      "postalCode": "03756",
      "phone": "603-650-5000",
      "affiliation": "Regional Academic Oncology Network (Lebanon, NH)"
    },
    {
      "npi": "1023099249",
      "name": "Dr. Thomas Delaney, MD",
      "rawName": "Thomas Delaney",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Lebanon",
      "state": "NH",
      "postalCode": "03756",
      "phone": "603-650-6600",
      "affiliation": "Regional Academic Oncology Network (Lebanon, NH)"
    },
    {
      "npi": "1982713913",
      "name": "Dr. Anna Fariss, MD",
      "rawName": "Anna Fariss",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Lebanon",
      "state": "NH",
      "postalCode": "03756",
      "phone": "603-650-6602",
      "affiliation": "Regional Academic Oncology Network (Lebanon, NH)"
    }
  ],
  "new-jersey": [
    {
      "npi": "1245349638",
      "name": "Dr. Muhammad Abbasi, MD",
      "rawName": "Muhammad Abbasi",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "333 ROUTE 46 W",
      "city": "Mountain lakes",
      "state": "NJ",
      "postalCode": "07046",
      "phone": "973-316-1701",
      "affiliation": "Regional Academic Oncology Network (Mountain lakes, NJ)"
    },
    {
      "npi": "1073803896",
      "name": "Dr. Peter Abdelmessieh, DO",
      "rawName": "Peter Abdelmessieh",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "16 EMERALD ROAD",
      "city": "Robbinsville",
      "state": "NJ",
      "postalCode": "08691",
      "phone": "212-434-2000",
      "affiliation": "Regional Academic Oncology Network (Robbinsville, NJ)"
    },
    {
      "npi": "1720540495",
      "name": "Dr. Prashasti Agrawal, MD",
      "rawName": "Prashasti Agrawal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "480 RED HILL RD",
      "city": "Middletown",
      "state": "NJ",
      "postalCode": "07748",
      "phone": "833-921-2959",
      "affiliation": "Regional Academic Oncology Network (Middletown, NJ)"
    },
    {
      "npi": "1811348931",
      "name": "Dr. Mohamed Ahmed, MD",
      "rawName": "Mohamed Ahmed",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1600 E HIGH ST",
      "city": "Pottstown",
      "state": "PA",
      "postalCode": "19464",
      "phone": "610-327-7000",
      "affiliation": "Regional Academic Oncology Network (Pottstown, PA)"
    },
    {
      "npi": "1649328410",
      "name": "Dr. Joseph Aisner, MD",
      "rawName": "Joseph Aisner",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "195 LITTLE ALBANY ST",
      "city": "New brunswick",
      "state": "NJ",
      "postalCode": "08901",
      "phone": "732-235-2465",
      "affiliation": "Regional Academic Oncology Network (New brunswick, NJ)"
    },
    {
      "npi": "1659766889",
      "name": "Dr. Heidar Albandar, MD",
      "rawName": "Heidar Albandar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "701 OSTRUM ST STE 501",
      "city": "Fountain hill",
      "state": "PA",
      "postalCode": "18015",
      "phone": "484-503-7000",
      "affiliation": "Regional Academic Oncology Network (Fountain hill, PA)"
    },
    {
      "npi": "1306805460",
      "name": "Dr. Robert Alter, MD",
      "rawName": "Robert Alter",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "92 2ND ST",
      "city": "Hackensack",
      "state": "NJ",
      "postalCode": "07601",
      "phone": "551-996-5072",
      "affiliation": "Regional Academic Oncology Network (Hackensack, NJ)"
    },
    {
      "npi": "1467959338",
      "name": "Dr. Sunny Arora, MD",
      "rawName": "Sunny Arora",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "100 HWY 36",
      "city": "West long branch",
      "state": "NJ",
      "postalCode": "07764",
      "phone": "732-222-1711",
      "affiliation": "Regional Academic Oncology Network (West long branch, NJ)"
    },
    {
      "npi": "1740761915",
      "name": "Dr. Hafiz Aslam, MD",
      "rawName": "Hafiz Aslam",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1215 LAWN AVE STE 120",
      "city": "Elkhart",
      "state": "IN",
      "postalCode": "46514",
      "phone": "574-523-2733",
      "affiliation": "Regional Academic Oncology Network (Elkhart, IN)"
    },
    {
      "npi": "1093829608",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Clinic/Center",
      "taxonomyCode": "261Q00000X",
      "practiceAddress": "2500 ENGLISH CREEK AVE STE 602",
      "city": "Egg harbor township",
      "state": "NJ",
      "postalCode": "08234",
      "phone": "800-658-1010",
      "affiliation": "Regional Academic Oncology Network (Egg harbor township, NJ)"
    },
    {
      "npi": "1043137755",
      "name": "Dr. Brooke Barber, MD",
      "rawName": "Brooke Barber",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "52 CENTENNIAL DR",
      "city": "Hammonton",
      "state": "NJ",
      "postalCode": "08037",
      "phone": "401-203-3779",
      "affiliation": "Regional Academic Oncology Network (Hammonton, NJ)"
    },
    {
      "npi": "1407965775",
      "name": "Dr. Fazal Bari, MD",
      "rawName": "Fazal Bari",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "333 ROUTE 46 W",
      "city": "Mountain lakes",
      "state": "NJ",
      "postalCode": "07046",
      "phone": "973-316-1701",
      "affiliation": "Regional Academic Oncology Network (Mountain lakes, NJ)"
    },
    {
      "npi": "1578543930",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "130 CARNIE BLVD",
      "city": "Voorhees",
      "state": "NJ",
      "postalCode": "08043",
      "phone": "856-424-0003",
      "affiliation": "Regional Academic Oncology Network (Voorhees, NJ)"
    },
    {
      "npi": "1679502488",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "900 ROUTE 70 EAST",
      "city": "Lakewood",
      "state": "NJ",
      "postalCode": "08701",
      "phone": "732-901-7314",
      "affiliation": "Regional Academic Oncology Network (Lakewood, NJ)"
    },
    {
      "npi": "1871893529",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Dermatology",
      "taxonomyCode": "207N00000X",
      "practiceAddress": "2805 FRINGE LANE",
      "city": "Easton",
      "state": "PA",
      "postalCode": "18040",
      "phone": "732-731-6118",
      "affiliation": "Regional Academic Oncology Network (Easton, PA)"
    },
    {
      "npi": "1265430433",
      "name": "Dr. Arvin Adler, DO",
      "rawName": "Arvin Adler",
      "credential": "DO",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "350 BOULEVARD",
      "city": "Passaic",
      "state": "NJ",
      "postalCode": "07055",
      "phone": "973-365-5088",
      "affiliation": "Regional Academic Oncology Network (Passaic, NJ)"
    },
    {
      "npi": "1457304230",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "29 E 29TH ST",
      "city": "Bayonne",
      "state": "NJ",
      "postalCode": "07002",
      "phone": "201-858-5336",
      "affiliation": "Regional Academic Oncology Network (Bayonne, NJ)"
    },
    {
      "npi": "1376597856",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "111 N HIGHLAND AVE",
      "city": "Nyack",
      "state": "NY",
      "postalCode": "10960",
      "phone": "845-727-0828",
      "affiliation": "Regional Academic Oncology Network (Nyack, NY)"
    },
    {
      "npi": "1710111711",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "900 ROUTE 70",
      "city": "Lakewood",
      "state": "NJ",
      "postalCode": "08701",
      "phone": "732-928-5300",
      "affiliation": "Regional Academic Oncology Network (Lakewood, NJ)"
    },
    {
      "npi": "1316262363",
      "name": "Dr. Manuj Agarwal, MD",
      "rawName": "Manuj Agarwal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "333 COTTMAN AVENUE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-2581",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    }
  ],
  "new-mexico": [
    {
      "npi": "1013940675",
      "name": "Dr. Bernard Agbemadzo, MD",
      "rawName": "Bernard Agbemadzo",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "PMG HEMATOLOGY/ONCOLOGY",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87110",
      "phone": "505-559-6100",
      "affiliation": "Regional Academic Oncology Network (Albuquerque, NM)"
    },
    {
      "npi": "1821088063",
      "name": "Dr. Amyn Alidina, MD",
      "rawName": "Amyn Alidina",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4901 LANG AVE NE",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87109",
      "phone": "505-822-3948",
      "affiliation": "Regional Academic Oncology Network (Albuquerque, NM)"
    },
    {
      "npi": "1477882876",
      "name": "Dr. Peter Bernat, MD",
      "rawName": "Peter Bernat",
      "credential": "MD",
      "specialty": "Medical Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2559 MEDICAL DR",
      "city": "Alamogordo",
      "state": "NM",
      "postalCode": "88310",
      "phone": "575-437-8216",
      "affiliation": "Regional Academic Oncology Network (Alamogordo, NM)"
    },
    {
      "npi": "1992762439",
      "name": "Dr. William Blevins, MD",
      "rawName": "William Blevins",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "101 OCEAN BLVD",
      "city": "Taos ski valley",
      "state": "NM",
      "postalCode": "87525",
      "phone": "575-776-8421",
      "affiliation": "Regional Academic Oncology Network (Taos ski valley, NM)"
    },
    {
      "npi": "1477765550",
      "name": "Dr. Benjamin Downie, MD",
      "rawName": "Benjamin Downie",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2219 DILLON RD",
      "city": "Clovis",
      "state": "NM",
      "postalCode": "88101",
      "phone": "575-769-7365",
      "affiliation": "Regional Academic Oncology Network (Clovis, NM)"
    },
    {
      "npi": "1831724517",
      "name": "Dr. Joseph Ekofo, MD",
      "rawName": "Joseph Ekofo",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2211 LOMAS BLVD NE",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87106",
      "phone": "505-272-6646",
      "affiliation": "Regional Academic Oncology Network (Albuquerque, NM)"
    },
    {
      "npi": "1750444915",
      "name": "Dr. Esme Finlay, MD",
      "rawName": "Esme Finlay",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1201 CAMINO DE SALUD NE",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87102",
      "phone": "505-272-3120",
      "affiliation": "Regional Academic Oncology Network (Albuquerque, NM)"
    },
    {
      "npi": "1346234788",
      "name": "Dr. Annette Fontaine, MD",
      "rawName": "Annette Fontaine",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4901 LANG AVE NE",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87109",
      "phone": "505-842-8171",
      "affiliation": "Regional Academic Oncology Network (Albuquerque, NM)"
    },
    {
      "npi": "1679515589",
      "name": "Dr. Maynard Fuller, MD",
      "rawName": "Maynard Fuller",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "150 S ROADRUNNER PKWY",
      "city": "Las cruces",
      "state": "NM",
      "postalCode": "88011",
      "phone": "505-556-8600",
      "affiliation": "Regional Academic Oncology Network (Las cruces, NM)"
    },
    {
      "npi": "1619053709",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1313 E 32ND ST",
      "city": "Silver city",
      "state": "NM",
      "postalCode": "88061",
      "phone": "505-538-4000",
      "affiliation": "Regional Academic Oncology Network (Silver city, NM)"
    },
    {
      "npi": "1417950536",
      "name": "Dr. Richard Giudice, MD",
      "rawName": "Richard Giudice",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4901 LANG AVE NE",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87109",
      "phone": "505-842-8171",
      "affiliation": "Regional Academic Oncology Network (Albuquerque, NM)"
    },
    {
      "npi": "1033302625",
      "name": "Dr. Fei Gu, MD",
      "rawName": "Fei Gu",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "4200 BECKNER ROAD",
      "city": "Santa fe",
      "state": "NM",
      "postalCode": "87507",
      "phone": "505-477-2200",
      "affiliation": "Regional Academic Oncology Network (Santa fe, NM)"
    },
    {
      "npi": "1952306219",
      "name": "Dr. Paul Anthony, MD",
      "rawName": "Paul Anthony",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4650 JEFFERSON LN NE",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87109",
      "phone": "505-889-9639",
      "affiliation": "Regional Academic Oncology Network (Albuquerque, NM)"
    },
    {
      "npi": "1730611310",
      "name": "Dr. Patrick Beagen, MD",
      "rawName": "Patrick Beagen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4650 JEFFERSON LN NE",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87109",
      "phone": "505-727-7900",
      "affiliation": "Regional Academic Oncology Network (Albuquerque, NM)"
    },
    {
      "npi": "1417161704",
      "name": "Dr. Ajay Bhatnagar, MD",
      "rawName": "Ajay Bhatnagar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "500 UNIVERSITY DR",
      "city": "Hershey",
      "state": "PA",
      "postalCode": "17033",
      "phone": "717-531-8024",
      "affiliation": "Regional Academic Oncology Network (Hershey, PA)"
    },
    {
      "npi": "1285727883",
      "name": "Dr. Mary Bucci, MD",
      "rawName": "Mary Bucci",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8300 CONSTITUTION AVE NE",
      "city": "Albuquerque",
      "state": "NM",
      "postalCode": "87110",
      "phone": "505-291-2506",
      "affiliation": "Regional Academic Oncology Network (Albuquerque, NM)"
    },
    {
      "npi": "1558535971",
      "name": "Dr. Jason Call, MD",
      "rawName": "Jason Call",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2450 S TELSHOR BLVD",
      "city": "Las cruces",
      "state": "NM",
      "postalCode": "88011",
      "phone": "575-556-5800",
      "affiliation": "Regional Academic Oncology Network (Las cruces, NM)"
    },
    {
      "npi": "1306125653",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2450 S TELSHOR BLVD",
      "city": "Las cruces",
      "state": "NM",
      "postalCode": "88011",
      "phone": "575-556-5800",
      "affiliation": "Regional Academic Oncology Network (Las cruces, NM)"
    },
    {
      "npi": "1881884195",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2428 WEST PIERCE STREET",
      "city": "Carlsbad",
      "state": "NM",
      "postalCode": "88220",
      "phone": "575-302-3530",
      "affiliation": "Regional Academic Oncology Network (Carlsbad, NM)"
    }
  ],
  "north-dakota": [
    {
      "npi": "1972779551",
      "name": "Dr. Rami Abumasmah, MD",
      "rawName": "Rami Abumasmah",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "855 N WESTHAVEN DR",
      "city": "Oshkosh",
      "state": "WI",
      "postalCode": "54904",
      "phone": "920-456-7870",
      "affiliation": "Regional Academic Oncology Network (Oshkosh, WI)"
    },
    {
      "npi": "1063036135",
      "name": "Dr. Isaak Ailts, MD",
      "rawName": "Isaak Ailts",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "701-234-6161",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1669563771",
      "name": "Dr. Todor Dentchev, MD",
      "rawName": "Todor Dentchev",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "960 S COLUMBIA RD - ALTRU CANCER CENTER",
      "city": "Grand forks",
      "state": "ND",
      "postalCode": "58201",
      "phone": "701-780-5400",
      "affiliation": "Regional Academic Oncology Network (Grand forks, ND)"
    },
    {
      "npi": "1750776910",
      "name": "Dr. Michael Durando, MD",
      "rawName": "Michael Durando",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2101 ELM ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "623-487-4822",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1265726970",
      "name": "Dr. Brooke Esteves, DO",
      "rawName": "Brooke Esteves",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "500 CAMPUS DR",
      "city": "Hancock",
      "state": "MI",
      "postalCode": "49930",
      "phone": "906-483-1000",
      "affiliation": "Regional Academic Oncology Network (Hancock, MI)"
    },
    {
      "npi": "1225073661",
      "name": "Dr. Mark Gitau, MD",
      "rawName": "Mark Gitau",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "701-234-6161",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1558389106",
      "name": "Dr. Carol Grimm, MD",
      "rawName": "Carol Grimm",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "801 BROADWAY N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "701-234-4811",
      "affiliation": "Columbia University Herbert Irving Comprehensive Cancer Center"
    },
    {
      "npi": "1275055956",
      "name": "Dr. Alexander Johnson, MD",
      "rawName": "Alexander Johnson",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "701 E ROSSER AVE",
      "city": "Bismarck",
      "state": "ND",
      "postalCode": "58501",
      "phone": "701-323-8550",
      "affiliation": "Regional Academic Oncology Network (Bismarck, ND)"
    },
    {
      "npi": "1639169675",
      "name": "Dr. Bassim Kobrossy, MD",
      "rawName": "Bassim Kobrossy",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1702 UNIVERSITY DR S",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58103",
      "phone": "701-364-3300",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1811914583",
      "name": "Dr. John Leitch, MD",
      "rawName": "John Leitch",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58122",
      "phone": "701-234-2000",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1548287212",
      "name": "Dr. Ralph Levitt, MD",
      "rawName": "Ralph Levitt",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "701-234-4811",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1376585281",
      "name": "Dr. Janet Macheledt, MD",
      "rawName": "Janet Macheledt",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1702 UNIVERSITY DR S",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58103",
      "phone": "701-364-3300",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1811915515",
      "name": "Dr. Robert Arusell, MD",
      "rawName": "Robert Arusell",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58122",
      "phone": "701-234-6161",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1114945847",
      "name": "Dr. Dennis Bier, MD",
      "rawName": "Dennis Bier",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58122",
      "phone": "701-234-6161",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1538212162",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "500 N 8TH ST",
      "city": "Bismarck",
      "state": "ND",
      "postalCode": "58501",
      "phone": "701-222-6100",
      "affiliation": "Regional Academic Oncology Network (Bismarck, ND)"
    },
    {
      "npi": "1629369830",
      "name": "Dr. Miran Blanchard, MD",
      "rawName": "Miran Blanchard",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "701-234-6161",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1962427351",
      "name": "Dr. Mark Cooper, MD",
      "rawName": "Mark Cooper",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1702 UNIVERSITY DR S",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58103",
      "phone": "701-364-3300",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1730767518",
      "name": "Dr. Elliott Czarnecki, MD",
      "rawName": "Elliott Czarnecki",
      "credential": "MD",
      "specialty": "Student in an Organized Health Care Education/Training Program",
      "taxonomyCode": "390200000X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "701-234-6161",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1215499116",
      "name": "Dr. Salah Dajani, MD",
      "rawName": "Salah Dajani",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3000 32ND AVE S",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58103",
      "phone": "701-364-8000",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1235271388",
      "name": "Dr. Kyle Darras, MD",
      "rawName": "Kyle Darras",
      "credential": "MD",
      "specialty": "Nurse Practitioner",
      "taxonomyCode": "363L00000X",
      "practiceAddress": "7500 UNIVERSITY DR",
      "city": "Bismarck",
      "state": "ND",
      "postalCode": "58504",
      "phone": "701-355-3770",
      "affiliation": "Regional Academic Oncology Network (Bismarck, ND)"
    }
  ],
  "oklahoma": [
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1063362598",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "301 N 32ND ST",
      "city": "Muskogee",
      "state": "OK",
      "postalCode": "74401",
      "phone": "918-683-2000",
      "affiliation": "Regional Academic Oncology Network (Muskogee, OK)"
    },
    {
      "npi": "1689134041",
      "name": "Dr. Haripriya Andanamala, MD",
      "rawName": "Haripriya Andanamala",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 NE 10TH ST",
      "city": "Oklahoma city",
      "state": "OK",
      "postalCode": "73104",
      "phone": "405-271-4022",
      "affiliation": "Regional Academic Oncology Network (Oklahoma city, OK)"
    },
    {
      "npi": "1568088615",
      "name": "Dr. Aqsa Ashraf, MD",
      "rawName": "Aqsa Ashraf",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "800 NE 10TH ST",
      "city": "Oklahoma city",
      "state": "OK",
      "postalCode": "73104",
      "phone": "572-244-0111",
      "affiliation": "Regional Academic Oncology Network (Oklahoma city, OK)"
    },
    {
      "npi": "1114157195",
      "name": "Dr. Dennis Buck, DO",
      "rawName": "Dennis Buck",
      "credential": "DO",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2500 E HUNT DR STE H-J",
      "city": "Show low",
      "state": "AZ",
      "postalCode": "85901",
      "phone": "928-537-6937",
      "affiliation": "Regional Academic Oncology Network (Show low, AZ)"
    },
    {
      "npi": "1639258379",
      "name": "Dr. Mathew Cherian, MD",
      "rawName": "Mathew Cherian",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 NE 10TH ST STE 3010",
      "city": "Oklahoma city",
      "state": "OK",
      "postalCode": "73104",
      "phone": "405-271-8778",
      "affiliation": "Regional Academic Oncology Network (Oklahoma city, OK)"
    },
    {
      "npi": "1366785586",
      "name": "Dr. Nirmal Choradia, MD",
      "rawName": "Nirmal Choradia",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 NE 10TH ST # 2300",
      "city": "Oklahoma city",
      "state": "OK",
      "postalCode": "73104",
      "phone": "205-613-4023",
      "affiliation": "Regional Academic Oncology Network (Oklahoma city, OK)"
    },
    {
      "npi": "1831272889",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3525 NW 56TH ST",
      "city": "Oklahoma city",
      "state": "OK",
      "postalCode": "73112",
      "phone": "405-942-9200",
      "affiliation": "Regional Academic Oncology Network (Oklahoma city, OK)"
    },
    {
      "npi": "1295701738",
      "name": "Dr. Atulkumar Dave, MD",
      "rawName": "Atulkumar Dave",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2330 PAYSPHERE CIR",
      "city": "Chicago",
      "state": "IL",
      "postalCode": "60674",
      "phone": "847-746-4358",
      "affiliation": "Regional Academic Oncology Network (Chicago, IL)"
    },
    {
      "npi": "1093782245",
      "name": "Dr. John Eckenrode, MD",
      "rawName": "John Eckenrode",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "11212 E 48TH ST",
      "city": "Tulsa",
      "state": "OK",
      "postalCode": "74146",
      "phone": "918-556-3000",
      "affiliation": "Regional Academic Oncology Network (Tulsa, OK)"
    },
    {
      "npi": "1306090220",
      "name": "Dr. Muhammad Furqan, MD",
      "rawName": "Muhammad Furqan",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 NE 10TH ST STE B",
      "city": "Oklahoma city",
      "state": "OK",
      "postalCode": "73104",
      "phone": "405-271-4022",
      "affiliation": "Regional Academic Oncology Network (Oklahoma city, OK)"
    },
    {
      "npi": "1780297648",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "11100 HEFNER POINTE DR",
      "city": "Oklahoma city",
      "state": "OK",
      "postalCode": "73120",
      "phone": "405-839-7340",
      "affiliation": "Regional Academic Oncology Network (Oklahoma city, OK)"
    },
    {
      "npi": "1699124263",
      "name": "Dr. Zeinab Abou yehia, MD",
      "rawName": "Zeinab Abou yehia",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "100 E CARROLL ST",
      "city": "Salisbury",
      "state": "MD",
      "postalCode": "21801",
      "phone": "410-543-7000",
      "affiliation": "Regional Academic Oncology Network (Salisbury, MD)"
    },
    {
      "npi": "1194655910",
      "name": "Dr. Chase Adams, MD",
      "rawName": "Chase Adams",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "800 STANTON L YOUNG BLVD",
      "city": "Oklahoma city",
      "state": "OK",
      "postalCode": "73104",
      "phone": "405-271-5963",
      "affiliation": "Regional Academic Oncology Network (Oklahoma city, OK)"
    },
    {
      "npi": "1205959863",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3500 E FRANK PHILLIPS BLVD",
      "city": "Bartlesville",
      "state": "OK",
      "postalCode": "74006",
      "phone": "918-331-1857",
      "affiliation": "Regional Academic Oncology Network (Bartlesville, OK)"
    },
    {
      "npi": "1720254923",
      "name": "Dr. Shripal Bhavsar, MD",
      "rawName": "Shripal Bhavsar",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "5911 W MEMORIAL RD",
      "city": "Oklahoma city",
      "state": "OK",
      "postalCode": "73142",
      "phone": "405-773-6530",
      "affiliation": "Regional Academic Oncology Network (Oklahoma city, OK)"
    },
    {
      "npi": "1588000228",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1522 N DIVISION ST",
      "city": "Blytheville",
      "state": "AR",
      "postalCode": "72315",
      "phone": "870-762-1400",
      "affiliation": "Regional Academic Oncology Network (Blytheville, AR)"
    },
    {
      "npi": "1811997265",
      "name": "Dr. Christopher Bozarth, MD",
      "rawName": "Christopher Bozarth",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "230 N MIDWEST BLVD",
      "city": "Midwest city",
      "state": "OK",
      "postalCode": "73110",
      "phone": "405-737-8455",
      "affiliation": "Regional Academic Oncology Network (Midwest city, OK)"
    },
    {
      "npi": "1043244148",
      "name": "Dr. Cynthia Bryant, MD",
      "rawName": "Cynthia Bryant",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1501 N FLORENCE AVE STE 191",
      "city": "Claremore",
      "state": "OK",
      "postalCode": "74017",
      "phone": "918-283-4078",
      "affiliation": "Regional Academic Oncology Network (Claremore, OK)"
    }
  ],
  "oregon": [
    {
      "npi": "1780689513",
      "name": "Dr. Anupama Acheson, MD",
      "rawName": "Anupama Acheson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "9135 SW BARNES RD",
      "city": "Portland",
      "state": "OR",
      "postalCode": "97225",
      "phone": "503-216-6300",
      "affiliation": "Regional Academic Oncology Network (Portland, OR)"
    },
    {
      "npi": "1831518687",
      "name": "Dr. Molly Andreason, MD",
      "rawName": "Molly Andreason",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3181 SW SAM JACKSON PARK RD",
      "city": "Portland",
      "state": "OR",
      "postalCode": "97239",
      "phone": "503-494-8211",
      "affiliation": "Regional Academic Oncology Network (Portland, OR)"
    },
    {
      "npi": "1285904615",
      "name": "Dr. Dilip Babu, MD",
      "rawName": "Dilip Babu",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "19260 SW 65TH AVE STE 435",
      "city": "Tualatin",
      "state": "OR",
      "postalCode": "97062",
      "phone": "971-262-9700",
      "affiliation": "Regional Academic Oncology Network (Tualatin, OR)"
    },
    {
      "npi": "1659807931",
      "name": "Dr. Titas Banerjee, MD",
      "rawName": "Titas Banerjee",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "24988 SE STARK ST STE 140",
      "city": "Gresham",
      "state": "OR",
      "postalCode": "97030",
      "phone": "971-262-9500",
      "affiliation": "Regional Academic Oncology Network (Gresham, OR)"
    },
    {
      "npi": "1508033465",
      "name": "Dr. Nicholas Barber, MD",
      "rawName": "Nicholas Barber",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "875 OAK ST SE STE 4030",
      "city": "Salem",
      "state": "OR",
      "postalCode": "97301",
      "phone": "503-561-6444",
      "affiliation": "Regional Academic Oncology Network (Salem, OR)"
    },
    {
      "npi": "1265460661",
      "name": "Dr. Dennis Beckworth, MD",
      "rawName": "Dennis Beckworth",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "133 ROUTE 3",
      "city": "Dededo",
      "state": "GU",
      "postalCode": "96929",
      "phone": "671-645-5546",
      "affiliation": "Regional Academic Oncology Network (Dededo, GU)"
    },
    {
      "npi": "1669487179",
      "name": "Dr. Tomasz Beer, MD",
      "rawName": "Tomasz Beer",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3181 SW SAM JACKSON PARK RD",
      "city": "Portland",
      "state": "OR",
      "postalCode": "97239",
      "phone": "503-494-6594",
      "affiliation": "Regional Academic Oncology Network (Portland, OR)"
    },
    {
      "npi": "1699827477",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Family Medicine",
      "taxonomyCode": "207Q00000X",
      "practiceAddress": "1501 NE MEDICAL CENTER DR",
      "city": "Bend",
      "state": "OR",
      "postalCode": "97701",
      "phone": "541-382-2811",
      "affiliation": "Regional Academic Oncology Network (Bend, OR)"
    },
    {
      "npi": "1174847719",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Family Medicine",
      "taxonomyCode": "207Q00000X",
      "practiceAddress": "865 SW VETERANS WAY",
      "city": "Redmond",
      "state": "OR",
      "postalCode": "97756",
      "phone": "541-322-3500",
      "affiliation": "Regional Academic Oncology Network (Redmond, OR)"
    },
    {
      "npi": "1255837746",
      "name": "Dr. Raed Benkhadra, MD",
      "rawName": "Raed Benkhadra",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "441 NW ELKS DR STE 100",
      "city": "Corvallis",
      "state": "OR",
      "postalCode": "97330",
      "phone": "541-768-4950",
      "affiliation": "Regional Academic Oncology Network (Corvallis, OR)"
    },
    {
      "npi": "1629290549",
      "name": "Dr. Eric Bernstein, MD",
      "rawName": "Eric Bernstein",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "810 12TH ST",
      "city": "Hood river",
      "state": "OR",
      "postalCode": "97031",
      "phone": "541-387-1338",
      "affiliation": "Regional Academic Oncology Network (Hood river, OR)"
    },
    {
      "npi": "1376076828",
      "name": "Dr. Matthew Blackburn, MD",
      "rawName": "Matthew Blackburn",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1130 NW 22ND AVE STE 150",
      "city": "Portland",
      "state": "OR",
      "postalCode": "97210",
      "phone": "971-262-9600",
      "affiliation": "Regional Academic Oncology Network (Portland, OR)"
    },
    {
      "npi": "1447746326",
      "name": "Dr. Bradley Ackerson, MD",
      "rawName": "Bradley Ackerson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9205 SW BARNES RD LOWR LEVEL",
      "city": "Portland",
      "state": "OR",
      "postalCode": "97225",
      "phone": "503-216-2195",
      "affiliation": "Regional Academic Oncology Network (Portland, OR)"
    },
    {
      "npi": "1609371459",
      "name": "Dr. Mohit Agarwal, MD",
      "rawName": "Mohit Agarwal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "615 FAIRHURST ST",
      "city": "Sterling",
      "state": "CO",
      "postalCode": "80751",
      "phone": "970-399-5607",
      "affiliation": "Regional Academic Oncology Network (Sterling, CO)"
    },
    {
      "npi": "1952467607",
      "name": "Dr. Jerald Albrich, MD",
      "rawName": "Jerald Albrich",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2389 N MAPLE ST",
      "city": "Canby",
      "state": "OR",
      "postalCode": "97013",
      "phone": "503-651-3531",
      "affiliation": "Regional Academic Oncology Network (Canby, OR)"
    },
    {
      "npi": "1386677151",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1102 E CENTENNIAL DR",
      "city": "Pittsburg",
      "state": "KS",
      "postalCode": "66762",
      "phone": "620-235-7900",
      "affiliation": "Regional Academic Oncology Network (Pittsburg, KS)"
    },
    {
      "npi": "1326507484",
      "name": "Dr. Lauren Andring, MD",
      "rawName": "Lauren Andring",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2500 NE NEFF RD",
      "city": "Bend",
      "state": "OR",
      "postalCode": "97701",
      "phone": "541-706-5922",
      "affiliation": "Regional Academic Oncology Network (Bend, OR)"
    },
    {
      "npi": "1831509926",
      "name": "Dr. William Arscott, MD",
      "rawName": "William Arscott",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "12123 SW 69TH AVE",
      "city": "Tigard",
      "state": "OR",
      "postalCode": "97223",
      "phone": "971-708-7600",
      "affiliation": "Regional Academic Oncology Network (Tigard, OR)"
    },
    {
      "npi": "1194816843",
      "name": "Dr. Mary Austin-seymour, MD",
      "rawName": "Mary Austin-seymour",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "501 NW ELKS DR",
      "city": "Corvallis",
      "state": "OR",
      "postalCode": "97330",
      "phone": "541-768-5220",
      "affiliation": "Regional Academic Oncology Network (Corvallis, OR)"
    },
    {
      "npi": "1700413788",
      "name": "Dr. Adam Avant, MD",
      "rawName": "Adam Avant",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4805 NE GLISAN ST GARDEN LEVEL",
      "city": "Portland",
      "state": "OR",
      "postalCode": "97213",
      "phone": "032-150-6295",
      "affiliation": "Regional Academic Oncology Network (Portland, OR)"
    }
  ],
  "rhode-island": [
    {
      "npi": "1972779551",
      "name": "Dr. Rami Abumasmah, MD",
      "rawName": "Rami Abumasmah",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "855 N WESTHAVEN DR",
      "city": "Oshkosh",
      "state": "WI",
      "postalCode": "54904",
      "phone": "920-456-7870",
      "affiliation": "Regional Academic Oncology Network (Oshkosh, WI)"
    },
    {
      "npi": "1770836413",
      "name": "Dr. Veena Balakrishnan iyer, MD",
      "rawName": "Veena Balakrishnan iyer",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "450 BROOKLINE AVE",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-632-3000",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1295834406",
      "name": "Dr. Stephanie Cardarella, MD",
      "rawName": "Stephanie Cardarella",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "101 COLUMBIAN ST FL 3",
      "city": "Weymouth",
      "state": "MA",
      "postalCode": "02190",
      "phone": "781-624-4800",
      "affiliation": "Regional Academic Oncology Network (Weymouth, MA)"
    },
    {
      "npi": "1265489371",
      "name": "Dr. Benedito Carneiro, MD",
      "rawName": "Benedito Carneiro",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "164 SUMMIT AVE",
      "city": "Providence",
      "state": "RI",
      "postalCode": "02906",
      "phone": "401-793-7151",
      "affiliation": "Regional Academic Oncology Network (Providence, RI)"
    },
    {
      "npi": "1386857399",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Psychiatry & Neurology, Psychiatry",
      "taxonomyCode": "2084P0800X",
      "practiceAddress": "275 NICHOLS RD",
      "city": "Fitchburg",
      "state": "MA",
      "postalCode": "01420",
      "phone": "978-466-2000",
      "affiliation": "Regional Academic Oncology Network (Fitchburg, MA)"
    },
    {
      "npi": "1639607245",
      "name": "Dr. Matthew Danish, MD",
      "rawName": "Matthew Danish",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "230 WATERFORD PKWY S",
      "city": "Waterford",
      "state": "CT",
      "postalCode": "06385",
      "phone": "860-444-3744",
      "affiliation": "Regional Academic Oncology Network (Waterford, CT)"
    },
    {
      "npi": "1336596774",
      "name": "Dr. Kathryn Decarli, MD",
      "rawName": "Kathryn Decarli",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "593 EDDY ST",
      "city": "Providence",
      "state": "RI",
      "postalCode": "02903",
      "phone": "401-457-3336",
      "affiliation": "Regional Academic Oncology Network (Providence, RI)"
    },
    {
      "npi": "1376573394",
      "name": "Dr. Don Dizon, MD",
      "rawName": "Don Dizon",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "101 DUDLEY ST",
      "city": "Providence",
      "state": "RI",
      "postalCode": "02905",
      "phone": "401-274-1100",
      "affiliation": "Regional Academic Oncology Network (Providence, RI)"
    },
    {
      "npi": "1992209803",
      "name": "Dr. Victor Gazivoda, MD",
      "rawName": "Victor Gazivoda",
      "credential": "MD",
      "specialty": "Surgery",
      "taxonomyCode": "208600000X",
      "practiceAddress": "12902 USF MAGNOLIA DR",
      "city": "Tampa",
      "state": "FL",
      "postalCode": "33612",
      "phone": "813-745-0370",
      "affiliation": "Regional Academic Oncology Network (Tampa, FL)"
    },
    {
      "npi": "1861843963",
      "name": "Dr. Mansour Gergi, MD",
      "rawName": "Mansour Gergi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-8400",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1174905236",
      "name": "Dr. Sassine Ghanem, MD",
      "rawName": "Sassine Ghanem",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2500 ENGLISH CREEK AVE",
      "city": "Egg harbor township",
      "state": "NJ",
      "postalCode": "08234",
      "phone": "609-404-7345",
      "affiliation": "Regional Academic Oncology Network (Egg harbor township, NJ)"
    },
    {
      "npi": "1841371002",
      "name": "Dr. Susan Gingrich, MD",
      "rawName": "Susan Gingrich",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "101 DUDLEY ST",
      "city": "Providence",
      "state": "RI",
      "postalCode": "02905",
      "phone": "401-453-7520",
      "affiliation": "Regional Academic Oncology Network (Providence, RI)"
    },
    {
      "npi": "1629430376",
      "name": "Dr. Ankit Agarwal, MD",
      "rawName": "Ankit Agarwal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9618 HUEBNER RD STE 120",
      "city": "San antonio",
      "state": "TX",
      "postalCode": "78240",
      "phone": "650-940-7280",
      "affiliation": "Regional Academic Oncology Network (San antonio, TX)"
    },
    {
      "npi": "1285691972",
      "name": "Dr. Michele Albert, MD",
      "rawName": "Michele Albert",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 FRANCIS STREET ASB1 L2",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02115",
      "phone": "617-732-7936",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1215566849",
      "name": "Dr. James Assif, MD",
      "rawName": "James Assif",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "142 KENYON AVE",
      "city": "Wakefield",
      "state": "RI",
      "postalCode": "02879",
      "phone": "401-284-0850",
      "affiliation": "Regional Academic Oncology Network (Wakefield, RI)"
    },
    {
      "npi": "1750334769",
      "name": "Dr. Rashmi Benda, MD",
      "rawName": "Rashmi Benda",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "450 TOLL GATE RD",
      "city": "Warwick",
      "state": "RI",
      "postalCode": "02886",
      "phone": "401-732-2300",
      "affiliation": "Regional Academic Oncology Network (Warwick, RI)"
    },
    {
      "npi": "1396770327",
      "name": "Dr. Stuart Berman, MD",
      "rawName": "Stuart Berman",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "BETH ISRAEL DEACONESS MED CTR",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-667-2345",
      "affiliation": "Regional Academic Oncology Network (Boston, MA)"
    },
    {
      "npi": "1467973099",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Urology",
      "taxonomyCode": "208800000X",
      "practiceAddress": "195 COLLYER ST STE 201",
      "city": "Providence",
      "state": "RI",
      "postalCode": "02904",
      "phone": "401-272-7799",
      "affiliation": "Regional Academic Oncology Network (Providence, RI)"
    },
    {
      "npi": "1427525583",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Urology",
      "taxonomyCode": "208800000X",
      "practiceAddress": "2 DUDLEY ST STE 185",
      "city": "Providence",
      "state": "RI",
      "postalCode": "02905",
      "phone": "401-421-0710",
      "affiliation": "Regional Academic Oncology Network (Providence, RI)"
    },
    {
      "npi": "1629545652",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Urology",
      "taxonomyCode": "208800000X",
      "practiceAddress": "827 N MAIN ST STE 4",
      "city": "Providence",
      "state": "RI",
      "postalCode": "02904",
      "phone": "401-383-5710",
      "affiliation": "Regional Academic Oncology Network (Providence, RI)"
    }
  ],
  "south-carolina": [
    {
      "npi": "1396772117",
      "name": "Dr. Farooq Akbar, MD",
      "rawName": "Farooq Akbar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "308 COLISEUM DR STE 120",
      "city": "Macon",
      "state": "GA",
      "postalCode": "31217",
      "phone": "478-745-6130",
      "affiliation": "Regional Academic Oncology Network (Macon, GA)"
    },
    {
      "npi": "1396729414",
      "name": "Dr. Steven Akman, MD",
      "rawName": "Steven Akman",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "171 ASHLEY AVE",
      "city": "Charleston",
      "state": "SC",
      "postalCode": "29425",
      "phone": "843-792-1414",
      "affiliation": "Regional Academic Oncology Network (Charleston, SC)"
    },
    {
      "npi": "1679987382",
      "name": "Dr. Mariam Alexander, MD",
      "rawName": "Mariam Alexander",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "171 ASHLEY AVE",
      "city": "Charleston",
      "state": "SC",
      "postalCode": "29425",
      "phone": "843-792-1414",
      "affiliation": "Regional Academic Oncology Network (Charleston, SC)"
    },
    {
      "npi": "1962780536",
      "name": "Dr. Zeeshan Ali, MD",
      "rawName": "Zeeshan Ali",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "340 MEDICAL PKWY STE 100",
      "city": "Greer",
      "state": "SC",
      "postalCode": "29650",
      "phone": "864-662-4000",
      "affiliation": "Regional Academic Oncology Network (Greer, SC)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1417674516",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "16 OKATIE CENTER BLVD S STE 2-201",
      "city": "Okatie",
      "state": "SC",
      "postalCode": "29909",
      "phone": "912-692-2000",
      "affiliation": "Regional Academic Oncology Network (Okatie, SC)"
    },
    {
      "npi": "1326031618",
      "name": "Dr. Rebecca Bechhold, MD",
      "rawName": "Rebecca Bechhold",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "171 ASHLEY AVE",
      "city": "Charleston",
      "state": "SC",
      "postalCode": "29425",
      "phone": "843-792-1414",
      "affiliation": "Regional Academic Oncology Network (Charleston, SC)"
    },
    {
      "npi": "1023275633",
      "name": "Dr. Kevin Becker, MD",
      "rawName": "Kevin Becker",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "39 SABIN ST",
      "city": "Charleston",
      "state": "SC",
      "postalCode": "29425",
      "phone": "843-792-9300",
      "affiliation": "Regional Academic Oncology Network (Charleston, SC)"
    },
    {
      "npi": "1679593966",
      "name": "Dr. Britt Bolemon, MD",
      "rawName": "Britt Bolemon",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "65 INTERNATIONAL DR",
      "city": "Greenville",
      "state": "SC",
      "postalCode": "29615",
      "phone": "864-987-7000",
      "affiliation": "Regional Academic Oncology Network (Greenville, SC)"
    },
    {
      "npi": "1609984558",
      "name": "Dr. Frank Brescia, MD",
      "rawName": "Frank Brescia",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "171 ASHLEY AVE",
      "city": "Charleston",
      "state": "SC",
      "postalCode": "29425",
      "phone": "843-792-1414",
      "affiliation": "Regional Academic Oncology Network (Charleston, SC)"
    },
    {
      "npi": "1356375810",
      "name": "Dr. Carolyn Britten, MD",
      "rawName": "Carolyn Britten",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "171 ASHLEY AVE",
      "city": "Charleston",
      "state": "SC",
      "postalCode": "29425",
      "phone": "843-792-1414",
      "affiliation": "Regional Academic Oncology Network (Charleston, SC)"
    },
    {
      "npi": "1437119997",
      "name": "Dr. Michael Bruin, MD",
      "rawName": "Michael Bruin",
      "credential": "MD",
      "specialty": "Medical Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "516 S VAN BUREN RD",
      "city": "Eden",
      "state": "NC",
      "postalCode": "27288",
      "phone": "336-623-6862",
      "affiliation": "Regional Academic Oncology Network (Eden, NC)"
    },
    {
      "npi": "1457308678",
      "name": "Dr. Eric Aguero, MD",
      "rawName": "Eric Aguero",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "171 ASHLEY AVE",
      "city": "Charleston",
      "state": "SC",
      "postalCode": "29425",
      "phone": "843-792-1414",
      "affiliation": "Regional Academic Oncology Network (Charleston, SC)"
    },
    {
      "npi": "1457596140",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "111 MIRACLE DR",
      "city": "Aiken",
      "state": "SC",
      "postalCode": "29801",
      "phone": "803-641-7850",
      "affiliation": "Regional Academic Oncology Network (Aiken, SC)"
    },
    {
      "npi": "1801965793",
      "name": "Dr. Heather Allen, MD",
      "rawName": "Heather Allen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "101 E WOOD ST",
      "city": "Spartanburg",
      "state": "SC",
      "postalCode": "29303",
      "phone": "864-560-6917",
      "affiliation": "Regional Academic Oncology Network (Spartanburg, SC)"
    },
    {
      "npi": "1942769997",
      "name": "Dr. Samuel Andersen, MD",
      "rawName": "Samuel Andersen",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4708 OLEANDER DR",
      "city": "Myrtle beach",
      "state": "SC",
      "postalCode": "29577",
      "phone": "843-449-9415",
      "affiliation": "Regional Academic Oncology Network (Myrtle beach, SC)"
    },
    {
      "npi": "1659722353",
      "name": "Dr. Eric Anderson, MD",
      "rawName": "Eric Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2000 BOISE AVE",
      "city": "Loveland",
      "state": "CO",
      "postalCode": "80538",
      "phone": "970-820-4640",
      "affiliation": "Regional Academic Oncology Network (Loveland, CO)"
    },
    {
      "npi": "1568444529",
      "name": "Dr. Stephen Andrews, DO",
      "rawName": "Stephen Andrews",
      "credential": "DO",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4708 OLEANDER DR",
      "city": "Myrtle beach",
      "state": "SC",
      "postalCode": "29577",
      "phone": "843-449-9415",
      "affiliation": "Regional Academic Oncology Network (Myrtle beach, SC)"
    },
    {
      "npi": "1205008349",
      "name": "Dr. Albert Attia, MD",
      "rawName": "Albert Attia",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4500 SAN PABLO RD S",
      "city": "Jacksonville",
      "state": "FL",
      "postalCode": "32224",
      "phone": "904-953-2000",
      "affiliation": "Regional Academic Oncology Network (Jacksonville, FL)"
    }
  ],
  "south-dakota": [
    {
      "npi": "1932811981",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "310 22ND AVE STE 101",
      "city": "Brookings",
      "state": "SD",
      "postalCode": "57006",
      "phone": "605-697-9586",
      "affiliation": "Regional Academic Oncology Network (Brookings, SD)"
    },
    {
      "npi": "1831485077",
      "name": "Dr. Sanggyu Bae, MD",
      "rawName": "Sanggyu Bae",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1233 34TH ST NW",
      "city": "Bemidji",
      "state": "MN",
      "postalCode": "56601",
      "phone": "218-333-5522",
      "affiliation": "Regional Academic Oncology Network (Bemidji, MN)"
    },
    {
      "npi": "1518058163",
      "name": "Dr. Larry Ebbert, MD",
      "rawName": "Larry Ebbert",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "85 MAUI LANI PKWY",
      "city": "Wailuku",
      "state": "HI",
      "postalCode": "96793",
      "phone": "808-442-5700",
      "affiliation": "Regional Academic Oncology Network (Wailuku, HI)"
    },
    {
      "npi": "1467428995",
      "name": "Dr. David Elson, MD",
      "rawName": "David Elson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1000 E. 23RD ST.",
      "city": "Sioux falls",
      "state": "SD",
      "postalCode": "57105",
      "phone": "605-322-6900",
      "affiliation": "Regional Academic Oncology Network (Sioux falls, SD)"
    },
    {
      "npi": "1225073661",
      "name": "Dr. Mark Gitau, MD",
      "rawName": "Mark Gitau",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "701-234-6161",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    },
    {
      "npi": "1275055956",
      "name": "Dr. Alexander Johnson, MD",
      "rawName": "Alexander Johnson",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "701 E ROSSER AVE",
      "city": "Bismarck",
      "state": "ND",
      "postalCode": "58501",
      "phone": "701-323-8550",
      "affiliation": "Regional Academic Oncology Network (Bismarck, ND)"
    },
    {
      "npi": "1356317887",
      "name": "Dr. Michael Robinson, MD",
      "rawName": "Michael Robinson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "353 FAIRMONT BLVD.",
      "city": "Rapid city",
      "state": "SD",
      "postalCode": "57701",
      "phone": "605-719-2300",
      "affiliation": "Regional Academic Oncology Network (Rapid city, SD)"
    },
    {
      "npi": "1255531430",
      "name": "Dr. Bongi Rudder, MD",
      "rawName": "Bongi Rudder",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "200 1ST ST SW",
      "city": "Rochester",
      "state": "MN",
      "postalCode": "55905",
      "phone": "507-284-2511",
      "affiliation": "Regional Academic Oncology Network (Rochester, MN)"
    },
    {
      "npi": "1316970536",
      "name": "Dr. Jonathan Sande, MD",
      "rawName": "Jonathan Sande",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "512 SKYLINE BLVD STE 1",
      "city": "Cloquet",
      "state": "MN",
      "postalCode": "55720",
      "phone": "218-879-4641",
      "affiliation": "Regional Academic Oncology Network (Cloquet, MN)"
    },
    {
      "npi": "1952492506",
      "name": "Dr. Mark Schroeder, MD",
      "rawName": "Mark Schroeder",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "353 FAIRMONT BLVD.",
      "city": "Rapid city",
      "state": "SD",
      "postalCode": "57701",
      "phone": "605-719-2300",
      "affiliation": "Regional Academic Oncology Network (Rapid city, SD)"
    },
    {
      "npi": "1275528382",
      "name": "Dr. Thomas Tan, MD",
      "rawName": "Thomas Tan",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "400 MEDICAL PLZ STE 100",
      "city": "Lake st louis",
      "state": "MO",
      "postalCode": "63367",
      "phone": "636-639-8600",
      "affiliation": "Regional Academic Oncology Network (Lake st louis, MO)"
    },
    {
      "npi": "1164522751",
      "name": "Dr. Richard Tenglin, MD",
      "rawName": "Richard Tenglin",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "353 FAIRMONT BLVD.",
      "city": "Rapid city",
      "state": "SD",
      "postalCode": "57701",
      "phone": "605-719-2300",
      "affiliation": "Regional Academic Oncology Network (Rapid city, SD)"
    },
    {
      "npi": "1578794715",
      "name": "Dr. Troy Adolfson, MD",
      "rawName": "Troy Adolfson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "620 3RD AVE SE",
      "city": "Aberdeen",
      "state": "SD",
      "postalCode": "57401",
      "phone": "605-622-5500",
      "affiliation": "Regional Academic Oncology Network (Aberdeen, SD)"
    },
    {
      "npi": "1760625768",
      "name": "Dr. Kyle Arneson, MD",
      "rawName": "Kyle Arneson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1000 E 23RD ST STE 100",
      "city": "Sioux falls",
      "state": "SD",
      "postalCode": "57105",
      "phone": "605-322-1625",
      "affiliation": "Regional Academic Oncology Network (Sioux falls, SD)"
    },
    {
      "npi": "1477847861",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1000 E. 23RD ST.",
      "city": "Sioux falls",
      "state": "SD",
      "postalCode": "57105",
      "phone": "605-322-1625",
      "affiliation": "Regional Academic Oncology Network (Sioux falls, SD)"
    },
    {
      "npi": "1962927269",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "605 N FOSTER ST",
      "city": "Mitchell",
      "state": "SD",
      "postalCode": "57301",
      "phone": "605-995-5756",
      "affiliation": "Regional Academic Oncology Network (Mitchell, SD)"
    },
    {
      "npi": "1780004713",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "310 S PENN ST STE 105",
      "city": "Aberdeen",
      "state": "SD",
      "postalCode": "57401",
      "phone": "605-622-5500",
      "affiliation": "Regional Academic Oncology Network (Aberdeen, SD)"
    },
    {
      "npi": "1619906120",
      "name": "Dr. Jeffrey Brindle, MD",
      "rawName": "Jeffrey Brindle",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "401 9TH AVE NW",
      "city": "Watertown",
      "state": "SD",
      "postalCode": "57201",
      "phone": "605-882-7000",
      "affiliation": "Regional Academic Oncology Network (Watertown, SD)"
    },
    {
      "npi": "1104025113",
      "name": "Dr. Joni Buechler-price, MD",
      "rawName": "Joni Buechler-price",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "401 9TH AVE NW",
      "city": "Watertown",
      "state": "SD",
      "postalCode": "57201",
      "phone": "605-882-7000",
      "affiliation": "Regional Academic Oncology Network (Watertown, SD)"
    },
    {
      "npi": "1730767518",
      "name": "Dr. Elliott Czarnecki, MD",
      "rawName": "Elliott Czarnecki",
      "credential": "MD",
      "specialty": "Student in an Organized Health Care Education/Training Program",
      "taxonomyCode": "390200000X",
      "practiceAddress": "820 4TH ST N",
      "city": "Fargo",
      "state": "ND",
      "postalCode": "58102",
      "phone": "701-234-6161",
      "affiliation": "Regional Academic Oncology Network (Fargo, ND)"
    }
  ],
  "utah": [
    {
      "npi": "1346330966",
      "name": "Dr. Wallace Akerley, MD",
      "rawName": "Wallace Akerley",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1950 CIRCLE OF HOPE",
      "city": "Salt lake city",
      "state": "UT",
      "postalCode": "84112",
      "phone": "801-585-0100",
      "affiliation": "Regional Academic Oncology Network (Salt lake city, UT)"
    },
    {
      "npi": "1659926228",
      "name": "Dr. Khaled Alhamad, MD",
      "rawName": "Khaled Alhamad",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "30 N 1900 E RM 5C402",
      "city": "Salt lake city",
      "state": "UT",
      "postalCode": "84132",
      "phone": "801-585-0120",
      "affiliation": "Regional Academic Oncology Network (Salt lake city, UT)"
    },
    {
      "npi": "1043674666",
      "name": "Dr. Lisa Arnold, DO",
      "rawName": "Lisa Arnold",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5171 S. COTTONWOOD ST.",
      "city": "Murray",
      "state": "UT",
      "postalCode": "84107",
      "phone": "801-507-3630",
      "affiliation": "Regional Academic Oncology Network (Murray, UT)"
    },
    {
      "npi": "1902905417",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Pathology, Anatomic Pathology & Clinical Pathology",
      "taxonomyCode": "207ZP0102X",
      "practiceAddress": "50 N MEDICAL DR",
      "city": "Salt lake city",
      "state": "UT",
      "postalCode": "84132",
      "phone": "801-581-2507",
      "affiliation": "Regional Academic Oncology Network (Salt lake city, UT)"
    },
    {
      "npi": "1134582323",
      "name": "Dr. Roma Bhatia, MD",
      "rawName": "Roma Bhatia",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2000 CIRCLE OF HOPE DR RM L1376",
      "city": "Salt lake city",
      "state": "UT",
      "postalCode": "84112",
      "phone": "801-585-1435",
      "affiliation": "City of Hope Comprehensive Cancer Center"
    },
    {
      "npi": "1992880991",
      "name": "Dr. Thomas Brown, MD",
      "rawName": "Thomas Brown",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1221 MADISON ST FL 2",
      "city": "Seattle",
      "state": "WA",
      "postalCode": "98104",
      "phone": "206-386-2323",
      "affiliation": "Regional Academic Oncology Network (Seattle, WA)"
    },
    {
      "npi": "1568547255",
      "name": "Dr. Saundra Buys, MD",
      "rawName": "Saundra Buys",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1950 CIRCLE OF HOPE",
      "city": "Salt lake city",
      "state": "UT",
      "postalCode": "84112",
      "phone": "801-585-0100",
      "affiliation": "Regional Academic Oncology Network (Salt lake city, UT)"
    },
    {
      "npi": "1124172697",
      "name": "Dr. Justin Call, MD",
      "rawName": "Justin Call",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3592 W 9000 S",
      "city": "West jordan",
      "state": "UT",
      "postalCode": "84088",
      "phone": "801-562-8732",
      "affiliation": "Regional Academic Oncology Network (West jordan, UT)"
    },
    {
      "npi": "1801845730",
      "name": "Dr. Nitin Chandramouli, MD",
      "rawName": "Nitin Chandramouli",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3838 S 700 E",
      "city": "Salt lake city",
      "state": "UT",
      "postalCode": "84106",
      "phone": "801-269-0231",
      "affiliation": "Regional Academic Oncology Network (Salt lake city, UT)"
    },
    {
      "npi": "1396760724",
      "name": "Dr. Lei Chen, MD",
      "rawName": "Lei Chen",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "50 N MEDICAL DR",
      "city": "Salt lake city",
      "state": "UT",
      "postalCode": "84132",
      "phone": "801-581-2121",
      "affiliation": "Regional Academic Oncology Network (Salt lake city, UT)"
    },
    {
      "npi": "1457493967",
      "name": "Dr. Gregory Chipman, MD",
      "rawName": "Gregory Chipman",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "48 N 1100 E",
      "city": "American fork",
      "state": "UT",
      "postalCode": "84003",
      "phone": "801-492-9934",
      "affiliation": "Regional Academic Oncology Network (American fork, UT)"
    },
    {
      "npi": "1528281375",
      "name": "Dr. Adam Cohen, MD",
      "rawName": "Adam Cohen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8081 INNOVATION PARK DR",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22031",
      "phone": "571-472-4724",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1356229694",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1308 E 900 S UNIT 1B",
      "city": "St george",
      "state": "UT",
      "postalCode": "84790",
      "phone": "949-922-1970",
      "affiliation": "Regional Academic Oncology Network (St george, UT)"
    },
    {
      "npi": "1518981380",
      "name": "Dr. James Adams, MD",
      "rawName": "James Adams",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "125 BAPTIST WAY STE 1C",
      "city": "Pensacola",
      "state": "FL",
      "postalCode": "32503",
      "phone": "448-227-6000",
      "affiliation": "Regional Academic Oncology Network (Pensacola, FL)"
    },
    {
      "npi": "1306231907",
      "name": "Dr. Bryan Ager, MD",
      "rawName": "Bryan Ager",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "605 E HOLLAND AVE STE 100",
      "city": "Spokane",
      "state": "WA",
      "postalCode": "99218",
      "phone": "509-228-1000",
      "affiliation": "Regional Academic Oncology Network (Spokane, WA)"
    },
    {
      "npi": "1063678514",
      "name": "Dr. Spencer Ashton, MD",
      "rawName": "Spencer Ashton",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "600 S MEDICAL CENTER DR",
      "city": "St george",
      "state": "UT",
      "postalCode": "84790",
      "phone": "435-688-4175",
      "affiliation": "Regional Academic Oncology Network (St george, UT)"
    },
    {
      "npi": "1003865932",
      "name": "Dr. Vilija Avizonis, MD",
      "rawName": "Vilija Avizonis",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3838 S 700 E",
      "city": "Salt lake city",
      "state": "UT",
      "postalCode": "84106",
      "phone": "801-281-6860",
      "affiliation": "Regional Academic Oncology Network (Salt lake city, UT)"
    },
    {
      "npi": "1841587094",
      "name": "Dr. Ryan Bair, MD",
      "rawName": "Ryan Bair",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1400 N 500 E",
      "city": "Logan",
      "state": "UT",
      "postalCode": "84341",
      "phone": "435-716-1000",
      "affiliation": "Regional Academic Oncology Network (Logan, UT)"
    },
    {
      "npi": "1194961789",
      "name": "Dr. Brandon Barney, MD",
      "rawName": "Brandon Barney",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "170 N 1100 E",
      "city": "American fork",
      "state": "UT",
      "postalCode": "84003",
      "phone": "801-357-2480",
      "affiliation": "Regional Academic Oncology Network (American fork, UT)"
    },
    {
      "npi": "1538504436",
      "name": "Dr. Christian Barney, MD",
      "rawName": "Christian Barney",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "395 W COUGAR BLVD STE 104",
      "city": "Provo",
      "state": "UT",
      "postalCode": "84604",
      "phone": "801-357-2480",
      "affiliation": "Regional Academic Oncology Network (Provo, UT)"
    }
  ],
  "vermont": [
    {
      "npi": "1992220933",
      "name": "Dr. Asad Anwar, MD",
      "rawName": "Asad Anwar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-8400",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1265991269",
      "name": "Dr. Alzira Avelino, MD",
      "rawName": "Alzira Avelino",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-656-5465",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1730145087",
      "name": "Dr. Suzanne Berlin, DO",
      "rawName": "Suzanne Berlin",
      "credential": "DO",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "LAHEY HEMATOLOGY AND ONCOLOGY AT PARKLAND, DERRY",
      "city": "Derry",
      "state": "NH",
      "postalCode": "03038",
      "phone": "603-537-2060",
      "affiliation": "Regional Academic Oncology Network (Derry, NH)"
    },
    {
      "npi": "1134615883",
      "name": "Dr. Marie anne christine Buteau, MD",
      "rawName": "Marie anne christine Buteau",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-0000",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1114582178",
      "name": "Dr. Dimitrios Drekolias, MD",
      "rawName": "Dimitrios Drekolias",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-0000",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1386615201",
      "name": "Dr. Kurt Ebrahim, DO",
      "rawName": "Kurt Ebrahim",
      "credential": "DO",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2 INDEPENDENCE DR",
      "city": "Kennebunk",
      "state": "ME",
      "postalCode": "04043",
      "phone": "207-303-3300",
      "affiliation": "Regional Academic Oncology Network (Kennebunk, ME)"
    },
    {
      "npi": "1033312640",
      "name": "Dr. Shlomit Ein-gal, MD",
      "rawName": "Shlomit Ein-gal",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-8400",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1174540538",
      "name": "Dr. Edmund Folefac, MD",
      "rawName": "Edmund Folefac",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "300 W 10TH AVE",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43210",
      "phone": "614-293-6196",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1083639595",
      "name": "Dr. Alexander Fuld, MD",
      "rawName": "Alexander Fuld",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "215 N MAIN ST",
      "city": "White river junction",
      "state": "VT",
      "postalCode": "05009",
      "phone": "802-295-9363",
      "affiliation": "Regional Academic Oncology Network (White river junction, VT)"
    },
    {
      "npi": "1861843963",
      "name": "Dr. Mansour Gergi, MD",
      "rawName": "Mansour Gergi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-8400",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1336406040",
      "name": "Dr. James Gerson, MD",
      "rawName": "James Gerson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-8400",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1538553656",
      "name": "Dr. Sarah Gillett, MD",
      "rawName": "Sarah Gillett",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-2700",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1093938334",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "75 BEEKMAN ST",
      "city": "Plattsburgh",
      "state": "NY",
      "postalCode": "12901",
      "phone": "518-562-7120",
      "affiliation": "Regional Academic Oncology Network (Plattsburgh, NY)"
    },
    {
      "npi": "1295182442",
      "name": "Dr. Jason Beckta, MD",
      "rawName": "Jason Beckta",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "160 ALLEN ST",
      "city": "Rutland",
      "state": "VT",
      "postalCode": "05701",
      "phone": "802-747-1831",
      "affiliation": "Regional Academic Oncology Network (Rutland, VT)"
    },
    {
      "npi": "1205145398",
      "name": "Dr. Ahmed Chaudhary, MD",
      "rawName": "Ahmed Chaudhary",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "680 CENTRE ST",
      "city": "Brockton",
      "state": "MA",
      "postalCode": "02302",
      "phone": "508-941-7450",
      "affiliation": "Regional Academic Oncology Network (Brockton, MA)"
    },
    {
      "npi": "1306316625",
      "name": "Dr. Joshua Doyle, MD",
      "rawName": "Joshua Doyle",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "80 SEYMOUR ST",
      "city": "Hartford",
      "state": "CT",
      "postalCode": "06106",
      "phone": "860-972-2803",
      "affiliation": "Regional Academic Oncology Network (Hartford, CT)"
    },
    {
      "npi": "1619266624",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-0000",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1346270337",
      "name": "Dr. Daniel Fram, MD",
      "rawName": "Daniel Fram",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-3506",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1407059371",
      "name": "Dr. Havaleh Gagne, MD",
      "rawName": "Havaleh Gagne",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "111 COLCHESTER AVE",
      "city": "Burlington",
      "state": "VT",
      "postalCode": "05401",
      "phone": "802-847-3506",
      "affiliation": "Regional Academic Oncology Network (Burlington, VT)"
    },
    {
      "npi": "1346236759",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "80 SEYMOUR ST",
      "city": "Hartford",
      "state": "CT",
      "postalCode": "06106",
      "phone": "860-545-2803",
      "affiliation": "Regional Academic Oncology Network (Hartford, CT)"
    }
  ],
  "virginia": [
    {
      "npi": "1881805166",
      "name": "Dr. Nagla Abdel karim, MD",
      "rawName": "Nagla Abdel karim",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8081 INNOVATION PARK DR",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22031",
      "phone": "571-472-4724",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1922396753",
      "name": "Dr. Cherif Abdelmalek, MD",
      "rawName": "Cherif Abdelmalek",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "10 PROSPECT ST",
      "city": "Nashua",
      "state": "NH",
      "postalCode": "03060",
      "phone": "603-886-7900",
      "affiliation": "Regional Academic Oncology Network (Nashua, NH)"
    },
    {
      "npi": "1861445421",
      "name": "Dr. Peter Acs, MD",
      "rawName": "Peter Acs",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1500 SE MAGNOLIA EXT STE 205",
      "city": "Ocala",
      "state": "FL",
      "postalCode": "34471",
      "phone": "352-529-8232",
      "affiliation": "Regional Academic Oncology Network (Ocala, FL)"
    },
    {
      "npi": "1982672937",
      "name": "Dr. Ivan Aksentijevich, MD",
      "rawName": "Ivan Aksentijevich",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4660 KENMORE AVE STE 1018",
      "city": "Alexandria",
      "state": "VA",
      "postalCode": "22304",
      "phone": "571-483-1800",
      "affiliation": "Regional Academic Oncology Network (Alexandria, VA)"
    },
    {
      "npi": "1528446242",
      "name": "Dr. Jafar Al-mondhiry, MD",
      "rawName": "Jafar Al-mondhiry",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8081 INNOVATION PARK DR",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22031",
      "phone": "571-472-1190",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1942628458",
      "name": "Dr. Joshua Allen, MD",
      "rawName": "Joshua Allen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3580 JOSEPH SIEWICK DR STE 403",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22033",
      "phone": "703-391-4395",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1548143878",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "20522 FALCONS LANDING CIR",
      "city": "Potomac falls",
      "state": "VA",
      "postalCode": "20165",
      "phone": "703-858-3100",
      "affiliation": "Regional Academic Oncology Network (Potomac falls, VA)"
    },
    {
      "npi": "1467318204",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "125 WOODSTREAM BLVD STE 205",
      "city": "Stafford",
      "state": "VA",
      "postalCode": "22556",
      "phone": "540-371-0079",
      "affiliation": "Regional Academic Oncology Network (Stafford, VA)"
    },
    {
      "npi": "1801752647",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4545 EMPIRE CT",
      "city": "Fredericksburg",
      "state": "VA",
      "postalCode": "22408",
      "phone": "540-371-0079",
      "affiliation": "Regional Academic Oncology Network (Fredericksburg, VA)"
    },
    {
      "npi": "1639659105",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "24430 STONE SPRINGS BLVD UNIT 515",
      "city": "Dulles",
      "state": "VA",
      "postalCode": "20166",
      "phone": "703-858-3110",
      "affiliation": "Regional Academic Oncology Network (Dulles, VA)"
    },
    {
      "npi": "1700742541",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "4501 EMPIRE CT",
      "city": "Fredericksburg",
      "state": "VA",
      "postalCode": "22408",
      "phone": "540-371-0079",
      "affiliation": "Regional Academic Oncology Network (Fredericksburg, VA)"
    },
    {
      "npi": "1992268783",
      "name": "Dr. Chike Abana, MD",
      "rawName": "Chike Abana",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "6251 E VIRGINIA BEACH BLVD STE 115",
      "city": "Norfolk",
      "state": "VA",
      "postalCode": "23502",
      "phone": "757-213-5770",
      "affiliation": "Regional Academic Oncology Network (Norfolk, VA)"
    },
    {
      "npi": "1457379497",
      "name": "Dr. Olubunmi Abayomi, MD",
      "rawName": "Olubunmi Abayomi",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1250 E MARSHALL STREET",
      "city": "Richmond",
      "state": "VA",
      "postalCode": "23298",
      "phone": "804-828-7232",
      "affiliation": "Regional Academic Oncology Network (Richmond, VA)"
    },
    {
      "npi": "1891056495",
      "name": "Dr. Bret Adams, MD",
      "rawName": "Bret Adams",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2013 JEFFERSON ST SW FL 2",
      "city": "Roanoke",
      "state": "VA",
      "postalCode": "24014",
      "phone": "540-982-0237",
      "affiliation": "Regional Academic Oncology Network (Roanoke, VA)"
    },
    {
      "npi": "1316262363",
      "name": "Dr. Manuj Agarwal, MD",
      "rawName": "Manuj Agarwal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "333 COTTMAN AVENUE",
      "city": "Philadelphia",
      "state": "PA",
      "postalCode": "19111",
      "phone": "215-728-2581",
      "affiliation": "Regional Academic Oncology Network (Philadelphia, PA)"
    },
    {
      "npi": "1073797460",
      "name": "Dr. Harold Agbahiwe, MD",
      "rawName": "Harold Agbahiwe",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "8613 ROUTE 29 STE 100N",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22031",
      "phone": "703-934-4450",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1316923014",
      "name": "Dr. Sanjeev Aggarwal, MD",
      "rawName": "Sanjeev Aggarwal",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "7901 LAKE MANASSAS DR STE 100",
      "city": "Gainesville",
      "state": "VA",
      "postalCode": "20155",
      "phone": "540-829-8888",
      "affiliation": "Regional Academic Oncology Network (Gainesville, VA)"
    },
    {
      "npi": "1124055645",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "203 ACADEMY ST S",
      "city": "Ahoskie",
      "state": "NC",
      "postalCode": "27910",
      "phone": "252-209-8483",
      "affiliation": "Regional Academic Oncology Network (Ahoskie, NC)"
    },
    {
      "npi": "1366428419",
      "name": "Dr. M moinuddin Ali, MD",
      "rawName": "M moinuddin Ali",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "9105 STONY POINT PKWY",
      "city": "Richmond",
      "state": "VA",
      "postalCode": "23235",
      "phone": "804-287-6101",
      "affiliation": "Regional Academic Oncology Network (Richmond, VA)"
    }
  ],
  "washington-dc": [
    {
      "npi": "1043841059",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "9160 FORUM CORPORATE PKWY STE 350",
      "city": "Fort myers",
      "state": "FL",
      "postalCode": "33905",
      "phone": "239-785-3200",
      "affiliation": "Regional Academic Oncology Network (Fort myers, FL)"
    },
    {
      "npi": "1265929723",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "3100 PLAZA PROPERTIES BLVD",
      "city": "Columbus",
      "state": "OH",
      "postalCode": "43219",
      "phone": "614-383-6000",
      "affiliation": "Regional Academic Oncology Network (Columbus, OH)"
    },
    {
      "npi": "1902630478",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "106 IRVING ST NW STE 4100",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20010",
      "phone": "202-726-0941",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    },
    {
      "npi": "1245726371",
      "name": "Dr. Prashanth Ashok kumar, MD",
      "rawName": "Prashanth Ashok kumar",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2150 PENNSYLVANIA AVE NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20037",
      "phone": "202-677-6903",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    },
    {
      "npi": "1568635712",
      "name": "Dr. Nilofer Azad, MD",
      "rawName": "Nilofer Azad",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "600 N WOLFE ST",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21287",
      "phone": "410-955-9441",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1508184490",
      "name": "Dr. Karim Boudadi, MD",
      "rawName": "Karim Boudadi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5255 LOUGHBORO RD NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20016",
      "phone": "202-537-4686",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    },
    {
      "npi": "1811058050",
      "name": "Dr. William Dahut, MD",
      "rawName": "William Dahut",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6900 GEORGIA AVENUE, NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20307",
      "phone": "301-435-8183",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    },
    {
      "npi": "1073571519",
      "name": "Dr. Nancy Dawson, MD",
      "rawName": "Nancy Dawson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3800 RESERVOIR RD NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20007",
      "phone": "202-444-2223",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    },
    {
      "npi": "1659390755",
      "name": "Dr. John Deeken, MD",
      "rawName": "John Deeken",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "8081 INNOVATION PARK DR",
      "city": "Fairfax",
      "state": "VA",
      "postalCode": "22031",
      "phone": "571-472-4724",
      "affiliation": "Regional Academic Oncology Network (Fairfax, VA)"
    },
    {
      "npi": "1750776837",
      "name": "Dr. Kimberley Doucette, MD",
      "rawName": "Kimberley Doucette",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3800 RESERVOIR RD NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20007",
      "phone": "202-444-3736",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    },
    {
      "npi": "1154610467",
      "name": "Dr. Kieron Dunleavy, MD",
      "rawName": "Kieron Dunleavy",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3800 RESERVOIR RD NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20007",
      "phone": "202-444-3736",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    },
    {
      "npi": "1861952632",
      "name": "Dr. Kaitlyn Dykes, MD",
      "rawName": "Kaitlyn Dykes",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "200 W ARBOR DR",
      "city": "San diego",
      "state": "CA",
      "postalCode": "92103",
      "phone": "800-926-8273",
      "affiliation": "Regional Academic Oncology Network (San diego, CA)"
    },
    {
      "npi": "1942696752",
      "name": "Dr. Nima Aghdam, MD",
      "rawName": "Nima Aghdam",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "330 BROOKLINE AVE BSMT",
      "city": "Boston",
      "state": "MA",
      "postalCode": "02215",
      "phone": "617-667-2345",
      "affiliation": "Dana-Farber Cancer Institute"
    },
    {
      "npi": "1164467460",
      "name": "Dr. Ebrahim Ashayeri, MD",
      "rawName": "Ebrahim Ashayeri",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2041 GEORGIA AVE NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20060",
      "phone": "202-865-1421",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    },
    {
      "npi": "1629085881",
      "name": "Dr. Sheree Brown, MD",
      "rawName": "Sheree Brown",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "320 KENNESTONE HOSPITAL BLVD",
      "city": "Marietta",
      "state": "GA",
      "postalCode": "30060",
      "phone": "770-793-7500",
      "affiliation": "Regional Academic Oncology Network (Marietta, GA)"
    },
    {
      "npi": "1104212026",
      "name": "Dr. Aidan Burke, MD",
      "rawName": "Aidan Burke",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "600 MOYE BLVD",
      "city": "Greenville",
      "state": "NC",
      "postalCode": "27834",
      "phone": "252-744-1888",
      "affiliation": "Regional Academic Oncology Network (Greenville, NC)"
    },
    {
      "npi": "1891795167",
      "name": "Dr. Joann Collier-manning, MD",
      "rawName": "Joann Collier-manning",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3800 RESERVOIR RD NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20007",
      "phone": "202-745-8314",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    },
    {
      "npi": "1417956640",
      "name": "Dr. Brian Collins, MD",
      "rawName": "Brian Collins",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3800 RESERVOIR RD NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20007",
      "phone": "202-444-3320",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    },
    {
      "npi": "1396764965",
      "name": "Dr. Sean Collins, MD",
      "rawName": "Sean Collins",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "3800 RESERVOIR RD NW",
      "city": "Washington",
      "state": "DC",
      "postalCode": "20007",
      "phone": "202-444-3320",
      "affiliation": "Regional Academic Oncology Network (Washington, DC)"
    }
  ],
  "west-virginia": [
    {
      "npi": "1326525114",
      "name": "Dr. Ahmad Abu-hashyeh, MD",
      "rawName": "Ahmad Abu-hashyeh",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "500 JOHN DEERE RD",
      "city": "Moline",
      "state": "IL",
      "postalCode": "61265",
      "phone": "309-779-5000",
      "affiliation": "Regional Academic Oncology Network (Moline, IL)"
    },
    {
      "npi": "1639351760",
      "name": "Dr. Abdul Adjei, MD",
      "rawName": "Abdul Adjei",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1000 EAST MOUNTAIN BLVD.",
      "city": "Wilkes-barre",
      "state": "PA",
      "postalCode": "18711",
      "phone": "570-808-6150",
      "affiliation": "Regional Academic Oncology Network (Wilkes-barre, PA)"
    },
    {
      "npi": "1659766889",
      "name": "Dr. Heidar Albandar, MD",
      "rawName": "Heidar Albandar",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "701 OSTRUM ST STE 501",
      "city": "Fountain hill",
      "state": "PA",
      "postalCode": "18015",
      "phone": "484-503-7000",
      "affiliation": "Regional Academic Oncology Network (Fountain hill, PA)"
    },
    {
      "npi": "1396059705",
      "name": "Dr. Mohamed Alsharedi, MD",
      "rawName": "Mohamed Alsharedi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2195 HARRODSBURG RD FL 2",
      "city": "Lexington",
      "state": "KY",
      "postalCode": "40504",
      "phone": "859-258-4673",
      "affiliation": "Regional Academic Oncology Network (Lexington, KY)"
    },
    {
      "npi": "1316364441",
      "name": "Dr. Ruta Arays, MD",
      "rawName": "Ruta Arays",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "800 ROSE ST",
      "city": "Lexington",
      "state": "KY",
      "postalCode": "40536",
      "phone": "859-323-2650",
      "affiliation": "Regional Academic Oncology Network (Lexington, KY)"
    },
    {
      "npi": "1699778894",
      "name": "Dr. Adesola Awomolo, MD",
      "rawName": "Adesola Awomolo",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1000 36TH ST",
      "city": "Vero beach",
      "state": "FL",
      "postalCode": "32960",
      "phone": "772-567-4673",
      "affiliation": "Regional Academic Oncology Network (Vero beach, FL)"
    },
    {
      "npi": "1851361521",
      "name": "Dr. Kevin Bird, MD",
      "rawName": "Kevin Bird",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "510 BUTLER AVE",
      "city": "Martinsburg",
      "state": "WV",
      "postalCode": "25401",
      "phone": "304-263-0811",
      "affiliation": "Regional Academic Oncology Network (Martinsburg, WV)"
    },
    {
      "npi": "1609211614",
      "name": "Dr. Joseph Caveney, MD",
      "rawName": "Joseph Caveney",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1 MEDICAL CENTER DR",
      "city": "Morgantown",
      "state": "WV",
      "postalCode": "26506",
      "phone": "304-293-4229",
      "affiliation": "Regional Academic Oncology Network (Morgantown, WV)"
    },
    {
      "npi": "1487439683",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "275 DRY HILL RD",
      "city": "Beckley",
      "state": "WV",
      "postalCode": "25801",
      "phone": "304-253-6060",
      "affiliation": "Regional Academic Oncology Network (Beckley, WV)"
    },
    {
      "npi": "1902836612",
      "name": "Dr. Catherine Chodkiewicz, MD",
      "rawName": "Catherine Chodkiewicz",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "1800 MULBERRY ST",
      "city": "Scranton",
      "state": "PA",
      "postalCode": "18510",
      "phone": "570-703-8000",
      "affiliation": "Regional Academic Oncology Network (Scranton, PA)"
    },
    {
      "npi": "1447451067",
      "name": "Dr. Aneel Chowdhary, MD",
      "rawName": "Aneel Chowdhary",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1400 HAL GREER BLVD",
      "city": "Huntington",
      "state": "WV",
      "postalCode": "25701",
      "phone": "304-399-6678",
      "affiliation": "Regional Academic Oncology Network (Huntington, WV)"
    },
    {
      "npi": "1780647453",
      "name": "Dr. Justin Cohen, MD",
      "rawName": "Justin Cohen",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "3415 MACCORKLE AVENUE SE",
      "city": "Charleston",
      "state": "WV",
      "postalCode": "25304",
      "phone": "304-388-8380",
      "affiliation": "Regional Academic Oncology Network (Charleston, WV)"
    },
    {
      "npi": "1265888762",
      "name": "Dr. Paul Adedoyin, MD",
      "rawName": "Paul Adedoyin",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1400 HAL GREER BLVD",
      "city": "Huntington",
      "state": "WV",
      "postalCode": "25701",
      "phone": "304-399-6610",
      "affiliation": "Regional Academic Oncology Network (Huntington, WV)"
    },
    {
      "npi": "1104824663",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1410 CLARK ST",
      "city": "Cambridge",
      "state": "OH",
      "postalCode": "43725",
      "phone": "304-422-3398",
      "affiliation": "Regional Academic Oncology Network (Cambridge, OH)"
    },
    {
      "npi": "1104941335",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "115 SUMMERS HOSPITAL ROAD",
      "city": "Hinton",
      "state": "WV",
      "postalCode": "25951",
      "phone": "304-466-1000",
      "affiliation": "Regional Academic Oncology Network (Hinton, WV)"
    },
    {
      "npi": "1174528798",
      "name": "Dr. Cengiz Aygun, MD",
      "rawName": "Cengiz Aygun",
      "credential": "MD",
      "specialty": "Specialist",
      "taxonomyCode": "174400000X",
      "practiceAddress": "9105 FRANKLIN SQUARE DR",
      "city": "Baltimore",
      "state": "MD",
      "postalCode": "21237",
      "phone": "410-682-6800",
      "affiliation": "Regional Academic Oncology Network (Baltimore, MD)"
    },
    {
      "npi": "1609816214",
      "name": "Dr. Joseph Baisden, MD",
      "rawName": "Joseph Baisden",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "210 NEW HOPE RD",
      "city": "Princeton",
      "state": "WV",
      "postalCode": "24740",
      "phone": "304-425-1960",
      "affiliation": "Regional Academic Oncology Network (Princeton, WV)"
    },
    {
      "npi": "1427072446",
      "name": "Dr. Jose Barba, MD",
      "rawName": "Jose Barba",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "4605 MACCORKLE AVE SW",
      "city": "South charleston",
      "state": "WV",
      "postalCode": "25309",
      "phone": "304-766-3668",
      "affiliation": "Regional Academic Oncology Network (South charleston, WV)"
    },
    {
      "npi": "1518596600",
      "name": "Dr. Vincent Cassidy, MD",
      "rawName": "Vincent Cassidy",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "2013 JEFFERSON ST SW FL 2",
      "city": "Roanoke",
      "state": "VA",
      "postalCode": "24014",
      "phone": "540-982-0237",
      "affiliation": "Regional Academic Oncology Network (Roanoke, VA)"
    },
    {
      "npi": "1427240266",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "500 CHERRY ST",
      "city": "Bluefield",
      "state": "WV",
      "postalCode": "24701",
      "phone": "304-327-1565",
      "affiliation": "Regional Academic Oncology Network (Bluefield, WV)"
    }
  ],
  "wisconsin": [
    {
      "npi": "1588827778",
      "name": "Dr. Kamal kant singh Abbi, MD",
      "rawName": "Kamal kant singh Abbi",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1726 SHAWANO AVE",
      "city": "Green bay",
      "state": "WI",
      "postalCode": "54303",
      "phone": "920-884-3135",
      "affiliation": "Regional Academic Oncology Network (Green bay, WI)"
    },
    {
      "npi": "1972779551",
      "name": "Dr. Rami Abumasmah, MD",
      "rawName": "Rami Abumasmah",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "855 N WESTHAVEN DR",
      "city": "Oshkosh",
      "state": "WI",
      "postalCode": "54904",
      "phone": "920-456-7870",
      "affiliation": "Regional Academic Oncology Network (Oshkosh, WI)"
    },
    {
      "npi": "1114183290",
      "name": "Dr. Syed Abutalib, MD",
      "rawName": "Syed Abutalib",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2900 W OKLAHOMA AVE",
      "city": "Milwaukee",
      "state": "WI",
      "postalCode": "53215",
      "phone": "414-649-6380",
      "affiliation": "Regional Academic Oncology Network (Milwaukee, WI)"
    },
    {
      "npi": "1346473345",
      "name": "Dr. Kalid Adab, MD",
      "rawName": "Kalid Adab",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "2900 W OKLAHOMA AVE",
      "city": "Milwaukee",
      "state": "WI",
      "postalCode": "53215",
      "phone": "414-649-6380",
      "affiliation": "Regional Academic Oncology Network (Milwaukee, WI)"
    },
    {
      "npi": "1144780107",
      "name": "Dr. Jacob Adashek, DO",
      "rawName": "Jacob Adashek",
      "credential": "DO",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "W180N11070 RIVER LN",
      "city": "Germantown",
      "state": "WI",
      "postalCode": "53022",
      "phone": "262-532-9755",
      "affiliation": "Regional Academic Oncology Network (Germantown, WI)"
    },
    {
      "npi": "1558139956",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Clinic/Center, Oncology",
      "taxonomyCode": "261QX0200X",
      "practiceAddress": "480 E DIVISION ST",
      "city": "Fond du lac",
      "state": "WI",
      "postalCode": "54935",
      "phone": "920-926-4100",
      "affiliation": "Regional Academic Oncology Network (Fond du lac, WI)"
    },
    {
      "npi": "1750395745",
      "name": "Dr. Eyad Al-hattab, MD",
      "rawName": "Eyad Al-hattab",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1400 BELLINGER ST",
      "city": "Eau claire",
      "state": "WI",
      "postalCode": "54703",
      "phone": "715-838-5222",
      "affiliation": "Regional Academic Oncology Network (Eau claire, WI)"
    },
    {
      "npi": "1609842624",
      "name": "Dr. Mark Albertini, MD",
      "rawName": "Mark Albertini",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "600 HIGHLAND AVE",
      "city": "Madison",
      "state": "WI",
      "postalCode": "53792",
      "phone": "608-265-1700",
      "affiliation": "Regional Academic Oncology Network (Madison, WI)"
    },
    {
      "npi": "1710299482",
      "name": "Dr. Waddah Arafat, MD",
      "rawName": "Waddah Arafat",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "5200 HARRY HINES BLVD",
      "city": "Dallas",
      "state": "TX",
      "postalCode": "75235",
      "phone": "214-590-4656",
      "affiliation": "Regional Academic Oncology Network (Dallas, TX)"
    },
    {
      "npi": "1952752305",
      "name": "Dr. Danielle Atibalentja, MD",
      "rawName": "Danielle Atibalentja",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology",
      "taxonomyCode": "207RH0000X",
      "practiceAddress": "600 HIGHLAND AVE",
      "city": "Madison",
      "state": "WI",
      "postalCode": "53792",
      "phone": "608-915-0100",
      "affiliation": "Regional Academic Oncology Network (Madison, WI)"
    },
    {
      "npi": "1922053107",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "General Acute Care Hospital",
      "taxonomyCode": "282N00000X",
      "practiceAddress": "3400 UNION AVE",
      "city": "Sheboygan",
      "state": "WI",
      "postalCode": "53081",
      "phone": "920-802-2100",
      "affiliation": "Regional Academic Oncology Network (Sheboygan, WI)"
    },
    {
      "npi": "1518070077",
      "name": "Dr. Lynn Baatz, MD",
      "rawName": "Lynn Baatz",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2300 WESTERN AVE",
      "city": "Manitowoc",
      "state": "WI",
      "postalCode": "54220",
      "phone": "920-320-2249",
      "affiliation": "Regional Academic Oncology Network (Manitowoc, WI)"
    },
    {
      "npi": "1508363532",
      "name": "Dr. Now bahar Alam, MD",
      "rawName": "Now bahar Alam",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1400 BELLINGER STREET",
      "city": "Eau claire",
      "state": "WI",
      "postalCode": "54703",
      "phone": "715-838-5222",
      "affiliation": "Regional Academic Oncology Network (Eau claire, WI)"
    },
    {
      "npi": "1629001417",
      "name": "Dr. Bethany Anderson, MD",
      "rawName": "Bethany Anderson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "600 HIGHLAND AVE",
      "city": "Madison",
      "state": "WI",
      "postalCode": "53792",
      "phone": "608-263-8500",
      "affiliation": "Regional Academic Oncology Network (Madison, WI)"
    },
    {
      "npi": "1609881077",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine",
      "taxonomyCode": "207R00000X",
      "practiceAddress": "400 W RIVER WOODS PKWY",
      "city": "Glendale",
      "state": "WI",
      "postalCode": "53212",
      "phone": "414-465-3000",
      "affiliation": "Regional Academic Oncology Network (Glendale, WI)"
    },
    {
      "npi": "1356391247",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "General Acute Care Hospital",
      "taxonomyCode": "282N00000X",
      "practiceAddress": "2251 N SHORE DR",
      "city": "Rhinelander",
      "state": "WI",
      "postalCode": "54501",
      "phone": "715-361-2000",
      "affiliation": "Regional Academic Oncology Network (Rhinelander, WI)"
    },
    {
      "npi": "1295754844",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "General Acute Care Hospital",
      "taxonomyCode": "282N00000X",
      "practiceAddress": "410 DEWEY ST",
      "city": "Wisconsin rapids",
      "state": "WI",
      "postalCode": "54494",
      "phone": "715-423-6060",
      "affiliation": "Regional Academic Oncology Network (Wisconsin rapids, WI)"
    },
    {
      "npi": "1538112230",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "General Acute Care Hospital",
      "taxonomyCode": "282N00000X",
      "practiceAddress": "900 ILLINOIS AVE",
      "city": "Stevens point",
      "state": "WI",
      "postalCode": "54481",
      "phone": "715-346-5000",
      "affiliation": "Regional Academic Oncology Network (Stevens point, WI)"
    },
    {
      "npi": "1366404329",
      "name": "Dr. Richard Auchter, MD",
      "rawName": "Richard Auchter",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1104 JOHN NOLEN DR",
      "city": "Madison",
      "state": "WI",
      "postalCode": "53713",
      "phone": "608-251-6868",
      "affiliation": "Regional Academic Oncology Network (Madison, WI)"
    }
  ],
  "wyoming": [
    {
      "npi": "1578586418",
      "name": "Dr. James Burke, MD",
      "rawName": "James Burke",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "2825 8TH AVE N",
      "city": "Billings",
      "state": "MT",
      "postalCode": "59101",
      "phone": "406-238-2500",
      "affiliation": "Regional Academic Oncology Network (Billings, MT)"
    },
    {
      "npi": "1659458008",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "214 E 23RD ST",
      "city": "Cheyenne",
      "state": "WY",
      "postalCode": "82001",
      "phone": "307-773-8237",
      "affiliation": "Regional Academic Oncology Network (Cheyenne, WY)"
    },
    {
      "npi": "1740700798",
      "name": "Dr. Iloabueke Chineke, MD",
      "rawName": "Iloabueke Chineke",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6501 E 2ND ST",
      "city": "Casper",
      "state": "WY",
      "postalCode": "82609",
      "phone": "307-235-5433",
      "affiliation": "Regional Academic Oncology Network (Casper, WY)"
    },
    {
      "npi": "1316119639",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Hematology & Oncology",
      "taxonomyCode": "207RH0003X",
      "practiceAddress": "6501 E 2ND ST",
      "city": "Casper",
      "state": "WY",
      "postalCode": "82609",
      "phone": "307-235-5433",
      "affiliation": "Regional Academic Oncology Network (Casper, WY)"
    },
    {
      "npi": "1356492482",
      "name": "Dr. Elie Fahed, MD",
      "rawName": "Elie Fahed",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "6501 E 2ND ST",
      "city": "Casper",
      "state": "WY",
      "postalCode": "82609",
      "phone": "307-235-5433",
      "affiliation": "Regional Academic Oncology Network (Casper, WY)"
    },
    {
      "npi": "1457391773",
      "name": "Dr. Kyung nam Kim, MD",
      "rawName": "Kyung nam Kim",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1401 W 5TH ST",
      "city": "Sheridan",
      "state": "WY",
      "postalCode": "82801",
      "phone": "307-672-1000",
      "affiliation": "Regional Academic Oncology Network (Sheridan, WY)"
    },
    {
      "npi": "1083865554",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1035 ROSE LN",
      "city": "Riverton",
      "state": "WY",
      "postalCode": "82501",
      "phone": "307-856-4688",
      "affiliation": "Regional Academic Oncology Network (Riverton, WY)"
    },
    {
      "npi": "1487607180",
      "name": "Dr. Banu Symington, MD",
      "rawName": "Banu Symington",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "1180 COLLEGE DR",
      "city": "Rock springs",
      "state": "WY",
      "postalCode": "82901",
      "phone": "307-382-2234",
      "affiliation": "Regional Academic Oncology Network (Rock springs, WY)"
    },
    {
      "npi": "1841246022",
      "name": "Dr. Keith Thompson, MD",
      "rawName": "Keith Thompson",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "15 SHRINE CLUB RD",
      "city": "Lander",
      "state": "WY",
      "postalCode": "82520",
      "phone": "307-332-0324",
      "affiliation": "Regional Academic Oncology Network (Lander, WY)"
    },
    {
      "npi": "1003952821",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Internal Medicine, Medical Oncology",
      "taxonomyCode": "207RX0202X",
      "practiceAddress": "400 2ND ST",
      "city": "Rock springs",
      "state": "WY",
      "postalCode": "82901",
      "phone": "307-382-5116",
      "affiliation": "Regional Academic Oncology Network (Rock springs, WY)"
    },
    {
      "npi": "1194961789",
      "name": "Dr. Brandon Barney, MD",
      "rawName": "Brandon Barney",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "170 N 1100 E",
      "city": "American fork",
      "state": "UT",
      "postalCode": "84003",
      "phone": "801-357-2480",
      "affiliation": "Regional Academic Oncology Network (American fork, UT)"
    },
    {
      "npi": "1659959286",
      "name": "Dr. Adam Beighley, MD",
      "rawName": "Adam Beighley",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "6501 E 2ND ST",
      "city": "Casper",
      "state": "WY",
      "postalCode": "82609",
      "phone": "307-235-5433",
      "affiliation": "Regional Academic Oncology Network (Casper, WY)"
    },
    {
      "npi": "1699161182",
      "name": "Dr. Joshua Binks, MD",
      "rawName": "Joshua Binks",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "1180 COLLEGE DR",
      "city": "Rock springs",
      "state": "WY",
      "postalCode": "82901",
      "phone": "307-212-7760",
      "affiliation": "Regional Academic Oncology Network (Rock springs, WY)"
    },
    {
      "npi": "1063575611",
      "name": "Dr.  , MD",
      "rawName": " ",
      "credential": "MD",
      "specialty": "Emergency Medicine",
      "taxonomyCode": "207P00000X",
      "practiceAddress": "501 S BURMA AVE",
      "city": "Gillette",
      "state": "WY",
      "postalCode": "82716",
      "phone": "307-688-1415",
      "affiliation": "Regional Academic Oncology Network (Gillette, WY)"
    },
    {
      "npi": "1538268305",
      "name": "Dr. Jeffrey Carlton, MD",
      "rawName": "Jeffrey Carlton",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "214 E 23RD ST",
      "city": "Cheyenne",
      "state": "WY",
      "postalCode": "82001",
      "phone": "307-633-7823",
      "affiliation": "Regional Academic Oncology Network (Cheyenne, WY)"
    },
    {
      "npi": "1194825935",
      "name": "Dr. Don Dickerson, MD",
      "rawName": "Don Dickerson",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "803 W MARKET ST STE 100",
      "city": "Lima",
      "state": "OH",
      "postalCode": "45805",
      "phone": "419-996-5063",
      "affiliation": "Regional Academic Oncology Network (Lima, OH)"
    },
    {
      "npi": "1366508814",
      "name": "Dr. Subashini Furman, MD",
      "rawName": "Subashini Furman",
      "credential": "MD",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "310 E 24TH ST",
      "city": "Cheyenne",
      "state": "WY",
      "postalCode": "82001",
      "phone": "307-634-9311",
      "affiliation": "Regional Academic Oncology Network (Cheyenne, WY)"
    },
    {
      "npi": "1023696622",
      "name": "Dr. Sarah Glynn, DO",
      "rawName": "Sarah Glynn",
      "credential": "DO",
      "specialty": "Radiation Oncology",
      "taxonomyCode": "2085R0001X",
      "practiceAddress": "6501 E 2ND ST",
      "city": "Casper",
      "state": "WY",
      "postalCode": "82609",
      "phone": "307-235-5433",
      "affiliation": "Regional Academic Oncology Network (Casper, WY)"
    }
  ]
};
